const messagesES = {
    code: "es",
    messages: {
        cache: {
            management: "Gestión de caché",
            createNew: "Crear nuevo caché",
            keySearchPlaceholder: "Buscar clave (comodín soportado: *chat*, chat*, *chat)",
            type: "Tipo de caché",
            actorType: "Tipo de actor",
            selectAutomation: "Seleccionar automatización",
            selectChatbot: "Seleccionar chatbot",
            selectUser: "Seleccionar usuario",
            clearFilters: "Limpiar filtros",
            deleteSelected: "Eliminar seleccionados",
            extendSelected: "Extender duración seleccionada",
            makeSelectedNeverExpire: "Hacer que seleccionados nunca expiren",
            deleteAllActorCaches: "Eliminar todos los cachés de este actor",
            emptyState: "Aún no se encontró caché",
            editCache: "Editar caché",
            key: "Clave de caché",
            keyPlaceholder: "Ejemplo: user_session_123",
            value: "Valor de caché",
            stringValuePlaceholder: "Valor de cadena",
            dataType: "Tipo de datos",
            validityDuration: "Duración de validez",
            neverExpire: "Nunca expirar",
            specifyDuration: "Especificar duración",
            specifyDate: "Especificar fecha",
            minutes: "Minutos",
            hours: "Horas",
            days: "Días",
            update: "Actualizar",
            create: "Crear",
            bulkExtend: "Extensión masiva",
            bulkExtendInfo: "Se extenderá la duración de validez de {count} caché(s).",
            newValidityDuration: "Nueva duración de validez",
            extend: "Extender",
            keyLabel: "Clave",
            valueLabel: "Valor",
            typeLabel: "Tipo",
            createdBy: "Creado por",
            createdAt: "Creado el",
            updatedBy: "Actualizado por",
            expiresAt: "Expira el",
            actions: "Acciones",
            edit: "Editar",
            extendDuration: "Extender duración",
            makeNeverExpire: "Hacer nunca expirar",
            loadError: "Error al cargar la lista de caché",
            updateSuccess: "Caché actualizado",
            createSuccess: "Caché creado",
            saveError: "Error al guardar caché",
            deleteCache: "Eliminar caché",
            confirmDelete: "Sí, eliminar",
            deleteSuccess: "Caché eliminado",
            extendSuccess24h: "Duración de caché extendida 24 horas",
            extendError: "Error al extender duración de caché",
            deleteActorCaches: "Eliminar cachés del actor",
            deleteActorCachesConfirm: "¿Está seguro de eliminar todos los cachés de \"{actor}\"? Esta acción no se puede deshacer.",
            confirmDeleteAll: "Sí, eliminar todo",
            countDeleted: "{count} caché(s) eliminado(s)",
            bulkDelete: "Eliminación masiva",
            bulkDeleteConfirm: "Se eliminarán {count} caché(s). ¿Está seguro?",
            bulkMakeNeverExpire: "Hacer nunca expirar masivamente",
            bulkMakeNeverExpireConfirm: "Se eliminará la expiración de {count} caché(s). ¿Está seguro?",
            makeNeverExpireSuccess: "Caché configurado para nunca expirar",
            makeNeverExpireError: "Error al hacer que caché nunca expire",
            bulkExtendError: "Error al extender duraciones de caché",
            bulkExtendSuccess: "Duración de {count} caché(s) extendida",
            bulkMakeNeverExpireSuccess: "{count} caché(s) configurado(s) para nunca expirar",
            deleteCacheConfirm: "¿Está seguro de eliminar el caché \"{key}\"?",
            selectedCount: "{count} caché(s) seleccionado(s)",
            valueTitle: "Valor de caché: {key}",
            never: "Nunca",
            automation: "Automatización",
            chatbot: "Chatbot",
            user: "Usuario",
            api: "API",
            all: "Todos",
            public: "Público",
            private: "Privado"
        },
        zoho: {
            SETTING_GROUP: "Configuración",
            usermapping: "Mapeo de usuarios"
        },
        chatWindow: {
            descending: "Descendente",
            ascending: "Ascendente",
            filterTable: "Filtrar",
            thereIsNoChatContent: "No hay contenido de chat disponible.",
            thereIsNoChatContentDsc: "Aquí puedes ver el contenido del chat y enviar mensajes.",
            interactions: "Interacciones:",
            departments: "Departamentos",
            channels: "Canales",
            date: "Fecha",
            lastChatStatus: "Último estado del chat",
            all: "Todos",
            queued: "En cola",
            open: "Abierto",
            closed: "Cerrado",
            private: "Privado",
            chatbot: "Chatbot",
            lostMissed: "Perdido / No atendido",
            interaction: "Interacción",
            myActiveInbox: "Mi bandeja de entrada activa",
            activeQueueInbox: "Bandeja de entrada activa + en cola",
            chatbotActiveInbox: "Bandeja de entrada activa del chatbot",
            myDepartmentsActiveInbox: "Bandeja de entrada activa de mis departamentos",
            notInteractedYesterday: "No hubo interacciones ayer",
            queueInbox: "Bandeja de entrada en cola",
            whatsappActiveInbox: "Bandeja de entrada activa de WhatsApp",
            socialMediaActiveInbox: "Bandeja de entrada activa de redes sociales",
            missedThisMonth: "Chats perdidos este mes",
            chooseAFileOrDragItHere: "¡Elige un archivo o arrástralo aquí!",
            watching: "Observando",
            selectFilter: "Seleccionar filtro",
            clearAll: "Limpiar todo",
            me: "Yo",
            today: "Hoy",
            yesterday: "Ayer",
            thisWeek: "Esta semana",
            lastWeek: "La semana pasada",
            last7Days: "Últimos 7 días",
            last30Days: "Últimos 30 días",
            thisMonth: "Este mes",
            lastMonth: "El mes pasado",
            last24h: "Últimas 24 horas",
            custom: "Personalizado",
            startMessage: "Iniciar mensaje",
            goToAgentReport: "Ir al informe del agente",
            agentDetail: "Detalle del agente",
            agentList: "Lista de agentes",
            selectedFilter: "Filtro seleccionado",
            groupBy: "Agrupar",
            none: "Sin grupo",
            agent: "Representante",
            department: "Departamento",
            tag: "Etiqueta",
            website: "Sitio web",
            channel: "Canal",
            platform: "Platforma",
            answerStatus: "Estado de la respuesta",
            sortBy: "Ordenar",
            lastPostAbove: "Última publicación arriba",
            newChatsAbove: "Nuevos chats arriba",
            oldChatsAbove: "Chats antiguos arriba",
            live: "Vivir",
            systemStatus: "Estado del sistema",
            refresh: "Actualizar",
            close: "Cerrar",
            totalCustomers: "Total de clientes",
            totalAnswered: "Total respondido",
            waitingAnswer: "Esperando respuesta",
            totalAgentInChat: "Total de agentes en el chat",
            onlineAgentCount: "Cantidad de agentes en línea",
            totalCustomer: "Cliente total",
            answered: "Respondido",
            unanswered: "Sin respuesta",
            noContactWasFoundMatchingTheCurrentFilters: "No se encontró ningún contacto que coincida con los filtros actuales.",
            you: "Tú",
            others: "Otros",
            queue: "Cola",
            chatbotContact: "Chatbot",
            closedContact: "Cerrado",
            myInteractions: "Mis Interacciones",
            special: "Especial",
            allInteractions: "Todos los contactos",
            waiting: "Pendiente",
            departmentToWhichItIsAffiliated: "Departamento al que está adscrito",
            owner: "Propietario",
            switchToLiveSupportMode: "Cambiar al modo de soporte en vivo",
            switchToLiveSupportModeConfirmation: "¿Desea cambiar al modo de soporte en vivo para ver este contacto?",
            hiddenChatsWarning: "Hay {count} chats que no puedes ver en esta lista",
            clickToSeeDetails: "Haz clic para ver los detalles",
            viewDetails: "Ver detalles",
            hiddenChatsDetails: "Detalles de chats ocultos",
            totalHiddenChats: "Total de chats ocultos",
            examples: "Ejemplos",
            reasons: {
                visitorNotFound: "Visitante no encontrado",
                noChannelAccess: "No tienes acceso a este canal",
                ownedByOtherNotChannelOwner: "Pertenece a otro usuario (No eres el propietario del canal)",
                ownedByOtherNoChannel: "Pertenece a otro usuario (Sin canal)",
                noOwnerAdminOnly: "Chat sin propietario (Solo los administradores y propietarios del canal pueden ver)"
            }
        },
        chat: {
            inbox: "Bandeja de Entrada",
            layouts: {
                chat: "Vista de Chat",
                table: "Vista de Tabla",
                kanban: "Vista de Kanban"
            },
            filters: {
                allContacts: "Todos los Contactos",
                myInbox: "Mi Bandeja de Entrada",
                myContacts: "Mis Contactos",
                missed: "Perdidos",
                unanswered: "Sin respuesta",
                unassigned: "Sin Asignar",
                chatbot: "Chatbot"
            },
            groups: {
                views: "Vistas",
                customFilters: "Filtros Personalizados",
                team: "Equipo",
                contacts: "Contactos",
                system: "Sistema"
            },
            sidebar: {
                tabScreen: "Pantalla de pestañas",
                search: "Buscar",
                addNewFilter: "Añadir nuevo filtro",
                edit: "Editar",
                showInTable: "Mostrar en modo tabla",
                showInKanban: "Mostrar en modo Kanban",
                rename: "Renombrar",
                makePublic: "Hacer público",
                makePrivate: "Hacer privado",
                moveToTop: "Mover arriba",
                moveToBottom: "Mover abajo",
                delete: "Eliminar",
                renameFilterTitle: "Renombrar filtro",
                filterNamePlaceholder: "Introduce el nombre del filtro",
                positionUpdateError: "Error al actualizar la posición",
                filterNameEmpty: "El nombre del filtro no puede estar vacío",
                filterNameUpdated: "Nombre del filtro actualizado",
                filterNameUpdateError: "Error al actualizar el nombre del filtro",
                filterVisibilityUpdateError: "Error al actualizar la visibilidad del filtro",
                filterMadePrivate: "Filtro establecido como privado",
                filterMadePublic: "Filtro establecido como público",
                filterMovedToTop: "Filtro movido arriba",
                filterMovedToBottom: "Filtro movido abajo",
                filterMoveError: "Error al mover el filtro",
                onlyCreatorOrRootCanDeletePublic: "Solo el creador o el usuario root pueden eliminar filtros públicos",
                deleteFilterTitle: "Eliminar filtro",
                deleteFilterConfirm: "¿Está seguro de que desea eliminar el filtro \"{name}\"?",
                deleteFilterOk: "Eliminar",
                deleteFilterCancel: "Cancelar",
                filterDeleted: "Filtro eliminado",
                filterDeleteError: "Error al eliminar el filtro",
                websiteAnalytics: "Analíticas del sitio web"
            },
            gridContactList: {
                emptyConversationsTitle: "No se encontró chat",
                emptyConversationsDescription: "Aún no tienes un chat activo. Puedes iniciar un nuevo chat desde la página del cliente.",
                markAsUnanswered: "Marcar como sin respuesta",
                markAsAnswered: "Marcar como respondido",
                removeVIP: "Quitar VIP",
                markAsVIP: "Marcar como VIP",
                markAsRead: "Marcar como leído",
                markAsUnread: "Marcar como no leído",
                closeChat: "Cerrar chat",
                markedAsAnswered: "Marcado como respondido",
                markedAsUnanswered: "Marcado como sin respuesta",
                operationFailed: "Operación fallida",
                markedAsVIP: "Marcado como VIP",
                vipRemoved: "VIP eliminado",
                markedAsUnread: "Marcado como no leído",
                markedAsRead: "Marcado como leído",
                confirmCloseChat: "¿Estás seguro de que quieres terminar el chat?",
                chatClosed: "Chat cerrado"
            },
            tableContactList: {
                editFilter: "Editar filtro",
                chatStatus: "Estado del Chat",
                grouping: "Agrupación",
                allContacts: "Todos los contactos",
                groupNone: "Ninguno",
                groupTag: "Etiqueta",
                groupDepartment: "Departamento",
                groupChannel: "Canal",
                groupPlatform: "Plataforma",
                groupOwner: "Propietario",
                groupUsers: "Participantes",
                groupAnswerStatus: "Estado de respuesta",
                statusAll: "Todos",
                statusOpen: "Abierto",
                statusClosed: "Cerrado",
                statusUnknown: "Desconocido",
                copyLabel: "Copia",
                filterCreatedSuccess: "Filtro creado correctamente",
                filterCreatedNameDuplicate: "El nombre \"{createName}\" ya estaba en uso. El filtro se creó como \"{filterName}\".",
                filterCreateFailed: "No se pudo crear el filtro",
                filterCreateError: "Ocurrió un error al crear el filtro.",
                platformSupsis: "Supsis",
                platformEmail: "Correo electrónico",
                platformWhatsapp: "WhatsApp",
                platformWeb: "Web",
                platformInstagram: "Instagram",
                platformTelegram: "Telegram",
                platformMessenger: "Messenger",
                platformMetaLeads: "Meta Leads",
                platformTrendyol: "Trendyol",
                platformLinkedin: "LinkedIn",
                answerStatusAnswered: "Respondido",
                answerStatusUnanswered: "Sin respuesta"
            },
            kanbanContactList: {
                filterHide: "Ocultar filtros",
                filterAdd: "Añadir filtro",
                broadcast: "Difusión",
                broadcastSelectPlaceholder: "Seleccionar difusión...",
                loading: "Cargando...",
                broadcastNotFound: "No se encontró difusión",
                broadcastTitle: "Título",
                broadcastDate: "Fecha",
                broadcastStatus: "Estado",
                broadcastProgress: "Progreso",
                refresh: "Actualizar",
                kanbanLoading: "Cargando Kanban...",
                deletedUser: "Usuario eliminado",
                unowned: "Sin propietario",
                activeInChat: "Activo (en chat)",
                newInQueue: "Nuevo (en cola)",
                agentDown: "Agente desconectado",
                closed: "Cerrado",
                blocked: "Bloqueado",
                unblocked: "Desbloqueado",
                groupsLoadError: "Error al cargar grupos",
                dataLoadError: "Error al cargar datos",
                broadcastsLoadError: "Error al cargar difusiones",
                dataRefreshed: "Datos actualizados",
                refreshError: "Error durante la actualización",
                unknownContact: "Contacto desconocido",
                assigned: "Sin asignar",
                platformMobile: "Móvil",
                broadcastStatusCreated: "Creado",
                broadcastStatusScheduled: "Programado",
                broadcastStatusQueued: "En cola",
                broadcastStatusRunning: "Enviando",
                broadcastStatusCompleted: "Completado",
                broadcastStatusFailed: "Fallido",
                broadcastStatusCancelled: "Cancelado",
                metaLeadNewLead: "Nuevo lead",
                metaLeadInitialContact: "Primer contacto",
                metaLeadNeedsAssessment: "Evaluación de necesidades",
                metaLeadProposalSent: "Propuesta enviada",
                metaLeadProposalReview: "Revisión de propuesta",
                metaLeadNegotiation: "Negociación",
                metaLeadDecisionStage: "Etapa de decisión",
                metaLeadClosure: "Cierre",
                metaLeadFollowUp: "Seguimiento",
                broadcastSent: "Enviado",
                broadcastDelivered: "Entregado",
                broadcastRead: "Leído",
                broadcastFailed: "Fallido",
                broadcastEdited: "Editado",
                broadcastDeleted: "Eliminado",
                triggerTypeApi: "API",
                triggerTypeBroadcast: "Difusión",
                triggerTypeAutomation: "Automatización",
                emptyGroup: "No hay contactos en este grupo",
                loadMore: "Cargar más...",
                groupSelectTitle: "Seleccionar campo de agrupación",
                searchPlaceholder: "Buscar...",
                categoryBasic: "Básico",
                categoryDemographic: "Demográfico",
                categoryTags: "Etiquetas y categoría",
                categoryMeta: "Meta Leads",
                categoryBroadcast: "Difusión",
                categoryOther: "Otro",
                fieldAnswerStatus: "Estado de respuesta",
                fieldLastConversationStatus: "Estado del chat",
                fieldOwner: "Propietario",
                fieldUsers: "Participantes",
                fieldChannel: "Canal",
                fieldPlatform: "Plataforma",
                fieldCountry: "País",
                fieldCity: "Ciudad",
                fieldBrowser: "Navegador",
                fieldPreferredLang: "Idioma",
                fieldTags: "Etiquetas",
                fieldDepartment: "Departamento",
                fieldMetaLeadStatus: "Estado del lead",
                fieldMetaLeadAdName: "Nombre del anuncio",
                fieldMetaLeadAdsetName: "Conjunto de anuncios",
                fieldMetaLeadCampaignName: "Campaña",
                fieldMetaLeadFormName: "Nombre del formulario",
                fieldMetaLeadPlatform: "Plataforma Meta",
                fieldLastBroadcastStatus: "Estado de difusión",
                fieldLastBroadcastReason: "Razón de difusión",
                fieldBlockedSnapshot: "Estado de bloqueo",
                fieldLastTriggerType: "Tipo de activación",
                fieldZohoLeadStatus: "Estado lead Zoho",
                fieldZohoLeadSource: "Fuente lead Zoho",
                broadcastTriggerSuccess: "¡Respondió al mensaje de difusión!",
                broadcastTriggerWaiting: "Esperando respuesta...",
                unknownUser: "Usuario desconocido",
                unread: "No leído",
                platformIg: "Instagram",
                platformFb: "Facebook"
            },
            gridContactListToolBar: {
                chatStatus: "Estado del Chat",
                sortBy: "Ordenar por",
                all: "Todos",
                open: "Abierto",
                closed: "Cerrado",
                allStatus: "Todos",
                lastActivity: "Última Actividad",
                createdAt: "Fecha de Creación",
                unknown: "Desconocido"
            },
            chatCloseSettings: {
                selectPhone: "Seleccionar teléfono",
                selectPhoneDescription: "¿Con qué teléfono desea llamar a {number}?",
                call: "Llamar",
                unnamedChannel: "Canal sin nombre",
                typeVisitorName: "Escriba el nombre del visitante...",
                webphoneCall: "Llamar con Webphone",
                hideSystemMessages: "Ocultar mensajes del sistema",
                chatbotDebugMode: "Modo de depuración del chatbot",
                createTask: "Crear tarea",
                showProfile: "Mostrar perfil",
                sendCapiEvent: "Enviar evento CAPI",
                noPhoneNumber: "No se encontró número para llamar",
                noWebphoneChannel: "No se encontró canal de webphone",
                webphoneCalling: "Llamando a {number} con Webphone...",
                unknown: "Desconocido",
                channelTypeKirmiziSantral: "Kırmızı Santral",
                channelTypeTelnyx: "Telnyx",
                channelTypeNetgsm: "NetGSM",
                channelTypeWebPhone: "Teléfono web",
                platformWeb: "Web",
                platformWhatsapp: "WhatsApp",
                platformWhatsappBusiness: "WhatsApp Business",
                platformInstagram: "Instagram",
                platformInstagramV2: "Instagram V2",
                platformMessenger: "Messenger",
                platformTelegram: "Telegram",
                platformTrendyol: "Trendyol",
                platformEmail: "Correo electrónico",
                platformSms: "SMS",
                vipCustomerTooltip: "★ Cliente VIP"
            },
            contactDetail: {
                removeVIPTooltip: "Quitar VIP",
                markAsVIPTooltip: "Marcar como VIP (Los usuarios marcados como VIP siempre se mostrarán en la parte superior en los chats).",
                customerOwnership: "Propiedad del Cliente",
                ownershipDescription: "Cuando se asigna la propiedad del cliente, solo el propietario y los administradores completos pueden verla",
                unowned: "Sin propietario",
                assignToMe: "Asignar a Mí",
                removeOwnership: "Quitar Propiedad",
                dragPlaceholder: "Mover aquí",
                currentConversationDepartment: "Departamento de Conversación Actual",
                pastInteractionDepartments: "Departamentos de Interacción Pasados",
                createdAt: "Fecha de Creación",
                updatedAt: "Fecha de Actualización",
                zohoSync: "Sincronización de Zoho",
                zohoSyncQuestion: "¿Desea realizar operaciones de cambio de contacto en Zoho también?",
                basicInfo: "Información de Contacto",
                loginInfo: "Información del Formulario de Contacto",
                profileFields: "Campos de Perfil",
                systemInfo: "Información del Sistema"
            },
            contactDetailItem: {
                removeOwnership: "Quitar Propiedad",
                assignOwnershipToMe: "Asignar Propiedad a Mí",
                vipCustomer: "Cliente VIP",
                contentCopiedSuccess: "¡Contenido copiado exitosamente!",
                invalidEmail: "¡Dirección de correo electrónico inválida!",
                invalidValue: "¡Valor inválido!"
            },
            filtersSection: {
                addFilter: "Agregar Filtro",
                all: "Todos",
                open: "Abierto",
                closed: "Cerrado",
                relevance: "Relevancia",
                lastActivityNewest: "Actividad Más Reciente",
                lastActivityOldest: "Actividad Más Antigua",
                noParticipant: "Sin Participante",
                ownershipFilter: "Filtro de Propiedad",
                metaReferral: "Referencia Meta",
                userStatus: "Estado del Usuario",
                unowned: "Sin propietario",
                fromAds: "De Anuncios",
                notFromAds: "No De Anuncios",
                blockedUsers: "Usuarios Bloqueados",
                unblockedUsers: "Usuarios No Bloqueados",
                unread: "No Leído",
                read: "Leído",
                yes: "Sí",
                no: "No",
                answered: "Respondido",
                unanswered: "Sin Respuesta",
                active: "Activo",
                lost: "Perdido",
                new: "Nuevo",
                chatbot: "Chatbot",
                closedStatus: "Cerrado",
                platform: "Plataforma",
                channel: "Canal",
                department: "Departamento",
                tag: "Etiqueta",
                participant: "Participante",
                ownership: "Propiedad",
                lastActivityTime: "Hora de Última Actividad",
                fullName: "Nombre Completo",
                email: "Email",
                phone: "Teléfono",
                vipCustomer: "Cliente VIP",
                hasVIP: "Tiene VIP",
                noVIP: "Sin VIP",
                operatingSystem: "Sistema Operativo",
                browser: "Navegador",
                ipAddress: "Dirección IP",
                visitingPage: "Página Visitada",
                adInteraction: "Interacción con Anuncios",
                blockedStatus: "Estado de Bloqueo",
                connectionTime: "Hora de Conexión",
                createdAt: "Fecha de Creación",
                updatedAt: "Fecha de Actualización",
                readStatus: "Estado de Lectura",
                missedChat: "Chat Perdido",
                answerStatus: "Estado de Respuesta",
                lastConversationStatus: "Estado de Última Conversación",
                lastTriggerState: "Estado del Último Activador",
                type: "Tipo",
                name: "Nombre",
                enterTriggerName: "Ingrese el nombre del activador...",
                zohoInfo: "Información de Zoho",
                id: "ID",
                enterContactOrLeadId: "Ingrese el ID de Contacto o Lead...",
                broadcastMessage: "Mensaje Masivo",
                today: "Hoy",
                yesterday: "Ayer",
                thisWeek: "Esta Semana",
                lastWeek: "Semana Pasada",
                last7Days: "Últimos 7 Días",
                last30Days: "Últimos 30 Días",
                thisMonth: "Este Mes",
                lastMonth: "Mes Pasado"
            },
            filterChip: {
                operator: "Operador:",
                enterText: "Ingrese texto...",
                enterNumber: "Ingrese número...",
                type: "Tipo",
                value: "Valor",
                enterValue: "Ingrese valor...",
                addFilter: "Agregar Filtro",
                equals: "Igual",
                contains: "Contiene",
                startsWith: "Comienza Con",
                endsWith: "Termina Con",
                greaterThan: "Mayor Que",
                lessThan: "Menor Que",
                greaterThanOrEqual: "Mayor o Igual Que",
                lessThanOrEqual: "Menor o Igual Que",
                between: "Entre",
                custom: "Personalizado",
                select: "Seleccionar"
            },
            filterPanel: {
                backToChat: "Volver a la Vista de Chat",
                publicFilter: "Filtro Público",
                privateFilter: "Filtro Privado",
                editFilterName: "Editar Nombre del Filtro",
                contactsFound: " contactos encontrados",
                enterFilterName: "Ingrese el nombre del filtro",
                filterSuggestions: "Sugerencias de Filtro",
                private: "Privado",
                public: "Público",
                createFilter: "Crear Filtro",
                update: "Actualizar",
                changeToPublic: "Cambiar a Público",
                changeToPrivate: "Cambiar a Privado",
                delete: "Eliminar",
                clearSearch: "Limpiar Búsqueda",
                previous: "Anterior",
                next: "Siguiente",
                searchTerm: "Término de Búsqueda:",
                whichFieldToSearch: "¿En qué campo desea buscar?",
                contactId: "ID de Contacto",
                conversationId: "ID de Conversación",
                noSearchAllFields: "No, buscar en todos los campos",
                yesSearchOnlyField: "Sí, buscar solo en {field}",
                search: "Buscar",
                allFields: "Todos los Campos",
                fullname: "Nombre completo",
                email: "Email",
                whatsappNumber: "Número de WhatsApp",
                phone: "Teléfono",
                contactIdField: "campo de ID de contacto",
                conversationIdField: "ID de Conversación",
                searchAllFieldsPlaceholder: "Ingrese lo que desea buscar en todos los campos",
                searchFullnamePlaceholder: "Ingrese lo que desea buscar por Nombre Completo",
                searchEmailPlaceholder: "Ingrese lo que desea buscar por Email",
                searchWhatsappPlaceholder: "Ingrese lo que desea buscar por WhatsApp",
                searchPhonePlaceholder: "Ingrese lo que desea buscar por Teléfono",
                searchContactIdPlaceholder: "Ingrese el ID de Contacto que desea buscar",
                searchConversationIdPlaceholder: "Ingrese el ID de Conversación que desea buscar",
                searchPlaceholder: "Buscar",
                edited: " (Editado)",
                unnamedFilter: "Filtro Sin Nombre",
                all: "Todos",
                open: "Abierto",
                closed: "Cerrado",
                unknown: "Desconocido",
                filterUpdatedSuccess: "Filtro actualizado exitosamente",
                filterUpdatedDescription: "El filtro \"{name}\" ha sido actualizado.",
                filterUpdateFailed: "No se pudo actualizar el filtro",
                filterUpdateError: "Ocurrió un error al actualizar el filtro.",
                filterSavedSuccess: "Filtro guardado exitosamente",
                filterSavedDescription: "El nombre \"{createName}\" ya estaba en uso. El filtro se creó como \"{filterName}\".",
                filterCreatedDescription: "El filtro \"{filterName}\" ha sido creado.",
                filterSaveFailed: "No se pudo guardar el filtro",
                filterSaveError: "Ocurrió un error al guardar el filtro.",
                aiFilterCreatedSuccess: "Filtro de IA creado exitosamente",
                aiFilterCreatedDescription: "El nombre \"{createName}\" ya estaba en uso. El filtro se creó como \"{filterName}\" y se aplicó.",
                aiFilterCreatedApplied: "El filtro \"{filterName}\" ha sido creado y aplicado.",
                aiFilterCreateFailed: "No se pudo crear el filtro",
                aiFilterCreateError: "Ocurrió un error al crear el filtro de IA.",
                phoneDetected: "Número de Teléfono Detectado",
                emailDetected: "Dirección de Email Detectada",
                idFormatDetected: "Formato de ID Detectado",
                contactIdDetected: "ID de Contacto Detectado",
                conversationIdDetected: "ID de Conversación Detectado",
                searchMode: "Modo de Búsqueda",
                phoneDetectedMessage: "El valor que ingresó parece ser un número de teléfono. ¿Desea buscar solo en el campo de número de teléfono?",
                emailDetectedMessage: "El valor que ingresó parece ser una dirección de correo electrónico. ¿Desea buscar solo en el campo de correo electrónico?",
                idFormatDetectedMessage: "El valor que ingresó parece ser un formato de ID. ¿En qué campo desea buscar?",
                phoneField: "campo de número de teléfono",
                emailField: "campo de correo electrónico",
                conversationIdFieldName: "campo de ID de conversación",
                idField: "campo de ID",
                deleteFilter: "Eliminar Filtro",
                deleteFilterConfirm: "¿Está seguro de que desea eliminar el filtro \"{name}\"? Esta acción no se puede deshacer.",
                cancel: "Cancelar",
                filterDeletedSuccess: "Filtro eliminado exitosamente",
                filterDeletedDescription: "El filtro \"{name}\" ha sido eliminado.",
                filterDeleteFailed: "No se pudo eliminar el filtro",
                filterDeleteError: "Ocurrió un error al eliminar el filtro.",
                visibilityUpdatedSuccess: "Visibilidad actualizada exitosamente",
                visibilityUpdatedDescription: "El filtro se ha establecido como \"{visibility}\".",
                visibilityUpdateFailed: "No se pudo actualizar la visibilidad",
                visibilityUpdateError: "Ocurrió un error al actualizar el filtro.",
                publicVisibility: "público",
                privateVisibility: "privado"
            },
            contactList: {
                noContactsFound: "No se encontraron contactos",
                unknownContact: "Contacto Desconocido",
                unknown: "Desconocido",
                fullName: "Nombre Completo",
                platform: "Plataforma",
                email: "Email",
                phone: "Teléfono",
                tags: "Etiquetas",
                status: "Estado",
                lastActivity: "Última Actividad",
                answerStatus: "Estado de Respuesta",
                channel: "Canal",
                owner: "Propietario",
                vip: "VIP",
                connectionTime: "Hora de Conexión",
                unread: "No Leído",
                departments: "Departamentos",
                operatingSystem: "Sistema Operativo",
                browser: "Navegador",
                countryCity: "País - Ciudad",
                ipAddress: "Dirección IP",
                visitingPage: "Página Visitada",
                lastConversationDate: "Fecha de Última Conversación",
                blockedStatus: "Estado de Bloqueo",
                lastConversationParticipants: "Participantes de Última Conversación",
                preferredLanguage: "Idioma Preferido",
                createdAt: "Fecha de Creación",
                updatedAt: "Fecha de Actualización",
                broadcastStatus: "Estado de Broadcast",
                broadcastAnswer: "Respuesta de Broadcast",
                zohoContactId: "ID de Contacto Zoho",
                zohoLeadId: "ID de Lead Zoho",
                profileFields: "Campos de Perfil",
                closed: "Cerrado",
                open: "Abierto",
                unknownStatus: "Desconocido",
                answered: "Respondido",
                unanswered: "Sin Respuesta",
                unreadStatus: "No Leído",
                readStatus: "Leído",
                vipStatus: "VIP",
                normal: "Normal",
                blocked: "Bloqueado",
                today: "Hoy",
                yesterday: "Ayer",
                enqueued: "En Cola",
                sent: "Enviado",
                delivered: "Entregado",
                read: "Leído",
                deleted: "Eliminado",
                failed: "Fallido",
                replied: "Respondido",
                notReplied: "No Respondido",
                jsonProperty: "Propiedad JSON",
                jsonCopiedSuccess: "¡Contenido JSON copiado exitosamente!"
            }
        },
        form: {
            title: {
                titleSettings: "Configuración de título",
                fullNameSettings: "Configuración de nombre completo",
                emailSettings: "Configuración de correo electrónico",
                addressSettings: "Configuración de dirección",
                phoneSettings: "Configuración de teléfono",
                datePickerSettings: "Configuración del selector de fecha",
                shortTextSettings: "Configuración de texto corto",
                longTextSettings: "Configuración de texto largo",
                dropDownListSettings: "Configuración de lista desplegable",
                singleChoiceSettings: "Configuración de selección única",
                multipleSelectionSettings: "Configuración de selección múltiple",
                numberSettings: "Configuración de números",
                hourSettings: "Configuración de hora",
                spinnerSettings: "Configuración de spinner",
                sendSettings: "Configuración de envío",
                starRatingSettings: "Configuración de calificación por estrellas",
                ratingScaleSettings: "Configuración de escala de calificación",
                separationElementSettings: "Configuración de elemento de separación",
                fileUploadSettings: "Configuración de carga de archivos",
                imageSettings: "Configuración de imagen"
            },
            lineColor: "Color de la línea",
            separatorColorInfo: "Seleccione o ingrese el color del separador (por ejemplo, #RRGGBB)",
            separatorHeight: "Altura del separador",
            separatorHeightInfo: "Ingrese la altura del separador",
            bottomSpace: "Espacio inferior",
            bottomSpaceInfo: "Agregue espacio debajo del separador",
            topSpace: "Espacio superior",
            topSpaceInfo: "Agregue espacio por encima del separador",
            sideSpace: "Espacio lateral",
            sideSpaceInfo: "Agregue espacio a la izquierda y derecha del separador",
            onlyImageUpload: "¡Solo puedes cargar una imagen!",
            imageSizeLimit: "¡El tamaño de tu imagen no debe exceder los 5MB!",
            image: "Imagen",
            size: "Tamaño",
            width: "Ancho",
            height: "Altura",
            imageAlignment: "Alineación de la imagen",
            wide: "Ancho",
            small: "Pequeño",
            textAlignment: "Alineación de texto",
            chooseHorizontalAlignment: "Elija cómo alinear este título horizontalmente.",
            headerSize: "Tamaño del encabezado",
            addSmallTextBelowHeader: "Agregue un texto más pequeño debajo del encabezado",
            subHeaderText: "Texto del subtítulo",
            subLabel1: "Subetiqueta(1)",
            subLabel2: "Subetiqueta(2)",
            validPhoneNumber: "Por favor, ingrese un número de teléfono válido",
            masked: "Enmascarado",
            copyField: "Copiar campo",
            copyFieldDescription: "Cree una copia de este campo manteniendo todos sus ajustes guardados",
            enterQuestion: "Ingresa una pregunta",
            notRequired: "No requerido",
            addDescriptionBelowField: "Agregue una breve descripción debajo del campo",
            setDefault: "Establecer como predeterminado",
            pleaseSelect: "Por favor seleccione",
            placeholder: "Marcador de posición",
            required: "Obligatorio",
            fieldEmptyError: "No permita que se envíe el formulario si este campo está vacío",
            subLabels: "Subetiquetas",
            addressLine1: "Línea de dirección 1",
            addressLine2: "Línea de dirección 2",
            postalCode: "Código postal",
            stateProvince: "Estado / Provincia",
            chooseLabelAlignment: "Elija cómo alinear el texto de la etiqueta horizontalmente",
            right: "DERECHA",
            left: "IZQUIERDA",
            top: "ARRIBA",
            labelAlignment: "Alineación de etiqueta",
            fieldLabel: "Etiqueta de campo",
            read: "Leído",
            itemsPerPage: "elementos/página",
            downloadAllDataAsPDF: "Descargar todos los datos como PDF",
            downloadAllDataAsExcel: "Descargar todos los datos como Excel",
            downloadSelectedDataAsPDF: "Descargar los datos seleccionados como PDF",
            downloadSelectedDataAsExcel: "Descargar los datos seleccionados como Excel",
            selectItemToViewDetails: "Seleccione un elemento para ver detalles.",
            deleteFormConfirm: "Si elimina este formulario, todos los datos asociados se eliminarán permanentemente. ¿Está seguro de que desea continuar?",
            redicetFormAnswer: "REDIRIGIR RESPUESTAS DE FORMULARIO",
            redicetFormAnswerDesc: "Al redirigir respuestas de formularios al sistema de tickets, asegúrese de solicitar un número de teléfono o una dirección de correo electrónico del usuario en el formulario. Esta información es importante para una comunicación más rápida y eficaz con el usuario.",
            redicetFormAnswerDesc2: "Las respuestas al formulario se dirigen al sistema como tickets.",
            rediectAnswersToTicket: "Redirige las respuestas entrantes a un ticket.",
            errorTicketMode: "Error al actualizar el modo de ticket:",
            formView: "Ver formulario",
            formEdit: "Formulario de actualización",
            totalResponse: "Respuesta total",
            totalUnreadResponse: "Total de respuestas no leídas",
            totalReadResponse: "Respuesta de lectura total",
            totalArchivedResponse: "Total de respuestas archivadas",
            singleChoice: "Opción única",
            _delete: "Borrar",
            inbox: "Bandeja de entrada",
            edit: "Editar",
            forms: "Formularios",
            formsDesc: "Aquí puede gestionar sus formularios.",
            createaForm: "crear formulario",
            allForms: "todas las formas",
            formPublish: {
                shareFast: "COMPARTIR RÁPIDO",
                shareFastDesc: "Enlace directo al formulario y uso compartido en redes sociales",
                add: "AÑADE",
                addDesc: "Varias opciones de incrustación en páginas web",
                assignForm: "FORMULARIO DE ASIGNACIÓN",
                assignFormDesc: "Asigne sus formularios a otras personas",
                emails: "CORREOS ELECTRÓNICOS",
                emailsDesc: "Recordatorios y uso compartido instantáneo",
                prefill: "PREFILL",
                prefillDesc: "Rellene previamente sus formularios",
                pdf: "PDF",
                pdfDesc: "Descargar PDF rellenable",
                platforms: "PLATAFORMAS",
                platformsDesc: "Opciones de publicación de terceros",
                linkToYour: "DIRECCIÓN DE ENLACE DE SU FORMULARIO",
                linkToYourDesc: "Su formulario se ha publicado de forma segura y está listo para su uso en esta dirección.",
                shareWithLink: "COMPARTIR CON ENLACE",
                publicForm: "Formulario público",
                copyLink: "COPIAR ENLACE",
                openInNewTab: "ABRIR EN NUEVA PESTAÑA",
                linkCopied: "Enlace copiado",
                codeCopied: "Código copiado",
                iframe: "IFRAME",
                iframeDesc: "Añade el formulario a tu página con iFrame",
                openWindow: "VENTANA ABIERTA",
                openWindowDesc: "Enlace a un formulario emergente",
                formAddDesc: "Copie y pegue este fragmento en su código y coloque el formulario en su sitio web."
            },
            formSettings: {
                enterNameForm: "Introduzca un nombre para este formulario",
                selectStatusForm: "Seleccione el estado de su formulario",
                disabled: "Discapacitados",
                disableSpecifiedTime: "Desactivar a una hora determinada",
                disableFormResponse: "Desactivar cuando se alcanza el límite de respuesta del formulario",
                pageShownAfterForm: "La página que aparece después de enviar el formulario",
                formNotFound: "Formulario no encontrado.",
                errorLoadingform: "Se ha producido un error al cargar el formulario.",
                formUpdated: "El título del formulario se ha actualizado correctamente.",
                formErrorUpdated: "Se ha producido un error al actualizar el título del formulario",
                formSettings: "CONFIGURACIÓN DE FORMULARIOS",
                changeFormStateAndProperties: "Cambiar el estado y las propiedades del formulario",
                title: "Título",
                newFormSettings: "Nueva configuración del formulario",
                formStatus: "Estado del formulario",
                activateOrDeactivate: "Activar, desactivar o activar condicionalmente su formulario",
                effective: "EFFECTIVO",
                yourFromIsVisible: "Su formulario es ahora visible y puede recibir respuestas.",
                emails: "CORREOS ELECTRÓNICOS",
                emailsDesc: "Enviar correos electrónicos de autorespuesta y correos electrónicos de notificación",
                conditions: "CONDICIONES",
                conditionsDesc: "Sección de lógica condicional que desencadena acciones en función de las entradas del formulario",
                thankYouPage: "PÁGINA DE AGRADECIMIENTO",
                thankYouPageDesc: "La página que aparece después de enviar el formulario",
                integretions: "Conecte su formulario a otras aplicaciones",
                integretionsDesc: "Connecter votre formulaire à d'autres applications"
            },
            clickToDeleteYourLogo: "Haga clic para eliminar su logotipo",
            create: "Cree",
            settings: "Ajustes",
            load: "Carga",
            insertFormField: "Insertar campo de formulario",
            addYourLogo: "Añada su logotipo",
            surveyElements: {
                surveyElements: "Elementos de la encuesta",
                dataTable: "Tabla de datos",
                starRating: "Clasificación por estrellas",
                evaluationScale: "Escala de evaluación"
            },
            pageElements: {
                pageElements: "Elementos de la página",
                separationElement: "Elemento de separación",
                partitionCollapse: "Colapso de la partición",
                pageBreak: "Fin de la página"
            },
            basicElements: {
                basicElements: "Elementos básicos",
                shortText: "Texto Corto",
                longText: "Texto Largo",
                paragraph: "Paragrapth",
                dropDownList: "Lista desplegable",
                singleChoice: "Signle Cohice",
                multipleSelection: "Selección Múltiple",
                number: "Número",
                image: "İmage",
                fileUpload: "Carga de archivos",
                hour: "Hora",
                spinner: "Spinner",
                send: "Enviar"
            },
            formElements: {
                formElements: "Elementos de formulario",
                title: "Título",
                fullName: "Nombre y apellidos",
                email: "Correo electrónico",
                address: "Dirección",
                phone: "Teléfono",
                datePicker: "Selector de fecha",
                appointment: "Cita previa",
                signature: "Firma",
                productList: "Lista de productos"
            },
            startWithaBlankForm: "empezar con un formulario en blanco",
            startFromScratch: "Empezar de cero",
            createOrTransferaForm: "Crear o transferir un formulario para iniciar la recogida de datos",
            createForm: "Crear formulario",
            trashBin: "Papelera",
            formAutomations: "Automatizaciones de formularios",
            trashBinList: {
                title: "Papelera",
                description: "Sus formularios eliminados se muestran aquí",
                loading: "Cargando formularios eliminados...",
                restore: "Restaurar",
                permanentDelete: "Eliminar permanentemente",
                delete: "Eliminar",
                emptyTitle: "La papelera está vacía",
                emptyDescription: "No se encontraron formularios eliminados",
                totalResponses: "Total de respuestas",
                unread: "No leído",
                read: "Leído",
                archived: "Archivado",
                restoreConfirmDescription: "¿Está seguro de que desea restaurar este formulario? El formulario y todos sus datos se agregarán a la lista de formularios activos.",
                deleteConfirmDescription: "¿Está seguro de que desea eliminar permanentemente este formulario? Esta acción no se puede deshacer y se eliminarán todos los datos asociados con el formulario.",
                deletedToday: "Eliminado hoy",
                deletedYesterday: "Eliminado ayer",
                deletedDaysAgo: "Eliminado hace {count} días",
                deletedWeeksAgo: "Eliminado hace {weeks} semanas",
                deletedMonthsAgo: "Eliminado hace {months} meses",
                restoreSuccess: "Formulario restaurado correctamente",
                restoreError: "Ocurrió un error al restaurar el formulario",
                deleteSuccess: "Formulario eliminado permanentemente",
                deleteError: "Ocurrió un error al eliminar el formulario"
            }
        },
        automation: {
            deleteAutomationsTitle: "Eliminar Automatizaciones",
            deleteAutomationsConfirmation: "¿Estás seguro de que quieres eliminar {count} automatizaciones? Esta acción no se puede deshacer.",
            automationsMoveError: "Error al mover las automatizaciones",
            noAutomationToMove: "No se encontró automatización para mover",
            deleteCategoryConfirmation: "¿Estás seguro de que quieres eliminar la categoría \"{categoryName}\"? Las automatizaciones de esta categoría se moverán a la categoría \"{generalCategory}\".",
            automationsMovedToCategory: "{count} automatizaciones movidas a la categoría \"{categoryName}\"",
            automationImportedSuccessfully: "Automatización {name} importada con éxito",
            automationPasteError: "Error al pegar la automatización",
            invalidAutomationExport: "No se encontró una exportación válida de automatización Supsis en el portapapeles",
            invalidAutomationJSON: "No se encontró un JSON de automatización válido en el portapapeles",
            clipboardNotSupported: "El acceso al portapapeles no es compatible con este navegador",
            automationJSONCopyError: "Error al copiar la automatización",
            automationCopiedToClipboardFallback: "Automatización copiada al portapapeles como JSON (método alternativo)",
            automationCopiedToClipboard: "Automatización copiada al portapapeles como JSON. Puedes pegarla con Ctrl+V en otro panel de cliente.",
            automationCopyError: "Error al copiar la automatización",
            automationCopied: "Automatización copiada",
            automationMoveError: "Error al mover la automatización",
            automationMovedToCategory: "Automatización movida a la categoría \"{categoryName}\"",
            categoryDeletedSuccessfully: "Categoría eliminada con éxito",
            categoryDeleteError: "Error al eliminar la categoría",
            automationsDeleteError: "Error al eliminar las automatizaciones",
            automationsDeletedSuccessfully: "Automatizaciones borradas correctamente",
            categoryUpdatedSuccessfully: "Categoría actualizada",
            categoryUpdateError: "Error al actualizar la categoría",
            categorySaveError: "Error al guardar la categoría",
            categoryCreatedSuccessfully: "Categoría creada. Puedes arrastrar automatizaciones a esta categoría.",
            categoryNameAlreadyExists: "Ya existe una categoría con este nombre",
            categoryNameRequired: "El nombre de la categoría no puede estar vacío",
            moveAllAutomations: "Mover Todas las Automatizaciones",
            deleteAutomations: "{count} automatizaciones eliminadas",
            selectedAutomations: "{count} automatizaciones seleccionadas",
            pasteInfoMessage: "¡Se detectó automatización copiada en el portapapeles! Crea una nueva automatización pegándola inmediatamente con <strong>Ctrl+V</strong>.",
            categoryName: "Nombre de Categoría",
            categoryNamePlaceholder: "Ingresa el nombre de la categoría",
            editCategory: "Editar Categoría",
            deleteCategory: "Eliminar Categoría",
            createCategory: "Agregar Categoría",
            publishAutomation: "Publicado",
            unpublishAutomation: "Detenido",
            timerAutomation: "Programado",
            eventAutomation: "Evento",
            deleteAutomation: "Eliminar Automatización",
            changeCategory: "Cambiar Categoría",
            copyAutomation: "Copiar Automatización",
            copyAutomationAsJSON: "Copiar como JSON",
            emptyCategoryMessage: "Puedes agregar automatizaciones a la categoría arrastrándolas aquí",
            whenFormSubmitted: "Cuando se envía un formulario",
            taskCreated2: "Tarea creada",
            waitingTaskCreation: "Esperando la creación de la tarea...",
            calendarEventCreated: "Evento creado en el calendario",
            calendarEventUpdated: "Evento actualizado en el calendario",
            calendarEventDeleted: "Evento eliminado del calendario",
            reservationCreated: "Reserva creada",
            reservationDateChanged: "Fecha de reserva cambiada",
            reservationDeleted: "Reserva eliminada",
            chatLost: "Cuando se pierde el chat",
            webchatCompleted: "Cuando se completa el chat web",
            instagramCompleted: "Cuando se completa el chat del canal de Instagram",
            messengerCompleted: "Cuando se completa el chat del canal de Messenger",
            whatsappCompleted: "Cuando se completa el chat del canal de WhatsApp",
            telegramCompleted: "Cuando se completa el chat del canal de Telegram",
            chatAssignedToAgent: "Cuando el chat se asigna a un agente",
            profileButtonClicked: "Cuando se hace clic en el botón de automatización desde el perfil",
            operatedTask: "Tarea que se está ejecutando",
            tableSelection: "Selección de tabla",
            selectTable: "Seleccionar Tabla",
            whichTableAutomationAddRecords: "¿Qué tabla quieres que ejecute la automatización cuando se añada un registro? Por favor, selecciona",
            whichTableAutomationUpdateRecords: "¿Desea ejecutar la automatización cuando se actualice un registro en qué tabla? Por favor, seleccione",
            whichTableAutomationDeletedRecords: "¿Desde qué tabla desea ejecutar la automatización cuando se elimine un registro? Por favor, seleccione",
            whichTableAutomationClickRecords: "¿En qué tabla desea ejecutar la automatización cuando se haga clic en el botón de automatización de un registro? Por favor, seleccione",
            selectAtLeastOneField: "Se debe seleccionar al menos un campo",
            generalCategory: "General",
            configureTrackFields: "Configurar campos de seguimiento",
            configureMessageFilter: "Configurar filtro de mensajes",
            makeFreeTier: "Hacer gratuito",
            revertFreeTier: "Revertir a nivel normal",
            webhook: "Webhook",
            system: "Sistema",
            freeTierTooltip: "Esta automatización está en el nivel gratuito. El uso no se deducirá de su cuota.",
            freeTierBadge: "Nivel gratuito",
            trackFieldsLabel: "Campos a seguir",
            trackFieldsSelectPlaceholder: "Si no se selecciona ningún campo, se seguirán todos los campos",
            selectFieldPlaceholder: "Seleccionar campo",
            tableMustBeSelectedFirst: "Primero se debe seleccionar la tabla para la automatización",
            fieldsLoadError: "Error al cargar los campos",
            trackFieldsUpdated: "Campos de seguimiento actualizados",
            updateError: "Error durante la actualización",
            automationMadeFreeTier: "Automatización establecida como nivel gratuito",
            makeFreeTierError: "Error al establecer nivel gratuito",
            automationRevertedToNormalTier: "Automatización revertida a nivel normal",
            revertFreeTierError: "Error al revertir a nivel normal",
            wrongPassword: "¡Contraseña incorrecta!",
            configLoadError: "Error al cargar la configuración",
            messageFilterConfigUpdated: "Configuración del filtro de mensajes actualizada",
            freeTierPasswordPrompt: "Introduzca la contraseña para hacer gratuito:",
            configurePreFilters: "Configurar prefiltros",
            configureExecutionPrivacy: "Configurar permiso de ejecución",
            editDescription: "Editar descripción",
            permissions: {
                title: "Permisos de acceso",
                mode: "Modo de permisos",
                publicMode: "Público",
                customMode: "Personalizado",
                publicModeDesc: "Todos los usuarios pueden acceder y editar esta automatización.",
                customModeDesc: "Solo los usuarios y departamentos especificados pueden acceder a esta automatización.",
                confirmPublicMode: "Cambiar a modo público",
                confirmPublicModeDesc: "Después de esta operación, todos los usuarios podrán acceder a esta automatización. ¿Desea continuar?",
                addUser: "Añadir usuario",
                addDepartment: "Añadir departamento",
                selectUser: "Seleccionar usuario",
                selectDepartment: "Seleccionar departamento",
                add: "Añadir",
                targetHeader: "Usuario/Departamento",
                matrixInfo: "Seleccione los permisos que desea conceder a cada usuario o departamento.",
                noTargetsAdded: "Aún no se han añadido usuarios ni departamentos. Añada uno arriba para conceder permisos.",
                confirmRemoveTarget: "Quitar permiso",
                confirmRemoveTargetDesc: "¿Está seguro de que desea quitar los permisos de este usuario o departamento?",
                saveSuccess: "Permisos de acceso guardados correctamente",
                saveError: "Se produjo un error al guardar los permisos de acceso",
                unknownUser: "Usuario desconocido",
                unknownDepartment: "Departamento desconocido",
                noReadAccess: "No tiene acceso a esta automatización.",
                usersTab: "Usuarios",
                departmentsTab: "Departamentos",
                authorizedUsers: "Usuarios autorizados",
                otherUsers: "Otros usuarios",
                authorizedDepartments: "Departamentos autorizados",
                otherDepartments: "Otros departamentos",
                cannotChangeOwnPermission: "No puede cambiar su propio permiso",
                you: "Usted",
                customPermissionDefined: "Permiso personalizado definido para este usuario",
                customPermission: "Permiso personalizado",
                grantPermission: "Conceder permiso",
                revokePermission: "Quitar permiso",
                applyToOthers: "Aplicar a otras automatizaciones",
                applyToOthersDesc: "Aplicar esta configuración de permisos a otras automatizaciones que seleccione",
                applyToOthersTitle: "Aplicar configuración de permisos a otras automatizaciones",
                applyToOthersWarning: "La configuración de permisos existente de las automatizaciones seleccionadas será reemplazada por la de esta automatización.",
                selectAll: "Seleccionar todo",
                selectedCount: "{count} automatizaciones seleccionadas",
                applyToSelected: "Aplicar a seleccionados",
                noAutomationsFound: "No se encontraron automatizaciones",
                searchPlaceholder: "Buscar automatización o categoría...",
                applySuccess: "Configuración de permisos aplicada a {count} automatizaciones correctamente",
                applyFailed: "Error al aplicar la configuración de permisos a {count} automatizaciones",
                applyError: "Error al aplicar la configuración de permisos",
                groups: {
                    basic: "Básico",
                    flow: "Flujo",
                    meta: "Info",
                    publish: "Publicar",
                    actions: "Acciones",
                    plan: "Plan",
                    filter: "Filtro"
                },
                scopes: {
                    read: "Ver",
                    readDesc: "Permiso para ver la automatización",
                    flowUpdate: "Editar flujo",
                    flowUpdateDesc: "Permiso para añadir, eliminar y editar bloques de automatización",
                    metaUpdate: "Editar info",
                    metaUpdateDesc: "Permiso para editar nombre, descripción y categoría de la automatización",
                    publish: "Publicar",
                    publishDesc: "Permiso para publicar y despublicar la automatización",
                    delete: "Eliminar",
                    deleteDesc: "Permiso para eliminar la automatización",
                    duplicate: "Duplicar",
                    duplicateDesc: "Permiso para duplicar la automatización",
                    planView: "Ver planes",
                    planViewDesc: "Permiso para ver los planes de ejecución de la automatización",
                    planCancel: "Cancelar plan",
                    planCancelDesc: "Permiso para cancelar planes programados",
                    reschedule: "Reprogramar",
                    rescheduleDesc: "Permiso para reprogramar la automatización",
                    prefilterUpdate: "Editar filtro",
                    prefilterUpdateDesc: "Permiso para editar la configuración del prefiltro"
                }
            },
            planStatus: "Estado del plan",
            scheduled: "Programado",
            completed: "Completado",
            cancelado: "Cancelado",
            startTest: "Iniciar prueba",
            unpublish: "Anular publicación",
            whenMessagePicked: "Cuando se selecciona un mensaje a través de la interfaz de chat",
            whenTaskCompleted: "Cuando se completa una tarea",
            whenTaskDeleted: "Cuando se elimina una tarea",
            whenTaskAssigneeChanged: "Cuando se cambia el asignatario de una tarea",
            whenTaskPriorityChanged: "Cuando se cambia la prioridad de una tarea",
            whenTaskDueDateChanged: "Cuando se cambia la fecha de vencimiento de una tarea",
            whenTaskStatusChanged: "Cuando se cambia el estado de una tarea",
            whenTaskArchived: "Cuando se archiva una tarea",
            whenTagAdded: "Cuando se añade una etiqueta a la tarea",
            whenTagRemovedTask: "Cuando se elimina una etiqueta de una tarea",
            whenTagChecklist: "Cuando se completa una lista de comprobación de una tarea",
            whenReminderActivated: "Cuando se activa un recordatorio",
            whenTicketCreated: "Cuando se crea un ticket",
            whenTicketStageChanged: "Cuando se cambia la etapa de un ticket",
            whenTicketAssigneeChanged: "Cuando se cambia el asignatario de un ticket",
            whenTicketClosed: "Cuando se cierra un ticket",
            whenTicketUpdated: "Cuando se actualiza un ticket",
            autoPlanAndTaskHistory: "Plan de automatización e historial de tareas",
            automation: "Automatización",
            botScenario: "Escenario Bot",
            nameSurname: "NombreApellido",
            phone164: "*Introducir en formato E164. Por ejemplo: 905396667744",
            whichWpChannels: "¿Qué canales de Whatsapp añadir?",
            findContact: "Buscar contacto",
            findContacts: "Buscar contactos",
            offsetDesc: "Saltar los N primeros contactos. El valor por defecto es '0'. Utilícelo para desplazarse por los contactos",
            limitDesc: "Número máximo de contactos a devolver después de offset. El valor por defecto es '10'. Utilícelo para paginar",
            contact: "Contacto",
            selectAction: "Seleccionar acción",
            addMethod: "Añadir método",
            selectField: "Seleccionar campo",
            schedulerRunningPlanEx: "Ejemplo de plan de ejecución del planificador",
            schedulerPlanner: "Planificador del Planificador",
            taskCreated: "¿Tarea creada?",
            taskStatus: "Estado de la tarea",
            terminateReason: "Motivo de terminación",
            taskDuration: "Duración de la tarea",
            taskWakeUpCount: "Recuento de tareas activadas",
            completedAt: "Completado",
            cancelledAt: "Cancelado",
            nextRunAt: "Próxima ejecución",
            configSchedulerAuto: "Configurar temporizador para automatización",
            saveChanges: "Guardar cambios",
            catchAllWebhooks: "Capturar todos los Webhooks de esta URL",
            webhookDataExPreview: "Webhook Data Sample Preview (se mostrará después de enviar la petición)",
            webhookUrlCopied: "URL del Webhook copiada al portapapeles",
            selectAnBlock: "Selecciona un bloque",
            dataFormats: "Formatos de datos",
            whenRecordCreated: "Cuando se crea un registro",
            whenRecordUpdated: "Cuando se actualiza un registro",
            whenRecordDelete: "Cuando se elimina un registro",
            whenRecordAutomation: "Cuando se pulsa un botón de automatización de un registro",
            whenWebhookTriggered: "Cuando se activa un webhook",
            whenChatCreated: "Cuando se crea un chat",
            whenChatClosed: "Cuando se cierra un chat",
            whenChatRated: "Cuando se valora un chat",
            whenNewContactCreated: "Cuando se crea un nuevo contacto",
            whenContactUpdate: "Cuando se actualiza un contacto",
            whenContactPropUpdate: "Cuando se actualiza una propiedad de un contacto",
            whenNewTagAdded: "Cuando se añade una nueva etiqueta",
            whenTagRemoved: "Cuando se elimina una etiqueta",
            whenNewEmailReceived: "Cuando se recibe un nuevo correo electrónico",
            whenNewTaskCreated: "Cuando se crea una nueva tarea",
            whenNewMetaleadCreated: "Cuando se crea un nuevo meta-lead",
            whenNewAgentCreated: "Cuando se crea un nuevo agente",
            whenAgentOnline: "Cuando un agente se conecta",
            whenAgentOffline: "Cuando un agente se desconecta",
            whenAgentStatusChanged: "Cuando cambia el estado de un agente",
            whenAgentLogin: "Cuando un agente inicia sesión",
            whenNewInvoiceCreated: "Cuando se crea una nueva factura",
            whenNewWpReceived: "Cuando se recibe un nuevo mensaje de WhatsApp",
            whenNewReservationCreated: "Cuando se crea una nueva reserva",
            whenNewChatbotReceived: "Cuando se recibe un nuevo mensaje de chatbot",
            chatWebhookAutomation: "Capturar un Webhook y ejecutar una automatización",
            automationName: "Nombre de automatización",
            supsisObject: "Objeto Supsis",
            selectModule: "Modelo de selección",
            bodyType: "Tipo de cuerpo",
            selectBodyType: "Seleccionar tipo de cuerpo",
            selectMethod: "Seleccionar método",
            trigger: "Disparador",
            published: "Publicado",
            createdAt: "Creado en",
            action: "Acción",
            type: "Tipo",
            view: "Ver",
            createTimerAutomation: "Crear automatización de temporizador",
            createEventBasedAutomation: "Crear automatización basada en eventos",
            createWebhookAutomation: "Crear automatización Webhook",
            automationsCouldNotBeDeleted: "Las automatizaciones no se pueden borrar",
            timerAutomationCreatedSuccessfully: "Automatización de temporizador creada con éxito",
            eventAutomationCreatedSuccessfully: "Automatisation d'un événement créé avec succès",
            webhookAutomationCreatedSuccessfully: "Automatización Webhook Creada con Éxito",
            automationsCouldNotBeFetched: "No se han podido recuperar las automatizaciones",
            automationPublishedStateUpdatedSuccessfully: "Automatización Estado Publicado Actualizado con Éxito",
            automations: "Automatizaciones",
            allAutomations: "Todas las automatizaciones",
            scheduledAutomations: "Automatizaciones programadas",
            eventBasedAutomations: "Automatizaciones basadas en eventos",
            buttonAutomations: "Automatizaciones de botón",
            webhookAutomations: "Automatizaciones de webhook",
            analytics: "Analíticas",
            insights: "Perspectivas",
            trash: "Papelera",
            sandboxPage: {
                title: "Escenarios de automatización eliminados",
                description: "Las automatizaciones no restauradas serán eliminadas permanentemente por el sistema en 30 días",
                emptyState: "No hay automatizaciones eliminadas en la papelera",
                unnamedAutomation: "Automatización sin título",
                restore: "Restaurar",
                timerAutomation: "Automatización por temporizador",
                eventAutomation: "Automatización por evento",
                webhook: "Webhook",
                buttonAutomation: "Automatización por botón",
                tableButtonAutomation: "Automatización por botón de tabla",
                chatbotAutomation: "Automatización de chatbot",
                unknown: "Desconocido",
                user: "Usuario",
                restoreConfirmTitle: "¿Está seguro de que desea restaurar esta automatización?",
                restoreConfirmContent: "La automatización {name} será restaurada.",
                restoreSuccess: "Automatización restaurada",
                restoreFailed: "Error al restaurar",
                loadError: "Error al cargar las automatizaciones eliminadas"
            },
            insightsPage: {
                title: "Estadísticas de automatización",
                selectAutomation: "Seleccionar automatización",
                dateRange: "Rango de fechas",
                datePlaceholderStart: "Inicio",
                datePlaceholderEnd: "Fin",
                lastWeek: "Última semana",
                lastMonth: "Último mes",
                last3Months: "Últimos 3 meses",
                statusFilter: "Filtro de estado",
                statusScheduled: "Programado",
                statusRunning: "En ejecución",
                statusWaitingReply: "Esperando respuesta",
                statusDone: "Completado",
                statusFailed: "Fallido",
                statusCancelled: "Cancelado",
                clearFilters: "Limpiar filtros",
                refreshData: "Actualizar datos",
                activeFilters: "Filtros activos:",
                totalTasks: "Total de tareas",
                executedTasks: "Tareas ejecutadas",
                successRate: "Tasa de éxito",
                successfulTasks: "Tareas exitosas",
                avgDuration: "Duración promedio",
                avgWorkDuration: "Duración promedio de trabajo",
                activeTasks: "Tareas activas",
                runningNow: "En ejecución ahora",
                dailyTaskExecution: "Ejecución diaria de tareas",
                statusDistribution: "Distribución de estado",
                durationDistribution: "Distribución de duración",
                terminateReasons: "Razones de finalización",
                automationPerformance: "Rendimiento de automatización",
                view: "Ver",
                automationName: "Nombre de automatización",
                executionCount: "Número de ejecuciones",
                actions: "Acciones",
                totalTasksLegend: "Total de tareas",
                successfulLegend: "Exitoso",
                failedLegend: "Fallido",
                taskCount: "Número de tareas",
                ms: "ms",
                sec: "seg",
                min: "min",
                hour: "h",
                automationsLoadError: "Error al cargar las automatizaciones",
                insightsLoadError: "Error al cargar las estadísticas"
            },
            settingsWidget: {
                viewActivityLogs: "Ver registros de actividad",
                activityLogsTitle: "Registros de actividad",
                activityLogsEmpty: "Aún no hay registros de actividad",
                activityLogsLoadError: "Error al cargar los registros de actividad",
                exportedToClipboard: "Automatización exportada al portapapeles",
                settings: "Configuración"
            },
            blocks: {
                ASSIGN_OWNER: "Asignar Propietario",
                autoForwardToOwnerForce: "Reenvío automático al propietario (incluso con chatbot activo)",
                SHOW_WIDGET: "Mostrar widget",
                REPLY_TRENDYOL_QUESTION: "Responder pregunta de Trendyol",
                PUNTO_INICIO: "PUNTO DE INICIO",
                AI_ASSISTANT: "ASISTENTE AI",
                BOT_RESPONSE: "RESPUESTA BOT",
                AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
                AI_CLASSIFICATION: "CLASIFICACIÓN AI",
                AI_MENU_FLOW: "MENÚ AI",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMENTARIO",
                PLATFORM_FLOW: "PLATAFORMA",
                DEFAULT_FALLBACK: "FALLBACK POR DEFECTO",
                DEFAULT_TIMEOUT: "TIEMPO DE ESPERA POR DEFECTO",
                AI_FUNCTIONS: "FUNCIONES AI",
                FILTER: "FILTRO",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "ENTRADA DE ARCHIVOS ADJUNTOS",
                USER_INPUT: "ENTRADA DE USUARIO",
                GO_TO_STEP: "IR AL PASO",
                WEBHOOK: "WEBHOOK",
                SET_ATTRIBUTE: "ESTABLECER ATRIBUTO",
                QUESTION: "PREGUNTA",
                CLOSE_CHAT: "CERRAR CHAT",
                CREATE_TICKET: "CREAR TICKET",
                TRANSFER_CHAT: "TRANSFERIR CHAT",
                TRANSFER_TO_CHATBOT: "TRANSFERIR A CHATBOT",
                TAG_CHAT: "AÑADIR ETIQUETA",
                REMOVE_TAG: "ELIMINAR ETIQUETA",
                SET_DEPARTMENT: "ESTABLECER DEPARTAMENTO",
                SEND_TRANSCRIPT: "ENVIAR TRANSCRIPCIÓN",
                SEND_SMS: "ENVIAR SMS",
                SEND_MAIL: "ENVIAR SMS",
                CREATE_EVENT: "CREAR EVENTO",
                CREATE_RESERVATION: "CREAR RESERVA",
                RESERVATION_OPEN_URL: "URL DE APERTURA DE RESERVA",
                RESERVATION_SELECT_DAY: "SELECCIONAR DÍA DE RESERVA",
                RESERVATION_EVENT_LIST: "VISITANTE DE LISTA DE RESERVA",
                RESERVATION_SELECT_TIME: "SELECCIONAR HORA DE RESERVA",
                CREATE_TASK: "CREAR TAREA",
                SHOPIFY_SHOW_PRODUCTS: "MOSTRAR PRODUCTOS DE SHOPIFY",
                SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY DISPONIBILIDAD DEL PRODUCTO",
                SHOPIFY_ORDER_STATUS: "SHOPIFY ESTADO DEL PEDIDO",
                AKINON_SHOW_PRODUCTS: "MOSTRAR PRODUCTOS DE AKINON",
                AKINON_FIND_PRODUCT: "AKINON ENCONTRAR PRODUCTO",
                AKINON_ORDER_STATUS: "AKINON ESTADO DEL PEDIDO",
                AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
                AKINON_SELECT_SIZE: "AKINON SELECCIONAR TALLA",
                AKINON_FIND_NEAREST_STOCK: "MOSTRAR STOCK DE LA TIENDA",
                AKINON_FIND_NEAREST_STORES: "MOSTRAR TIENDAS MÁS CERCANAS",
                AKINON_SHOW_DISCOUNT_CODES: "MOSTRAR CÓDIGOS DE DESCUENTO",
                SUPPRESSION_ADD: "BLOQUEAR CONTACTO",
                SUPPRESSION_REMOVE: "DESBLOQUEAR CONTACTO",
                IDEASOFT_SELECT_ORDER: "SELECCIONAR PEDIDO",
                IDEASOFT_ORDER_STATUS: "OBTENER EL ESTADO DEL PEDIDO",
                IDEASOFT_GET_MEMBER_INFO: "RELLENAR INFORMACIÓN DE MIEMBRO",
                TICKET_UPDATE: "ACTUALIZACIÓN DE ENTRADAS",
                TSOFT_SELECT_ORDER: "SELECCIONAR PEDIDO",
                TSOFT_ORDER_STATUS: "OBTENER EL ESTADO DEL PEDIDO",
                TICIMAX_V2_SELECT_ORDER: "SELECCIONAR PEDIDO",
                TICIMAX_V2_ORDER_STATUS: "OBTENER EL ESTADO DEL PEDIDO",
                IKAS_GET_MEMBER_INFO: "Obtener detalles del miembro",
                IKAS_SELECT_ORDER: "Seleccionar pedido",
                IKAS_ORDER_STATUS: "Obtener estado del pedido",
                GET_LOCATION: "OBTENER UBICACIÓN",
                FALLBACK: "FALLBACK",
                TIMEOUT: "TIEMPO DE ESPERA",
                SUCCESS: "ÉXITO",
                FAILURE: "FAIL",
                PROBEL_SELECT_BRANCH: "Seleccionar sucursal",
                PROBEL_SELECT_CLINIC: "Seleccionar Policlínica",
                PROBEL_SELECT_DAY: "Seleccionar día de cita",
                PROBEL_SELECT_HOUR: "Seleccionar hora de cita",
                PROBEL_MAKE_APPOINTMENT: "Pedir cita",
                PROBEL_CANCEL_APPOINTMENT: "Cancelación de cita",
                PROBEL_GET_PATIENT_TOKEN: "Obtener token de paciente",
                PROBEL_FILL_INFO: "Obtener información MERNIS",
                PROBEL_SELECT_APPOINTMENT: "Seleccionar cita",
                SEND_WP_BUSINESS_MESSAGE: "ENVIAR MENSAJE DE WHATSAPP",
                MESSENGER_SEND_MESSAGE: "ENVIAR MENSAJE DE MESSENGER",
                INSTAGRAM_SEND_MESSAGE: "ENVIAR MENSAJE DE INSTAGRAM",
                INSTAGRAM_COMMENT_REPLY: "RESPONDER COMENTARIO",
                INSTAGRAM_COMMENT_DELETE: "BORRAR COMENTARIO",
                INSTAGRAM_COMMENT_SHOW: "MOSTRAR COMENTARIO",
                INSTAGRAM_COMMENT_HIDE: "OCULTAR COMENTARIO",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "RESPONDER COMO PRIVADO",
                LOOP: "bucle",
                LOOP_NEXT: "siguiente elemento del bucle",
                LOOP_BREAK: "Romper bucle",
                LOOP_CONTINUE: "Continuar bucle siguiente",
                LOOP_FINISH: "Finalizar bucle",
                SLEEP: "Dormir",
                NOOP: "Noop",
                CATCH_WEBHOOK: "Capturar Webhook",
                TERMINATE_AUTOMATION: "Terminar automatización",
                CREATE_CONTACT: "Crear contacto",
                UPDATE_CONTACT: "Actualizar contacto",
                FIND_CONTACTS: "Buscar contactos",
                FIND_CONTACT: "Encontrar contacto",
                FIND_CHATS: "Encontrar Chats",
                FIND_CHAT: "Buscar chat",
                WAIT_FOR: "Esperar",
                STRING_FORMAT: "Formatear cadena",
                NUMBER_FORMAT: "Formatear número",
                DATE_FORMAT: "Formato de fecha",
                RECORDS_FROM_CSV: "Registros de CSV",
                MESSAGE_RECEIVED: "Mensaje recibido",
                ASK_AI: "Inteligencia Artificial",
                TABLE_CREATE_RECORD: "Crear registro",
                TABLE_DELETE_RECORD: "Eliminar registro",
                TABLE_UPDATE_RECORD: "Actualizar registro",
                TABLE_FIND_RECORD: "Buscar registro",
                TABLE_FIND_RECORDS: "Listar registros",
                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho Buscar registro (por teléfono)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho Agregar archivo al registro",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho Cargar imagen en campo personalizado",
                ZOHO_CREATE_RECORD: "Zoho Crear registro",
                GET_SUPSIS_RECORD_BY_ID: "Obtener registro",
                META_SEND_CAPI_EVENT: "Enviar evento CAPI",
                GOOGLE_DRIVE_UPLOAD_FILE: "Subir archivo",
                GOOGLE_DRIVE_DOWNLOAD_FILE: "Descargar archivo",
                GOOGLE_DRIVE_GET_FILE_INFO: "Obtener información del archivo",
                GOOGLE_DRIVE_DELETE_FILE: "Eliminar archivo",
                ADD_TO_SEGMENT: "Add to Segment",
                REMOVE_FROM_SEGMENT: "Remove from Segment",
                START_POINT: "START POINT",
                FEEDBACK_AI_ASSISTANT: "FEEDBACK AI ASSISTANT",
                INSERT_TO_SYSTEM_PROMPT: "INSERT TO SYSTEM PROMPT",
                AI_CALL: "AI CALL",
                TAVILY_WEB_SEARCH: "WEB SEARCH (TAVILY)",
                RUN_JAVASCRIPT: "RUN JAVASCRIPT",
                SEND_JSON_RESPONSE: "RESPOND TO WEBHOOK",
                UPDATE_TASK: "UPDATE TASK",
                CACHE_WRITE: "CACHE WRITE",
                CACHE_READ: "CACHE READ",
                CACHE_EXTEND: "CACHE EXTEND",
                CACHE_DELETE: "CACHE DELETE",
                YOUTUBE_REPLY_COMMENT: "Reply Comment",
                YOUTUBE_UPDATE_COMMENT_STATUS: "Update Comment Status",
                YOUTUBE_SET_MODERATION_STATUS: "Set Moderation Status",
                GOOGLE_BUSINESS_REPLY_REVIEW: "Reply Review",
                GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "Update Review Status",
                GOOGLE_PLAY_REPLY_REVIEW: "Reply Review",
                GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "Update Review Status",
                APP_STORE_REPLY_REVIEW: "Reply Review",
                APP_STORE_UPDATE_REVIEW_STATUS: "Update Review Status",
                APP_STORE_DELETE_REVIEW_RESPONSE: "Delete Review Response",
                OPENROUTER_RESPONSE: "OpenRouter AI Response",
                OPENAI_RESPONSE: "Generate with OpenAI",
                GOOGLE_AI_RESPONSE: "Generate with Google AI",
                ANTHROPIC_RESPONSE: "Generate with Anthropic",
                MISTRAL_RESPONSE: "Generate with Mistral",
                AZURE_RESPONSE: "Generate with Azure",
                BEDROCK_RESPONSE: "Generate with AWS Bedrock",
                COHERE_RESPONSE: "Generate with Cohere",
                XAI_RESPONSE: "Generate with xAI",
                DEEPINFRA_RESPONSE: "Generate with DeepInfra",
                TOGETHER_RESPONSE: "Generate with Together",
                FIREWORKS_RESPONSE: "Generate with Fireworks",
                SILICONFLOW_RESPONSE: "Generate with SiliconFlow",
                PARASAIL_RESPONSE: "Generate with Parasail",
                NEBIUS_RESPONSE: "Generate with Nebius",
                ALIBABA_RESPONSE: "Generate with Alibaba",
                XIAOMI_RESPONSE: "Generate with Xiaomi",
                SAMBANOVA_RESPONSE: "Generate with SambaNova",
                MOONSHOT_RESPONSE: "Generate with Moonshot",
                MINIMAX_RESPONSE: "Generate with MiniMax",
                NVIDIA_RESPONSE: "Generate with NVIDIA",
                FALLIMENTO: "FAIL",
                OPENAI_WEB_SEARCH: "WEB SEARCH (OPENAI)",
                OPEN_AI: "OPEN_AI",
                PLATTFORM_FLOW: "PLATTFORM",
                SUCCESSO: "SUCCESSO"
            },
            newAutomation: "Nueva automatización",
            totalAutomations: "Total {count} automatizaciones",
            totalAutomationsWithHidden: "Total {total} automatizaciones ({visible} visibles)",
            cancelled: "Cancelado",
            whenVoiceAgentCallStarted: "Cuando se inicia una llamada del agente de voz",
            whenVoiceAgentCallEnded: "Cuando finaliza una llamada del agente de voz",
            whenVoiceAgentCallAnalyzed: "Cuando se analiza una llamada del agente de voz",
            createAnEventAutomation: "Crear una automatización por evento",
            automationPublishedStateCouldNotBeUpdated: "No se pudo actualizar el estado de publicación de la automatización",
            enablePreFilters: "Activar prefiltros",
            preFilterDescription: "Los prefiltros permiten determinar cuándo debe ejecutarse la automatización. Cuando están activos, la automatización solo se activará para eventos que coincidan con las condiciones definidas.",
            preFilters: "Prefiltros",
            executionRules: "Reglas de ejecución",
            preFilterInfo: "Con los prefiltros puede determinar cuándo debe ejecutarse la automatización. Solo se activará para eventos que coincidan con sus condiciones.",
            preFiltersSaved: "Prefiltros guardados correctamente",
            preFiltersSaveError: "Error al guardar los prefiltros",
            preFiltersConfiguration: "Configuración de prefiltros",
            executionPrivacyTitle: "Permiso de ejecución",
            executionPrivacyDescription: "¿Qué usuarios o departamentos pueden ejecutar esta automatización? Si se deja vacío, todos los usuarios pueden ejecutarla.",
            executionPrivacyPublic: "Todos los usuarios pueden ejecutar esta automatización",
            executionPrivacyConfiguration: "Configuración del permiso de ejecución",
            executionPrivacySaved: "Permiso de ejecución guardado correctamente",
            executionPrivacySaveError: "Error al guardar el permiso de ejecución",
            addDescription: "Añadir descripción...",
            descriptionPlaceholder: "Introduzca la descripción de la automatización...",
            descriptionSaved: "Descripción guardada correctamente",
            descriptionSaveError: "Error al guardar la descripción",
            makePublicExecution: "Hacer público",
            makePublicExecutionConfirmTitle: "¿Está seguro de que desea hacer pública esta automatización?",
            makePublicExecutionConfirmContent: "Después de esta operación, todos los representantes podrán ejecutar esta automatización.",
            madePublicExecution: "La automatización se ha hecho pública",
            openrouterResponse: "Respuesta de OpenRouter AI",
            selectProvider: "Seleccionar proveedor",
            modelName: "Modelo",
            modelHint: "Ej.: google/gemini-2.0-flash-001, openai/gpt-4o",
            systemInstructions: "Instrucciones del sistema (opcional)",
            systemInstructionsPlaceholder: "Indique a la IA cómo debe comportarse...",
            promptPlaceholder: "Escriba su pregunta para la IA...",
            advancedSettings: "Configuración avanzada",
            temperatureHint: "Valores bajos producen respuestas más coherentes, valores altos más creativas (0-2)",
            maxTokens: "Tokens máximos",
            maxTokensHint: "Número máximo de tokens a generar",
            maxTokensPlaceholder: "Por defecto: límite del modelo",
            selectChannel: "Seleccionar canal (opcional)",
            autoSelectChannel: "Selección automática",
            archivingDate: "Fecha de archivo",
            automationPublishedStateUpdatedSupdatedSuccessfully: "Estado de publicación de la automatización actualizado correctamente",
            automationsCouldNouldNotBeFetched: "No se pudo obtener la automatización",
            automazioni: "Automatizaciones",
            webhookAutomationCutomationCreatedSuccessfully: "Automatización webhook creada correctamente"
        },
        modules: {
            kanbanSettings: {
                title: "Configuración",
                column: "Configuración de columna",
                selectField: "Seleccione un campo",
                selectFieldPlaceholder: "Seleccione un campo",
                card: "Configuración de tarjeta",
                selectFields: "Seleccione los campos a mostrar en la tarjeta",
                cancel: "Cancelar",
                save: "Guardar",
                kanban: "Configuración Kanban"
            },
            createFailed: "Error en la creación del módulo",
            createSuccess: "Módulo creado con éxito",
            moduleDeletedSuccessfully: "Módulo eliminado correctamente",
            deleteModuleTitle: "Eliminar Módulo",
            deleteModuleContent: "¿Estás seguro de que quieres eliminar este módulo?",
            modules: "Módulos",
            relations: "Relaciones",
            newRelation: "Nueva Relación",
            editRelation: "Editar Relación",
            modulesSettings: "Configuración de Módulos",
            displayName: "Nombre para Mostrar",
            description: "Descripción",
            table: "Tabla",
            menuApiSettings: "Configuración de Menú y API",
            icon: "Ícono",
            save: "Guardar",
            exampleIcon: "Ej: extension, home",
            newModule: "Nuevo Módulo",
            moduleName: "Nombre del Módulo",
            apiName: "Nombre de la API",
            type: "Tipo",
            apiAccess: "Acceso a la API",
            actions: "Acciones",
            module: "Módulo",
            relation: "Relación",
            moduleRelationName: "Módulo/Relación",
            moduleRelationTable: "Tabla de Módulo/Relación",
            showInMainMenu: "Mostrar en Menú Principal",
            apiEnabled: "API Habilitada",
            settings: "Configuración",
            createModule: "Crear Módulo",
            relationType: "Tipo de Relación",
            relationTypeTableToTable: "Tabla a Tabla",
            relationTypeTableToStandart: "Tabla a Módulo Estándar",
            relationTypeStandartToTable: "Módulo Estándar a Tabla",
            fromColumn: "Desde",
            toColumn: "Hasta",
            apiDoc: "Documentación API",
            standartModule: "Módulo Estándar",
            customTable: "Tabla Personalizada",
            localField: "Campo Local",
            showingRemoteFieldInList: "Mostrar Campo Remoto en Lista",
            relationSettings: "Configuración de Relación",
            remoteField: "Campo Remoto",
            localFieldType: "Tipo de Campo Local",
            standart: "Estándar",
            custom: "Personalizado",
            contact: "Contacto",
            viewRecord: "Ver registro",
            recordDetail: "Detalles del registro",
            recordNotFound: "Registro o información de la tabla no encontrada",
            relatedLists: "Listas relacionadas",
            recordViewer: "Visualizador de registros",
            updateSuccess: "Módulo actualizado correctamente",
            updateFailed: "Error al actualizar el módulo",
            editModule: "Editar módulo",
            priority_high: "Alta",
            priority_highest: "Más alta",
            priority_low: "Baja",
            priority_lowest: "Más baja",
            priority_medium: "Media"
        },
        tables: {
            enterWidgetName: "Ingrese el nombre del widget",
            widgetName: "Nombre del Widget",
            renameWidget: "Renombrar Widget",
            assistantCapabilities: "Capacidades del Asistente",
            addNewFieldsToTable: "Puede agregar nuevos campos a la tabla",
            editExistingFields: "Puede editar campos existentes",
            deleteUnnecessaryFields: "Puede eliminar campos innecesarios",
            filterRecords: "Puede filtrar registros",
            groupRecords: "Puede agrupar registros",
            hideFieldsCapability: "Puede ocultar campos",
            createConditionalFormatting: "Puede crear formato condicional",
            createCalculationFormulas: "Puede crear fórmulas de cálculo",
            createSampleRecords: "Puede crear registros de muestra",
            examplePrompt: "Ejemplo: Añade los campos Nombre, Apellido, Correo electrónico y Teléfono para la información del cliente a esta tabla...",
            supsisAssistantTables: "Supsis Assistant: Tablas",
            supsisAssistantWritePrompt: "Describe lo que quieres que haga el Asistente Supsis",
            supsisAssistantExamplePrompt: "Crea una tabla para rastrear reuniones. Incluye campos como tema de la reunión, fecha, participantes, persona responsable, decisiones tomadas y acciones de seguimiento.",
            sendSupsisAssistant: "Enviar al Asistente Supsis",
            examplePromptsTitle: "Solicitudes de Ejemplo:",
            examplePrompts: {
                addCustomerInfoFields: "Añade los campos Nombre, Apellido, Correo electrónico y Teléfono para la información del cliente a esta tabla.",
                addOrderFields: "Añade los campos Nombre del producto, Cantidad, Precio unitario, Importe total y Fecha del pedido a la tabla de pedidos.",
                addBirthDateField: "Añade un campo de Fecha de nacimiento a esta tabla y configura el formato de fecha a DD/MM/AAAA.",
                updateStatusField: "Actualiza el campo Estado, hazlo desplegable con las opciones: Pendiente, En proceso, Completado, Cancelado.",
                replaceAddressFields: "Elimina el campo Dirección y añade en su lugar los campos Dirección Línea 1, Dirección Línea 2, Distrito, Ciudad y Código Postal.",
                alignTextFields: "Alinea todos los campos de texto al centro y limita la longitud máxima del texto a 100 caracteres.",
                addAutoIncrementID: "Añade un campo de ID autoincremental con el prefijo PRD- para el producto.",
                addTotalAmountFormula: "Añade el campo Importe total como fórmula para calcular el producto de cantidad y precio unitario.",
                createActiveCustomersFilter: "Crea un filtro para mostrar solo a los clientes activos.",
                filterRecentUsers: "Filtra los usuarios que se registraron en los últimos 30 días.",
                groupByStatus: "Agrupa los registros por la columna Estado.",
                hideAllExceptDeliveryAndOrderNo: "Oculta todos los campos excepto la Fecha de entrega y el Número de pedido.",
                colorCodeOrders: "Colorea los pedidos retrasados de rojo, los que se entregarán hoy de amarillo y los completados de verde.",
                highlightHighPaymentRecords: "Resalta en morado los registros con un monto de pago superior a 1000 TL.",
                groupAndHighlightUnpaidOrders: "Agrupa por fecha de pedido y resalta en rojo los pedidos no pagados.",
                createSampleRecords: "Crea 10 registros de muestra en esta tabla.",
                addSampleRecordsForAliAndAhmet: "Añade 5 registros de muestra con los nombres de cliente Ali y Ahmet.",
                createRandomSampleOrders: "Crea 20 registros de pedidos de muestra con estados aleatorios.",
                hrCandidateTracking: "Quiero crear un software de seguimiento de candidatos (ATS) para nuestros procesos de recursos humanos. Incluye todo lo que un ATS debería tener. Usa nombres de campo en turco.",
                crmModuleCreation: "Crea todos los módulos necesarios para la Gestión de Relaciones con Clientes (CRM). Incluye información del cliente, registros de reuniones y gestión de oportunidades.",
                realEstatePortfolioManagement: "Quiero configurar un sistema de gestión de portafolio inmobiliario. Debería manejar detalles de propiedades, solicitudes de clientes y seguimiento de ventas.",
                schoolManagementSystem: "Quiero gestionar el seguimiento de estudiantes, profesores y horarios de clases para un sistema de gestión escolar. Usa nombres de campo en turco.",
                projectManagementSystem: "Quiero crear un sistema de gestión de proyectos. Incluye tareas, miembros del equipo, seguimiento de tiempo y características de informes.",
                inventoryAndWarehouseManagement: "Quiero construir un sistema para la gestión de inventarios y almacenes. Debería manejar entradas/salidas de productos, niveles de inventario y seguimiento de proveedores.",
                serviceAndMaintenanceTracking: "Quiero un sistema de seguimiento de servicios y mantenimiento. Debería gestionar dispositivos de clientes, historial de mantenimiento y asignaciones de técnicos.",
                restaurantManagementSystem: "Quiero configurar un sistema de gestión de restaurantes. Incluye seguimiento de mesas, gestión de pedidos, visualización en cocina y operaciones de facturación."
            },
            createAppWithSupsisAssistant: "Crear aplicación con Supsis Assistant",
            noWidgets: "No hay widgets agregados",
            widgetLoadError: "Error al cargar el widget",
            createDashboardSupsisAssistant: "Crear Dashboard con Supsis Assistant",
            youtubeDesc: "Agrega videos de YouTube a tu panel",
            iframeDesc: "Agrega contenido de iframe a tu panel",
            countdownDesc: "Agrega un contador para rastrear fechas importantes",
            countdown: "Contador",
            textDesc: "Agrega contenido de texto personalizado a tu panel",
            numbersDesc: "Obtenga un resumen rápido de todas las columnas numéricas",
            numbers: "Números",
            addWidget: "Agregar widget",
            graphDesc: "Crea un widget de gráfico para visualizar datos en tus tablas",
            graph: "Gráfico",
            suggested: "Sugerido",
            creationDate: "Fecha de creación",
            today: "Hoy",
            month: "Mes",
            week: "Semana",
            day: "Día",
            table: "Tabla",
            kanban: "Kanban",
            calendar: "Calendario",
            calendarSettings: "Configuración del Calendario",
            colorBy: "Color Por",
            startDateField: "Campo de Fecha de Inicio",
            endDateField: "Campo de Fecha de Fin (Opcional)",
            eventCardFields: "Campos de Tarjeta de Evento",
            selectColorField: "Seleccionar Campo de Color",
            selectStartDateField: "Seleccionar Campo de Fecha de Inicio",
            selectEndDateField: "Seleccionar Campo de Fecha de Fin",
            cancel: "Cancelar",
            save: "Guardar",
            kanbanNotAvailable: "Vista Kanban No Disponible",
            needDropdownField: "Para usar la vista Kanban, necesita al menos un campo desplegable estático en su tabla. Puede agregar un nuevo campo o editar uno existente desde la configuración de la tabla.",
            notAvailable: "Vista de Calendario No Disponible",
            needDateField: "Necesita al menos un campo de fecha en su tabla para usar la vista de calendario. Puede agregar un nuevo campo o editar uno existente desde la configuración de la tabla.",
            switchToTable: "Cambiar a Vista de Tabla",
            operator: "Operador",
            conditionalColor: "Color condicional",
            groupField: "Campo de grupo",
            selectDirection: "Seleccionar dirección",
            showEmptyGroups: "Mostrar grupos vacíos",
            clearGrouping: "Limpiar agrupación",
            applyGrouping: "Aplicar agrupación",
            sortDirection: "Dirección de ordenación",
            downloadSelectedRecords: "Descargar registros seleccionados",
            downloadSelected: "Descargar seleccionados",
            downloadSelectedWithCount: "Descargar seleccionados ({count})",
            downloadThisPage: "Descargar esta página",
            downloadAll: "Descargar todo",
            downloadRecords: "Descargar registros",
            downloadRecordsSettings: "Descargar registros - Configuración",
            recordLimitExceededTooltip: "Límite de registros alcanzado. Debe actualizar su plan para importar registros.",
            zebraMode: "Modo Zebra",
            viewName: "Nombre de la vista",
            enterViewName: "Introduzca el nombre de la vista",
            enterDesc: "Introducir descripción",
            viewNameRequired: "Nombre de vista requerido",
            runWebhookAutomation: "Ejecutar Automatización Webhook",
            downloadAllRecords: "Descargar todos los registros",
            deleteRecords: "Eliminar Registros",
            editRecords: "Actualizar Registros",
            duplicateRecords: "Duplicar registros",
            selected: "Seleccionado",
            sureDeleteRecords: "¿Está seguro de que desea eliminar registros?",
            selectedRecordSucs: "Los registros seleccionados se han eliminado correctamente",
            errorDeletingRecords: "Se ha producido un error al eliminar registros",
            sureCopyRecords: "¿Está seguro de que desea copiar los registros?",
            copyRecords: "Copiar registros",
            recordsCopiedSucs: "Los registros seleccionados se han copiado correctamente",
            recordsCopiedError: "Se ha producido un error al copiar los registros seleccionados",
            viewSucsCreated: "La vista se ha creado correctamente",
            editMultipleRecords: "Editar Registros Múltiples",
            importRecords: "Importar Registros",
            importHasStarted: "Se ha iniciado la importación. Puede tardar unos minutos dependiendo del tamaño de los datos. Por favor, espere...",
            anErrorImport: "Se ha producido un error durante la importación",
            recordCreated: "Crear registro",
            recordUpdated: "Actualizar registro",
            recordDeleted: "Eliminar registro",
            noAutomationDefined: "No hay automatización definida todavía",
            nameTheAutomationAdd: "Nombre de la automatización que se ejecutará cuando se añada un registro a esta tabla:",
            nameTheAutomationUpdate: "Nombra la automatización que se ejecutará cuando se actualice un registro de esta tabla:",
            nameTheAutomationDelete: "Nombra la automatización que se ejecutará cuando se elimine un registro de esta tabla:",
            editField: "Editar campo",
            sort: "Ordenar",
            sortAscending: "Ordenar A-Z",
            sortDescending: "Ordenar Z-A",
            clearSort: "Quitar ordenación",
            markAsIdentifierField: "Marcar como campo identificador",
            runAI: "Ejecutar IA",
            ascending: "Ascendente",
            descending: "Descendente",
            createField: "Crear campo",
            insertBefore: "Insertar Antes",
            insertAfter: "Insertar después",
            goToRelatedAuto: "Ir a automatización relacionada",
            permission: "Permiso",
            lockField: "Bloquear campo",
            hideField: "Ocultar campo",
            deleteField: "Eliminar campo",
            watchVideo: "Ver vídeo",
            uploadError: "Error de carga",
            updateError: "Error de actualización",
            invalidValue: "Valor no válido. Por favor, utilice el formato correcto",
            errorUpdatingRecord: "Se ha producido un error al actualizar el registro",
            errorCreatingView: "Se ha producido un error al crear la vista",
            datetimeOptions: "Opciones de fecha y hora",
            numberOptions: "Opciones de número",
            currencyOptions: "Opciones de moneda",
            dropdownOptions: "Opciones desplegables",
            automationButtonOptions: "Opciones del botón de automatización",
            defaultLabel: "Etiqueta por defecto",
            disableWhenClicked: "Desactivar al hacer clic",
            fieldSucsCreate: "Campo creado con éxito",
            fieldCreatingFailed: "Se ha producido un error al crear el campo",
            fieldSucsUpdate: "Campo actualizado con éxito",
            fieldUpdatingFailed: "Se ha producido un error al actualizar el campo",
            showAll: "Mostrar todo",
            hideAll: "Ocultar todo",
            searchFields: "Buscar campos",
            firstRowHeader: "La primera fila contiene el encabezado",
            seperatorCharacter: "Carácter separador",
            comma: "Coma",
            semicolan: "Punto y coma",
            tableFieldOrFileColumns: "Asignación de campo de tabla / columnas de archivo",
            exampleResultPreview: "Vista previa del resultado de ejemplo",
            newView: "Nueva vista",
            createViewaFiltering: "Crear Vistas para continuar filtrando, ordenando y ocultando campos sin cambiar la Tabla Maestra",
            pleaseUpdateSelected: "Por favor seleccione el campo que desea actualizar para los registros seleccionados",
            pleaseSelectedNewValue: "Por favor, introduzca el nuevo valor para el campo seleccionado.",
            selectedMenuItem: "Elemento de menú seleccionado:",
            deleteTable: "Borrar tabla",
            sureDeleteTable: "¿Está seguro de que desea eliminar esta tabla?",
            deleteTableSucs: "La tabla se ha eliminado correctamente.",
            deleteTableError: "Error al borrar la tabla:",
            editTable: "Editar tabla",
            createNewField: "Crear nuevo campo",
            tables: "Tablas",
            tableName: "Nombre de la tabla",
            description: "Descripción",
            createTable: "Crear Tabla",
            createNewTable: "Crear nueva tabla",
            allTables: "Todas las tablas",
            myTables: "Mis tablas",
            myFavorites: "Mis favoritos",
            errorCreatingTable: "Error al crear tabla:",
            customerTable: "Tabla de clientes",
            customerTableDesc: "Tabla de clientes por defecto",
            leadTracking: "Seguimiento de clientes potenciales",
            leadTrackingDesc: "Tabla de seguimiento de clientes potenciales",
            todoList: "Lista de tareas",
            todoListDesc: "Lista para el seguimiento de tareas",
            approvalReq: "Solicitud de aprobación",
            approvalReqDesc: "Gestión de solicitudes de aprobación",
            eventSchedule: "Calendario de eventos",
            eventScheduleDesc: "Calendario de próximos eventos",
            inventoryList: "Lista de inventario",
            inventoryListDesc: "Realiza un seguimiento de las existencias de productos",
            bookingForm: "Formulario de reserva",
            bookingFormDesc: "Seguimiento de reservas",
            bugTracker: "Rastreador de errores",
            bugTrackerDesc: "Seguimiento de errores de software",
            employeeDirectory: "Directorio de empleados",
            employeeDirectoryDesc: "Contiene información sobre los empleados",
            errorPullTable: "Error al extraer datos de la tabla",
            newRecordSucs: "Nuevo registro creado con éxito",
            failedNewRecord: "Error al crear un nuevo registro:",
            newRecordCreateError: "Se ha producido un error al crear un nuevo registro:",
            recordCount: "Recuento de registros",
            increaseLimit: "Límite de incremento",
            newRecord: "Nuevo registro",
            imports: "Importación",
            exports: "Exportación",
            download: "Descarga",
            automateYourData: "Automatizar sus datos",
            recordUpdatedSucs: "Registro actualizado correctamente",
            failedToUpdateRecord: "Error al actualizar el registro",
            recordUpdatingError: "Error al actualizar registro",
            mainTable: "Tabla principal",
            filter: "Filtro",
            hideFields: "Ocultar campos",
            saveAsView: "Guardar como vista",
            search: "Buscar",
            create: "Crear",
            izquierda: "Izquierda",
            center: "Medio",
            right: "Derecha",
            selectTimezone: "Seleccionar zona horaria",
            createFieldSucs: "Campo creado con éxito",
            failedCreateField: "Error al crear el campo:",
            createFieldError: "Se ha producido un error al crear el campo",
            addCondition: "Añadir condición",
            applyFilter: "Aplicar filtro",
            fieldType: "Tipo de campo",
            alignment: "Alineación",
            blankTable: "Tabla en blanco",
            templates: "Plantillas",
            timezone: "Zona horaria",
            timeFormat: "Formato de hora",
            includeTime: "Hora incluida",
            decimalFormat: "Formato decimal",
            currencySymbol: "Símbolo de moneda",
            mode: "Modo",
            statics: "Estática",
            dynamic: "Dinámico",
            multipleSelection: "Selección múltiple",
            addOption: "Añadir opción",
            text: "Texto",
            longText: "Texto largo",
            number: "Número",
            currency: "Moneda",
            datetime: "Fecha y hora",
            dropdown: "Lista desplegable",
            checkbox: "Casilla de verificación",
            email: "Correo electrónico",
            phone: "Teléfono",
            file: "Archivo",
            image: "Imagen",
            video: "Vídeo",
            audio: "Audio",
            color: "Color",
            automationButton: "Botón de automatización",
            trashBin: "Papelera",
            pasteInfoDetected: "¡Se detectó una tabla copiada en el portapapeles! Pegue con Ctrl+V para crear una nueva tabla.",
            addCategory: "Añadir categoría",
            editCategory: "Editar categoría",
            deleteCategory: "Eliminar categoría",
            moveAllTables: "Mover todas las tablas",
            dragTablesToCategory: "Arrastre tablas aquí para añadirlas a esta categoría",
            deleteProtectionActive: "Protección contra borrado activa",
            copyTable: "Copiar tabla",
            copyAsJSON: "Copiar como JSON",
            changeCategory: "Cambiar categoría",
            turnOffDeleteProtection: "Desactivar protección contra borrado",
            turnOnDeleteProtection: "Activar protección contra borrado",
            privacySettings: "Configuración de privacidad",
            categoryName: "Nombre de categoría",
            categoryNamePlaceholder: "Introduzca el nombre de la categoría",
            categoryUpdate: "Actualizar",
            categoryCreate: "Crear",
            categoryNameRequired: "El nombre de la categoría no puede estar vacío",
            categoryAlreadyExists: "Ya existe una categoría con este nombre",
            categoryCreated: "Categoría creada. Puede arrastrar tablas a esta categoría.",
            categorySaveError: "Error al guardar la categoría",
            categoryUpdated: "Categoría actualizada",
            categoryUpdateError: "Error al actualizar la categoría",
            deleteCategoryConfirm: "Eliminar categoría",
            deleteCategoryConfirmContent: "¿Está seguro de eliminar \"{name}\"? Las tablas de esta categoría se moverán a \"General\".",
            categoryDeleted: "Categoría eliminada",
            categoryDeleteError: "Error al eliminar la categoría",
            tableMovedToCategory: "Tabla movida a la categoría \"{name}\"",
            tableMoveError: "Error al mover la tabla",
            tableProtectedWarning: "Esta tabla está protegida contra borrado. Quite la protección primero para eliminar.",
            deleteProtectionEnabled: "Protección contra borrado activada",
            deleteProtectionDisabled: "Protección contra borrado desactivada",
            protectionUpdateError: "Error al actualizar el estado de protección",
            tableCopied: "Tabla copiada",
            tableCopyError: "Error al copiar la tabla",
            tableJsonCopied: "Tabla copiada al portapapeles como JSON. Puede pegar con Ctrl+V en otro panel de cliente.",
            tableJsonCopiedFallback: "Tabla copiada al portapapeles como JSON (método alternativo)",
            tableJsonCopyError: "Error al copiar la tabla como JSON",
            clipboardNotSupported: "El acceso al portapapeles no está soportado en este navegador",
            noValidTableJson: "No se encontró JSON de tabla válido en el portapapeles",
            noValidSupsisExport: "No se encontró exportación de tabla Supsis válida en el portapapeles",
            tableImported: "Tabla \"{name}\" importada correctamente",
            tablePasteError: "Error al pegar la tabla",
            noTablesToMove: "No hay tablas para mover",
            tablesMovedToCategory: "{count} tablas movidas a la categoría \"{name}\"",
            tablesMoveError: "Error al mover las tablas",
            noPermissionEditPrivacy: "No tiene permiso para editar la configuración de privacidad de esta tabla",
            sandboxTitle: "Escenarios de tablas eliminadas",
            sandboxDesc: "Las tablas eliminadas se borran permanentemente automáticamente después de 30 días en la papelera",
            sandboxEmpty: "No hay tablas eliminadas en la papelera",
            unnamedTable: "Tabla sin nombre",
            restore: "Restaurar",
            permanentlyDelete: "Eliminar permanentemente",
            unknown: "Desconocido",
            user: "Usuario",
            restoreTableConfirm: "¿Está seguro de restaurar esta tabla?",
            restoreTableContent: "La tabla {name} será restaurada.",
            tableRestored: "Tabla restaurada",
            restoreFailed: "Restauración fallida",
            permanentlyDeleteConfirm: "¿Está seguro de eliminar permanentemente esta tabla?",
            permanentlyDeleteContent: "La tabla {name} será eliminada permanentemente. Esta acción no se puede deshacer.",
            yesPermanentlyDelete: "Sí, eliminar permanentemente",
            tablePermanentlyDeleted: "Tabla eliminada permanentemente",
            permanentDeleteFailed: "Eliminación permanente fallida",
            deletedTablesLoadError: "Error al cargar las tablas eliminadas",
            otherTables: "Otras tablas",
            noTablesFound: "No se encontraron tablas",
            renameView: "Renombrar vista",
            enterNewViewName: "Introduzca el nuevo nombre de la vista",
            viewRenamedSuccess: "Vista renombrada correctamente.",
            viewRenameError: "Se produjo un error al renombrar la vista.",
            deleteView: "Eliminar vista",
            confirmDeleteView: "¿Está seguro de que desea eliminar esta vista?",
            viewDuplicatedSuccess: "Vista duplicada correctamente.",
            viewDuplicateError: "Se produjo un error al duplicar la vista.",
            duplicateView: "Duplicar vista",
            confirmDuplicateView: "¿Está seguro de que desea duplicar esta vista?",
            viewDeletedSuccess: "Vista eliminada correctamente.",
            viewDeleteError: "Se produjo un error al eliminar la vista.",
            errorProcessingFile: "Se produjo un error al procesar el archivo",
            left: "Izquierda",
            upload: "Subir",
            permissions: {
                title: "Configuración de privacidad de la tabla",
                mode: "Modo de permisos",
                publicMode: "Público",
                customMode: "Personalizado",
                publicModeDesc: "En este modo, todos los usuarios tienen acceso completo a la tabla.",
                customModeDesc: "En este modo, solo ciertos usuarios y departamentos tienen acceso a la tabla.",
                confirmPublicMode: "Cambiar a modo público",
                confirmPublicModeDesc: "Si cambia a modo público, se eliminarán todos los permisos personalizados. ¿Desea continuar?",
                addUser: "Añadir usuario",
                addDepartment: "Añadir departamento",
                selectUser: "Seleccionar usuario",
                selectDepartment: "Seleccionar departamento",
                add: "Añadir",
                matrixInfo: "Puede gestionar los permisos de usuarios y departamentos en la matriz siguiente. Las casillas marcadas significan autorizado.",
                targetHeader: "Usuario / Departamento",
                noTargetsAdded: "Aún no se han añadido usuarios ni departamentos",
                confirmRemoveTarget: "Quitar destino",
                confirmRemoveTargetDesc: "¿Está seguro de que desea quitar este usuario/departamento de los permisos?",
                saveSuccess: "Configuración de permisos guardada correctamente",
                saveError: "Error al guardar la configuración de permisos",
                unknownUser: "Usuario desconocido",
                unknownDepartment: "Departamento desconocido",
                noPermission: "No tiene permiso para realizar esta acción",
                groups: {
                    basic: "Permisos básicos",
                    record: "Permisos de registros",
                    view: "Permisos de vistas",
                    page: "Permisos de páginas",
                    field: "Permisos de campos",
                    widget: "Permisos de widgets",
                    importExport: "Importar/Exportar"
                },
                scopes: {
                    tableRead: "Ver",
                    tableReadDesc: "Ver tabla",
                    tableMetaEdit: "Editar tabla",
                    tableMetaEditDesc: "Editar nombre, categoría y descripción de la tabla",
                    recordCreate: "Crear registro",
                    recordCreateDesc: "Crear un nuevo registro",
                    recordUpdate: "Actualizar registro",
                    recordUpdateDesc: "Actualizar registros existentes",
                    recordDelete: "Eliminar registro",
                    recordDeleteDesc: "Eliminar registros",
                    viewCreate: "Crear vista",
                    viewCreateDesc: "Crear una nueva vista",
                    viewUpdate: "Actualizar vista",
                    viewUpdateDesc: "Actualizar vistas existentes",
                    viewDelete: "Eliminar vista",
                    viewDeleteDesc: "Eliminar vistas",
                    pageRead: "Ver página",
                    pageReadDesc: "Ver páginas especiales",
                    pageCreate: "Crear página",
                    pageCreateDesc: "Crear una nueva página",
                    pageUpdate: "Actualizar página",
                    pageUpdateDesc: "Actualizar páginas existentes",
                    pageDelete: "Eliminar página",
                    pageDeleteDesc: "Eliminar páginas",
                    fieldCreate: "Crear campo",
                    fieldCreateDesc: "Crear un nuevo campo",
                    fieldUpdate: "Actualizar campo",
                    fieldUpdateDesc: "Actualizar campos existentes",
                    fieldDelete: "Eliminar campo",
                    fieldDeleteDesc: "Eliminar campos",
                    widgetCreate: "Crear widget",
                    widgetCreateDesc: "Crear un nuevo widget",
                    widgetUpdate: "Actualizar widget",
                    widgetUpdateDesc: "Actualizar widgets existentes",
                    widgetDelete: "Eliminar widget",
                    widgetDeleteDesc: "Eliminar widgets",
                    bulkImport: "Importación masiva",
                    bulkImportDesc: "Importar registros en masa",
                    export: "Exportar",
                    exportDesc: "Exportar registros"
                }
            },
            ascendente: "Ascendente",
            centro: "Centro",
            colore: "Color",
            colour: "Color",
            company: "Empresa",
            createFailed: "Error al crear el módulo",
            createSuccess: "Módulo creado correctamente",
            destra: "Derecha",
            dinamico: "Dinámico",
            discendente: "Descendente",
            dynamisch: "Dinámico",
            failCreateField: "Error al crear el campo:",
            failToUpdateRecord: "Error al actualizar el registro",
            immagine: "Imagen",
            individual: "Individual",
            priority_high: "Alta",
            priority_highest: "Más alta",
            priority_low: "Baja",
            priority_lowest: "Más baja",
            priority_medium: "Media",
            rechts: "Derecha",
            semicolon: "Punto y coma",
            separatorCharacter: "Carácter separador",
            sinistra: "Izquierda",
            statica: "Estática",
            tabelle: "Tablas"
        },
        plans: {
            manageWithChatbot: "Gestionar con Chatbot",
            manageInbox: "Gestionar bandeja de entrada",
            commentManagement: "Gestionar comentarios",
            privateReplyMessage: "Responder comentarios en privado",
            mentionTicket: "Convertir menciones en tickets",
            week: "Semana",
            readyContents: "Contenidos listos",
            webhookIntegration: "Integración de Webhook",
            businessChannel: "Canal de negocios de WhatsApp",
            confirmationFeature: "Función de confirmación",
            specialReporting: "Informes especiales",
            aiAssistant: "Asistente de IA",
            flexibleBilling: "Facturación flexible",
            automaticReservation: "Reserva automática",
            taskManagement: "Gestión de tareas",
            calendarIntegration: "Integración de calendario",
            activeChatbot: "Chatbot activo",
            smsIntegration: "Integración de SMS",
            mailIntegration: "Integración de correo",
            startChatWithVisitor: "Iniciar chat con visitante",
            whatsappManaging: "Gestión de Whatsapp",
            automaticChatbotButton: "Botón/Chatbot automático",
            personalizedBroadcasts: "Transmisiones personalizadas",
            chatWithNonContacts: "Chat con no contactos",
            broadcastMessaging: "Mensajería de difusión",
            perBroadcast: "Por difusión",
            extraPricePerMessage: "Precio extra por mensaje",
            smartTrigger: "Disparador inteligente",
            telegramIntegration: "Integración de Telegram",
            instagramIntegration: "Integración de Instagram",
            ticketFeature: "Función de ticket",
            storage: "Almacenamiento",
            onePanelManagement: "Gestión de un solo panel",
            isolatedDatabaseConnection: "Conexión de base de datos aislada",
            removeLogo: "Eliminar logotipo de Supsis",
            chatBaloonCustomization: "Personalización del globo de chat",
            chatAndNotifications: "Chat y Notificaciones",
            unlimited: "Ilimitado",
            specialCustomerSupport: "Soporte especial al cliente",
            softwareSupport: "Soporte de software",
            standardSupport: "Soporte estándar",
            teamChatIntegration: "Integración de chat de equipo",
            fileAndVoiceShare: "Compartir archivos y voz",
            instantVisitor: "Seguimiento instantáneo de visitantes",
            detailedReporting: "Informes detallados",
            normalreporting: "Informes normales",
            noExtraCosts: "Sin costos adicionales",
            accessibleToAllAgents: "Accesible para todos los agentes",
            dataSecurity: "Seguridad de datos",
            autoTranslate: "Traducción automática",
            chatbotVersionHistory: "Historial de versiones del chatbot",
            chatbotStory: "Historia del chatbot",
            freeAgent: "Agente gratuito",
            stableAgentCount: "Número de agentes estables",
            stableChannelCount: "Número de canales estables",
            chipPlans: "Planes asequibles",
            generalPlan: "Plan general",
            specialPlan: "Plan especial",
            currentPlan: "Plan actual",
            selected: "Seleccionado",
            popular: "Popular",
            trialPkg: "Paquete de prueba",
            support: "Soporte 24/7",
            flexiblePricing: "Precios flexibles",
            rightToCancel: "Derecho de cancelación en cualquier momento",
            unlimitedCBScenario: "Escenarios de chatbot ilimitados",
            freeFirstScenario: "Primer escenario gratuito",
            unlimitedLearn: "Formación ilimitada en chatbots",
            allPlatformIntegration: "Integración con todas las plataformas",
            detailedReports: "Informes detallados",
            aiSupport: "Soporte de IA",
            creativeAI: "Asistente de chat IA rápido y realista",
            unlimitedSession: "Sesiones ilimitadas simultáneamente",
            assistantFromWebsite: "Creación de asistente desde el sitio web",
            assistantFromDoc: "Creación de chatbot desde el documento",
            mobileApp: "Aplicación móvil",
            commentManage: "Gestionar comentarios"
        },
        messenger: {
            channel: "Canal de Messenger",
            manageChannel: "Gestionar canal",
            channelDetail: "Detalle del canal",
            integrationTitle: "Integración de Messenger",
            deleteDesc: "¿Estás seguro de que deseas eliminar el canal de Messenger?",
            channels: "Canales de Messenger",
            connectMessenger: "Conectar a Messenger",
            detail: "detalle",
            visibility: "Visibilidad",
            settings_group: "Configuración",
            commentsettings: "Gestión de comentarios",
            commentSettingsTitle: "Configuración de comentarios de Messenger",
            commentSettingsDesc: "Gestiona tus comentarios de Messenger",
            adoptimization: "Optimización de anuncios"
        },
        instagram: {
            channel: "Canal de Instagram",
            detail: "detalle",
            visibility: "Visibilidad",
            settings_group: "Configuración",
            commentsettings: "Gestión de comentarios",
            commentSettingsTitle: "Gestión de comentarios de Instagram",
            commentSettingsDesc: "Administra tus comentarios de Instagram",
            commentSettingsTicket: "Asegura que los comentarios entrantes se registren en el sistema como tickets.",
            commentSettingsChatbot: "Seleccione a qué escenario de chatbot deben dirigirse los comentarios entrantes.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "Mostrar Todos Los Canales de Instagram",
            brand: "Marca",
            questions: "Preguntas",
            showAllLinkedinChannels: "Mostrar todos los canales de LinkedIn",
            showAllTelegramChannels: "Mostrar todos los canales de Telegram",
            adoptimization: "Optimización de anuncios"
        },
        calendar: {
            calendarsDesc: "Evitar conflictos de horarios",
            generalAvailability: "Disponibilidad general",
            generalAvailabilityDesc: "Especifica las horas en las que estás regularmente disponible para citas",
            appointDuration: "Duración de la cita",
            appointDurationDesc: "¿Cuánto debe durar cada cita?",
            customDuration: "Duración personalizada",
            descriptionDesc: "Añade una nota que describa tu servicio. La nota que añadas aparecerá en su página de reserva y en los correos electrónicos de confirmación.",
            resForm: "Formulario de reserva",
            resFormDesc: "Personaliza el formulario que la gente utilizará para reservar una cita.",
            addField: "Añadir campo",
            addAnItem: "Añadir un elemento",
            saveItem: "Guardar elemento",
            planningTimeframe: "Plazo de planificación",
            planningTimeframeDesc: "Limitar el plazo en el que se puede concertar una cita.",
            availableAtMoment: "Disponible ahora",
            startAndEndDate: "Fechas de inicio y fin",
            maxNumberAppoint: "Número máximo de días tras los cuales se puede concertar una cita",
            howLongMinAppoint: "Tiempo hasta el que se puede reservar la cita",
            planningIntervalStartEnd: "Fechas de inicio y fin del intervalo de planificación",
            startTime: "Hora de inicio",
            done: "Hecho",
            receivedAppointInterval: "Intervalo de citas recibidas",
            receivedAppointIntervalDesc: "Gestiona las citas recibidas para que aparezcan en tu calendario",
            interimTime: "Tiempo intermedio",
            interimTimeDesc: "Añadir tiempo entre intervalos de citas",
            dayMaxRes: "Número máximo de reservas por día",
            dayMaxResDesc: "Limitar el número de citas reservadas que se pueden aceptar en un solo día",
            customise: "Establecer personalizado",
            noAvatar: "Sin avatar",
            organizationName: "Nombre de la organización",
            enterFullAdress: "Introduzca la dirección completa",
            noCoverPhoto: "Sin foto de portada",
            enterAboutInfo: "Introducir información sobre",
            service: "Servicio",
            deleteService: "Eliminar servicio",
            enterGoogleMapsUrl: "Introducir URL de Google Maps",
            enterLatitude: "Introducir latitud",
            enterLongitude: "Introducir longitud",
            enterNumber: "Introducir número de teléfono",
            uploadAvatar: "Subir avatar",
            teamMemberDeleteError: "Error al eliminar miembro del equipo:",
            setupBookingWebsite: "Configurar página web de reservas",
            bookingLandingPageBuilder: "Creador de página de reserva",
            coverPhoto: "Foto de portada",
            enterOrganisationName: "Introduzca el nombre de la organización",
            about: "Acerca de",
            services: "Servicios",
            deleteServices: "Eliminar servicio",
            selectReservationPlan: "Seleccionar plan de reserva",
            addNewService: "Añadir nuevo servicio",
            addNewMember: "Añadir nuevo miembro",
            fullAddress: "Dirección completa",
            latitude: "Latitud",
            longitude: "Longitud",
            contactDetails: "Datos de contacto",
            emailAddress: "Dirección de correo electrónico",
            enterEmail: "Introduzca la dirección de correo electrónico",
            websiteURL: "URL del sitio web",
            enterWebsiteURL: "Introducir URL del sitio web",
            reservationPolicy: "Política de reserva",
            enterResPolicy: "Introduzca la política de reserva",
            workingHours: "Horas de trabajo",
            selectEndHour: "Seleccionar hora de finalización",
            addNewHour: "Añadir nueva hora",
            updateMemberInfo: "Actualizar información del miembro",
            errorRecevingData: "Error al recuperar datos:",
            anonymService: "Servicio anónimo",
            unknownPlan: "Plan desconocido",
            errorCreatingMockPage: "Error al crear la página ficticia",
            failedToCreateBookingPage: "Error al crear la página de reserva",
            fileSizeToolLarge: "Tamaño de archivo demasiado grande",
            errorLoadingTheLogo: "Error al cargar el logotipo:",
            failedToLoadLogo: "Error al cargar el logotipo",
            errorUpdating: "Error al actualizar:",
            failedToUpdate: "Error al actualizar",
            newMember: "Nuevo miembro",
            errorLoadingAvatar: "Error al cargar el avatar:",
            avatarFailedToLoad: "Error al cargar avatar",
            teamMemberSuccessfullyDeleted: "Miembro del equipo eliminado con éxito",
            teamMemberNotDelete: "Fallo al eliminar miembro del equipo",
            yesDelete: "Sí, eliminar",
            sureResDelete: "¿Está seguro de que desea eliminar esta reserva?",
            resDetails: "Detalles de la reserva",
            infoPersonMakingRes: "Información de la persona que realiza la reserva",
            appointmentProgram: "Programa de la cita",
            goToAppointSettings: "Ir a la configuración del programa de citas",
            resPlanCreateSuccess: "Plan de reserva creado con éxito",
            pleaseEnterTitle: "Por favor, introduzca el título",
            sureContinueSaving: "¿Está seguro de que desea continuar sin guardar?",
            appointProgram: "PROGRAMA DE RESERVAS",
            everyMonth: "Cada mes",
            firstEveryMonth: "Primero de cada mes",
            dayOf: "Día",
            notRepeat: "No se repite",
            daily: "Todos los días",
            weekly: "Una vez a la semana",
            monthly: "Una vez al mes",
            annually: "Una vez al año",
            custom: "Especial",
            eventSaved: "Evento guardado",
            createAppoint: "Crear cita",
            calendarSetting: "Configuración del calendario",
            notAuthezord: "No está autorizado para realizar esta operación",
            notAuthorizedToPerformOperation: "No está autorizado para realizar esta operación.",
            reservationWebPage: "Página web de reservas",
            reservationBuilder: "Sitio web de reservas",
            reservationPrograms: "Programas de reserva",
            automations: "Automatizaciones",
            addReservationProgram: "Añadir programa de reserva",
            resPlanError: "Error al recibir planes de reserva:",
            resDeleteSure: "¿Está seguro de que desea eliminar este programa de reservas?",
            resDeleteSuccess: "El programa de reservas se ha eliminado correctamente.",
            resDeleteError: "Error al borrar el programa de reservas:",
            unkownUser: "Usuario desconocido",
            eventNotFound: "Evento no encontrado",
            reservations: "Reservas",
            events: "Eventos",
            upcoming: "próximo",
            past: "Anterior",
            setting: "Configuraciones",
            delete: "Eliminar",
            cancel: "Cancelar",
            save: "Guardar",
            close: "Cerrar",
            deleteRepeatEvent: "Eliminar evento recurrente",
            thisEvent: "Este evento",
            thisAndOtherEvent: "Este y otros eventos",
            allEvent: "Todos los eventos",
            ok: "OK",
            googleCalendarLink: "Agregar a Google Calendar",
            yahooCalendarLink: "Agregar a Yahoo Calendar",
            subject: "Asunto",
            visitor: "Visitante",
            allDay: "Todo el día",
            title: "Título",
            deleteEvent: "Eliminar evento",
            deleteEvents: "Eliminar eventos",
            deleteEventsSure: "¿Está seguro de que desea eliminar los eventos de este calendario?",
            deleteEventConfirm: "¿Está seguro de que desea eliminar este evento?",
            notEmptyTitle: "¡El título no puede estar vacío!",
            tasks: "Tareas",
            googleConnect: "Integración con Google",
            googleDisconnect: "Desconectar integración con Google",
            sure: "¿Está seguro?",
            disconnectGoogleSure: "¿Está seguro de que desea desconectar Google?",
            yes: "Sí",
            no: "No",
            customRepeat: "Repetición personalizada",
            recurrenceFrequency: "Frecuencia de repetición",
            repeatDays: "Repetir en los días:",
            never: "Nunca",
            thisDate: "En esta fecha:",
            recurrenceCount: "Número de repeticiones:",
            end: "Fin",
            event: "Evento",
            calendars: "Calendarios",
            newCalendar: "Crear nuevo calendario",
            changeColor: "Cambiar color",
            addCalendar: "Agregar calendario",
            nameCalendar: "Nombre del calendario",
            description: "Descripción",
            change: "Cambiar",
            deleteCalendar: "Eliminar calendario",
            deleteCalendarSure: "¿Está seguro de que desea eliminar este calendario?",
            notEmptyCalendarName: "El nombre del calendario no puede estar vacío",
            myEvents: "Mis eventos",
            everyoneEvents: "Todos los eventos",
            haveEvent: "eventos del agente",
            goCalendar: "Ir al calendario",
            goReservation: "Crear una reserva",
            agents: "Agentes",
            today: "Hoy",
            month: "Mes",
            week: "Semana",
            day: "Día",
            list: "Lista",
            planingIntervalStartEnd: "Fechas de inicio y fin del intervalo de planificación",
            customize: "Establecer personalizado",
            enterOrganizationName: "Introduzca el nombre de la organización",
            weely: "Semanal",
            annualy: "Anual",
            appointmentDuration: "Duración de la cita",
            appointmentSchedule: "Programa de citas",
            calendari: "Calendario",
            goToAppointmentSettings: "Ir a la configuración del programa de citas",
            infoPersonMakingReservation: "Información de la persona que realiza la reserva",
            reservationDetails: "Detalles de la reserva",
            sureReservationDelete: "¿Está seguro de que desea eliminar esta reserva?",
            teamMemberNotDeleted: "No se pudo eliminar el miembro del equipo"
        },
        ticimax: {
            segment: "Segmento",
            settings_group: "Grupo de configuración",
            waitDayFromLastSend: "Día de espera desde el último mensaje enviado",
            automationRuleName: "Nombre de la regla de automatización",
            time: "Hora",
            year: "Año",
            month: "Mes",
            dayOfMonth: "Día del mes",
            day: "Día",
            bySecond: "Por segundo",
            byMinute: "Por minuto",
            byHour: "Por hora",
            byWeekNo: "Por número de semana",
            byYearDay: "Por día del año",
            byMonthDay: "Por día del mes",
            byMonth: "Por mes",
            december: "Diciembre",
            november: "Noviembre",
            october: "Octubre",
            september: "Septiembre",
            august: "Agosto",
            july: "Julio",
            june: "Junio",
            may: "Mayo",
            april: "Abril",
            march: "Marzo",
            february: "Febrero",
            january: "Enero",
            byWeekDay: "Por día de la semana",
            interval: "Intervalo",
            seconds: "Segundos",
            minutes: "Minutos",
            hourly: "Cada hora",
            daily: "Diario",
            weekly: "Semanal",
            monthly: "Mensual",
            yearly: "Anual",
            frequency: "Frecuencia",
            attributes: {
                vip: "VIP",
                segment: "Segmento",
                province: "Provincia",
                country: "País",
                phone: "Teléfono",
                email: "Correo electrónico",
                fullname: "Nombre completo",
                couponPercent: "% de cupón",
                lastOrderDate: "Último pedido",
                firstOrderDate: "Primer pedido",
                county: "Condado",
                lastSource: "Última fuente",
                firstSource: "Primera fuente",
                lastPaymentType: "Último método de pago",
                firstPaymentType: "Primer método de pago",
                maxOrderAmount: "Importe máximo del pedido",
                minOrderAmount: "Importe mínimo del pedido",
                totalOrderAmount: "Importe total del pedido",
                totalOrderCount: "Número total de pedidos",
                usedCouponAmount: "Importe del cupón utilizado",
                usedCouponCount: "Número de cupones utilizados",
                tookDayFromLastOrder: "Días desde el último pedido",
                isCouponUser: "¿Es usuario de cupón?"
            },
            createAutomation: "Crear automatización",
            previous: "Anterior",
            createAutomationDesc: "Crea y gestiona la automatización de mensajes",
            newTicimaxChannel: "Nuevo canal de Ticimax",
            connextToTicimaxXml: "Conectar al servicio XML de Ticimax",
            connectTicimax: "Conectar con Ticimax",
            examplePreview: "Vista previa del ejemplo",
            completeAutomationRule: "Regla de automatización completa",
            configureMessage: "Configurar mensaje",
            automationTimer: "Temporizador de automatización",
            findTargetMembers: "Encontrar miembros objetivos",
            createAutomationRule: "Crear regla de automatización",
            action: "Acción",
            status: "Estado",
            triggeredUserCount: "Número de usuarios activados",
            nextScheduled: "Próxima programada",
            timerRule: "Regla de temporizador",
            automationRules: "Reglas de automatización",
            apply: "Aplicar",
            searchAMember: "Buscar un miembro",
            segmentedMembersDesc: "Enumere y automatice los miembros segmentados",
            manageVisibilityDesc: "Administrar la visibilidad del canal",
            xmlOrderListURL: "URL de la lista de pedidos XML",
            manageIntegrationDesc: "Administrar su integración de Ticimax",
            detail: "Detalle",
            ticimaxChannelsTitle: "Canales de Ticimax",
            ticimaxDetail: "Detalle de Ticimax",
            settingsGroup: "Ajustes",
            visibility: "Visibilidad",
            members: "Miembros",
            automation: "Automatización",
            integrationChannel: "Canal de integración",
            channelUpdated: "Canal actualizado correctamente",
            channelUpdateFailed: "Error al actualizar el canal"
        },
        notification: {
            taskArchive: "Se envía una notificación cuando se archiva una tarea.",
            taskComplet: "Se envía una notificación cuando se cierra una tarea completada.",
            adjustNow: "Ajustar ahora",
            chatAssignedMe: "Cuando se me asigna un chat.",
            ticketAssignedMe: "Cuando se me asigna un ticket.",
            myChatClosed: "Cuando se cierra un chat que poseo.",
            contactOwner: "Cuando cambia el propietario del chat, cuando se asigna o se retira la propiedad.",
            tagActionsToVisitor: "Cuando se agrega o se retira una etiqueta de un visitante.",
            ticketCreated: "Cuando un visitante o un chatbot crea un ticket.",
            notesActions: "Cuando se agrega o se retira una nota de un cliente.",
            visitorProfileUpdated: "Cuando se actualiza el perfil de un visitante.",
            chatStartedByAnyPlatform: "Cuando se inicia un chat desde cualquier canal.",
            userActions: "Cuando se crea, actualiza o elimina un usuario.",
            departmentActions: "Cuando se crea, actualiza o elimina un departamento.",
            settingsActions: "Cuando se crean, actualizan o eliminan configuraciones.",
            integrationsActions: "Cuando se crea, actualiza o elimina un canal de integración.",
            loginFormActions: "Cuando se actualiza o activa el formulario de inicio de sesión.",
            bannedWordActions: "Cuando se crea, actualiza o elimina una palabra prohibida.",
            emailActions: "Cuando se crea, actualiza o elimina una cuenta de correo electrónico.",
            preparedContentActions: "Cuando se crea, actualiza o elimina contenido preparado.",
            roleActions: "Cuando se crea, actualiza o elimina un rol.",
            tagActions: "Cuando se crea, actualiza o elimina una etiqueta.",
            welcomeMessageActions: "Cuando se crea, actualiza o elimina un mensaje de bienvenida.",
            webhookActions: "Cuando se crea, actualiza o elimina un webhook.",
            billingEvents: "Cuando se crea una factura o se actualiza su estado.",
            systemStatus: "Cuando se actualiza el estado del sistema de soporte en vivo.",
            reservationMessageCrud: "Cuando se crea, actualiza o elimina una reserva.",
            ipAddressWhiteListEvents: "Cuando se agrega, actualiza o elimina una dirección IP permitida.",
            taskAssignedMe: "Cuando se me asigna una tarea.",
            workflowCreated: "Cuando se crea un flujo de trabajo.",
            workflowDeleted: "Cuando se elimina un flujo de trabajo.",
            createdTask: "Cuando se crea una tarea.",
            deletedTask: "Cuando se elimina una tarea.",
            chatbotStoryCrud: "Cuando se crea, actualiza o elimina una historia de chatbot.",
            chatbotForwardAgent: "El chatbot reenvía un chat a un agente.",
            userSegmentCrud: "Cuando se crea, actualiza o elimina un segmento de usuario.",
            chatbotCreditLow: "Cuando el crédito del chatbot es bajo.",
            wpCreditLow: "Cuando el crédito de WhatsApp cae por debajo de 100 TL.",
            wpCustomerGroupCrud: "Cuando se crea, actualiza o elimina un grupo de clientes de WhatsApp.",
            wpBroadcastMessageStatus: "Cuando se inicia, completa o cancela el envío de un mensaje de difusión de WhatsApp.",
            wpTemplateMesssageCrud: "Cuando se crea, actualiza o elimina un mensaje de plantilla de WhatsApp.",
            whatsappQrChannelStatusUpdated: "Cuando se actualiza el estado de conexión del canal WhatsApp QR.",
            activityTypeLabels: {
                "chat-assign": "Cuando se me asigna un chat",
                "ticket-assign": "Cuando se me asigna un ticket",
                "task-assign": "Cuando se me asigna una tarea",
                "task-complet": "Cuando se completa una tarea",
                "chat-close-own": "Cuando se cierra un chat que me pertenece",
                "tag-actions-to-visitor": "Etiquetas agregadas o eliminadas de un contacto",
                "create-ticket": "Ticket creado por un visitante o chatbot. También, cuando se envía un mensaje fuera de línea desde la ventana de chat",
                "note-actions-to-visitor": "Notas agregadas o eliminadas de un contacto",
                "visitor-profile-updates": "Actualizaciones del perfil del visitante",
                "chat-start": "Chat iniciado en cualquier plataforma por un contacto o agente",
                "user-crud": "Usuario creado, actualizado o eliminado",
                "department-crud": "Departamento creado, actualizado o eliminado",
                "settings-crud": "Configuraciones creadas, actualizadas o eliminadas",
                "integration-channel-crud": "Canal de integración creado, actualizado o eliminado",
                "login-form-crud": "Formulario de inicio de sesión actualizado, activado o desactivado",
                "banned-word-crud": "Palabra prohibida creada, actualizada o eliminada",
                "email-account-crud": "Cuenta de correo electrónico creada o eliminada",
                "prepared-content-crud": "Contenido preparado creado o eliminado",
                "role-crud": "Rol creado, actualizado o eliminado",
                "tag-crud": "Etiqueta creada, actualizada o eliminada",
                "welcome-message-crud": "Mensaje de bienvenida creado, actualizado o eliminado",
                "webhook-crud": "Webhook creado, actualizado o eliminado",
                "automation-created": "Automatización creada",
                "automation-deleted": "Automatización eliminada",
                "automation-published": "Automatización publicada",
                "automation-unpublished": "Automatización no publicada",
                "automation-updated": "Automatización actualizada",
                "billing-events": "Eventos de facturación",
                "task-workflow-crud": "Flujo de trabajo de tareas creado, actualizado o eliminado",
                "task-crud": "Tarea creada, actualizada o eliminada",
                "system-status": "Cambios de estado del sistema en línea o fuera de línea",
                "chatbot-story-crud": "Historia del chatbot creada, actualizada o eliminada",
                "chatbot-forward-chat": "El chatbot reenvía un chat a un agente",
                "chatbot-user-segment-crud": "Segmento de usuario creado, actualizado o eliminado",
                "chatbot-credit-low": "Cuando el crédito del chatbot es bajo",
                "whatsapp-credit-low": "Cuando el crédito de WhatsApp es bajo",
                "whatsapp-customer-group-crud": "Cuando se crea, actualiza o elimina un grupo de clientes de WhatsApp",
                "whatsapp-broadcast-message-crud": "Cuando se envía, completa o cancela un mensaje de difusión de WhatsApp",
                "whatsapp-template-message-crud": "Cuando se crea, actualiza o elimina un mensaje de plantilla de WhatsApp",
                "form-created": "Formulario creado",
                "form-updated": "Formulario actualizado",
                "form-deleted": "Formulario eliminado",
                "form-restored": "Formulario restaurado",
                "form-downloaded": "Formulario descargado",
                "user-role-changed": "Rol de usuario cambiado",
                "user-password-changed": "Contraseña de usuario cambiada",
                "user-email-changed": "Dirección de correo electrónico del usuario cambiada",
                "user-name-changed": "Nombre de usuario cambiado",
                "user-phone-changed": "Teléfono de usuario cambiado",
                "user-disabled": "Usuario deshabilitado/habilitado",
                "role-updated": "Rol actualizado",
                "task-workflow-updated": "Flujo de trabajo de tareas actualizado",
                "task-workflow-pipeline-stage-added": "Etapa de pipeline de flujo de trabajo de tareas agregada",
                "task-workflow-pipeline-stage-updated": "Etapa de pipeline de flujo de trabajo de tareas actualizada",
                "task-workflow-pipeline-stage-deleted": "Etapa de pipeline de flujo de trabajo de tareas eliminada",
                "drive-folder-created": "Carpeta de Drive creada",
                "drive-folder-deleted": "Carpeta de Drive eliminada",
                "drive-folder-renamed": "Carpeta de Drive renombrada",
                "drive-file-added": "Archivo agregado a Drive",
                "drive-file-deleted": "Archivo eliminado de Drive",
                "task-module-rules-enabled": "Reglas del módulo de tareas habilitadas",
                "task-module-rules-disabled": "Reglas del módulo de tareas deshabilitadas",
                "task-module-rules-rule-added": "Regla agregada al flujo de trabajo de tareas",
                "task-module-rules-rule-deleted": "Regla eliminada del flujo de trabajo de tareas",
                "task-module-rules-rule-updated": "Regla actualizada en el flujo de trabajo de tareas",
                "task-module-rules-rule-enabled": "Regla habilitada en el flujo de trabajo de tareas",
                "task-module-rules-rule-disabled": "Regla deshabilitada en el flujo de trabajo de tareas",
                "contact-module-rules-enabled": "Reglas del módulo de contactos habilitadas",
                "contact-module-rules-disabled": "Reglas del módulo de contactos deshabilitadas",
                "contact-module-rules-rule-added": "Regla agregada al módulo de contactos",
                "contact-module-rules-rule-updated": "Regla actualizada en el módulo de contactos",
                "contact-module-rules-rule-deleted": "Regla eliminada del módulo de contactos",
                "contact-module-rules-rule-enabled": "Regla habilitada en el módulo de contactos",
                "contact-module-rules-rule-disabled": "Regla deshabilitada en el módulo de contactos",
                "developer-token-changed": "Token de desarrollador actualizado",
                "table-created": "Tabla creada",
                "table-field-added": "Campo agregado a la tabla",
                "table-field-updated": "Campo actualizado en la tabla",
                "table-field-deleted": "Campo eliminado de la tabla",
                "table-view-added": "Vista agregada a la tabla",
                "table-view-updated": "Vista actualizada en la tabla",
                "table-view-deleted": "Vista eliminada de la tabla",
                "table-page-added": "Página agregada a la tabla",
                "table-page-updated": "Página actualizada en la tabla",
                "table-page-deleted": "Página eliminada de la tabla",
                "table-widget-added": "Widget agregado a la página de la tabla",
                "table-widget-updated": "Widget actualizado en la página de la tabla",
                "table-widget-deleted": "Widget eliminado de la página de la tabla",
                "table-privacy-changed": "Configuración de privacidad de la tabla actualizada",
                "web-app-created": "Aplicación web creada",
                "web-app-updated": "Aplicación web actualizada",
                "web-app-deleted": "Aplicación web eliminada",
                "web-tab-created": "Pestaña web creada",
                "web-tab-updated": "Pestaña web actualizada",
                "web-tab-deleted": "Pestaña web eliminada",
                "module-created": "Módulo creado",
                "module-updated": "Módulo actualizado",
                "module-deleted": "Módulo eliminado",
                "relation-created": "Relación creada",
                "relation-updated": "Relación actualizada",
                "voice-agent-created": "Agente de voz creado",
                "voice-agent-updated": "Agente de voz actualizado",
                "voice-agent-deleted": "Agente de voz eliminado",
                "voice-agent-phone-number-inbound-agent-changed": "Agente de llamada entrante del número de teléfono cambiado",
                "voice-agent-phone-number-outbound-agent-changed": "Agente de llamada saliente del número de teléfono cambiado",
                "voice-agent-batch-call-created": "Llamada por lotes creada",
                "voice-agent-knowledge-base-created": "Base de conocimientos creada",
                "voice-agent-knowledge-base-deleted": "Base de conocimientos eliminada",
                "table-data-downloaded": "Datos de la tabla descargados",
                "table-data-imported": "Datos masivos importados a la tabla",
                "table-data-batch-updated": "Datos de la tabla actualizados por lotes",
                "table-data-batch-deleted": "Datos de la tabla eliminados por lotes",
                "contact-batch-updated": "Contactos actualizados por lotes",
                "chat-data-downloaded": "Historial de chat descargado",
                "automation-restored": "Cuando la automatización se restaura desde la papelera",
                "waba-supsis-partner-remove": "Cuando se elimina el partner de WhatsApp Business API V2",
                "waba-supsis-account-deleted": "Cuando se elimina la cuenta de WhatsApp Business API V2",
                "waba-supsis-account-violation": "Cuando se detecta una violación de cuenta de WhatsApp Business API V2",
                "waba-supsis-ad-account-linked": "Cuando se vincula la cuenta publicitaria de WhatsApp Business API V2",
                "waba-supsis-auth-intl-price-eligibility-update": "Cuando se actualiza la elegibilidad de precios internacionales de WhatsApp Business API V2",
                "waba-supsis-disabled-update": "Cuando se realiza la actualización de deshabilitación de WhatsApp Business API V2",
                "waba-supsis-mm-lite-terms-signed": "Cuando se firman los términos MM Lite de WhatsApp Business API V2",
                "waba-supsis-partner-app-installed": "Cuando se instala la aplicación partner de WhatsApp Business API V2",
                "waba-supsis-partner-app-uninstalled": "Cuando se desinstala la aplicación partner de WhatsApp Business API V2",
                "waba-supsis-partner-client-certification-status-update": "Cuando se actualiza el estado de certificación del cliente partner de WhatsApp Business API V2",
                "waba-supsis-business-primary-location-country-update": "Cuando se actualiza el país de ubicación principal del negocio de WhatsApp Business API V2",
                "waba-supsis-volume-based-pricing-tier-update": "Cuando se actualiza el nivel de precios por volumen de WhatsApp Business API V2",
                "waba-supsis-message-template-components-update": "Cuando se actualizan los componentes de plantilla de mensaje de WhatsApp Business API V2",
                "waba-supsis-message-template-status-update": "Cuando se actualiza el estado de plantilla de mensaje de WhatsApp Business API V2",
                waba_supsis_partner_remove: "Partner de WhatsApp Business API V2 eliminado",
                waba_supsis_account_deleted: "Cuenta de WhatsApp Business API V2 eliminada",
                waba_supsis_account_violation: "Violación de cuenta de WhatsApp Business API V2 detectada",
                waba_supsis_ad_account_linked: "Cuenta publicitaria de WhatsApp Business API V2 vinculada",
                waba_supsis_auth_intl_price_eligibility_update: "Actualización de elegibilidad de precios internacionales de WhatsApp Business API V2",
                waba_supsis_disabled_update: "Actualización de deshabilitación de WhatsApp Business API V2",
                waba_supsis_mm_lite_terms_signed: "Términos MM Lite de WhatsApp Business API V2 firmados",
                waba_supsis_partner_added: "Partner de WhatsApp Business API V2 añadido",
                waba_supsis_partner_app_installed: "Aplicación partner de WhatsApp Business API V2 instalada",
                waba_supsis_partner_app_uninstalled: "Aplicación partner de WhatsApp Business API V2 desinstalada",
                waba_supsis_partner_client_certification_status_update: "Estado de certificación del cliente partner de WhatsApp Business API V2 actualizado",
                waba_supsis_business_primary_location_country_update: "País de ubicación principal del negocio de WhatsApp Business API V2 actualizado",
                waba_supsis_volume_based_pricing_tier_update: "Nivel de precios por volumen de WhatsApp Business API V2 actualizado",
                waba_supsis_message_template_components_update: "Componentes de plantilla de mensaje de WhatsApp Business API V2 actualizados",
                waba_supsis_message_template_status_update: "Estado de plantilla de mensaje de WhatsApp Business API V2 actualizado",
                waba_supsis_template_category_update: "Categoría de plantilla de WhatsApp Business API V2 actualizada",
                waba_supsis_PARTNER_REMOVE: "Partner de WhatsApp Business API V2 eliminado",
                waba_supsis_ACCOUNT_DELETED: "Cuenta de WhatsApp Business API V2 eliminada",
                "task-workflow-restored": "Cuando el flujo de trabajo de tareas se restaura desde la papelera",
                "task-workflow-permanently-deleted": "Cuando el flujo de trabajo de tareas se elimina permanentemente de la papelera",
                "table-deleted": "Cuando se elimina la tabla",
                "table-restored": "Cuando la tabla se restaura desde la papelera",
                "table-permanently-deleted": "Cuando la tabla se elimina permanentemente de la papelera"
            },
            crmActions: "Acciones CRM",
            mobileApp: "Aplicación móvil",
            webPanel: "Panel web",
            notifications: "Notificaciones",
            whatsappActions: "Acciones de Whatsapp",
            chatbotActions: "Acciones del chatbot",
            companyActions: "Acciones de la empresa",
            basicActions: "Acciones básicas",
            notificationSettingsDesc: "Elija qué notificaciones desea recibir y dónde desea recibirlas.",
            noNotificationDesc2: "Aquí verás todas las notificaciones relacionadas con los trabajos, candidatos y piscinas de talento que estás siguiendo. Puedes personalizar las notificaciones ajustando la configuración.",
            noNotificationTitle2: "Aún no hay notificaciones.",
            noNotificationTitle1: "Sin notificaciones. Disfruta del silencio.",
            adjustSettings: "Ajustar configuración",
            showAll: "Mostrar todo",
            showOnlyUnread: "Mostrar solo no leídos",
            mailWasSent: "El correo electrónico fue enviado.",
            mailAdressRemoved: "Dirección de correo electrónico eliminada.",
            chatbotPublished: "La versión <b>{version}</b> del chatbot fue publicada por <b>{user}</b>.",
            chatbotDeleted: "El chatbot <b>{chatbot}</b> fue eliminado por <b>{user}</b>.",
            settingsUpdatedWoDetail: "La configuración fue actualizada por <b>{user}</b>.",
            noActivityDesc: "Actualmente no hay actividad en el sistema. Deben ocurrir algunos eventos",
            noActivityTitle: "Todavía no hay actividad",
            actionType: "Tipo de acción",
            dateBetween: "Fecha entre",
            selectActor: "Seleccionar usuario",
            activities: "Actividades",
            chatbotCreated: "El chatbot llamado <b>{chatbot}</b> fue creado por <b>{user}</b>.",
            taskAddedTags: "<b>{user}</b> agregó estas etiquetas a la tarea (<b>{taskTitle}</b>): <b>{tags}</b>",
            taskStageChanged: "La etapa de la tarea <b>{task}</b> se cambió de <b>{oldStage}</b> a <b>{newStage}</b> por <b>{user}</b>.",
            taskCreated: "La tarea <b>{task}</b> fue creada por <b>{user}</b>.",
            contactPropRemoved: "La propiedad del visitante <b>{prop}</b> fue eliminada por <b>{user}</b>.",
            contactPropAdded: "La propiedad del visitante <b>{prop}</b> fue agregada por <b>{user}</b>.",
            userRemoved: "El usuario <b>{oldUser}</b> fue eliminado por <b>{user}</b>.",
            loginFormUpdated: "El formulario de inicio de sesión del visitante fue actualizado por <b>{user}</b>.",
            loginFormDeactivated: "El formulario de inicio de sesión del usuario fue desactivado por <b>{user}</b>.",
            loginFormActivated: "El formulario de inicio de sesión del usuario fue activado por <b>{user}</b>.",
            invoiceRefunded: "El proceso de reembolso fue realizado por <b>{user}</b>.",
            paymentMethodAdded: "Se agregó un nuevo método de pago por <b>{user}</b>.",
            invoicePaymentFailed: "El pago de la factura no fue aceptado por <b>{user}</b>.",
            invoicePaymentReceived: "El pago de la factura fue aceptado por <b>{user}</b>.",
            planStarted: "<b>{user}</b> El usuario inició la suscripción para <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent: "<b>{user}</b> El usuario inició la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{details} Representante</b>).",
            planStartedChatbot: "<b>{user}</b> El usuario inició la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sesión</b>).",
            planStartedWhatsapp: "<b>{user}</b> El usuario inició la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canales de Whatsapp</b>).",
            planStartedWhatsappApi: "<b>{user}</b> El usuario inició la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canales de Negocios de Whatsapp</b>).",
            PlanCanceled: "<b>{user}</b> El usuario canceló la suscripción para <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent: "<b>{user}</b> El usuario canceló la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{details} Representante</b>).",
            planCanceledChatbot: "<b>{user}</b> El usuario canceló la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sesión</b>).",
            planCanceledWhatsapp: "<b>{user}</b> El usuario canceló la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canales de Whatsapp</b>).",
            planCanceledWhatsappApi: "<b>{user}</b> El usuario canceló la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canales de Negocios de Whatsapp</b>).",
            invoiceCreated: "La factura fue creada por <b>{user}</b>.",
            billingAddressUpdated: "La información de la dirección fue actualizada por <b>{user}</b>.",
            taskWorkflowDeleted: "El flujo de trabajo <b>{workflow}</b> fue eliminado por <b>{user}</b>.",
            whatsappBroadcastFailed: "Fallo en el envío del mensaje de difusión titulado <b>{title}</b>.",
            whatsappBroadcastCancelled: "Se ha cancelado el envío del mensaje de difusión titulado <b>{title}</b>.",
            whatsappBroadcastCompleted: "Se ha enviado con éxito un mensaje de difusión titulado <b>{title}</b> a <b>{numbers}</b> destinatarios.",
            whatsappBroadcastCreated: "Se ha enviado un mensaje de difusión titulado <b>{title}</b> a <b>{numbers}</b> destinatarios por <b>{user}</b>.",
            ticketAssigned: "Se ha asignado un ticket a <b>{user2}</b> por <b>{user1}</b>.",
            userLoggedIn: "<b>{user}</b> se ha conectado a SUPSIS.",
            chatJoined: "<b>{agent}</b> se unió al chat con <b>{visitor}</b>.",
            chatForwarded: "El chat con <b>{visitor}</b> fue enviado a <b>{agent}</b> por <b>{user}</b>.",
            chatAssigned: "El chat con <b>{visitor}</b> fue asignado a <b>{agent}</b> por el sistema.",
            customerGroupUpdated: "El grupo <b>{group}</b> fue actualizado por <b>{user}</b>.",
            customerGroupRemoved: "El grupo <b>{group}</b> fue eliminado por <b>{user}</b>.",
            customerGroupAdded: "El grupo <b>{group}</b> fue creado por <b>{user}</b>.",
            contentRemoved: "El contenido listo <b>{content}</b> fue eliminado por <b>{user}</b>.",
            contentAdded: "El contenido listo <b>{content}</b> fue agregado por <b>{user}</b>.",
            channelVisibilityChanged: "La visibilidad del canal de integración <b>{channel}</b> fue cambiada por <b>{user}</b>.",
            taskDeleted: "La tarea <b>{task}</b> fue eliminada por <b>{user}</b>.",
            taskCompleted: "<b>{task}</b> tarea fue completada por <b>{user}</b>.",
            taskArchived: "<b>{user}</b> por <b>{task}</b> tarea archivada.",
            userRemovedToDepartment: "El usuario <b>{user2}</b> fue eliminado del departamento <b>{department}</b> por <b>{user1}</b>.",
            userAddedToDepartment: "El usuario <b>{user2}</b> fue añadido al departamento <b>{department}</b> por <b>{user1}</b>.",
            mailAddressAdded: "Dirección de correo electrónico <b>{email}</b> agregada por <b>{user}</b>",
            settingUpdate: "Actualizado por <b>{user}</b>:",
            taskWFlowCreated: "Flujo de trabajo de tareas <b>{Wflow}</b> creado por <b>{user}</b>.",
            bannedWordRemoved: "La palabra prohibida <b>{bWord}</b> fue eliminada por <b>{user}</b>.",
            bannedWordCreated: "La palabra prohibida <b>{bWord}</b> fue creada por <b>{user}</b>.",
            taskPriorityUpdated: "<b>{user}</b> cambió la prioridad de la tarea <b>{taskTitle}</b> de <b>{oldPriority}</b> a <b>{newPriority}</b>",
            welcomeMessageRemoved: "El mensaje de bienvenida <b>{welcome}</b> fue eliminado por <b>{user}</b>.",
            welcomeMessageAdded: "Mensaje de bienvenida <b>{welcome}</b> creado por <b>{user}</b>.",
            tagRemoved: "Etiqueta <b>{tag}</b> eliminada por <b>{user}</b>.",
            tagAdded: "Etiqueta <b>{tag}</b> agregada por <b>{user}</b>.",
            roleRemoved: "Rol <b>{role}</b> eliminado por <b>{user}</b>.",
            roleAdded: "Rol <b>{role}</b> agregado por <b>{user}</b>.",
            departmentRemoved: "Departamento <b>{department}</b> eliminado por <b>{user}</b>.",
            departmentAdded: "Departamento <b>{department}</b> agregado por <b>{user}</b>.",
            triggerUpdated: "Un desencadenador actualizado por <b>{user}</b>.",
            triggerRemoved: "Un desencadenador eliminado por <b>{user}</b>.",
            triggerAdded: "Un nuevo desencadenador creado por <b>{user}</b>.",
            webhookRemoved: "Webhook de <b>{user1}</b> eliminado por <b>{user2}</b>",
            webhookAdded: "Webhook agregado por <b>{user1}</b>, agregado por <b>{user2}</b>.",
            chatClosed: "El chat con <b>{visitor}</b> fue finalizado por <b>{agent}</b>.",
            chatOwnerUpdated: "<b>{agent}</b> reasignó a <b>{visitor}</b> de <b>{oldOwner}</b> a <b>{newOwner}</b>.",
            customerOwnershipRemoved: "<b>{actor}</b> eliminó la propiedad de <b>{visitor}</b> de <b>{oldOwner}</b>, dejándolo sin propietario.",
            customerOwnershipAssigned: "<b>{actor}</b> asignó la propiedad de <b>{visitor}</b> de sin propietario a <b>{newOwner}</b>.",
            customerOwnershipReassigned: "<b>{actor}</b> reasignó la propiedad de <b>{visitor}</b> de <b>{oldOwner}</b> a <b>{newOwner}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> inició un chat <b>{platform}</b> con <b>{visitor}</b>.",
            chatOpenedByVisitor: "Se inició un chat <b>{platform}</b> por <b>{visitor}</b>.",
            channelRemoved: "El canal <b>{channel}</b> fue eliminado por <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> creó un representante llamado <b>{newAgent}</b>.",
            visitorUnblocked: "El visitante <b>{visitor}</b> desbloqueado por el usuario <b>{agent}</b>.",
            visitorBlocked: "El visitante <b>{visitor}</b> bloqueado por <b>{agent}</b>.",
            userStatusChanged: "El usuario <b>{name}</b> cambió el estado de <b>{oldStatus}</b> a <b>{newStatus}</b>.",
            channelCreated: "El canal <b>{channel}</b> fue creado por <b>{name}</b>.",
            reservationCreatedPlan: "<b>{name}</b> usuario programó la cita llamada <b>{title}</b> para el <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> usuario ha actualizado la cita llamada <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> Benutzer hat den Termin mit dem Namen <b>{title}</b> gelöscht.",
            reservationCreated: "Se ha creado una reserva para el usuario <b>{name}</b> y el visitante <b>{visitor}</b> en la fecha <b>{date}</b>.",
            reservationDeleted: "La cita programada entre el usuario <b>{name}</b> y el visitante <b>{visitor}</b> en la fecha <b>{date}</b> ha sido cancelada.",
            taskWorkflowCrud: "El flujo de trabajo de la tarea se crea, actualiza o elimina",
            taskCrud: "La tarea se crea, actualiza o elimina",
            taskStatusChanged: "Cuando cambia el estado de la tarea",
            autoRebalanceEvents: "Cuando un reequilibrio automático se completa, falla o se desactiva.",
            automationActions: "Acciones de automatización",
            automationCreated: "{user} creó una automatización llamada {automation}.",
            automationDeleted: "{user} eliminó una automatización llamada {automation}.",
            automationRestored: "{user} restauró la automatización {automation} desde la papelera.",
            automationPublished: "{user} publicó una automatización llamada {automation}.",
            automationUnpublished: "{user} despublicó una automatización llamada {automation}.",
            automationUpdated: "{user} actualizó una automatización llamada {automation}.",
            automationCreatedNotification: "Cuando se crea una automatización.",
            automationDeletedNotification: "Cuando se elimina una automatización.",
            automationRestoredNotification: "Cuando la automatización se restaura desde la papelera.",
            automationPublishedNotification: "Cuando se publica una automatización.",
            automationUnpublishedNotification: "Cuando se despublica una automatización.",
            automationUpdatedNotification: "Cuando se actualiza una automatización.",
            formDeleted: "{user} eliminó el formulario \"{formName}\" (ID: {formId}).",
            formDeletedPermanent: "{user} eliminó permanentemente el formulario \"{formName}\" (ID: {formId}).",
            formRestored: "{user} restauró el formulario \"{formName}\" (ID: {formId}) desde la papelera.",
            formCreated: "{user} creó el formulario \"{formName}\".",
            formUpdated: "{user} actualizó el formulario \"{formName}\".",
            formDownloaded: "{user} descargó los datos del formulario \"{formName}\" (ID: {formId}).",
            userRoleChanged: "{actor} cambió el rol del usuario \"{userName}\" de \"{oldRoleName}\" a \"{newRoleName}\".",
            userPasswordChanged: "{actor} cambió la contraseña del usuario \"{userName}\".",
            userEmailChanged: "{actor} cambió el correo del usuario \"{userName}\" de \"{oldEmail}\" a \"{newEmail}\".",
            userNameChanged: "{actor} cambió el nombre del usuario \"{userName}\" de \"{oldName}\" a \"{newName}\".",
            userPhoneChanged: "{actor} cambió el teléfono del usuario \"{userName}\" de \"{oldPhone}\" a \"{newPhone}\".",
            userDisabled: "{actor} deshabilitó al usuario \"{userName}\".",
            userEnabled: "{actor} habilitó al usuario \"{userName}\".",
            roleUpdated: "{actor} actualizó el rol \"{roleName}\".",
            taskWorkflowUpdated: "{actor} actualizó el flujo de trabajo \"{workflowTitle}\".",
            taskWorkflowPipelineStageAdded: "{actor} añadió la etapa \"{stageName}\" al flujo de trabajo \"{workflowTitle}\".",
            taskWorkflowPipelineStageUpdated: "{actor} actualizó la etapa \"{stageName}\" del flujo de trabajo \"{workflowTitle}\".",
            taskWorkflowPipelineStageDeleted: "{actor} eliminó la etapa \"{stageName}\" del flujo de trabajo \"{workflowTitle}\".",
            driveFolderCreated: "{actor} creó la carpeta \"{folderName}\".",
            driveFolderDeleted: "{actor} eliminó la carpeta \"{folderName}\".",
            driveFolderRenamed: "{actor} renombró la carpeta \"{oldName}\" a \"{newName}\".",
            driveFileAdded: "{actor} añadió el archivo \"{fileName}\".",
            driveFileDeleted: "{actor} eliminó el archivo \"{fileName}\".",
            taskModuleRulesEnabled: "{actor} habilitó las reglas de tareas del flujo de trabajo \"{workflowTitle}\".",
            taskModuleRulesDisabled: "{actor} deshabilitó las reglas de tareas del flujo de trabajo \"{workflowTitle}\".",
            taskModuleRulesRuleAdded: "{actor} añadió la regla \"{ruleName}\" al flujo de trabajo \"{workflowTitle}\".",
            taskModuleRulesRuleDeleted: "{actor} eliminó la regla \"{ruleName}\" del flujo de trabajo \"{workflowTitle}\".",
            taskModuleRulesRuleUpdated: "{actor} actualizó la regla \"{ruleName}\" del flujo de trabajo \"{workflowTitle}\".",
            taskModuleRulesRuleEnabled: "{actor} habilitó la regla \"{ruleName}\" del flujo de trabajo \"{workflowTitle}\".",
            taskModuleRulesRuleDisabled: "{actor} deshabilitó la regla \"{ruleName}\" del flujo de trabajo \"{workflowTitle}\".",
            contactModuleRulesEnabled: "{actor} habilitó las reglas del módulo de contactos.",
            contactModuleRulesDisabled: "{actor} deshabilitó las reglas del módulo de contactos.",
            contactModuleRulesRuleAdded: "{actor} añadió la regla \"{ruleName}\" al módulo de contactos.",
            contactModuleRulesRuleUpdated: "{actor} actualizó la regla \"{ruleName}\" del módulo de contactos.",
            contactModuleRulesRuleDeleted: "{actor} eliminó la regla \"{ruleName}\" del módulo de contactos.",
            contactModuleRulesRuleEnabled: "{actor} habilitó la regla \"{ruleName}\" del módulo de contactos.",
            contactModuleRulesRuleDisabled: "{actor} deshabilitó la regla \"{ruleName}\" del módulo de contactos.",
            developerTokenChanged: "{actor} actualizó el token de acceso de desarrollador.",
            tableCreated: "{actor} creó la tabla \"{tableName}\".",
            tableDeleted: "{actor} eliminó la tabla \"{tableName}\".",
            tableRestored: "{actor} restauró la tabla \"{tableName}\" desde la papelera.",
            tablePermanentlyDeleted: "{actor} eliminó permanentemente la tabla \"{tableName}\" de la papelera.",
            tableFieldAdded: "{actor} añadió el campo \"{fieldName}\" a la tabla \"{tableName}\".",
            tableFieldUpdated: "{actor} actualizó el campo \"{fieldName}\" de la tabla \"{tableName}\".",
            tableFieldDeleted: "{actor} eliminó el campo \"{fieldName}\" de la tabla \"{tableName}\".",
            tableViewAdded: "{actor} añadió la vista \"{viewName}\" a la tabla \"{tableName}\".",
            tableViewUpdated: "{actor} actualizó la vista \"{viewName}\" de la tabla \"{tableName}\".",
            tableViewDeleted: "{actor} eliminó la vista \"{viewName}\" de la tabla \"{tableName}\".",
            tablePageAdded: "{actor} añadió la página \"{pageName}\" a la tabla \"{tableName}\".",
            tablePageUpdated: "{actor} actualizó la página \"{pageName}\" de la tabla \"{tableName}\".",
            tablePageDeleted: "{actor} eliminó la página \"{pageName}\" de la tabla \"{tableName}\".",
            tableWidgetAdded: "{actor} añadió el widget \"{widgetTitle}\" ({widgetType}) a la página \"{pageName}\" de la tabla \"{tableName}\".",
            tableWidgetUpdated: "{actor} actualizó el widget \"{widgetTitle}\" ({widgetType}) en la página \"{pageName}\" de la tabla \"{tableName}\".",
            tableWidgetDeleted: "{actor} eliminó el widget \"{widgetTitle}\" ({widgetType}) de la página \"{pageName}\" de la tabla \"{tableName}\".",
            tablePermissionChanged: "{actor} actualizó la configuración de privacidad de la tabla \"{tableName}\".",
            tableDataDownloaded: "{actor} descargó {recordCount} registros de la tabla \"{tableName}\".",
            tableDataImported: "{actor} importó {successCount}/{recordCount} registros en la tabla \"{tableName}\".",
            tableDataBatchUpdated: "{actor} actualizó en masa el campo \"{fieldName}\" de {recordCount} registros en la tabla \"{tableName}\".",
            tableDataBatchDeleted: "{actor} eliminó en masa {recordCount} registros de la tabla \"{tableName}\".",
            contactDataDownloaded: "{actor} descargó datos de {contactCount} contactos.",
            contactBatchUpdated: "{actor} realizó la actualización masiva {action} para {contactCount} contactos.",
            chatDataDownloaded: "{actor} descargó el historial de {chatCount} chats.",
            chatDataDownloadedWithVisitor: "{actor} descargó el historial de chat con \"{visitorName}\".",
            visitorTagAdded: "{actor} añadió la etiqueta {tagNames} a {visitorName}.",
            visitorTagRemoved: "{actor} eliminó la etiqueta {tagNames} de {visitorName}.",
            unknownVisitor: "Contacto desconocido",
            tagsLabel: "Etiquetas",
            webAppCreated: "{actor} creó la aplicación web \"{appName}\" ({appSlug}).",
            webAppUpdated: "{actor} actualizó la aplicación web \"{appName}\" ({appSlug}).",
            webAppDeleted: "{actor} eliminó la aplicación web \"{appName}\" ({appSlug}).",
            webTabCreated: "{actor} añadió la pestaña web \"{tabName}\" en {placement}.",
            webTabUpdated: "{actor} actualizó la pestaña web \"{tabName}\".",
            webTabDeleted: "{actor} eliminó la pestaña web \"{tabName}\" ({placement}).",
            moduleCreated: "{actor} creó \"{moduleName}\" {moduleType}.",
            moduleUpdated: "{actor} actualizó \"{moduleName}\" {moduleType}.",
            moduleDeleted: "{actor} eliminó \"{moduleName}\" {moduleType}.",
            relationCreated: "{actor} creó la relación \"{relationName}\".",
            relationUpdated: "{actor} actualizó la relación \"{relationName}\".",
            voiceAgentCreated: "{actor} creó el agente de voz \"{agentName}\" ({agentId}).",
            voiceAgentUpdated: "{actor} actualizó el agente de voz \"{agentName}\" ({agentId}).",
            voiceAgentDeleted: "{actor} eliminó el agente de voz \"{agentName}\" ({agentId}).",
            voiceAgentPhoneNumberInboundAgentChanged: "{actor} cambió el agente de llamadas entrantes del número {phoneNumber} a \"{agentName}\".",
            voiceAgentPhoneNumberOutboundAgentChanged: "{actor} cambió el agente de llamadas salientes del número {phoneNumber} a \"{agentName}\".",
            voiceAgentBatchCallCreated: "{actor} creó la llamada masiva \"{batchCallName}\" ({taskCount} contactos).",
            voiceAgentKnowledgeBaseCreated: "{actor} creó la base de conocimientos \"{knowledgeBaseName}\".",
            voiceAgentKnowledgeBaseDeleted: "{actor} eliminó la base de conocimientos \"{knowledgeBaseName}\".",
            webTabCreatedNotification: "Cuando se crea una pestaña web.",
            webTabUpdatedNotification: "Cuando se actualiza una pestaña web.",
            webTabDeletedNotification: "Cuando se elimina una pestaña web.",
            moduleCreatedNotification: "Cuando se crea un módulo o relación.",
            moduleUpdatedNotification: "Cuando se actualiza un módulo o relación.",
            moduleDeletedNotification: "Cuando se elimina un módulo o relación.",
            relationCreatedNotification: "Cuando se crea una relación.",
            relationUpdatedNotification: "Cuando se actualiza una relación.",
            voiceAgentCreatedNotification: "Cuando se crea un agente de voz.",
            voiceAgentUpdatedNotification: "Cuando se actualiza un agente de voz.",
            voiceAgentDeletedNotification: "Cuando se elimina un agente de voz.",
            voiceAgentPhoneNumberInboundAgentChangedNotification: "Cuando se cambia el agente de llamadas entrantes del número.",
            voiceAgentPhoneNumberOutboundAgentChangedNotification: "Cuando se cambia el agente de llamadas salientes del número.",
            voiceAgentBatchCallCreatedNotification: "Cuando se crea una llamada masiva.",
            voiceAgentKnowledgeBaseCreatedNotification: "Cuando se crea una base de conocimientos.",
            voiceAgentKnowledgeBaseDeletedNotification: "Cuando se elimina una base de conocimientos.",
            formDeletedNotification: "Cuando se elimina un formulario.",
            formRestoredNotification: "Cuando el formulario se restaura desde la papelera.",
            formCreatedNotification: "Cuando se crea un formulario.",
            formUpdatedNotification: "Cuando se actualiza un formulario.",
            formDownloadedNotification: "Cuando se descargan los datos del formulario.",
            userRoleChangedNotification: "Cuando cambia el rol del usuario.",
            userPasswordChangedNotification: "Cuando cambia la contraseña del usuario.",
            userEmailChangedNotification: "Cuando cambia el correo del usuario.",
            userNameChangedNotification: "Cuando cambia el nombre del usuario.",
            userPhoneChangedNotification: "Cuando cambia el teléfono del usuario.",
            userDisabledNotification: "Cuando el usuario se deshabilita o se activa.",
            roleUpdatedNotification: "Cuando se actualiza un rol.",
            taskWorkflowUpdatedNotification: "Cuando se actualiza el flujo de trabajo.",
            taskWorkflowPermanentlyDeletedNotification: "Cuando el flujo de trabajo se elimina de la papelera.",
            taskWorkflowPipelineStageAddedNotification: "Cuando se añade una etapa al flujo de trabajo.",
            taskWorkflowPipelineStageUpdatedNotification: "Cuando se actualiza una etapa del flujo de trabajo.",
            taskWorkflowPipelineStageDeletedNotification: "Cuando se elimina una etapa del flujo de trabajo.",
            driveFolderCreatedNotification: "Cuando se crea una carpeta en Drive.",
            driveFolderDeletedNotification: "Cuando se elimina una carpeta de Drive.",
            driveFolderRenamedNotification: "Cuando se renombra una carpeta de Drive.",
            driveFileAddedNotification: "Cuando se añade un archivo a Drive.",
            driveFileDeletedNotification: "Cuando se elimina un archivo de Drive.",
            taskModuleRulesEnabledNotification: "Cuando se habilitan las reglas de tareas.",
            taskModuleRulesDisabledNotification: "Cuando se deshabilitan las reglas de tareas.",
            taskModuleRulesRuleAddedNotification: "Cuando se añade una regla al flujo de trabajo.",
            taskModuleRulesRuleDeletedNotification: "Cuando se elimina una regla del flujo de trabajo.",
            taskModuleRulesRuleUpdatedNotification: "Cuando se actualiza una regla del flujo de trabajo.",
            taskModuleRulesRuleEnabledNotification: "Cuando se habilita una regla del flujo de trabajo.",
            taskModuleRulesRuleDisabledNotification: "Cuando se deshabilita una regla del flujo de trabajo.",
            contactModuleRulesEnabledNotification: "Cuando se habilitan las reglas del módulo de contactos.",
            contactModuleRulesDisabledNotification: "Cuando se deshabilitan las reglas del módulo de contactos.",
            contactModuleRulesRuleAddedNotification: "Cuando se añade una regla al módulo de contactos.",
            contactModuleRulesRuleUpdatedNotification: "Cuando se actualiza una regla del módulo de contactos.",
            contactModuleRulesRuleDeletedNotification: "Cuando se elimina una regla del módulo de contactos.",
            contactModuleRulesRuleEnabledNotification: "Cuando se habilita una regla del módulo de contactos.",
            contactModuleRulesRuleDisabledNotification: "Cuando se deshabilita una regla del módulo de contactos.",
            developerTokenChangedNotification: "Cuando se actualiza el token de acceso de desarrollador.",
            tableCreatedNotification: "Cuando se crea una nueva tabla.",
            tableDeletedNotification: "Cuando se elimina una tabla.",
            tableRestoredNotification: "Cuando la tabla se restaura desde la papelera.",
            tablePermanentlyDeletedNotification: "Cuando la tabla se elimina de la papelera.",
            tableFieldAddedNotification: "Cuando se añade un campo a la tabla.",
            tableFieldUpdatedNotification: "Cuando se actualiza un campo de la tabla.",
            tableFieldDeletedNotification: "Cuando se elimina un campo de la tabla.",
            tableViewActionsNotification: "Cuando se añade, actualiza o elimina una vista de la tabla.",
            tablePageActionsNotification: "Cuando se añade, actualiza o elimina una página de la tabla.",
            tableWidgetActionsNotification: "Cuando se añade, actualiza o elimina un widget de la página de la tabla.",
            tablePermissionChangedNotification: "Cuando se actualiza la configuración de privacidad de la tabla.",
            tableDataDownloadedNotification: "Cuando se descargan datos de la tabla.",
            tableDataImportedNotification: "Cuando se importan registros en masa a la tabla.",
            tableDataBatchUpdatedNotification: "Cuando se actualizan registros en masa en la tabla.",
            tableDataBatchDeletedNotification: "Cuando se eliminan registros en masa de la tabla.",
            contactBatchUpdatedNotification: "Cuando se actualizan contactos en masa.",
            chatDataDownloadedNotification: "Cuando se descarga el historial de chat.",
            webAppCreatedNotification: "Cuando se crea una aplicación web.",
            webAppUpdatedNotification: "Cuando se actualiza una aplicación web.",
            webAppDeletedNotification: "Cuando se elimina una aplicación web.",
            formActions: "Cuando se crea, actualiza o elimina un formulario.",
            userInfoActions: "Cuando cambian datos del usuario (rol, contraseña, email, nombre, teléfono, estado).",
            driveActions: "Operaciones de carpetas y archivos en Drive.",
            developerActions: "Cuando se actualiza el token de acceso de desarrollador.",
            contactModuleRulesActions: "Cuando se habilitan, deshabilitan, añaden, actualizan o eliminan reglas del módulo de contactos.",
            tableActions: "Cuando se crea una tabla o se añade, actualiza o elimina un campo.",
            wabaSupsisPartnerRemove: "Cuando se elimina el partner de Whatsapp Business API V2.",
            wabaSupsisAccountDeleted: "Cuando se elimina la cuenta de Whatsapp Business API V2.",
            wabaSupsisAccountViolation: "Cuando se detecta una violación de cuenta de Whatsapp Business API V2.",
            wabaSupsisAdAccountLinked: "Cuando se vincula la cuenta publicitaria de Whatsapp Business API V2.",
            wabaSupsisAuthIntlPriceEligibilityUpdate: "Cuando se actualiza la elegibilidad de precios internacionales de Whatsapp Business API V2.",
            wabaSupsisDisabledUpdate: "Cuando se actualiza el estado de deshabilitación de Whatsapp Business API V2.",
            wabaSupsisMmLiteTermsSigned: "Cuando se firman los términos MM Lite de Whatsapp Business API V2.",
            wabaSupsisPartnerAdded: "Cuando se añade el partner de Whatsapp Business API V2.",
            wabaSupsisPartnerAppInstalled: "Cuando se instala la aplicación del partner de Whatsapp Business API V2.",
            wabaSupsisPartnerAppUninstalled: "Cuando se desinstala la aplicación del partner de Whatsapp Business API V2.",
            wabaSupsisPartnerClientCertificationStatusUpdate: "Cuando se actualiza el estado de certificación del cliente del partner de Whatsapp Business API V2.",
            wabaSupsisBusinessPrimaryLocationCountryUpdate: "Cuando se actualiza el país de ubicación principal de Whatsapp Business API V2.",
            wabaSupsisVolumeBasedPricingTierUpdate: "Cuando se actualiza el nivel de precios por volumen de Whatsapp Business API V2.",
            wabaSupsisMessageTemplateComponentsUpdate: "Cuando se actualizan los componentes de plantilla de mensaje de Whatsapp Business API V2.",
            wabaSupsisMessageTemplateStatusUpdate: "Cuando se actualiza el estado de plantilla de mensaje de Whatsapp Business API V2.",
            wabaSupsisTemplateCategoryUpdate: "Cuando se actualiza la categoría de plantilla de Whatsapp Business API V2.",
            chatbotRestored: "El chatbot <b>{chatbot}</b> fue restaurado desde la papelera por <b>{user}</b>.",
            taskWorkflowRestored: "El flujo de trabajo <b>{workflow}</b> fue restaurado desde la papelera por <b>{user}</b>.",
            taskWorkflowPermanentlyDeleted: "El flujo de trabajo <b>{workflow}</b> fue eliminado de la papelera por <b>{user}</b>.",
            userLoggenIn: "<b>{user}</b> inició sesión en SUPSIS.",
            channelForwardConfigUpdated: "{actor} actualizó la configuración de reenvío del canal \"{channelName}\" {channelType}.",
            channelZohoConfigUpdated: "{actor} actualizó la configuración de integración Zoho del canal \"{channelName}\" {channelType}.",
            webhookUpdated: "{actor} actualizó el webhook \"{webhookName}\" ({webhookUrl})."
        },
        search: {
            prefix: {
                jump: "Git",
                new: "Nuevo",
                visitor: "Persona",
                dm: "DM",
                chatbot: "Chatbot",
                automation: "Automatización",
                table: "Tabla",
                module: "módulo",
                message: "Mensaje"
            },
            calendar: "Calendario",
            soundSettings: "Notificaciones de audio",
            allNotificationSettings: "Ajustes de notificación",
            allAuditLogs: "Registros de auditoría",
            allNotifications: "Todas las notificaciones",
            allActivities: "Todas las actividades",
            workFlow: "Flujo de trabajo",
            editTask: "Editar tarea",
            tasks: "Tareas",
            todo: "Cosas por hacer",
            tapTo: "Pulse ⇥ para operaciones '{prefix}'",
            newUsers: "Nuevo ⇥ usuario",
            newTags: "Nueva ⇥ Etiqueta",
            newRole: "Nuevo ⇥ Rol",
            newTrigger: "Nuevo ⇥ Trigger",
            newDepartment: "Nuevo ⇥ Departamento",
            newTicket: "Nuevo ⇥ Etiqueta",
            jumpSettings: "Ir ⇥ Ajustes",
            jumpIntegrations: "Ir ⇥ Integraciones",
            jumpTeam: "Ir ⇥ Equipo",
            jumpUsers: "Ir ⇥ Usuarios",
            jumpReport: "Ir ⇥ Informe",
            timingSettings: "Ajustes de temporización",
            exampleVisitorMail: "Visitante@mail.com",
            languageAndRegion: "Idioma y región",
            theme: "Tema",
            appearance: "Apariencia",
            color: "Color",
            fondo: "Fondo",
            smart: "Smart",
            teamChat: "Chat de equipo",
            chatbot: "ChatBot",
            chatbotTraining: "Entrenamiento de chatbot",
            chatbotUserSegments: "Segmentos de usuario de chatbot",
            chatbotIntegration: "Integración de Chatbot",
            chatbotEntities: "Entidades de Chatbot",
            chatbotIntegrationWebHook: "Integración Chatbot WebHook",
            chatbotArchive: "Archivo Chatbot",
            chatbotTemplatesAI: "Plantillas de inteligencia artificial de chatbot",
            chatbotTemplates: "Plantillas de Chatbot",
            chatbotReportsOverall: "Informes generales del chatbot",
            chatbotReportsAllChats: "Chatbot informa de todos los chats",
            chatbotReportsRatingDistribution: "Distribución de valoraciones de los informes del chatbot",
            chatbotReportsPaidChats: "Chatbot informa de chats de pago",
            chatbotReportsBusiestPeriod: "Periodo de mayor actividad del chatbot",
            chatbotTemplatesAllMessages: "Plantillas de chatbot Todos los mensajes",
            chatbotTemplatesAvarage: "Promedio de plantillas de chatbot",
            chatbotTemplatesPopularity: "Popularidad de las plantillas de chatbot",
            chatbotTemplatesAllUser: "Plantillas de chatbot de todos los usuarios",
            ticket: "Solicitudes de soporte",
            archives: "Archivo",
            tags: "Etiquetas",
            offlineSupportRequests: "Solicitudes de soporte sin conexión",
            roles: "Roles",
            users: "Usuarios",
            departments: "Departamentos",
            contents: "Contenidos Instantáneos",
            welcomeMessages: "Mensajes del sistema",
            catalog: "Catálogo",
            bannedWords: "Palabras prohibidas",
            bannedVisitors: "Visitantes prohibidos",
            application: "Aplicación",
            mails: "Correo",
            visitors: "Visitantes",
            integrationsWebhook: "Integración Webhook",
            billing: "Factura",
            reportNew: "Nuevo informe",
            integraciones: "Integraciones",
            chatbotStory: "Historias de chatbot",
            searchPlaceHolder: "Buscar, Ir o Añadir...",
            searchAreaTitle: "Buscar Supsis",
            searchAreaDesc1: "Puedes buscar cualquier cosa. Sólo",
            searchAreaDesc2: "o",
            searchAreaDesc3: "escribe o busca cualquier cosa",
            navigateBtn: "Navegar",
            selectBtn: "Seleccionar",
            cancelBtn: "Cancelar",
            integration: {
                shouldByInstaPack: "Usted debe comprar Instagram paquete para crear un canal de Instagram. Puede llegar a los paquetes con precios asequibles de inmediato.",
                createInstaLimitMax: "Has alcanzado el límite de creación de canales de Instagram. Maximun.",
                createInstaContinue: "Puedes crear un canal de Instagram. Para continuar, actualiza tu paquete o elimina alguno de tus canales de Instagram.",
                privatePolicy: "Política privada.",
                termsAndCondition: "Términos y condiciones.",
                readAndAgree: "He leído y estoy de acuerdo.",
                shouldByMessengerPack: "Debes adquirir un paquete de Messenger para crear un canal de Messenger. Puedes acceder a los paquetes con precios asequibles de forma inmediata.",
                createMessengerLimitMax: "Has alcanzado el límite de creación de canales de Messenger. Maximun.",
                createMessengerContinue: "Puedes crear un canal de mensajería. Para continuar, actualiza tu paquete o elimina alguno de tus canales Messenger.",
                selectMessengerAccount: "Selecciona cuenta de Messenger.",
                forwardLiveAgents: "👉 Reenviar agentes en directo",
                allDepartments: "Todos los Departamentos",
                deleteAll: "Borrar todo",
                wpBusinessAPI: "Integraciones - Whatsapp Business API",
                wpV1: "Integraciones - Multi Canales Whatsapp",
                instagram: "Integraciones - Instagram",
                instagramContactList: "Integraciones - Lista de contactos de Instagram",
                mail: "Integraciones - Mail",
                whatsapp: "Integraciones - Whatsapp",
                whatsappContactList: "Integraciones - Lista de contactos de Whatsapp",
                wpBCRequests: "Integraciones - Solicitudes de mensajes masivos de Whatsapp",
                wpBCCustomerGroups: "Integraciones - Grupos de clientes de Whatsapp a granel",
                wpBCTemplates: "Integraciones - Plantillas de mensajes masivos de Whatsapp",
                chatbot: "Integraciones - ChatBot",
                allSections: "Todas las secciones",
                createInstaInstaLimitMax: "Ha alcanzado el límite máximo para crear canales de Instagram.",
                createMessengerMessengerLimitMax: "Ha alcanzado el límite máximo para crear canales de Messenger.",
                directClientsForward: "👉 Reenviar a agentes en directo",
                shouldByByMessengerPack: "Debe adquirir un paquete de Messenger para crear un canal de Messenger. Puede acceder a paquetes con precios asequibles de inmediato.",
                wpBCRichieste: "Integraciones - Solicitudes de mensajes masivos de Whatsapp"
            },
            settings: {
                settings: "Ajustes",
                features: "Ajustes - Características",
                languageAndRegion: "Ajustes - Idioma y región",
                bubbleSettings: "Ajustes - Ajustes de burbuja",
                bubbleActions: "Ajustes - Acciones de la burbuja",
                themeSettings: "Ajustes - Ajustes de tema",
                visitorLoginForm: "Ajustes - Formulario de inicio de sesión del visitante",
                visitorAttribute: "Ajustes - Atributos del visitante",
                autoAssign: "Ajustes - Asignación automática",
                talkSettings: "Ajustes - Ajustes de la conversación",
                chatTimingSettings: "Ajustes - Ajustes de tiempo de chat",
                availability: "Ajustes - Disponibilidad",
                websiteIntegration: "Ajustes - Integración con el sitio web",
                developer: "Ajustes - Desarrollador"
            },
            background: "Fondo",
            subjects: "Temas",
            integrations: "Integraciones",
            applicazione: "Aplicación",
            archivi: "Archivo",
            audioSettings: "Configuración de audio",
            chatbotArchiv: "Archivo de Chatbot",
            chatbotTemplatesAverage: "Promedio de plantillas de chatbot",
            content: "Contenido instantáneo",
            contenuti: "Contenidos instantáneos",
            emails: "Correo",
            forbiddenWords: "Palabras prohibidas",
            integrationOperations: "Operaciones de integración",
            integrazioni: "Integraciones",
            integrazioniWebhook: "Integración Webhook",
            intelligent: "Inteligente",
            invoices: "Facturación",
            kalender: "Calendario",
            mail: "Correo",
            mailMessages: "Mensajes de correo",
            navigation: "Navegación",
            newReport: "Nuevo informe",
            newSection: "Nueva sección",
            ruoli: "Roles",
            soggetti: "Departamentos",
            tag: "Etiqueta",
            topics: "Temas",
            utenti: "Usuarios",
            visitatori: "Visitantes",
            webhookIntegration: "Integración Webhook",
            workflow: "Flujo de trabajo"
        },
        mail: {
            errorStatus: "Estado de error",
            mailSendErrorTitle: "Correo no entregado",
            mailSendErrorDescription: "Total de correos electrónicos no entregados",
            fixGrammarTitle: "Corrección gramatical",
            expandTextTitle: "Expansión del texto",
            summaryTitle: "Resumen",
            changeToneTitle: "Cambio de tono",
            translationTitle: "Traducción",
            replyTitle: "Respuesta",
            customRequestTitle: "Respuesta a solicitud personalizada",
            viewMode: "Modo de visualización",
            singleView: "Vista única",
            splitView: "Vista dividida",
            folders: "Carpetas",
            sendError: "Ocurrió un error al enviar el correo electrónico. Por favor, inténtalo de nuevo más tarde.",
            visitorCreationError: "Error al crear el visitante. Por favor, inténtalo de nuevo más tarde.",
            onlyImageAllowed: "Solo se permiten archivos de imagen.",
            imageFileTooLarge: "El archivo de imagen es demasiado grande. El tamaño máximo es de 10 MB.",
            imageUploaded: "Imagen subida con éxito.",
            imageUploadError: "Ocurrió un error durante la carga de la imagen.",
            mailAiAssistant: {
                aiCreateSummarized: "Crear resumen con IA",
                aiSentimentAnalysis: "Análisis de sentimiento con IA",
                contentRequired: "Se requiere contenido de correo electrónico para utilizar esta función",
                grammarFixed: "La gramática ha sido corregida",
                aiError: "El asistente de IA encontró un error",
                contentExpanded: "El contenido del correo electrónico ha sido ampliado",
                emailSummarized: "El correo electrónico ha sido resumido",
                toneChanged: "El tono se cambió a {tone}",
                emailTranslated: "Correo electrónico traducido al {language}",
                replyGenerated: "Respuesta automática generada",
                contentUpdated: "El contenido ha sido actualizado",
                contentRebuilt: "El contenido ha sido reconstruido",
                contentRebuildFailed: "No se pudo reconstruir el contenido",
                customRequestEmpty: "Por favor, ingresa una solicitud",
                customRequestApplied: "El contenido de la solicitud personalizada ha sido aplicado",
                loadingText: "IA trabajando",
                loadingDescription: "El texto está siendo analizado, por favor espera...",
                aiTitle: "Asistente de Correo Electrónico con IA",
                aiDescription: "Herramientas de IA para mejorar, editar y analizar tu correo electrónico",
                emptyContentTitle: "No se encontró contenido de correo electrónico",
                emptyContentDescription: "Se requiere contenido para utilizar las funciones de IA.",
                limitedAccessDescription: "Solo se muestran funciones limitadas ya que no hay contenido de correo.",
                resultEmotions: "Emociones detectadas",
                analysisDescription: "Explicación del análisis",
                recommendationsList: "Sugerencias de mejora",
                mailSummarize: "Resumen del correo",
                aiResponse: "Generado por IA",
                rebuild: "Reconstruir",
                applyText: "Aplicar texto",
                specialRequest: "Solicitud personalizada",
                specialRequestPlaceholder: "Ingresa tus instrucciones personalizadas aquí...",
                sendRequest: "Enviar solicitud",
                fixGrammarTitle: "Corregir gramática",
                fixGrammardescription: "Corrige automáticamente errores ortográficos y gramaticales",
                expandTextTitle: "Expandir texto",
                expandTextDescription: "Hace tu texto más completo y detallado",
                changeToneTitle: "Cambiar tono",
                changeToneDescription: "Transforma el tono y estilo del texto al tipo deseado",
                changeTone_ProfessionalTitle: "Profesional",
                changeTone_ProfessionalDescription: "Tono formal y profesional para entornos laborales",
                changeTone_FriendlyTitle: "Amistoso",
                changeTone_FriendlyDescription: "Enfoque cálido y sincero",
                changeTone_CasualTitle: "Informal",
                changeTone_CasualDescription: "Tono conversacional relajado y cotidiano",
                changeTone_FormalTitle: "Formal",
                changeTone_FormalDescription: "Estilo muy formal y corporativo",
                changeTone_ConfidentTitle: "Confiado",
                changeTone_ConfidentDescription: "Estilo de expresión fuerte e impactante",
                translateTitle: "Traducir",
                translateDescription: "Traduce tu texto a diferentes idiomas",
                generateReplyTitle: "Generar respuesta",
                generateReplyDescription: "Genera automáticamente una respuesta adecuada al correo recibido",
                customPromptTitle: "Solicitud personalizada",
                customPromptDescription: "Genera contenido de correo en base a tus instrucciones personalizadas"
            },
            searchEmail: "Buscar correo...",
            emailAttachments: "Adjuntos ({count})",
            signatureMessage: "Tienes una firma configurada. ¿Quieres añadirla al contenido del correo?",
            emailSubject: "Asunto del correo",
            takeItBack: "Deshacer",
            fastForward: "Rehacer",
            addEmoji: "Agregar emoji",
            addLink: "Agregar enlace",
            bold: "Negrita",
            italic: "Cursiva",
            underline: "Subrayado",
            fontFamily: "Fuente",
            textColor: "Color del texto",
            stringFormats: "Formatos de texto",
            alignLeft: "Alinear a la izquierda",
            alignRight: "Alinear a la derecha",
            alignCenter: "Centrar",
            normalText: "Texto normal",
            participantList: "{first}, {second}, {third} +{remaining} más",
            noMailFound: "No se encontró ningún correo",
            selectedMail: "{count} correo(s) seleccionado(s)",
            recipientEmailAddress: "Dirección de correo del destinatario",
            CCreceivers: "Destinatarios en CC",
            BCCreceivers: "Destinatarios en BCC",
            emptyStateMessage: "Selecciona un correo o crea uno nuevo",
            FromName: "Nombre del Remitente",
            broadcastCreatedSuccess: "Transmisión creada con éxito",
            confirmArchive: "¿Está seguro de que desea archivar esta transmisión?",
            archive: "Archivar",
            cancel: "Cancelar",
            archiveSuccess: "Transmisión archivada con éxito",
            archiveError: "Error al archivar la transmisión",
            empty: "Vacío",
            summerDiscounts: "Descuentos de verano",
            opportunities: "Oportunidades",
            newMailTemplateCreated: "Crear nueva plantilla de correo electrónico",
            dateRange: "Intervalo de fechas",
            templateName: "Nombre de la plantilla",
            category: "Categoría",
            templateUpdateSucs: "La plantilla se actualizó correctamente",
            templateUpdateError: "Se ha producido un error al actualizar la plantilla",
            marketing: "Marketing",
            operational: "Operacional",
            custom: "Especial",
            pleaseEnterTemplateName: "Por favor, introduzca el nombre de la plantilla",
            pleaseEnterTemplateSubject: "Introduzca el asunto de la plantilla",
            pleaseSelectTemplateCategories: "Por favor, seleccione la categoría de la plantilla",
            representMails: "Correos representativos",
            otherRepresentMails: "Puede realizar un seguimiento de los correos electrónicos entrantes y salientes hacia y desde las direcciones de correo electrónico de otros representantes",
            signatureAutoAdd: "Se ha cambiado con éxito el estado de la adición automática de firmas",
            autoAdd: "Adición automática",
            forwardEmailAddSucs: "Dirección de correo electrónico de reenvío añadida con éxito",
            errorAddingForwardEmail: "Se ha producido un error al añadir una dirección de correo electrónico de reenvío",
            mailAddForward: "Adición manual (reenvío completado)",
            mailAddForwarding: "Adición manual (reenvío completado)",
            broadcast: "Publicaciones",
            templates: "Plantillas",
            newMailArrived: "Ha llegado correo nuevo",
            mailSentSucs: "Correo enviado con éxito",
            representativeMails: "Correo representativo",
            composeNewEmail: "Redactar nuevo correo electrónico",
            couldNotUserMail: "No se ha podido enviar correo porque no hay correo de usuario",
            mailAddressReq: "Dirección de correo requerida",
            emailAddressInvalid: "Dirección de correo no válida",
            departmentIsNotValid: "Departamento no válido",
            mailSendNotValid: "Dirección de correo no válida",
            routingSteps: "Pasos de enrutamiento",
            owner: "Propietario",
            whereHeDirected: "A dónde dirigió",
            forwardingEmailAddress: "Dirección de correo electrónico de reenvío",
            deleteMailDesc: "Esta acción no se puede deshacer.",
            deleteMailTitle: "¿Estás seguro de que quieres eliminar esta dirección de correo electrónico?",
            gmailForwardMail: "Reenvío de correo electrónico de Gmail",
            senderMailAddressDesc: "Por favor, ingrese la dirección de correo electrónico del remitente",
            verified: "Verificado",
            notForwarded: "No reenviado",
            notVerified: "No verificado",
            default: "Predeterminado",
            isVerified: "Verificado",
            forwarding: "Reenvío",
            mailAdress: "Dirección de correo electrónico",
            addSenderAddress: "Agregar dirección del remitente",
            outlookForward: "Reenvío de Microsoft (Outlook/Exchange)",
            gmailForward: "Reenvío de Google (Gmail)",
            senderMail: "Correo del remitente",
            mailDetail: "Detalle del correo",
            mailNotFound: "Correo no encontrado",
            mailSelecting: "Seleccionando correo",
            newMail: "Nuevo correo electrónico",
            myMails: "Mis correos electrónicos",
            inbox: "Bandeja de entrada",
            sent: "Enviado",
            departmentMails: "Correos electrónicos del departamento",
            newTemplate: "Nuevo plantilla",
            unread: "No leído",
            unreply: "Sin responder",
            reply: "Responder",
            attachments: "Adjuntos del correo",
            To: "Para",
            From: "De",
            placeHolders: "Marcadores de posición",
            attacheFiles: "Adjuntar archivos",
            replyAll: "Responder a todos",
            forward: "Reenviar",
            deleteThread: "Eliminar hilo",
            markAsRead: "Marcar como leído",
            markAsAllRead: "Marcar todo como leído",
            emailEditor: "Editor de correo electrónico",
            integrateYourMail: "Integra tu correo electrónico",
            connect: "Conectar",
            departmentMail: "Correo electrónico del departamento",
            createMailAddress: "Crear dirección de correo electrónico",
            createNewMail: "Crear nuevo correo electrónico",
            canNotUserMail: "No se pudo enviar el correo porque no hay correo de usuario",
            createNewEmail: "Crear nuevo correo electrónico",
            ly: "Responder",
            operativ: "Operacional",
            ply: "Responder"
        },
        visitor: {
            ownership: "Propiedad",
            visitors: "Visitantes",
            bannedVisitors: "Visitantes Prohibidos",
            tags: "Etiquetas",
            profileFields: "Campos de Perfil",
            downloadAll: "Descargar todo",
            saveAsCustomerGroup: "Guardar como grupo de clientes",
            saveSearchFavorite: "Guardar búsqueda como favorita",
            editOrDeleteFavorite: "Editar o eliminar favorito",
            mail: "Correo",
            visitorDetail: "Detalles del visitante",
            selectedUser: "{selectedUser} de {totalUsers} usuarios seleccionados",
            uncheck: "Desmarcar todo",
            checkAll: "Marcar todo",
            matchedUsers: "{checkedCount} usuarios coincidentes",
            more: "Más",
            exportUsers: "Exportar usuarios seleccionados",
            exportAllUsers: "Exportar todos los usuarios",
            addSegment: "Agregar segmento",
            deleteCheckedUser: "Eliminar usuarios seleccionados",
            deleteAllUser: "Eliminar todos los usuarios",
            matchedFilter: "Coincidir con todos los filtros",
            visitor: "Visitante",
            deleteUser: "Eliminar usuario",
            userData: "Datos de usuario",
            lastSession: "Última sesión",
            notUserData: "No se encontraron datos de usuario",
            segments: "Segmentos",
            addTag: "Agregar etiqueta",
            userChats: "Chats de usuario",
            seeAll: "Ver todos",
            confirm: "Confirmar",
            manageSegments: "Administrar segmentos",
            search: "Buscar",
            manageTags: "Administrar etiquetas",
            allAttributes: "Ver todos los atributos",
            noData: "Sin datos",
            noEmail: "Sin correo electrónico",
            noIpAddress: "Dirección IP no encontrada.",
            noWpNumber: "Número no encontrado.",
            filterName: "nombre del filtro..",
            matchedContacts: "{chechkedCount} contactos coincidentes",
            channelContacts: "Contactos del canal",
            searchInAllFields: "Buscar en todos los campos",
            searchInName: "Buscar en nombre",
            importContacts: "Importar contactos",
            addNewContact: "Añadir nuevo contacto",
            importContactsTitle: "Importar contactos",
            addSingleContactTitle: "Añadir contacto único",
            downloadRecordsSettings: "Descargar registros - Configuración",
            excelExport: "Exportar a Excel",
            exportTotalRecords: "Total {total} registros",
            exportCancel: "Cancelar",
            whatsappContacts: "Contactos de WhatsApp",
            instagramContacts: "Contactos de Instagram",
            messengerContacts: "Contactos de Messenger",
            linkedinContacts: "Contactos de LinkedIn",
            telegramContacts: "Contactos de Telegram",
            metaLeadsContacts: "Contactos de MetaLeads",
            searchPlaceholderAll: "Escriba aquí para buscar en todos los campos",
            searchPlaceholderFullname: "Escriba aquí para buscar por nombre",
            searchPlaceholderEmail: "Escriba aquí para buscar por correo electrónico",
            searchPlaceholderPhone: "Escriba aquí para buscar por teléfono",
            searchPlaceholderWhatsapp: "Escriba aquí para buscar por WhatsApp",
            searchPlaceholderDefault: "Buscar",
            searchFieldAll: "Todos los campos",
            searchFieldName: "Nombre",
            searchFieldEmail: "Correo electrónico",
            searchFieldPhone: "Número de teléfono",
            searchFieldWhatsapp: "Número de WhatsApp",
            searchModePhoneDetected: "Número de teléfono detectado",
            searchModeEmailDetected: "Dirección de correo detectada",
            searchModeNotPhone: "No es un número de teléfono",
            searchModeNotEmail: "No es un correo electrónico",
            searchMode: "Modo de búsqueda",
            searchModePhoneMessage: "\"{query}\" se detectó como número de teléfono. Actualmente está en el campo {field}. ¿Desea buscar en el campo de número de teléfono?",
            searchModeEmailMessage: "\"{query}\" se detectó como dirección de correo. Actualmente está en el campo {field}. ¿Desea buscar en el campo de correo electrónico?",
            searchModeNotPhoneMessage: "\"{query}\" no tiene formato de número de teléfono. ¿Desea buscar en todos los campos o en el campo de nombre?",
            searchModeNotEmailMessage: "\"{query}\" no tiene formato de correo electrónico. ¿Desea buscar en todos los campos o en el campo de nombre?",
            unknownTag: "Desconocido",
            noRecordsToDownload: "No hay registros para descargar",
            excelCreatedSuccess: "Archivo Excel creado correctamente",
            exportCancelled: "Exportación cancelada",
            excelCreateError: "Se produjo un error al crear el archivo Excel",
            yes: "Sí",
            no: "No",
            unowned: "Sin asignar",
            whatsappGroupCreatedSuccess: "Grupo de clientes de WhatsApp creado correctamente.",
            whatsappGroupCreateError: "Se produjo un error al crear el grupo de clientes de WhatsApp.",
            mailGroupCreatedSuccess: "Grupo de clientes de correo creado correctamente.",
            mailGroupCreateError: "Se produjo un error al crear el grupo de clientes de correo.",
            messageHistory: "Historial de mensajes",
            pastConversations: "Conversaciones anteriores",
            defaultUser: "Usuario",
            blockManagement: "Gestión de bloqueo",
            vipCustomer: "Cliente VIP",
            startChat: "Iniciar chat",
            createEvent: "Crear evento",
            createTask: "Crear tarea",
            selectTask: "Seleccionar tarea",
            webphoneCall: "Llamar con Webphone",
            capiEventSend: "Enviar evento CAPI",
            defaultName: "Visitante",
            notAvailable: "N/D",
            relatedList: "Lista relacionada",
            adReferrals: "Referencias de anuncios",
            calls: "Llamadas",
            generalInfo: "Información general",
            callHistory: "Historial de llamadas",
            webTab: "Pestaña web",
            widgetUrlError: "No se pudo crear la URL del widget",
            deleteSuccess: "Visitante eliminado correctamente.",
            taskStatusUpdateSuccess: "Estado de la tarea actualizado correctamente",
            taskStatusUpdateError: "Error al actualizar el estado de la tarea",
            copyToClipboard: "Copiado al portapapeles",
            noPhoneNumber: "No hay número de teléfono para llamar",
            webphoneCalling: "Llamando a {phoneNumber} con Webphone...",
            filterResultMax5000: "El resultado del filtro está limitado a un máximo de 5000 personas",
            onlyContactsPhoneNumber: "Solo las personas con número de teléfono se transferirán al grupo",
            enterGroupName: "Introduzca el nombre del grupo",
            showInColumns: "Mostrar en columnas",
            sendMailSucs: "Correo enviado correctamente",
            equal: "Igual",
            notEqual: "No igual",
            contains: "Contiene",
            notContains: "No contiene",
            startsWith: "Empieza con",
            endWith: "Termina con",
            deletedCheckedUser: "Eliminar usuarios seleccionados",
            userMails: "Correos del usuario"
        },
        chatbotv2: {
            Ticket_Actions: "Acciones de Ticket",
            Task_Actions: "Acciones de Tarea",
            Contact_Actions: "Acciones de Contacto",
            Calendar_Actions: "Acciones de Calendario",
            "T-Soft_Actions": "Acciones T-Soft",
            "Ticimax-V2_Actions": "Acciones Ticimax",
            TSOFT_SELECT_ORDER: "SELECCIONAR PEDIDO",
            TSOFT_ORDER_STATUS: "OBTENER EL ESTADO DEL PEDIDO",
            TICIMAX_V2_SELECT_ORDER: "SELECCIONAR PEDIDO",
            TICIMAX_V2_ORDER_STATUS: "OBTENER EL ESTADO DEL PEDIDO",
            Ikas_Actions: "Acciones de Ikas",
            IKAS_GET_MEMBER_INFO: "Obtener detalles del miembro",
            IKAS_SELECT_ORDER: "Seleccionar pedido",
            IKAS_ORDER_STATUS: "Obtener estado del pedido",
            IDEASOFT_PRODUCT_SEARCH: "Búsqueda de productos",
            privateMessageDescription: "El mensaje privado solo puede ser visto por los agentes y permanece oculto para los visitantes.",
            AI_RANDOM_TEXT: "Texto aleatorio de IA",
            AI_IMAGE: "Imagen de IA",
            PRIVATE_MESSAGE: "Mensaje Privado",
            aiPrompt: "Solicitud de IA",
            variants: "Variantes",
            Zoho_Actions: "Acciones de Zoho",
            Table_Actions: "Acciones de tabla",
            Cache_Actions: "Acciones de caché",
            File_Actions: "Acciones de archivo",
            Google_Drive_Actions: "Acciones de Google Drive",
            Artificial_Intelligence: "Inteligencia Artificial",
            Data_Formatters: "Formateadores de datos",
            Loop_Actions: "Acciones de bucle",
            importSuccess: "Plantilla importada con éxito",
            importFailed: "Error al importar la plantilla",
            creatingBlank: "ChatBOT en blanco en fase de creación...",
            untitledChatbot: "ChatBOT sin título",
            errorCreating: "Error al crear el ChatBOT",
            typeAutomationTitle: "Escriba el título de automatización",
            typeStoryTitle: "Escribe un título de historia",
            setUpYourChatbot: "Configura tu chatbot",
            setUpYourChatbotDesc: "Entrena tu chatbot con datos, utiliza nuestras plantillas listas para usar o empieza desde cero",
            blankBot: "Bot en blanco",
            blankBotDesc: "Crea un chatbot en blanco que podrás entrenar y personalizar más tarde",
            aiBotDesc: "Crea un chatbot de IA basado en RAG. Agrega una base de conocimiento y elige tu modelo LLM.",
            recommended: "Recomendado",
            websiteDesc: "Analiza el contenido de tu sitio web para obtener respuestas a las preguntas más frecuentes de los usuarios",
            yourNeedEnterYourOpenAi: "Tienes que introducir tu clave de API de OpenAI para crear un chatbot automatizado rastreando tu sitio web",
            createOpenAiKey: "Crear clave Api",
            aiKnowledge: "Conocimiento de Inteligencia Artificial",
            modalUsage: "Uso modal",
            usedContentSources: "Fuentes de contenido utilizadas",
            websites: "Sitios web",
            articles: "Artículos",
            faq: "Preguntas frecuentes",
            ficheros: "Ficheros",
            functions: "Funciones",
            settings: "Ajustes",
            disableAi: "Desactivar IA",
            enableAi: "Activar Inteligencia Artificial",
            lastEdited: "Última edición",
            state: "Estado",
            frequentlyAskedQuestions: "Preguntas frecuentes (FAQ)",
            faqIsCreated: "Preguntas frecuentes creadas",
            selectKnowEnabled: "Activación de las bases de conocimiento seleccionadas",
            selectKnowDisabled: "Las bases de conocimiento seleccionadas están deshabilitadas...",
            selectKnowNotEnabled: "Las bases de conocimiento seleccionadas no están habilitadas...",
            selectKnowNotDisabled: "Las bases de conocimiento seleccionadas no están deshabilitadas",
            answered: "Respondido",
            answer: "Respuesta",
            addFile: "Añadir archivo",
            fileDeleted: "Ficheros eliminados",
            fileDeletedFailed: "Hubo un problema al borrar archivos",
            noFileAdded: "No se ha añadido ningún archivo",
            aiFunctions: "Funciones AI",
            addFunction: "Añadir función",
            aiFunctionCreateHint: "No use caracteres turcos al crear funciones de IA. Use solo letras inglesas, números y guiones bajos en los nombres de las funciones.",
            builtInFunctionsTitle: "Funciones integradas",
            builtInFunctionsDesc: "Estas son funciones predefinidas que pueden ser utilizadas por la inteligencia artificial.",
            builtInFunctionsOptionButtonsTitle: "La IA puede enviar mensajes con botones",
            builtInFunctionsOptionButtonsDesc: "Permite que la IA muestre botones clicables al usuario. Cuando está activo, la IA puede ofrecer botones de opciones al usuario.",
            builtInFunctionsCloseConversationTitle: "La IA puede terminar la conversación",
            builtInFunctionsCloseConversationDesc: "Permite que la IA termine la conversación cuando sea apropiado. Cuando está activo, la IA puede cerrar el chat.",
            builtInFunctionsTransferChatTitle: "La IA puede transferir al soporte en vivo",
            builtInFunctionsTransferChatDesc: "Permite que la IA transfiera la conversación al soporte en vivo cuando sea necesario. Cuando está activo, la IA puede transferir la conversación a un agente humano.",
            parameterCount: "Recuento de parámetros",
            auto: "Auto",
            usedByAI: "Utilizado por la IA",
            usedByAi: "Utilizado por la IA",
            notUsed: "No utilizado",
            saveAndClose: "Guardar y cerrar",
            contentPreview: "Vista previa del contenido",
            addContent: "Añadir contenido",
            populerUserQuestion: "Escanea el contenido de tu web para obtener respuestas a preguntas populares de los usuarios.",
            enterUrlAddress: "Introduce una dirección URL",
            sharingYourUrl: "Al compartir tu URL, confirmas que tienes los derechos necesarios para compartir su contenido.",
            pageSelected: "Páginas seleccionadas",
            trainChatbot: "Entrenar el chatbot",
            thereAreOnePages: "Hay 1 página dentro",
            categoryDesc: "Categoría. Elige cuál usar para entrenar tu modelo de IA.",
            scarpOrAddContent: "Recorte o añada contenido, que AI Assist puede utilizar para responder a las consultas de sus clientes.",
            noContentAdded: "Sin contenido añadido",
            howItWorks: "Cómo funciona",
            editEntries: "Editar entradas",
            newEntries: "Nuevas entradas",
            chatbotManagement: "Gestión de chatbot",
            chatbotScenarioList: "Lista Chatbot Schenerio",
            exportDiagramToClipboard: "Exportar diagrama al portapapeles",
            selectedStory: "{count} historia seleccionada",
            Meta_Actions: "Acciones de Meta",
            suppressionRemoved: "Supresión eliminada",
            suppressionAdded: "Supresión agregada",
            didntSuppression: "No hiciste ninguna supresión.",
            whatsappIntegrationTitle: "Integración de WhatsApp V1 y WhatsApp V2",
            whatsappApiIntegrationTitle: "Integración de la API de WhatsApp Business",
            ReadyTemplateBadge: "Plantilla lista",
            readyTemplates: "Plantillas listas",
            regex: "Regex",
            regexDescription: "Captura todo con Regex",
            chatbotLogo: "Logo del ChatBot",
            chatbotName: "Nombre del ChatBot",
            allSecnario: "Lista de escenarios de chatbot",
            ChatbotScenarioList: "Lista de escenarios de chatbot",
            Scenario: "Escenarios",
            filters: {
                equal: "es igual a",
                not_equal: "no es igual",
                contain: "contener",
                not_contain: "no contiene",
                starts_with: "comienza con",
                ends_with: "termina con",
                empty: "esta vacio",
                non_empty: "no vacío",
                longer_than: "mas largo que",
                shorter_than: "más corto que",
                less_than: "menos que",
                less_or_equal: "Menos o igual",
                greater_than: "mas grande que",
                greater_or_equal: "mayor o igual"
            },
            planRequired: "{integratable} Plan requerido",
            noDefaultStoryTitle: "Historia predeterminada",
            noDefaultStory: "No hay una historia predeterminada.",
            noMessage: "Sin mensaje",
            loading: "Cargando",
            loadMore: "Carga más",
            hostname: "Nombre de host",
            goToStory: "ir a la historia",
            noResultFound: "No se han encontrado resultados",
            checkYourFilterCombination: "Revise su combinación de filtro",
            clearYourSearch: "borra tu búsqueda",
            andTryAgain: "e intenta de nuevo",
            allTemplates: "Todas las plantillas",
            allAITemplates: "Todas las plantillas de IA",
            templatesFromTheIndustry: "Plantillas de la industria",
            basicTemplate: "Plantilla básica",
            proTemplate: "Plantilla avanzada",
            withBot: "& Bot",
            userWithBot: "Usuario y bot",
            chatDetail: "Detalles del chat",
            allUserDetail: "Ver todos los detalles del usuario",
            sessionData: "Datos de sesión",
            supsisChatWidget: "Widget de chat de supsis",
            integratedWith: "Integrado con :",
            botStory: "Bot Story",
            integration: "Integración",
            Users: "Usuarios",
            user_id: "ID de usuario",
            categories: "Categorías",
            worksWith: "Funciona con",
            importBot: "Bot",
            keyFeatures: "Características clave",
            importing: "importador",
            comingSoon: "Muy pronto",
            pickStory: "Elige una historia",
            conversationId: "ID de conversación",
            integrateStoryWithSupsisWidget: "Integre el widget de supsis con la historia de chatbot",
            integrateStoryWithWhatsapp: "Integre WhatsApp con Chatbot Story",
            integrateStoryWithInstagram: "Integrar Instagram con Chatbot Story",
            selectIntegratingStory: "Seleccione la historia que se integrará",
            install: "Instalar",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "Correo electrónico",
                phone: "Teléfono",
                language: "Idioma",
                timezone: "Zona horaria",
                gender: "Género",
                country: "País",
                referrer: "Referente",
                department: "Departamento",
                url: "Url",
                ip: "Ip",
                last_seen: "Ultima vez visto",
                name: "Nombre",
                user_id: "ID de usuario",
                message: "Mensaje",
                akinon_brand: "Marca",
                akinon_order_id: "Solicitar ID",
                akinon_product_id: "ID del Producto",
                akinon_user_id: "ID de usuario",
                akinon_user_name: "Nombre de usuario",
                akinon_user_email: "Correo electrónico de usuario",
                akinon_invoice_url: "URL de factura",
                akinon_order_status: "Estado de pedido",
                akinon_order_price: "Precio del pedido",
                akinon_shipper_name: "Nombre del remitente",
                akinon_product_size: "Tamaño del producto",
                akinon_sku: "Sku",
                akinon_product_url: "URL del producto",
                akinon_product_title: "Titulo del producto",
                akinon_product_image: "Imagen del producto",
                akinon_product_stock: "Stock de productos",
                akinon_order_date: "Fecha de orden",
                akinon_track_number: "Número de pista",
                akinon_track_url: "URL de seguimiento",
                akinon_latitude: "Latitud",
                akinon_longitude: "Longitud",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "AI Class Result",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                last_meta_post_id: "Último ID de publicación de metadatos",
                last_meta_post_caption: "Última leyenda de publicación de metadatos",
                last_meta_post_type: "Último tipo de publicación de metadatos",
                visitor_trigger_type: "Tipo de activación de visitante",
                visitor_trigger_name: "Nombre del activador del visitante",
                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",
                offline_mode: "Modo offline",
                available_agents: "Agentes disponibles",
                platform: "Plataforma",
                probel_sube_kodu: "Código de sucursal",
                probel_brans_adi: "Nombre de la rama",
                probel_brans_kodu: "Código de rama",
                probel_doktor_adi: "Nombre del doctor",
                probel_doktor_kodu: "Código del doctor",
                probel_poliklinik_adi: "Nombre de la policlínica",
                probel_poliklinik_kodu: "Código de la policlínica",
                probel_randevu_tarihi: "Fecha de cita",
                probel_date: "Fecha de cita",
                probel_randevu_saati: "Hora de cita",
                probel_randevu_id: "ID de cita",
                probel_hasta_token: "Token del paciente",
                probel_kimlik_tipi: "Tipo de identificación",
                probel_kimlik_no: "Número de identificación",
                probel_hasta_adi: "Nombre del paciente",
                probel_hasta_soyadi: "Apellido del paciente",
                probel_hasta_cinsiyet: "Género",
                probel_hasta_dogum_tarihi: "Fecha de nacimiento",
                probel_hasta_telefon: "Teléfono",
                hour: "Hora",
                segments: "Segments",
                tags: "Etiquetas",
                ticket: "boleto",
                metaReferrals: "Metareferencias",
                owner: "Owner",
                trendyol_question: "Product Question",
                trendyol_question_id: "Product Question ID",
                trendyol_product_id: "Product ID",
                trendyol_product: "Product Data",
                id: "ID",
                conversationId: "Conversation ID",
                b2cargo_companyCode: "Company Code",
                b2cargo_takipNo: "Tracking Number",
                b2cargo_takipseri: "Tracking Serial",
                b2cargo_evrakdurum: "Order Status",
                b2cargo_teslimtar: "Delivery Date",
                b2cargo_gonderen: "Sender Name",
                b2cargo_aliciAdi: "Receiver Name",
                b2cargo_cikisIl: "Province of Departure",
                b2cargo_varisIl: "Province of Arrival",
                b2cargo_teslim: "Product Status",
                b2cargo_urun: "Product Type",
                b2cargo_atfTarih: "Product ATF Date",
                b2cargo_palet: "Product Palette",
                b2cargo_koli: "Product Parcel",
                b2cargo_kg: "Product WEIGHT",
                b2cargo_desi: "Product DESI",
                b2cargo_zimmetno: "Debit No",
                b2cargo_varissube: "Arrival Branch",
                b2cargo_atfDurum: "ATF State",
                holiday_plus_room_id: "Room ID",
                holiday_plus_room_title: "Room Title",
                holiday_plus_room_description: "Room Description",
                holiday_plus_room_size: "Room Size",
                holiday_plus_room_price: "Room Price",
                holiday_plus_room_price_offer: "Room Price Offer",
                holiday_plus_room_discount_price: "Room Discount Price",
                holiday_plus_selected_hotel_id: "Selected Hotel ID",
                holiday_plus_checkin: "Check In",
                holiday_plus_checkout: "Check Out",
                holiday_plus_child_count: "Child Count",
                holiday_plus_adult_count: "Adult Count",
                holiday_plus_child_dates: "Child Dates",
                reservation_time: "Reservation Time",
                reservation_day: "Reservation Day"
            },
            storyList: "Lista de historias",
            douYouWannaDeleteItem: "¿Quieres eliminar este artículo?",
            douYouWannaDeleteWithChildren: "¿Quieres eliminar este artículo con sus hijos?",
            stories: "Cuentos",
            templates: "Plantillas",
            aitemplates: "Plantillas de IA",
            integrations: "Integraciones",
            all: "Todo",
            installed: "Instalado",
            installationOK: "Instalado",
            uninstall: "Desinstalar",
            remainingMessageDesc: "Mensajes gratuitos restantes:",
            openAISiteRoutingDescStart: "Puede hacer clic en el enlace",
            openAISiteRoutingDescEnd: "Para obtener una clave API.",
            integrationOK: "Integrado",
            chatWidget: "Widget de chat de supsis",
            artificialIntelligence: "Inteligencia artificial",
            integratePlatform: "ChatBot se puede integrar con {integretable}.",
            integrateOpenAIWithChatbot: "Integre el chat gpt-4 con chatbot",
            integrateChatBotWithChatGPT3: "Integración de chatbot con chat gpt-4",
            integrateStoryWithTelegram: "Integre la historia con telegrama",
            webhooks: "Webhooks",
            archive: "Archivo",
            reports: "Informes",
            uncheckAll: "Desmarcar todo",
            userSegments: "Segmentos de usuario",
            sandbox: "Papelera",
            sandboxPage: {
                title: "Escenarios de Chatbot Eliminados",
                description: "Tus escenarios eliminados se eliminarán automáticamente después de 30 días en la papelera",
                emptyState: "No hay escenarios eliminados en la papelera",
                unnamedScenario: "Escenario sin título",
                restore: "Restaurar",
                permanentlyDelete: "Eliminar permanentemente",
                unknown: "Desconocido",
                user: "Usuario",
                restoreConfirmTitle: "¿Está seguro de que desea restaurar este escenario?",
                restoreConfirmContent: "El escenario {story} será restaurado.",
                restoreSuccess: "Escenario restaurado correctamente",
                restoreError: "Error al restaurar",
                permanentDeleteConfirmTitle: "¿Está seguro de que desea eliminar permanentemente este escenario?",
                permanentDeleteConfirmContent: "Esta acción no se puede deshacer. El escenario se eliminará permanentemente.",
                permanentDeleteSuccess: "Escenario eliminado permanentemente",
                permanentDeleteError: "Error en la operación de eliminación",
                loadError: "Error al cargar los escenarios eliminados"
            },
            customBlocks: "Bloques personalizados",
            blockMarket: "Mercado de bloques",
            browseBlockMarket: "Explorar mercado de bloques",
            searchBlocks: "Buscar bloques...",
            unknownBlock: "Bloque desconocido",
            aiModelsComparison: "Comparación de modelos IA",
            aiModelsChangeModel: "Cambiar modelo",
            aiModelsRecommended: "Recomendado",
            aiModelsEconomic: "Económico",
            aiModelsCodex: "Codex",
            comingSoonVectorIntro: "Con OpenAI Vector Storage puedes entrenar tu chatbot con tu contenido personalizado.",
            comingSoonStep1Title: "Sube tus archivos",
            comingSoonStep1Desc: "Añade tus archivos PDF, Word, Excel, texto u otros documentos al sistema.",
            comingSoonStep2Title: "Procesamiento automático",
            comingSoonStep2Desc: "Tus archivos son analizados por OpenAI y convertidos a formato vectorial.",
            comingSoonStep3Title: "Respuestas inteligentes",
            comingSoonStep3Desc: "Tu chatbot proporciona respuestas precisas y significativas basadas en el contenido que subiste.",
            comingSoonTip: "Consejo: A medida que añades más contenido, la base de conocimiento de tu chatbot se expande y puede responder de forma más completa.",
            comingSoonGotIt: "Entendido",
            imageProcessingSettings: {
                title: "Configuración de procesamiento de imágenes",
                description: "Determine cómo se procesarán las imágenes enviadas al chatbot.",
                processingMode: "Modo de procesamiento",
                processWithBlock: "Procesar con bloque",
                processWithBlockDesc: "Enrutar imágenes al flujo de bloques local",
                processWithAI: "Procesar con IA",
                processWithAIDesc: "Procesar imágenes con inteligencia artificial",
                fallbackBlock: "Bloque de respaldo",
                fallbackBlockDesc: "Bloque al que redirigir cuando ocurre un error durante el procesamiento de imágenes",
                fallbackBlockPlaceholder: "Seleccionar bloque de respaldo",
                directJumpBlock: "Bloque de salto directo",
                directJumpBlockDesc: "Enrutar todas las imágenes directamente a este bloque",
                directJumpBlockPlaceholder: "Seleccionar bloque de salto directo (opcional)",
                aiProcessingMode: "Modo de procesamiento IA",
                processIndividual: "Procesar uno por uno",
                processIndividualDesc: "Enviar cada imagen a la IA por separado",
                processParallel: "Procesar en paralelo",
                processParallelDesc: "Recopilar imágenes dentro de un tiempo determinado y enviarlas juntas",
                bufferTime: "Duración del búfer (segundos)",
                bufferTimeDesc: "Tiempo de espera para recopilar imágenes",
                saveSuccess: "Configuración de procesamiento de imágenes actualizada correctamente",
                saveError: "Error al guardar la configuración"
            },
            addSegment: "Agregar segmento",
            addToSegment: "Agregar al segmento",
            removeFromSegment: "Eliminar del segmento",
            plansVTippyContent: "La facturación de este paquete se realizará al principio de cada mes y, en caso de que desee cancelar, se le cobrará su uso hasta el principio del mes y su paquete expirará.<br><br>El precio del paquete no incluye el IVA.<br><br>Los cambios en el paquete se reflejan en la factura al día siguiente.",
            segmentName: "Nombre de segmento",
            sameSegment: "¡Hay un segmento con el mismo nombre!",
            usersInSegment: "Usuarios en segmento",
            noUsersAdded: "No hay usuarios agregados",
            updateSegment: "Segmento de actualización",
            newSegment: "Nuevo segmento",
            selectAll: "Seleccionar todo",
            queriesSelected: "Consultas seleccionadas",
            noBlocksFound: "¡No se encontraron bloques!",
            userQuery: "Consulta de usuario",
            date: "Fecha",
            unmatched: "Sin par",
            goToChat: "Ir a chatear",
            selectStory: "Seleccionar historia",
            selectBlock: "Bloque de selección",
            training: "Capacitación",
            trainingAlert: "Para implementar los cambios que realizaste en la página de entrenamiento del bot, debes publicar la nueva versión del escenario que modificaste.",
            unmatchedPhrases: "Frases inigualables",
            ignored: "Ignorado",
            story: "Historia",
            timePeriod: "Periodo de tiempo",
            wholeTimeSpan: "Tramo de tiempo completo",
            selectAStory: "Seleccione una historia",
            searchUserQuery: "Buscar consulta de usuario",
            time: {
                today: "Hoy",
                yesterday: "Ayer",
                last7: "Los últimos 7 días",
                last30: "Últimos 30 días",
                "this-month": "Este mes",
                "last-month": "El mes pasado",
                "last-3-month": "Últimos 3 meses",
                "this-year": "Este año",
                "last-year": "El año pasado",
                custom: "Elija una fecha diferente"
            },
            emailProvider: "Proveedor de correo electrónico",
            triggerFromAnywhere: "Disparar desde cualquier lugar",
            allIntegrations: "Todas las integraciones",
            integrateYourCBwithChatWidget: "Integre su chatbot con el widget de chat.",
            integrateYourCBwithChatGpt3: "ChatBot se puede integrar con GPT-4. Se requiere la tecla API GPT-4.",
            integrateYourCBwithWebHook: "Pase la información de chat entre chatbot y sus servicios web con facilidad.",
            integrateYourCBwithIntegratable: "Pase la información de chat entre chatbot y {integratable} con facilidad.",
            addWebhook: "Agregar webhook",
            editWebhook: "Editar webhook",
            newWebhook: "Nuevo webhook",
            webhookTitle: "Título de webhook",
            webhookUrl: "URL de webhook",
            webhookToken: "Token webhook",
            webhookUsername: "Nombre de usuario de webhook",
            webhookPassword: "Contraseña de webhook",
            editBlock: "Editar",
            moveBlock: "Mover",
            copyBlock: "Copiar",
            addFilter: "Añadir filtro",
            addFilterGroup: "Agregar grupo de filtro",
            clearFilter: "filtro transparente",
            in: "en",
            and: "y",
            or: "o",
            chatbot: "Chatbot",
            allStories: "Todas las historias",
            addBot: "Crear bot",
            testBot: "Pon a prueba tu bot",
            publish: "Publicar",
            editName: "Editar nombre",
            search: "Busque en su historia ...",
            typeMoreThan3Char: "Escriba al menos 3 caracteres",
            expand: "Expandir",
            expandAll: "Expandir todo",
            noMatchingItem: "Sin elemento coincidente",
            hint: "Pista",
            select: "Seleccionar",
            navigate: "Navegar",
            dismiss: "Despedir",
            choseAttribute: "Elegir el atributo",
            selectReply: "Seleccionar respuesta",
            preview: "Avance",
            draft: "Borrador",
            lastUpdate: "Última actualización",
            published: "Publicado",
            newStory: "Nueva historia",
            updateStory: "Actualizar historia",
            storyDescription: "Descripción de la historia",
            storyTitle: "Título de historia",
            deleteSingleBlock: "Eliminar un solo bloque",
            deleteWithChildren: "Eliminar con los niños",
            startTestFromHere: "Comience la prueba desde aquí",
            copyBlockId: "Copiar ID de bloque",
            gotoLiveLink: "Ir a Live Link",
            copyBlockIdSuccessfull: "ID de bloque copiado en el portapapeles",
            collapse: "Colapsar",
            collapseAll: "Desplegar todo",
            snDelay: "{delay} retraso de sec",
            blockUpdated: "Bloque actualizado",
            addPayload: "Agregar carga útil",
            previewModeCaution: "Ahora estás previamente en una de las versiones de tu historia. ¡No puede guardar cambios en el modo de vista previa!",
            enterText: "Ingrese texto...",
            trackpad: "Pañuelo",
            navigation: "Navegación",
            navigationDesc: "Elija su modo de navegación. Depende de usted si será Trackpad o mouse.",
            botSetting: "Configuración de bot",
            botSettingDesc: "Establezca el nivel de confianza. Este es un porcentaje entre 0 y 100. El nivel define la corrección de ChatBot Interprets que están relacionados con las entradas del usuario.",
            languageSettingsDesc: "Asegúrese de que el lenguaje de Bot que responda es su lenguaje preferido.",
            mouse: "Ratón",
            Interactions: "Interacciones",
            Actions: "Comportamiento",
            Supsis_Actions: "Acciones de supsis",
            Shopify_Actions: "Acciones de Shopify",
            Akinon_Actions: "Acciones de Akinon",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "PUNTO DE PARTIDA",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "Respuesta de bots",
            AI_BOT_RESPONSE: "Respuesta de IA (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "Fallback de forma predeterminada",
            FILTER: "FILTRAR",
            addNewFilter: "Agregar nuevo filtro",
            FLOW: "FLUIR",
            ATTACHMENT_INPUT: "Entrada adjunta",
            USER_INPUT: "ENTRADA DEL USUARIO",
            GO_TO_STEP: "Ir a un paso",
            WEBHOOK: "Webhook",
            SET_ATTRIBUTE: "Establecer atributo",
            QUESTION: "PREGUNTA",
            CLOSE_CHAT: "Chat cerrado",
            CREATE_TICKET: "CREATE TICKET",
            TRANSFER_CHAT: "Chat de transferencia",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "Departamento establecido",
            SEND_TRANSCRIPT: "Enviar transcripción",
            SEND_SMS: "SEND SMS",
            SEND_MAIL: "SEND MAIL",
            CREATE_EVENT: "CREATE EVENT",
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_SELECT_TIME: "Select reservation time",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "Shopify Show Products",
            SHOPIFY_PRODUCT_AVAILABILITY: "Disponibilidad del producto Shopify",
            SHOPIFY_ORDER_STATUS: "Estado del pedido de Shopify",
            AKINON_SHOW_PRODUCTS: "Productos de Akinon Show",
            AKINON_FIND_PRODUCT: "Akinon encontrar producto",
            AKINON_ORDER_STATUS: "Estado de orden de Akinon",
            AKINON_SELECT_ORDER: "Orden de selección de Akinon",
            AKINON_SELECT_SIZE: "Tamaño de selección de Akinon",
            AKINON_FIND_NEAREST_STOCK: "Stock de la tienda de exhibición",
            AKINON_FIND_NEAREST_STORES: "Mostrar tiendas más cercanas",
            AKINON_SHOW_DISCOUNT_CODES: "Mostrar códigos de descuento",
            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            MESSENGER_SEND_MESSAGE: "ENVIAR MENSAJE DE MESSENGER",
            INSTAGRAM_SEND_MESSAGE: "ENVIAR MENSAJE DE INSTAGRAM",
            INSTAGRAM_COMMENT_REPLY: "RESPONDER AL COMENTARIO",
            INSTAGRAM_COMMENT_DELETE: "ELIMINAR COMENTARIO",
            INSTAGRAM_COMMENT_SHOW: "MOSTRAR COMENTARIO",
            INSTAGRAM_COMMENT_HIDE: "OCULTAR COMENTARIO",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "RESPONDER EN PRIVADO",
            followingAttributesFilled: "Se llenarán los siguientes atributos.",
            GET_LOCATION: "Obtener ubicación",
            FALLBACK: "RETROCEDER",
            SUCCESS: "ÉXITO",
            FAILURE: "FALLA",
            message: "Mensaje",
            condition: "Condición",
            score: "Puntaje",
            equal: "Igual",
            not_equal: "no es igual",
            contain: "Contener",
            not_contain: "No contiene",
            starts_with: "comienza con",
            ends_with: "termina con",
            empty: "vacío",
            longer_than: "mas largo que",
            shorter_than: "más corto que",
            less_than: "menos que",
            less_than_equal: "Menos que igual",
            greater_than: "mas grande que",
            greater_than_equal: "mayor que igual",
            value: "Valor",
            failures: "Fallas",
            email: "Correo electrónico",
            name: "Nombre",
            username: "Nombre de usuario",
            source: "Fuente",
            language: "Idioma",
            timezone: "Zona horaria",
            region: "Región",
            country: "País",
            referrer: "Referente",
            url: "Url",
            ip: "Ip",
            city: "Ciudad",
            lastSeen: "Ultima vez visto",
            userId: "ID de usuario",
            selectStep: "Seleccionar paso",
            keywords: "Palabras clave",
            userSays: "El usuario dice",
            addKeyword: "Agregar palabra clave",
            addUserMessage: "Agregar mensaje de usuario",
            set: "Colocar",
            to: "A",
            gender: "Género",
            go_to_failure: "Ir al fracaso",
            go_to_success: "Ir al éxito",
            untilFilled: "Hasta llenarlo",
            time1: "Una vez",
            time2: "2 veces",
            time3: "3 veces",
            time4: "4 veces",
            time5: "5 veces",
            any: "Cualquier",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Alfanumérico",
            integer: "Entero",
            no: "No",
            number: "Número",
            phone: "Teléfono",
            yes: "Sí",
            yesNo: "Sí No",
            anyDescription: "Coincide con cualquier cosa que no sea vacía.",
            alphanumericDescription: "Coincide con letras y números",
            integerDescription: "Coincide con un número entero",
            noDescription: "Coincide sin sinónimos",
            numberDescription: "Coincide con el número ordinal y cardinal",
            phoneDescription: "Coincide con el número de teléfono",
            yesDescription: "Coincide con sí sinónimos",
            yesNoDescription: "Coincide con los sinónimos de sí y no",
            emailDescription: "Correo electrónico de coincidencias",
            urlDescription: "Mataña URL",
            temperature: "Temperatura",
            askWhenInvalid: "Pregunte cuando sea inválido",
            applyFilter: "Aplicar filtro",
            RANDOM_TEXT: "Texto aleatorio",
            QUICK_REPLY: "Respuesta rápida",
            FILE: "Archivo",
            notificationMessageStartSuccess: "El bloque",
            notificationMessageEndSuccess: "ha sido añadido",
            notificationMessageStartError: "Se produjo un error, el bloque",
            notificationMessageEndError: "no ha sido agregado",
            blockChangedWannaUpdate: "Quiero actualizar cambiado",
            responses: "Respuestas",
            TEXT: "Texto",
            IMAGE: "Imagen",
            GALLERY: "Galería",
            BUTTON: "Botón",
            flow: "Fluir",
            active: "Activo",
            passive: "Pasivo",
            chooseAttributeType: "Elija el tipo de atributo",
            imageAttachment: "Adjunto de imagen",
            audioAttachment: "Accesorio de audio",
            videoAttachment: "Accesorio de video",
            documentAttachment: "Adjunto de documentos",
            anyAttachment: "Cualquier apego",
            typeAttributeValue: "Tipo de valor de atributo",
            typeSearchValue: "Tipo de valor de búsqueda",
            addAttribute: "Agregar atributo",
            addAttributeDescription: "El nombre del atributo solo puede contener caracteres alfanuméricos que son letras A-Z, números 0-9, tablero o bajo.",
            male: "Masculino",
            USER_DATA: "Datos del usuario",
            CUSTOM_ATTRIBUTES: "Atributos personalizados",
            enterBotResponseHere: "Ingrese la respuesta de bot aquí ...",
            enterPrivateBotResponseHere: "Ingrese el mensaje privado que enviará el bot ...",
            addCard: "Agregar tarjeta",
            addButton: "Botón Agregar",
            typeCardTitle: "Título de la tarjeta de tipo",
            typeCardDescription: "Tipo de descripción de la tarjeta",
            dragAndDropBrowse: "Arrastrar y soltar navegar",
            dragAndDropBrowseFile: "Subir archivo",
            button: "Botón",
            enterYourMessage: "Ingrese su mensaje",
            imageView: "Vista de imagen",
            imageUploading: "Carga de imágenes",
            fileUploading: "Carga de archivos ...",
            clickToChooseNewImage: "Haga clic para elegir una nueva imagen",
            clickToChooseNewFile: "Haga clic para elegir un archivo nuevo",
            removeTheExistingOne: "Eliminar el existente",
            validateResponseWithEntity: "Validar la respuesta con la entidad",
            actionOnFailureInput: "Acción sobre la entrada de falla",
            askNextQuestion: "Haga la siguiente pregunta",
            goToSuccessBlock: "Ir al bloque de éxito",
            goToFailureBlock: "Ir al bloque de falla",
            saveResposeToAttribute: "Guardar respuestas para atribuir",
            selectReplyType: "Seleccione Tipo de respuesta",
            questionVariants: "Variantes de preguntas",
            systemEntities: "Entidades del sistema",
            delay: "demora",
            retrySectionTextPart: "Preguntar",
            retrySectionText: ", si la respuesta del usuario no es válida",
            addNextQuestion: "Agregue la siguiente pregunta",
            typeBlockTitle: "Título del bloque de tipo",
            versionHistory: "Historial de versiones",
            restore: "Restaurar",
            versionName: "Nombre de la versión",
            restoreModalText: "Esta acción restaurará la versión seleccionada. ¿Estás seguro de que quieres restaurar esta versión?",
            restoreVersion: "Versión de restauración",
            newVersion: "Nueva versión",
            synonymMustBeUnique: "El sinónimo debe ser único",
            save: "Ahorrar",
            entries: "Entradas",
            youHaveNoEntries: "No tienes entradas",
            inputsCantBeEmpty: "Las entradas no pueden estar vacías",
            entryNamesMustBeUnique: "Los nombres de entrada deben ser únicos",
            entityNameMustBeUnique: "El nombre de la entidad debe ser único",
            synonyms: "Sinónimos",
            entities: "Entidades",
            title: "Título",
            entryName: "Nombre de entrada",
            entityhasbeenUpdatedSuccessfully: "La entidad se ha actualizado con éxito",
            emptyError: "Las entradas no pueden estar vacías",
            entityNameCantBeEmpty: "La entidad no puede estar vacía",
            allChats: "Todos los chats",
            paidChats: "Chats pagados",
            busiestPeriod: "Período más ocupado",
            ratingDistribution: "Distribución de calificaciones",
            allMessages: "Todos los mensajes",
            avarageMessages: "Mensajes de avaraje",
            popularity: "Popularidad",
            allUsers: "Todos los usuarios",
            interactionName: "Nombre de interacción",
            numberOfMessage: "Número de mensaje",
            ofAllUsersMessage: "% De todos los usuarios Mensaje",
            totalData: "Total de datos",
            avgData: "Datos de AVG",
            exportToCsv: "Exportar a CSV",
            exportToExcel: "Exportar a Excel",
            inMaintenance: "En mantenimiento",
            ADD_TO_SEGMENT: "Agregar al segmento",
            REMOVE_FROM_SEGMENT: "Eliminar del segmento",
            users: "Usuarios",
            webhookName: "Nombre de webhook",
            webHookUrl: "URL de webhook",
            webHookToken: "Token webhook",
            delete: "Borrar",
            basicAuth: "Autenticación básica",
            requiredFieldsCannotBeLeftBlank: "Los campos requeridos no se pueden dejar en blanco",
            headerValue: "Valor",
            yourVerificationToken: "Simbólico",
            yourWebHookName: "Tu nombre de webhook",
            yourWebHookUrl: "Tu URL webhook",
            enterKey: "Introducir clave",
            password: "Contraseña",
            saveSuccessfully: "Su transacción ha sido guardada con éxito",
            urlTypeError: "Complete el campo correctamente (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "OpenAI CHAT GPT-4 API Clave requerida.",
                apiKeyDesc: "ChatBot + Chat GPT-4 La integración requiere la tecla API. Obtenga su API-Key o use la tecla API a continuación para probar. Puede usar solo 20 mensajes para la prueba.",
                getApiKey: "Poner la llave API de AI",
                typeApiKey: "Escriba la tecla API",
                ownApiKey: "PROPIA CLAVE DE API OPERAI",
                trialApiKey: "Clave de API de prueba (restringido como 20 mensaje)",
                useOurTrial: "Use nuestra prueba gratuita",
                twentyMessages: "Puede probar usando 20 mensajes como gratis.",
                enableChatGpt3: "Habilitar chat gpt-4"
            },
            YouTube_Actions: "YouTube Actions",
            Google_Business_Actions: "Google Business Actions",
            Google_Play_Actions: "Google Play Actions",
            App_Store_Actions: "App Store Actions",
            META_SEND_CAPI_EVENT: "CAPI EVENT GÖNDER",
            META_SEND_CAPI_EVENTDesc: "Meta Conversions API (CAPI) kullanarak reklam optimizasyonu için conversion eventleri gönderir. Instagram ve Messenger reklamlarınızın performansını artırmanıza yardımcı olur.",
            CUSTOM_BLOCK: "Custom Block",
            CUSTOM_BLOCKDesc: "Execute custom JavaScript code with configurable parameters. Extend your chatbot by using blocks shared from the marketplace.",
            exampleOutput: "Example Output",
            outputSchema: "Output Schema (JSON)",
            FEEDBACK_AI_ASSISTANTDesc: "Supsis AI Artificial Intelligence Assistant is an intelligent solution that optimizes customer service and business processes. It provides 24/7 service by automatically responding to customer inquiries, offers multilingual support, and integrates with platforms like WhatsApp, Instagram, and Facebook. It facilitates sales, marketing, and appointment scheduling processes while offering personalized experiences to increase customer satisfaction. This assistant, which enhances efficiency and cost savings, provides businesses with a modern and effective customer service solution through fast and accurate information flow.",
            INSERT_TO_SYSTEM_PROMPTDesc: "The Insert to System Prompt block allows the chatbot to insert a message into the system prompt. The message is inserted into the system prompt at the specified position. The message is inserted into the system prompt at the specified position. The message is inserted into the system prompt at the specified position.",
            API_REQUESTDesc: "This block defines the structure and parameters used to send a request to an API. The API Request URL specifies the address where the data will be sent, while the method (GET, POST, etc.) determines the type of request. Headers include authentication and content type information, Body Type defines the format of the data being sent, and the Body section contains the main data to be sent to the API. Finally, the Example Response shows an example of the expected response from the API. This block facilitates API integrations and automates data exchange.",
            BOT_RESPONSEDesc: "The Bot’s Response block enhances interaction by responding to the user with different content types such as text, images, and files. This block is used to send plain text messages (Text), randomly selected text variants (Random Text), images (Image), or files (File). It also provides button responses to offer options to the user: Gallery presents interactive displays with images and descriptions; Button offers options and is persistent across all platforms; Quick Reply allows the user to make quick selections and disappears after selection. Gallery supports unlimited buttons on the website platform, while only one card can be sent on WhatsApp. On Instagram and Messenger, each gallery card is sent as a separate message. Quick Reply offers more than 3 buttons on Instagram and Messenger, and the buttons appear above the message box.",
            TAVILY_WEB_SEARCHDesc: "Web search allows retrieving information from various websites through AI-powered systems. When a search query is entered, the most relevant results are scanned based on the specified search depth, providing information tailored to the user's needs. Raw content, images, and image descriptions can also be included for a more comprehensive information transfer. Additionally, the obtained data can be summarized or presented in its raw form. Users can filter search results by including specific domains, ensuring access to information from the most reliable sources. Thus, AI-powered web searches optimize the process of obtaining fast and accurate information.",
            AI_BOT_RESPONSEDesc: "This system enables AI to generate personalized responses based on user inputs and predefined instructions; it provides accurate and comprehensive answers using pre-prepared templates while recording user feedback to improve future responses.",
            AI_CLASSIFICATIONDesc: "The AI Classification Block analyzes user messages and categorizes them into predefined categories, automatically triggering relevant actions. Automatic classification ensures correct routing based on message content, while flexible category management allows adding or editing categories. Classified data is filtered to take the most appropriate actions based on user requests. Additionally, Instagram messages and comments can be classified through this block, enabling automated responses or actions.",
            DEFAULT_TIMEOUTDesc: "The default timeout is triggered at the start of the scenario and takes precedence if it is shorter than the local timeout duration; to use only the local timeout, the default must be deleted. The timeout duration cannot exceed the session duration, and multiple timeouts can be used in conjunction with user inputs. This structure, triggered when no response is received from the user, is suitable for sending reminder messages or restarting specific flows.",
            FILTERDesc: "The Supsis AI platform allows chatbots to filter user data based on customized attributes, user information (name, email, phone, language, time zone, gender, etc.), and visitor profile information (country, IP, referrer, visit address, etc.). Filtering operations enable the creation of complex conditions using 'and' and 'or' operators; for example, providing live support during working hours or offering special responses based on specific countries, phone numbers, or visit addresses. These features analyze user behavior, enabling the chatbot to provide more personalized, fast, and effective responses, thereby increasing customer satisfaction and optimizing chatbot efficiency.",
            ATTACHMENT_INPUTDesc: "The File Input block allows the chatbot to securely store and generate a downloadable URL for files received from users; this URL can be shared via channels like email or WhatsApp. The user can only send files in a defined file input; otherwise, the system redirects to the local or default 'Otherwise' flow. Images, audio, video, documents, or other attachments are supported, and the system automatically initiates the relevant process for each file type, redirecting the file to relevant units if necessary.",
            USER_INPUTDesc: "The User Input block allows the chatbot to process, validate, and save data received from users, triggering relevant actions. Global keywords are valid everywhere, while local keywords work in specific steps. Inputs can be validated using regex and saved to the user profile. The confidence level determines how the chatbot responds to inputs. With the 'Go to Block' and 'Send Message' buttons, users can be directed to specific steps or interact with the chatbot. This structure enables the chatbot to manage user interactions more efficiently.",
            GO_TO_STEPDesc: "The Go to Step Action is a mechanism that directs chatbot users to predefined steps. Dynamic routing ensures users are directed to the correct flow based on their queries or triggered actions. Block name editing ensures the flow is understandable and connections are easily managed. Users can edit block names from the block or within the block. The 'Go to Step' action is particularly useful for organizing transitions in complex chatbot flows. The Go to Block button type works similarly, directing users who click the defined button to a predefined block. The Go To selection determines the block the button will direct to, optimizing the user experience.",
            WEBHOOKDesc: "The Webhook Action facilitates data sharing between the chatbot and external systems. It directs the user flow based on successful and failed scenarios. In a successful scenario, the user flow continues when data is successfully sent; in a failed scenario, an error message is displayed, and the user is redirected. Webhook integration enables interaction with external systems and data exchange. Webhooks enhance the chatbot's flexibility and enrich the flow. For integration, adjustments must be made according to the system's API documentation.",
            SET_ATTRIBUTEDesc: "The Set Attribute block allows data received from users to be saved to their profile card, classifying data as static, dynamic, or special. Static data saves fixed values, dynamic data saves information that changes based on user inputs, and special data saves randomly generated values (e.g., random numbers or OTP). User and visitor profile information is collected and stored during user interactions, making it available for future interactions. This block is useful for managing user data and providing more personalized and accurate responses.",
            ASSIGN_OWNERDesc: "The Assign Owner Block is used to assign an ongoing chat to a selected representative through the chatbot. The assignment algorithm determines the most suitable representative based on the number of contacts they have and specific date ranges. Additionally, assignments can be made only to online representatives, and certain representatives can be excluded from the assignment pool. This process is synchronized with Zoho CRM, saving the assigned representative's data to the CRM system, thereby managing customer support processes more efficiently.",
            QUESTIONDesc: "The Question block allows the chatbot to ask users questions and validate and process their responses. When the user provides the correct answer, the successful scenario is triggered, and the flow continues. If the user provides an incorrect answer, the failed scenario is activated, giving the user another chance to respond. Additionally, user responses are validated using validation parameters, and correct data is saved to the profile card. For example, email addresses are validated, and correctly formatted information is saved to the profile card. In case of incorrect responses, the user is given the opportunity to correct them. This feature makes the chatbot's interaction with users more personalized and accurate.",
            TRANSFER_TO_CHATBOTDesc: "The Transfer to Chatbot block directs the user to a predefined different chatbot flow, offering a personalized experience. Users can transition from one flow to another and are directed to the correct scenario based on their needs. Scenario selection uses filtering and tagging processes to ensure users are directed to the correct flow based on their specific attributes. This feature provides flexible and dynamic responses to user requests.",
            TAG_CHATDesc: "The Add Tag block adds tags to profiles based on user interactions, enabling segmentation and chatbot filtering. User inputs are analyzed to direct them to the correct department, followed by representative transfer. Tags are used to optimize customer support and sales processes.",
            REMOVE_TAGDesc: "The Remove Tag block removes unnecessary or outdated tags from user profiles, ensuring chatbot analyses remain current and accurate. Tags are automatically cleaned, making segmentation and data management more efficient.",
            SET_DEPARTMENTDesc: "The Set Department block automatically or manually directs users to the correct department based on their needs. The appropriate department is determined based on user selections or system data, tags are added for segmentation, and representative transfer is performed if necessary.",
            SEND_TRANSCRIPTDesc: "The Send Transcript block automatically sends a record of the chat with the user to a specified email address, contributing to support and analysis processes. The transcript can be sent to the email address in the user profile card or a manually entered address.",
            SEND_SMSDesc: "The Send SMS block enables the sending of automated and personalized messages using Supsis's integration with Postacell or another SMS provider. The SMS content is dynamically generated using the phone number in the user's profile card and system data. For integration and additional information, contact live support or info@supsis.com.",
            SEND_MAILDesc: "The Send Mail block enables automated email sending using information collected through the chatbot. Personalized email content can be created based on attributes in the user's profile card. The email subject and content can be dynamically customized, and automatic notifications can be sent to both users and relevant teams for support requests. Supsis's email module integrates with existing mail infrastructures, simplifying the process.",
            CREATE_EVENTDesc: "The Create Event block automatically adds events to users' calendars through the chatbot. The event title, description, and duration are determined using data from the user's profile information, and event owners and additional representatives can be assigned. Automatic notifications inform participants, and event details can be managed through calendar integrations (Google Calendar, Microsoft Teams), speeding up the process and optimizing time management.",
            CREATE_RESERVATIONDesc: "The Create Reservation block automatically initiates a reservation process using attributes from the user's profile card or manually entered form data. Information from the user's profile, such as email addresses, can be used for calendar events, and event details can be retrieved from these attributes. This block organizes information received through the reservation form by interacting with other blocks and initiates the reservation process, making it faster and more personalized.",
            RESERVATION_OPEN_URLDesc: "The View Reservation Screen block lists available appointments for the user through a predefined reservation calendar. The user can view available appointments on the calendar through this screen. Additionally, predefined duration options (e.g., 5 minutes, 15 minutes, 30 minutes) can be selected for the appointment duration. This feature only works on website chatbots and offers users convenient reservation options.",
            RESERVATION_SELECT_DAYDesc: "The Select Reservation Day block offers users a selection of weekly reservation days, and the selected reservation day is saved in the system. Relevant information is automatically retrieved from the user's profile card attributes, and the reservation day is determined. This block offers users options through buttons, directing them to the appropriate reservation day. This process is personalized with user-specific information and integrated with the event calendar.",
            RESERVATION_EVENT_LISTDesc: "The Customer Reservation List quickly and efficiently presents reservation data associated with users' email information. This process is performed using a specific customer's email address, and all reservations linked to that email address are listed for the user.",
            RESERVATION_SELECT_TIMEDesc: "The Select Reservation Time block offers users available times for the selected reservation day. The user selects a suitable time from the available options for the previously selected day. This block lists available times for the day based on data received from the Select Reservation Day block and offers options to the user. The selected reservation time is saved in the system and integrated appropriately using the user's profile information and attributes.",
            CREATE_TASKDesc: "The Create Task block automatically or manually adds tasks to the Task Management Module based on user requests. The task title, description, urgency level, workflow, and pipeline (column) are determined and assigned to relevant representatives. Tasks personalized with information from the user's profile card are notified to relevant individuals through system and email notifications. Google Calendar and Microsoft Teams integrations make the process easy to track. For example, when a customer requests additional information, the chatbot automatically creates a task in the 'Awaiting Contact' column of the sales process and notifies the relevant representative.",
            GET_LOCATIONDesc: "The Get Location Module allows the chatbot to collect geographic location information from users. When requesting location information from the user, a special message is displayed, and the location's latitude and longitude are saved to the profile card. The user can share their location manually by entering an address or selecting it on the map. This feature is particularly useful in e-commerce, logistics, and delivery sectors, personalizing the user experience. For example, an e-commerce chatbot can use this module to collect a delivery address from the user and complete the process.",
            SUPPRESSION_ADDDesc: "The Suppression block blocks a user on a specified platform (WhatsApp, Web Visitor, Instagram, Messenger). The value of the user to be blocked can be automatically retrieved from attributes or entered manually. Blocking can be applied to inbound (message reception), outbound (message sending), or both. For example, to block a user causing discomfort on WhatsApp, 'WhatsApp' is selected as the platform, the user's phone number is specified, and both inbound and outbound blocking are activated.",
            SUPPRESSION_REMOVEDesc: "The Remove Suppression block unblocks a previously blocked user on a specified platform (WhatsApp, Web, Instagram, etc.) using the value used for blocking (e.g., phone number, user ID). The value for unblocking can be automatically retrieved from the profile card attributes. This allows the unblocking process to be performed quickly and automatically.",
            SEND_WP_BUSINESS_MESSAGEDesc: "The Send WhatsApp Message block enables sending personalized messages to users using the WhatsApp Business API. When this action is triggered, a message is sent through the WhatsApp channel using a predefined template. The message content can be personalized using attributes from the profile card and manual inputs. The number to be sent can be entered manually or automatically retrieved from user information. Templates are approved formats in the WhatsApp Business API, and existing templates can be selected or new ones created. Variables within the template can be used to create personalized messages. Additionally, media files (JPEG, PNG, etc.) can be added to messages. This block enables automated message sending for scenarios like campaign messages, support requests, or special notifications.",
            MESSENGER_SEND_MESSAGEDesc: "This block allows the CHATBOT to send messages via Messenger. The CHATBOT can send messages containing text, images, or other media types to a specific recipient.",
            INSTAGRAM_SEND_MESSAGEDesc: "This block allows the CHATBOT to send direct messages via the Instagram platform. The CHATBOT can send messages containing text or media to a specific user.",
            INSTAGRAM_COMMENT_REPLYDesc: "This block is used to reply to a comment on an Instagram post. The CHATBOT can interact by replying to a specific comment.",
            INSTAGRAM_COMMENT_DELETEDesc: "This block is used to delete a comment on an Instagram post. The CHATBOT can remove unwanted or inappropriate comments.",
            INSTAGRAM_COMMENT_SHOWDesc: "This block is used to view a comment on an Instagram post. The CHATBOT can review a specific comment and see other users' opinions.",
            INSTAGRAM_COMMENT_HIDEDesc: "This block is used to hide a comment on an Instagram post. The CHATBOT can make a specific comment invisible, preventing followers from seeing it.",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATEDesc: "This block is used to reply to a comment on an Instagram post with a private message (DM). The CHATBOT can send a private response to the commenter, establishing a more personal communication.",
            TABLE_CREATE_RECORDDesc: "This block adds a new record to a specific table. Using information received from the user or other attributes in the system, a new record is created and added to the relevant table. Adding a new record is used for processes such as creating new customer information or product records.",
            TABLE_DELETE_RECORDDesc: "This block deletes a record from the data table. When the user wants to remove a record that is no longer valid or contains errors, this block is triggered. The deleted record is completely removed from the table and cannot be recovered. For example, this process is used to delete a customer's record or an invalid order.",
            TABLE_UPDATE_RECORDDesc: "This block updates the content of a record in the table. When the user wants to change information in an existing record, this block can be used. For example, this process is used to update a customer's address or product price. This operation only changes the specified record and does not affect other records in the table.",
            TABLE_FIND_RECORDDesc: "This block allows finding a specific record in the data table. When the user wants to search for specific data (e.g., a username or product ID) recorded in the table, this block is used. The search process allows users to quickly access a specific record.",
            TABLE_FIND_RECORDSDesc: "This block displays existing records in the table to the user. When the user wants to see all records in the table or filtered records based on specific criteria, this block is used. The listing process can include operations such as sorting and filtering data.",
            ADD_TO_SEGMENTDesc: "The Add to Segment Action allows adding users to defined segments after they go through specific steps. This action helps analyze user behavior by dividing it into segments and creating custom reports. Users are added to appropriate segments through the segment selection bar, and new segments can be created from the chatbot menu. For example, when a VIP customer makes a special campaign query, the Add to Segment action adds the user to the VIP segment. Segment reports can be reviewed through reporting, providing detailed data on which segments users are added to and their requests.",
            REMOVE_FROM_SEGMENTDesc: "The Remove from Segment Action is used to remove users from specific segments. This action updates segments, enabling more accurate analysis of users on a segment basis. Users are automatically removed from the relevant segment after selecting the segment to be removed through the segment selection bar. Segment updates and analyses of removed users can be performed through reporting, allowing clearer tracking of segment changes and user behavior.",
            files: "Files",
            Messaging_Actions: "Mesajlaşma Aksiyonları",
            exportDiagram: "Export Diagram",
            exportDiagramDescription: "Select the components you want to export. This data will be copied to the clipboard and can be imported into another scenario.",
            diagram: "Diagram",
            diagramExportDesc: "Chatbot flow diagram (required)",
            aiSettings: "AI Settings",
            aiSettingsExportDesc: "AI model settings, prompt and parameters",
            aiFunctionsExportDesc: "Select AI functions to export",
            knowledgeBase: "Knowledge Base",
            knowledgeBaseExportDesc: "Select knowledge base types to export",
            webPages: "Web Pages",
            noKnowledgeBase: "No knowledge base found to export",
            exportToClipboard: "Copy to Clipboard",
            exportSuccess: "Scenario successfully copied to clipboard",
            exportError: "An error occurred during export",
            exportDataFetchError: "Error fetching export data",
            model: "Model",
            topP: "Top P",
            toolChoice: "Tool Choice",
            prompt: "Prompt",
            B2Cargo_Actions: "B2Cargo Actions",
            Holiday_Plus_Actions: "Holiday+ Actions",
            HOLIDAY_PLUS_GET_ROOMS: "LIST ROOMS",
            HOLIDAY_PLUS_GET_HOTELS: "LIST HOTELS",
            ZOHO_CREATE_RECORD: "Zoho Create Record",
            B2CARGO_LOGIN_USER: "Kullanıcı Girişi",
            B2CARGO_PRODUCT_STATUS: "Ürün Durumu",
            createNewBlock: "Create New Block",
            marketplace: "Marketplace",
            myBlocks: "My Blocks",
            importedBlocks: "Imported Blocks",
            pendingApproval: "Pending Approval",
            utility: "Utility",
            dataTransform: "Data Transform",
            custom: "Custom",
            mostUsed: "Most Used",
            topRated: "Top Rated",
            newest: "Newest",
            uses: "uses",
            import: "Import",
            imported: "Imported",
            pending: "Pending",
            approved: "Approved",
            rejected: "Rejected",
            unlist: "Unlist",
            confirmDeleteBlock: "Are you sure you want to delete this block?",
            noBlocksCreated: "No blocks created yet",
            enterChangelog: "Enter changelog (optional)",
            publishBlock: "Publish Block",
            blockPublished: "Block published successfully",
            blockUnlisted: "Block unlisted successfully",
            blockDeleted: "Block deleted successfully",
            cannotDeleteActiveBlock: "Cannot delete block with active usage",
            noImportedBlocks: "No imported blocks",
            confirmRemoveImport: "Are you sure you want to remove this import?",
            remove: "Remove",
            importRemoved: "Import removed successfully",
            creator: "Creator",
            viewDetails: "View Details",
            approve: "Approve",
            reject: "Reject",
            noPendingBlocks: "No pending blocks",
            enterRejectionReason: "Enter rejection reason",
            rejectBlock: "Reject Block",
            blockApproved: "Block approved successfully",
            blockRejected: "Block rejected",
            blockImported: "Block imported successfully",
            parameters: "Parameters",
            noParameters: "No parameters required",
            ratings: "Ratings",
            writeReview: "Write your review...",
            selectOrTypeCategory: "Select or type category",
            changelogPlaceholder: "Enter changelog (optional)",
            category: "Category",
            description: "Description",
            tags: "Tags",
            submitRating: "Submit Rating",
            noRatings: "No ratings yet",
            latest: "Latest",
            pinned: "Pinned",
            createBlock: "Create Block",
            basicInfo: "Basic Info",
            blockName: "Block Name",
            enterBlockName: "Enter block name",
            enterDescription: "Enter description",
            icon: "Icon",
            addTags: "Add tags",
            javascriptCode: "JavaScript Code",
            addParameter: "Add Parameter",
            parameterName: "Parameter name (variable)",
            parameterLabel: "Display label",
            parameterDescription: "Description (help text)",
            defaultValue: "Default value",
            allowAutoUpdate: "Auto-update output schema on execution",
            visibility: "Visibility",
            allowedSiteIds: "Allowed Site IDs",
            enterSiteIds: "Enter site IDs",
            saveDraft: "Save Draft",
            fillRequired: "Please fill required fields",
            blockCreated: "Block created",
            selectCustomBlock: "Select Custom Block",
            selectCustomBlockDesc: "Choose a custom block from your imported blocks",
            outputPreview: "Output Preview",
            blockNotFound: "Block not found",
            pleaseSelectRating: "Please select a rating",
            ratingSubmitted: "Rating submitted",
            plans: "Planlar",
            chatBotPlans: "Chat Bot Planlar",
            FEEDBACK_AI_ASSISTANT: "FEEDBACK AI ASSISTANT",
            INSERT_TO_SYSTEM_PROMPT: "INSERT TO SYSTEM PROMPT",
            API_REQUEST: "API REQUEST",
            AI_CALL: "AI CALL",
            TAVILY_WEB_SEARCH: "WEB SEARCH",
            OPENAI_WEB_SEARCH: "WEB ARAMA (OPENAI)",
            RUN_JAVASCRIPT: "RUN JAVASCRIPT",
            DEFAULT_TIMEOUT: "DEFAULT TIMEOUT",
            AI_FUNCTIONS: "AI FUNCTIONS",
            ASSIGN_OWNER: "Sahip Ata",
            CACHE_WRITE: "CACHE WRITE",
            CACHE_READ: "CACHE READ",
            CACHE_EXTEND: "CACHE EXTEND",
            CACHE_DELETE: "CACHE DELETE",
            YOUTUBE_REPLY_COMMENT: "YOUTUBE REPLY COMMENT",
            YOUTUBE_UPDATE_COMMENT_STATUS: "YOUTUBE UPDATE COMMENT STATUS",
            YOUTUBE_SET_MODERATION_STATUS: "YOUTUBE SET MODERATION STATUS",
            GOOGLE_BUSINESS_REPLY_REVIEW: "GOOGLE BUSINESS REPLY REVIEW",
            GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "GOOGLE BUSINESS UPDATE REVIEW STATUS",
            GOOGLE_PLAY_REPLY_REVIEW: "GOOGLE PLAY REPLY REVIEW",
            GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "GOOGLE PLAY UPDATE REVIEW STATUS",
            APP_STORE_REPLY_REVIEW: "APP STORE REPLY REVIEW",
            APP_STORE_UPDATE_REVIEW_STATUS: "APP STORE UPDATE REVIEW STATUS",
            APP_STORE_DELETE_REVIEW_RESPONSE: "APP STORE DELETE REVIEW RESPONSE",
            TIMEOUT: "TIMEOUT",
            Probel_Actions: "Probel Aksiyonları",
            PROBEL_SELECT_BRANCH: "Branş Seç",
            PROBEL_SELECT_CLINIC: "Poliklinik Seç",
            PROBEL_SELECT_DAY: "Randevu Günü Seç",
            PROBEL_SELECT_HOUR: "Randevu Saati Seç",
            PROBEL_MAKE_APPOINTMENT: "Randevu Oluştur",
            PROBEL_CANCEL_APPOINTMENT: "Randevu İptal",
            PROBEL_GET_PATIENT_TOKEN: "Hasta Token Al",
            PROBEL_FILL_INFO: "MERNIS Bilgi Getir",
            PROBEL_SELECT_APPOINTMENT: "Randevu Seç",
            SUPPRESSION_ADD: "BLOCK CONTACT",
            SUPPRESSION_REMOVE: "UNBLOCK CONTACT",
            SEND_WP_BUSINESS_MESSAGE: "SEND WHATSAPP MESSAGE",
            TABLE_CREATE_RECORD: "Create Record",
            TABLE_DELETE_RECORD: "Delete Record",
            TABLE_UPDATE_RECORD: "Update Record",
            TABLE_FIND_RECORD: "Find Record",
            TABLE_FIND_RECORDS: "Find Records",
            OPENAI_WEB_SEARCHDesc: "Web search allows retrieving information from various websites through AI-powered systems. When a search query is entered, the most relevant results are scanned based on the specified search depth, providing information tailored to the user's needs. Raw content, images, and image descriptions can also be included for a more comprehensive information transfer. Additionally, the obtained data can be summarized or presented in its raw form. Users can filter search results by including specific domains, ensuring access to information from the most reliable sources. Thus, AI-powered web searches optimize the process of obtaining fast and accurate information.",
            TICKET_UPDATE: "ОБНОВЛЕННЫЙ TICKET",
            b2cargo_login_user: "Login User",
            b2cargo_product_status: "Product Status",
            cardInfos: "информация о карте",
            file: "File",
            fileCancellato: "File cancellato",
            impostazioni: "Impostazioni",
            risposta: "Risposta",
            setUpUpYourChatbot: "إعداد روبوت الدردشة الآلي الخاص بك",
            setUpUpYourChatbotDesc: "تدريب روبوت الدردشة الآلي الخاص بك باستخدام البيانات، استخدم قوالبنا الجاهزة للاستخدام أو ابدأ من الصفر.",
            yourNeedEnterEnterYourOpenAi: "تحتاج إلى إدخال مفتاح OpenAI API الخاص بك لإنشاء روبوت دردشة آلي عن طريق الزحف إلى موقعك الإلكتروني."
        },
        "Would you like to make default this story?": "#VALUE!",
        coupon: {
            code: "Código",
            discount: "Descuento",
            endDate: "Fecha final",
            name: "Nombre",
            email: "Correo electrónico",
            phone: "Teléfono",
            add: "Agregar cupón",
            coupons: "Cupones",
            couponDeleted: "Cupón eliminado",
            limit: "Límite",
            visitorBan: "El visitante ha sido bloqueado.",
            visitorUnBlock: "El bloqueo ha sido eliminado."
        },
        instagramTitle: "Haga clic en el botón a continuación para habilitar las funciones de Instagram.",
        instegramFunctionActive: "Función de Instagram habilitadar",
        ChatBOT: "robot de chat",
        WhatsappContacts: "Contactos Whatsapp",
        InstagramContacts: "Contactos Instagram",
        MessengerContacts: "Contactos de Messenger",
        volumeUp: "Sube el volumen",
        minimize: "Minimizar",
        maximize: "Maximizar",
        auditLogs: {
            auditLogsTitle: "Registros de auditoría",
            auditLogsSub: "Los registros de auditoría le permiten realizar un seguimiento de los eventos ocurridos en su empresa en los últimos 30 días.",
            actor: "Actor",
            actorSelect: "Seleccionar actor",
            actorSystem: "System (Supsis Ai)",
            actorChatbot: "Chatbot",
            actorApi: "API",
            actorVisitor: "Cualquier visitante",
            actorAgent: "Cualquier agente",
            adminUserSuffix: "(Usuario administrador)",
            activityType: {
                blocked: "Bloqueado",
                unblocked: "Desbloqueado",
                "chat-opened": "Chat abierto",
                "chat-closed": "Chat cerrado",
                "chat-rating": "Chat valorado",
                "chat-assigned-to-user": "Chat asignado al usuario",
                "chat-forwarded-to-user": "Chat reenviado al usuario",
                "contact-owner-updated": "Propietario del contacto actualizado",
                "user-joined-to-chat": "Usuario se unió al chat",
                "ticket-assigned-to-user": "Ticket asignado al usuario",
                online: "En línea",
                offline: "Desconectado",
                "page-changed": "Página cambiada",
                "create-ticket": "Ticket creado",
                "video-calling-started": "Videollamada iniciada",
                "video-calling-closed": "Videollamada finalizada",
                "voice-calling-started": "Llamada de voz iniciada",
                "voice-calling-closed": "Llamada de voz finalizada",
                "visitor-tag-added": "Etiqueta de visitante añadida",
                "visitor-tag-removed": "Etiqueta de visitante eliminada",
                "note-created": "Nota creada",
                "note-updated": "Nota actualizada",
                "visitor-profile-updated": "Perfil del visitante actualizado",
                "user-added": "Usuario añadido",
                "user-removed": "Usuario eliminado",
                "user-status-changed": "Estado del usuario cambiado",
                "user-logged-in": "Usuario inició sesión",
                "user-added-to-department": "Usuario añadido al departamento",
                "user-removed-from-depart": "Usuario eliminado del departamento",
                "user-role-changed": "Rol del usuario cambiado",
                "user-password-changed": "Contraseña del usuario cambiada",
                "user-email-changed": "Correo del usuario cambiado",
                "user-name-changed": "Nombre del usuario cambiado",
                "user-phone-changed": "Teléfono del usuario cambiado",
                "user-disabled": "Usuario deshabilitado",
                "user-enabled": "Usuario habilitado",
                "settings-updated": "Configuración actualizada",
                "whatsapp-broadcast-created": "Transmisión de WhatsApp creada",
                "whatsapp-broadcast-completed": "Transmisión de WhatsApp completada",
                "whatsapp-broadcast-canceled": "Transmisión de WhatsApp cancelada",
                "whatsapp-broadcast-failed": "Transmisión de WhatsApp fallida",
                "whatsapp-v1-bot-state-changed": "Estado del bot WhatsApp v1 cambiado",
                "whatsapp-v2-bot-state-changed": "Estado del bot WhatsApp v2 cambiado",
                "channel-created": "Canal creado",
                "channel-removed": "Canal eliminado",
                "channel-visibility-changed": "Visibilidad del canal cambiada",
                "channel-zoho-config-updated": "Configuración Zoho del canal actualizada",
                "channel-forward-config-updated": "Configuración de reenvío del canal actualizada",
                "login-form-activated": "Formulario de inicio de sesión activado",
                "login-form-deactivated": "Formulario de inicio de sesión desactivado",
                "login-form-updated": "Formulario de inicio de sesión actualizado",
                "chatbot-created": "Chatbot creado",
                "chatbot-deleted": "Chatbot eliminado",
                "chatbot-restored": "Chatbot restaurado desde la papelera",
                "chatbot-published": "Chatbot publicado",
                "chatbot-webhook-added": "Webhook del chatbot añadido",
                "chatbot-webhook-removed": "Webhook del chatbot eliminado",
                "banned-word-added": "Palabra prohibida añadida",
                "banned-word-removed": "Palabra prohibida eliminada",
                "mail-address-added": "Dirección de correo añadida",
                "mail-address-removed": "Dirección de correo eliminada",
                "mail-was-sent": "Correo enviado",
                "content-added": "Contenido añadido",
                "content-removed": "Contenido eliminado",
                "role-added": "Rol añadido",
                "role-removed": "Rol eliminado",
                "role-updated": "Rol actualizado",
                "department-added": "Departamento añadido",
                "department-removed": "Departamento eliminado",
                "tags-added": "Etiquetas añadidas",
                "tags-removed": "Etiquetas eliminadas",
                "trigger-added": "Desencadenador añadido",
                "trigger-removed": "Desencadenador eliminado",
                "trigger-updated": "Desencadenador actualizado",
                "welcome-message-added": "Mensaje de bienvenida añadido",
                "welcome-message-removed": "Mensaje de bienvenida eliminado",
                "customer-group-added": "Grupo de clientes añadido",
                "customer-group-removed": "Grupo de clientes eliminado",
                "customer-group-updated": "Grupo de clientes actualizado",
                "webhook-added": "Webhook añadido",
                "webhook-removed": "Webhook eliminado",
                "webhook-updated": "Webhook actualizado",
                "contact-prop-added": "Propiedad de contacto añadida",
                "contact-prop-removed": "Propiedad de contacto eliminada",
                "invoice-created": "Factura creada",
                "invoice-updated": "Factura actualizada",
                "invoice-payment-received": "Pago de factura recibido",
                "invoice-payment-failed": "Pago de factura fallido",
                "invoice-refunded": "Factura reembolsada",
                "invoice-deleted": "Factura eliminada",
                "payment-method-added": "Método de pago añadido",
                "billing-address-updated": "Dirección de facturación actualizada",
                "plan-started": "Plan iniciado",
                "plan-canceled": "Plan cancelado",
                "task-workflow-created": "Flujo de trabajo de tareas creado",
                "task-workflow-deleted": "Flujo de trabajo de tareas eliminado",
                "task-workflow-restored": "Flujo de trabajo de tareas restaurado desde la papelera",
                "task-workflow-permanently-deleted": "Flujo de trabajo de tareas eliminado permanentemente",
                "task-workflow-updated": "Flujo de trabajo de tareas actualizado",
                "task-workflow-pipeline-stage-added": "Etapa del pipeline del flujo de trabajo añadida",
                "task-workflow-pipeline-stage-updated": "Etapa del pipeline del flujo de trabajo actualizada",
                "task-workflow-pipeline-stage-deleted": "Etapa del pipeline del flujo de trabajo eliminada",
                "task-created": "Tarea creada",
                "task-deleted": "Tarea eliminada",
                "task-stage-changed": "Etapa de la tarea cambiada",
                "task-workflow-changed": "Flujo de trabajo de la tarea cambiado",
                "task-assigned-to-user": "Tarea asignada al usuario",
                "task-update-priority": "Prioridad de la tarea actualizada",
                "task-added-tags": "Etiquetas añadidas a la tarea",
                "task-removed-tags": "Etiquetas eliminadas de la tarea",
                "task-update-title": "Título de la tarea actualizado",
                "task-update-description": "Descripción de la tarea actualizada",
                "task-update-start-date": "Fecha de inicio de la tarea actualizada",
                "task-update-end-date": "Fecha de fin de la tarea actualizada",
                "task-update-owner": "Propietario de la tarea actualizado",
                "task-added-followers": "Seguidores añadidos a la tarea",
                "task-removed-followers": "Seguidores eliminados de la tarea",
                "task-added-collaborators": "Colaboradores añadidos a la tarea",
                "task-update-checklist": "Lista de verificación de la tarea actualizada",
                "task-added-subtask": "Subtarea añadida a la tarea",
                "task-removed-subtask": "Subtarea eliminada de la tarea",
                "task-added-attachment": "Adjunto añadido a la tarea",
                "task-comment-added": "Comentario añadido a la tarea",
                "task-comment-updated": "Comentario de la tarea actualizado",
                "task-comment-deleted": "Comentario de la tarea eliminado",
                "task-completed": "Tarea completada",
                "task-archived": "Tarea archivada",
                "task-restored": "Tarea restaurada desde la papelera",
                "task-unarchived": "Tarea desarchivada",
                "chatbot-credit-low": "Crédito del chatbot bajo",
                "chatbot-credit-done": "Crédito del chatbot agotado",
                "system-status": "Estado del sistema",
                "whatsapp-credit-low": "Crédito de WhatsApp bajo",
                "reservation-created-plan": "Plan de reserva creado",
                "reservation-updated-plan": "Plan de reserva actualizado",
                "reservation-deleted-plan": "Plan de reserva eliminado",
                "reservation-created": "Reserva creada",
                "reservation-updated": "Reserva actualizada",
                "reservation-deleted": "Reserva eliminada",
                "white-list-added": "Lista blanca añadida",
                "white-list-removed": "Lista blanca eliminada",
                "site-suspended": "Sitio suspendido",
                "site-dead": "Sitio deshabilitado",
                "site-enabled": "Sitio habilitado",
                custom: "Actividad personalizada",
                "auto-rebalance-success": "Recarga automática de saldo exitosa",
                "auto-rebalance-failed": "Recarga automática de saldo fallida",
                "auto-rebalance-disabled": "Recarga automática de saldo deshabilitada",
                "automation-created": "Automatización creada",
                "automation-deleted": "Automatización eliminada",
                "automation-restored": "Automatización restaurada desde la papelera",
                "automation-published": "Automatización publicada",
                "automation-unpublished": "Automatización despublicada",
                "automation-updated": "Automatización actualizada",
                "form-created": "Formulario creado",
                "form-updated": "Formulario actualizado",
                "form-deleted": "Formulario eliminado",
                "form-restored": "Formulario restaurado desde la papelera",
                "form-downloaded": "Datos del formulario descargados",
                "table-created": "Tabla creada",
                "table-deleted": "Tabla eliminada",
                "table-restored": "Tabla restaurada desde la papelera",
                "table-permanently-deleted": "Tabla eliminada permanentemente",
                "table-field-added": "Campo de tabla añadido",
                "table-field-updated": "Campo de tabla actualizado",
                "table-field-deleted": "Campo de tabla eliminado",
                "table-view-added": "Vista de tabla añadida",
                "table-view-updated": "Vista de tabla actualizada",
                "table-view-deleted": "Vista de tabla eliminada",
                "table-page-added": "Página de tabla añadida",
                "table-page-updated": "Página de tabla actualizada",
                "table-page-deleted": "Página de tabla eliminada",
                "table-widget-added": "Widget de tabla añadido",
                "table-widget-updated": "Widget de tabla actualizado",
                "table-widget-deleted": "Widget de tabla eliminado",
                "table-permission-changed": "Permisos de la tabla cambiados",
                "table-data-downloaded": "Datos de la tabla descargados",
                "table-data-imported": "Datos de la tabla importados",
                "table-data-batch-updated": "Datos de la tabla actualizados en lote",
                "table-data-batch-deleted": "Datos de la tabla eliminados en lote",
                "contact-data-downloaded": "Datos de contacto descargados",
                "contact-batch-updated": "Datos de contacto actualizados en lote",
                "chat-data-downloaded": "Datos del chat descargados",
                "voice-agent-created": "Agente de voz creado",
                "voice-agent-updated": "Agente de voz actualizado",
                "voice-agent-deleted": "Agente de voz eliminado",
                "voice-agent-phone-number-inbound-agent-changed": "Agente de llamadas entrantes cambiado",
                "voice-agent-phone-number-outbound-agent-changed": "Agente de llamadas salientes cambiado",
                "voice-agent-batch-call-created": "Llamada masiva del agente de voz creada",
                "voice-agent-knowledge-base-created": "Base de conocimiento del agente de voz creada",
                "voice-agent-knowledge-base-updated": "Base de conocimiento del agente de voz actualizada",
                "drive-folder-created": "Carpeta de Drive creada",
                "drive-folder-deleted": "Carpeta de Drive eliminada",
                "drive-folder-renamed": "Carpeta de Drive renombrada",
                "drive-file-added": "Archivo de Drive añadido",
                "drive-file-deleted": "Archivo de Drive eliminado",
                "task-module-rules-rule-added": "Regla del módulo de tareas añadida",
                "task-module-rules-rule-updated": "Regla del módulo de tareas actualizada",
                "task-module-rules-rule-deleted": "Regla del módulo de tareas eliminada",
                "task-module-rules-rule-enabled": "Regla del módulo de tareas habilitada",
                "task-module-rules-rule-disabled": "Regla del módulo de tareas deshabilitada",
                "task-module-rules-enabled": "Reglas del módulo de tareas habilitadas",
                "task-module-rules-disabled": "Reglas del módulo de tareas deshabilitadas",
                "contact-module-rules-rule-added": "Regla del módulo de contactos añadida",
                "contact-module-rules-rule-updated": "Regla del módulo de contactos actualizada",
                "contact-module-rules-rule-deleted": "Regla del módulo de contactos eliminada",
                "contact-module-rules-rule-enabled": "Regla del módulo de contactos habilitada",
                "contact-module-rules-rule-disabled": "Regla del módulo de contactos deshabilitada",
                "contact-module-rules-enabled": "Reglas del módulo de contactos habilitadas",
                "contact-module-rules-disabled": "Reglas del módulo de contactos deshabilitadas",
                "module-created": "Módulo creado",
                "module-updated": "Módulo actualizado",
                "module-deleted": "Módulo eliminado",
                "relation-created": "Relación creada",
                "relation-updated": "Relación actualizada",
                "relation-deleted": "Relación eliminada",
                "web-app-created": "Aplicación web creada",
                "web-app-updated": "Aplicación web actualizada",
                "web-app-deleted": "Aplicación web eliminada",
                "web-tab-created": "Pestaña web creada",
                "web-tab-updated": "Pestaña web actualizada",
                "web-tab-deleted": "Pestaña web eliminada",
                "developer-token-created": "Token de desarrollador creado",
                "developer-token-changed": "Token de desarrollador cambiado"
            },
            activityTypeSelect: "Seleccionar tipo de actividad",
            dateRange: "Rango de fechas",
            startDate: "Fecha de inicio",
            endDate: "Fecha de fin",
            reset: "Restablecer",
            filter: "Filtrar",
            activeFilters: "Filtros activos:",
            auditLogsTable: "Registros de auditoría",
            noActivityYet: "Aún no hay actividad",
            ipAddress: "Dirección IP",
            tablePagination: {
                goto: "Ir",
                pagePer: " / página",
                total: "Total",
                prev5: "5 páginas anteriores",
                next5: "5 páginas siguientes",
                cut: "Cortar",
                copy: "Copiar",
                insertRowAbove: "Insertar fila arriba",
                insertRowBelow: "Insertar fila abajo",
                removeRow: "eliminar fila(s)",
                emptyRow: "vaciar fila(s)",
                emptyColumn: "vaciar columna(s)",
                emptyCell: "Vaciar celda",
                leftFixedColumnTo: "Fijar columna a la izquierda",
                cancelLeftFixedColumnTo: "Cancelar fijar columna a la izquierda",
                rightFixedColumnTo: "Fijar columna a la derecha",
                cancelRightFixedColumnTo: "Cancelar fijar columna a la derecha"
            }
        },
        task: {
            taskID: "ID de la tarea",
            completeTask: "Completar tarea",
            closedTasks: "Tareas cerradas",
            moveToArchive: "Mover a archivo",
            changeWorkflow: "Mover a Otro Flujo de Trabajo",
            selectWorkflow: "Seleccionar flujo de trabajo",
            taskNumber: "Tarea #",
            priority_lowest: "Más Baja",
            priority_low: "Baja",
            priority_medium: "Media",
            priority_high: "Alta",
            priority_highest: "Más Alta",
            workflowActions: "Acciones del flujo de trabajo",
            workflowTitle: "Título del flujo de trabajo",
            deleteTask: "Eliminar tarea",
            archivingDate: "Fecha de archivo",
            selectOption: "Seleccione una opción",
            notAuthorisedCreateTask: "No está autorizado a crear una tarea",
            notAuthorisedCreateTaskDesc: "No está autorizado a realizar esta tarea",
            goToMessage: "Ir al mensaje",
            goToChat: "Ir al chat",
            showVisitor: "Mostrar visitante",
            closeTheTask: "Cerrar tarea",
            sureAddCompletedList: "¿Seguro que quieres añadir la tarea a la lista de completadas?",
            success: "Éxito",
            successDesc: "Nuevo campo añadido con éxito",
            moveAndDeleteTask: "Mover y eliminar tareas",
            justDelete: "Sólo eliminar",
            selectColumnMoveTask: "Selecciona la columna donde quieres mover las tareas",
            todos: "Tareas pendientes",
            inProgress: "En progreso",
            aprobado: "Aprobado",
            addAComment: "Agregar un comentario...",
            deleteComment: "¿Estás seguro de que deseas eliminar el comentario?",
            edited: "Editado",
            comments: "Comentarios",
            addComment: "Agregar comentario",
            workflow: "Flujo de trabajo",
            workflowDetail: "Detalles del flujo de trabajo",
            workflowPerm: "Permisos del flujo de trabajo",
            perm: "Permisos",
            detail: "Detalles",
            userPerm: "Permisos de usuario",
            deleteCard: "Eliminar tarjeta",
            createCard: "Crear tarjeta",
            editCard: "Editar tarjeta",
            dragCard: "Mover tarjeta",
            allWorkflow: "Todos los flujos de trabajo",
            createworkflow: "Crear flujo de trabajo",
            editDragActive: "Edición activa",
            editSortOrder: "Editar orden",
            deleteWorkflow: "¿Estás seguro de que quieres eliminar este flujo de trabajo?",
            permEditTask: "No tienes permiso para editar esta tarea",
            permEditTaskDes: "Contacta a tu administrador para obtener permisos de edición.",
            createTaskError: "No tienes permiso para crear tareas",
            createTaskErrorDesc: "Contacta a tu administrador para obtener permisos para crear tareas.",
            moveTaskError: "No tienes permiso para cambiar el estado de la tarea",
            moveTaskErrorDesc: "Contacta a tu administrador para obtener permisos para cambiar el estado de la tarea.",
            deleteTaskError: "No tienes permiso para eliminar tareas",
            deleteTaskErrorDesc: "Contacta a tu administrador para obtener permisos para eliminar tareas.",
            permissionError: "No tienes permiso para crear tareas",
            permissionErrorDesc: "Por favor, contacta a tu administrador para obtener permisos de creación de tareas",
            whatsappContactProfileTitle: "Perfil de {name} / {number}",
            createTaskVisitor: "Crear tarea (visitante)",
            editWorkflow: "Editar flujo de trabajo",
            visitor: "Perfil del visitante",
            createTaskMessage: "Crear tarea (Mensaje)",
            createStage: "Crear etapa",
            stagesAndStatuses: "Etapas y estados",
            workflowCreateDesc: "Descripción del flujo de trabajo",
            subTasks: "Subtareas",
            followers: "Seguidores",
            collaborators: "Colaboradores",
            addRelations: "Agregar relaciones",
            relations: "Relaciones",
            main: "Principal",
            name: "Nombre",
            completedOfCheck: "{completed} de {total} tareas completadas",
            workflowUpdateMs: "Flujo de trabajo actualizado correctamente",
            taskUpdateMs: "Tarea actualizada correctamente",
            workflowCreatedMs: "Flujo de trabajo creado correctamente",
            workflowCreateError: "No se pudo crear el flujo de trabajo",
            taskCreatedMs: "Tarea creada correctamente",
            settingsDesc3: "Además, el módulo de tareas de Supsis le permite crear su propio flujo de trabajo con automatización personalizable, lo que le permite gestionar las tareas de manera más efectiva y mejorar la colaboración dentro del equipo.",
            settingsDesc4: "De esta manera, puede realizar un seguimiento detallado de cada una de sus tareas, asignar tareas a los miembros del equipo y en general administrar sus procesos comerciales de manera más eficiente. El módulo de tareas de Supsis le proporciona una solución integral para la gestión de tareas y la coordinación de equipos.",
            settingsDesc2: "El módulo de tareas de Supsis no deja ninguna tarea sin supervisión. Puede filtrar tareas según cualquier parámetro, hacer un seguimiento de las cargas de trabajo para cada etapa del flujo de trabajo y organizar su calendario para que se ajuste a sus horarios.",
            settingsDesc1: "El módulo de tareas le permite organizar el trabajo colaborativo, delegar tareas y hacer un seguimiento del progreso de su equipo. Puede personalizar sus tareas según sus necesidades seleccionando cualquier vista y crear sus propios flujos de trabajo personalizados con automatizaciones.",
            taskModuleSettingsTitle: "Configuración del módulo de tareas",
            high: "Alto",
            medium: "Medio",
            low: "Bajo",
            priority: "Prioridad",
            addExistsSubtask: "Agregar sub tarea existente",
            addSubtask: "Agregar sub tarea",
            add: "Agregar",
            newCheckList: "Nueva lista de verificación",
            subtaskTitle: "Título de la subtarea",
            view: "Ver",
            attachFiles: "Adjuntar archivos",
            createTaskDesc: "Descripción de la tarea",
            title: "Título",
            createWorkflow: "Crear flujo de trabajo",
            editTask: "Editar tarea",
            createTask: "Crear tarea",
            deleteColumnCont: "¿Estás seguro de que quieres eliminar esta columna?",
            changeStage: "Cambiar Etapa",
            filterBar: {
                searchTasksPlaceholder: "Buscar en tareas...",
                otherUsers: "Otros usuarios",
                searchUserPlaceholder: "Buscar usuario...",
                filter: "Filtrar",
                clearFilters: "Borrar filtros",
                apply: "Aplicar",
                prioritySelection: "Selección de prioridad de tarea",
                priorityDescription: "Puede filtrar tareas por nivel de prioridad. Seleccione los niveles de prioridad que desea filtrar.",
                aboutPriorityLevels: "Acerca de los niveles de prioridad",
                priorityInfoText: "Los niveles de prioridad indican la importancia de las tareas. Las tareas de alta prioridad muestran el trabajo en el que su equipo debe enfocarse primero, mientras que las tareas de baja prioridad indican trabajo menos urgente.",
                userSelection: "Selección de usuario",
                assigneesDescription: "Puede filtrar por usuarios asignados a tareas. Seleccione los usuarios para ver solo las tareas asignadas a ellos.",
                unassigned: "Sin asignar",
                ownerSelection: "Selección de propietario de tarea",
                ownerDescription: "Puede filtrar por propietarios de tareas. Seleccione los usuarios para ver solo las tareas que poseen.",
                searchOwnerPlaceholder: "Buscar propietario de tarea...",
                followersSelection: "Selección de seguidores de tarea",
                followersDescription: "Puede filtrar por seguidores de tareas. Seleccione los usuarios para ver solo las tareas que siguen.",
                searchFollowerPlaceholder: "Buscar seguidor...",
                creatorSelection: "Selección de creador de tarea",
                creatorDescription: "Puede filtrar por quién creó la tarea o el sistema. Seleccione usuarios o tipos de sistema para filtrar tareas.",
                createdBySystem: "Creado por el sistema",
                createdByUsers: "Creado por usuarios",
                searchCreatorPlaceholder: "Buscar usuario...",
                filterByCreatedDate: "Filtrar por fecha de creación",
                today: "Hoy",
                thisWeek: "Esta semana",
                thisMonth: "Este mes",
                startDate: "Fecha de inicio",
                endDate: "Fecha de fin",
                aboutDateFilter: "Acerca del filtro de fecha",
                filterByStartDate: "Filtrar por fecha de inicio",
                filterByEndDate: "Filtrar por fecha de fin",
                overdueTasks: "Tareas vencidas",
                showOverdueTasks: "Mostrar tareas vencidas",
                importantInfo: "Información importante",
                filterByUpdateDate: "Filtrar por fecha de actualización",
                taskTags: "Etiquetas de tareas",
                searchTagPlaceholder: "Buscar etiqueta...",
                tagsLoading: "Cargando etiquetas...",
                noTagsMatchingSearch: "No hay etiquetas que coincidan con los criterios de búsqueda.",
                noTagsCreated: "Aún no se han creado etiquetas.",
                aboutTags: "Acerca de las etiquetas",
                pipelineSelection: "Selección de estado de pipeline",
                searchPipelinePlaceholder: "Buscar pipeline...",
                order: "Orden",
                pipelinesLoading: "Cargando pipelines...",
                noPipelinesMatchingSearch: "No hay pipelines que coincidan con los criterios de búsqueda.",
                noPipelinesCreated: "Aún no se han creado pipelines.",
                aboutPipelines: "Acerca de los pipelines",
                selected: "seleccionado",
                closeTask: "Cerrar tarea",
                tabPriorities: "Prioridad",
                tabOwners: "Propietario de tarea",
                tabFollowers: "Seguidores de tarea",
                tabCreatedBy: "Creador",
                tabCreatedDate: "Fecha de creación",
                tabUpdateDate: "Fecha de actualización",
                tabStartDate: "Fecha de inicio",
                tabEndDate: "Fecha de fin",
                tabTags: "Etiquetas",
                tabOverdue: "Tareas vencidas",
                tabStatus: "Estado",
                priorityLowest: "Prioridad más baja",
                priorityLow: "Prioridad baja",
                priorityMedium: "Prioridad media",
                priorityHigh: "Prioridad alta",
                priorityHighest: "Prioridad más alta",
                createdByApi: "Tareas creadas por API",
                createdByChatbot: "Tareas creadas por Chatbot",
                createdByAutomation: "Tareas creadas por Automatización",
                dateRangeCreatedDescription: "Establezca las fechas de inicio y fin para filtrar tareas creadas dentro de su rango de fechas seleccionado. Este filtro filtra las tareas por su fecha de creación (createdAt).",
                dateInfoCreatedText: "El filtro de fecha limita los resultados por fecha de creación de tareas. De esta manera puede encontrar fácilmente tareas creadas dentro de un período de tiempo específico.",
                dateRangeStartDescription: "Establezca la fecha de inicio para filtrar tareas creadas dentro de su rango de fechas seleccionado. Este filtro filtra las tareas por su fecha de inicio (startDate).",
                dateInfoStartText: "El filtro de fecha limita los resultados por fecha de inicio de tareas. De esta manera puede encontrar fácilmente tareas que comenzarán dentro de un período de tiempo específico.",
                dateRangeEndDescription: "Establezca la fecha de fin para filtrar tareas creadas dentro de su rango de fechas seleccionado. Este filtro filtra las tareas por su fecha de fin (endDate).",
                dateInfoEndText: "El filtro de fecha limita los resultados por fecha de fin de tareas. De esta manera puede encontrar fácilmente tareas que terminarán dentro de un período de tiempo específico.",
                dateRangeUpdateDescription: "Establezca las fechas de inicio y fin para filtrar tareas actualizadas dentro de su rango de fechas seleccionado. Este filtro filtra las tareas por su fecha de actualización (updatedAt).",
                dateInfoUpdateText: "El filtro de fecha limita los resultados por última fecha de actualización de tareas. De esta manera puede encontrar fácilmente tareas actualizadas dentro de un período de tiempo específico.",
                overdueDescription: "Puede filtrar tareas cuya fecha de vencimiento ha pasado y aún están incompletas. Cuando este filtro está activo, solo se mostrarán las tareas vencidas.",
                overdueDetail: "Las tareas cuya fecha de vencimiento ha pasado y aún están incompletas se mostrarán cuando este filtro esté activo. Estas tareas suelen ser las que su equipo debe abordar lo antes posible.",
                overdueInfoText: "Las tareas vencidas son tareas cuya fecha de vencimiento ha pasado pero aún no están completadas. Estas tareas indican trabajo importante que su equipo debe atender.",
                tagsDescription: "Puede filtrar tareas por sus etiquetas. Se mostrarán las tareas con las etiquetas que seleccione.",
                tagsInfoText: "Las etiquetas le ayudan a categorizar las tareas y encontrarlas más fácilmente. Si selecciona varias etiquetas, se mostrarán las tareas con cualquiera de las etiquetas seleccionadas.",
                pipelineDescription: "Puede filtrar tareas por estado del pipeline. Al seleccionar los pipelines que desee, puede ver solo las tareas en esas etapas.",
                pipelinesInfoText: "Los pipelines muestran en qué etapa están las tareas. Si selecciona varios pipelines, se mostrarán las tareas en cualquiera de los pipelines seleccionados."
            },
            assignees: "Asignados",
            owner: "Propietario",
            stage: "Etapa",
            writeSomething: "Escribe algo",
            selectAssginee: "Seleccionar destinatario",
            assignee: "Asignado",
            enterNewTaskDesc: "Ingrese la descripción de la nueva tarea",
            enterNewTaskTitle: "Ingrese el título de la nueva tarea",
            task: "Tarea",
            deleteTaskCont: "¿Estás seguro de que deseas eliminar estas tareas?",
            deleteWorkFlowCont: "¿Está seguro de que desea eliminar este flujo de trabajo?",
            completed: "Completado",
            todo: "Por hacer",
            kanbanBoard: "Tablero Kanban",
            listView: "Vista de Lista",
            taskNotifications: "Notificaciones de tareas",
            reports: "Informes",
            workflowSettings: "Configuración del flujo de trabajo",
            trashBin: "Papelera",
            taskReports: {
                title: "Informes de tareas",
                selectWorkflow: "Seleccionar flujo de trabajo",
                filters: "Filtros",
                clear: "Borrar",
                dateRange: "Rango de fechas:",
                dateRangePlaceholder: "Inicio - Fin",
                assignees: "Asignados:",
                selectUser: "Seleccionar usuario",
                unassigned: "Sin asignar",
                priority: "Prioridad:",
                selectPriority: "Seleccionar prioridad",
                emptyTitle: "Seleccione Workflow para ver informes",
                emptyDescription: "Seleccione un flujo de trabajo de arriba para ver informes de tareas.",
                loadingTitle: "Preparando informe",
                loadingSubtitle: "Analizando datos de tareas...",
                tasksClosed: "tareas cerradas",
                tasksUpdated: "tareas actualizadas",
                tasksCreated: "tareas creadas",
                upcomingDeadlines: "Fechas límite próximas",
                statusOverview: "Resumen de estado",
                statusOverviewSubtitle: "Vea el estado de sus tickets de un vistazo.",
                totalTickets: "Total de tickets",
                priorityDistribution: "Distribución de prioridad",
                teamWorkload: "Carga de trabajo del equipo",
                tooltipTasks: "{name}: {count} tareas ({percentage}%)",
                errorTitle: "Error al cargar el informe",
                retry: "Intentar de nuevo",
                last7Days: "Últimos 7 días",
                dateRangeIn: "entre {start} - {end}",
                upcomingCount: "{count} elementos tienen fechas límite próximas (próximos 7 días)",
                upcomingCountZero: "0 elementos tienen fechas límite próximas (próximos 7 días)",
                upcomingInRange: "{count} elementos tienen fechas límite ({start} - {end})",
                upcomingInRangeZero: "0 elementos tienen fechas límite ({start} - {end})",
                invalidWorkflowId: "Formato de ID de flujo de trabajo inválido: {id}",
                loadSuccess: "Datos del informe cargados correctamente.",
                unknownError: "Ocurrió un error desconocido",
                error: "Error"
            },
            taskNotification: {
                title: "Configuración de notificaciones de tareas",
                description: "Puede gestionar la configuración de notificaciones de tareas desde aquí."
            },
            workflowSandbox: {
                title: "Flujos de trabajo eliminados",
                description: "Los flujos de trabajo que no se utilizan durante 30 días se eliminan automáticamente por el sistema",
                emptyState: "No hay flujos de trabajo eliminados en la papelera",
                unnamedWorkflow: "Flujo de trabajo sin nombre",
                restore: "Restaurar",
                permanentlyDelete: "Eliminar permanentemente",
                unknown: "Desconocido",
                user: "Usuario",
                restoreConfirmTitle: "¿Está seguro de que desea restaurar este flujo de trabajo?",
                restoreConfirmContent: "El flujo de trabajo {title} será restaurado.",
                restoreSuccess: "Flujo de trabajo restaurado correctamente",
                restoreFailed: "Restauración fallida",
                deleteConfirmTitle: "¿Está seguro de que desea eliminar permanentemente este flujo de trabajo?",
                deleteConfirmContent: "El flujo de trabajo {title} será eliminado permanentemente. Esta acción no se puede deshacer.",
                deleteOkText: "Sí, eliminar permanentemente",
                cancel: "Cancelar",
                deleteSuccess: "Flujo de trabajo eliminado permanentemente",
                deleteFailed: "Eliminación permanente fallida",
                loadError: "Error al cargar los flujos de trabajo eliminados"
            },
            notAuthorizedCreateTask: "No está autorizado a crear una tarea",
            notAuthorizedCreateTaskDesc: "No está autorizado a realizar esta tarea.",
            approval: "Aprobado",
            taskDesc: "Descripción de la tarea",
            archiveAndTrash: "Archivo y papelera",
            trash: "Papelera",
            loading: "Cargando...",
            startDate: "Fecha de inicio",
            endDate: "Fecha de fin",
            clearFilter: "Limpiar filtro",
            noArchivedTasks: "No se encontraron tareas archivadas",
            noDeletedTasks: "No se encontraron tareas en la papelera",
            total: "Total",
            error: "Error",
            moveToBoard: "Mover al tablero",
            unarchive: "Desarchivar",
            taskMovedToBoard: "Tarea movida al tablero",
            taskMoveError: "Error al mover la tarea al tablero",
            taskDeleted: "Tarea eliminada",
            taskDeleteError: "Error al eliminar la tarea",
            taskUnarchived: "Tarea desarchivada",
            taskUnarchiveError: "Error al desarchivar la tarea",
            kanbanSettings: {
                cancel: "Cancelar",
                card: "Configuración de la tarjeta",
                column: "Configuración de la columna",
                kanban: "Configuración de Kanban",
                save: "Guardar",
                selectField: "Seleccionar campo",
                selectFieldPlaceholder: "Seleccionar campo",
                selectFields: "Seleccione los campos que se mostrarán en la tarjeta",
                title: "Configuración"
            }
        },
        permissionErrors: {
            userCreate: "No tiene permiso para agregar usuarios. Por favor, consulte a su administrador.",
            userRead: "No tiene permiso para ver usuarios. Por favor, consulte a su administrador.",
            userUpdate: "No tiene permiso para actualizar usuarios. Por favor, consulte a su administrador.",
            userDelete: "No tiene permiso para eliminar usuarios. Por favor, consulte a su administrador.",
            visitorBlock: "No tiene permiso para bloquear visitantes. Por favor, consulte a su administrador.",
            visitorUnblock: "No tiene permiso para desbloquear visitantes. Por favor, consulte a su administrador.",
            visitorDetailRead: "No tiene permiso para ver detalles de visitantes. Por favor, consulte a su administrador.",
            visitorListRead: "No tiene permiso para ver la lista de visitantes. Por favor, consulte a su administrador.",
            visitorDelete: "No tiene permiso para eliminar visitantes. Por favor, consulte a su administrador.",
            visitorExcel: "No tiene permiso para obtener la salida de Excel. Por favor, consulte a su administrador.",
            visitorUpdate: "No tiene permiso para actualizar visitantes. Por favor, consulte a su administrador.",
            bannedVisitorRead: "No tiene permiso para ver la lista de visitantes bloqueados. Por favor, consulte a su administrador.",
            bannedWordCreate: "No tiene permiso para agregar palabras prohibidas. Por favor, consulte a su administrador.",
            bannedWordRead: "No tiene permiso para ver palabras prohibidas. Por favor, consulte a su administrador.",
            bannedWordDelete: "No tiene permiso para eliminar palabras prohibidas. Por favor, consulte a su administrador.",
            chatRead: "No tiene permiso para ver chats. Por favor, consulte a su administrador.",
            chatUpdate: "No tienes permiso para editar chats. Consulta con tu administrador.",
            archiveRead: "No tienes permiso para ver archivos. Consulta con tu administrador.",
            roleCreate: "No tienes permiso para agregar roles. Consulta con tu administrador.",
            roleRead: "No tienes permiso para ver roles. Consulta con tu administrador.",
            roleUpdate: "No tienes permiso para actualizar roles. Consulta con tu administrador.",
            roleDelete: "No tienes permiso para eliminar roles. Consulta con tu administrador.",
            departmentCreate: "No tienes permiso para agregar departamentos. Consulta con tu administrador.",
            departmentRead: "No tienes permiso para ver departamentos. Consulta con tu administrador.",
            departmentUpdate: "No tienes permiso para actualizar departamentos. Consulta con tu administrador.",
            departmentDelete: "No tienes permiso para eliminar departamentos. Consulta con tu administrador.",
            preparedContentCreate: "No tienes permiso para crear contenido preparado. Consulta con tu administrador.",
            preparedContentRead: "No tienes permiso para ver contenido preparado. Consulta con tu administrador.",
            preparedContentUpdate: "No tienes permiso para actualizar contenido preparado. Consulta con tu administrador.",
            preparedContentDelete: "No tienes permiso para eliminar contenido preparado. Consulta con tu administrador.",
            welcomeCreate: "No tienes permiso para crear mensajes de bienvenida. Consulta con tu administrador.",
            welcomeRead: "No tienes permiso para ver mensajes de bienvenida. Consulta con tu administrador.",
            welcomeUpdate: "No tienes permiso para actualizar mensajes de bienvenida. Consulta con tu administrador.",
            welcomeDelete: "No tienes permiso para eliminar mensajes de bienvenida. Consulta con tu administrador.",
            settingCreate: "No tiene permiso para crear ajustes. Por favor, consulte con su administrador.",
            settingRead: "No tiene permiso para ver ajustes. Por favor, consulte con su administrador.",
            settingUpdate: "No tiene permiso para actualizar ajustes. Por favor, consulte con su administrador.",
            settingDelete: "No tiene permiso para eliminar ajustes. Por favor, consulte con su administrador.",
            reportCreate: "No tiene permiso para crear informes. Por favor, consulte con su administrador.",
            reportRead: "No tiene permiso para ver informes. Por favor, consulte con su administrador.",
            reportUpdate: "No tiene permiso para actualizar informes. Por favor, consulte con su administrador.",
            reportDelete: "No tiene permiso para eliminar informes. Por favor, consulte con su administrador.",
            offlineSupportRequestCreate: "No tiene permiso para crear solicitudes de soporte sin conexión. Por favor, consulte con su administrador.",
            offlineSupportRequestRead: "No tiene permiso para ver solicitudes de soporte sin conexión. Por favor, consulte con su administrador.",
            offlineSupportRequestUpdate: "No tiene permiso para responder a solicitudes de soporte sin conexión. Por favor, consulte con su administrador.",
            offlineSupportRequestDelete: "No tiene permiso para eliminar solicitudes de soporte sin conexión. Por favor, consulte con su administrador.",
            catalogCreate: "No tiene permiso para crear catálogos. Por favor, consulte con su administrador.",
            catalogRead: "No tiene permiso para ver catálogos. Por favor, consulte con su administrador.",
            catalogUpdate: "No tiene permiso para actualizar catálogos. Por favor, consulte con su administrador.",
            catalogDelete: "No tiene permiso para eliminar catálogos. Por favor, consulte con su administrador.",
            chatbotStoryCreate: "No tiene permiso para crear historias de chatbot. Por favor, consulte con su administrador.",
            chatbotStoryRead: "No tiene permiso para ver historias de chatbot. Por favor, consulte con su administrador.",
            chatbotStoryUpdate: "No tiene permiso para actualizar historias de chatbot. Por favor, consulte con su administrador.",
            chatbotStoryDelete: "No tiene permiso para eliminar historias de chatbot. Por favor, consulte con su administrador.",
            chatbotTemplateRead: "No tiene permiso para ver plantillas de chatbot. Por favor, consulte con su administrador.",
            chatbotTemplateAiRead: "No tiene permiso para ver plantillas de chatbot de IA. Por favor, consulte con su administrador.",
            chatbotIntegrationsRead: "No tiene permiso para ver integraciones de chatbot. Por favor, consulte con su administrador.",
            chatbotArchiveRead: "No tiene permiso para ver archivos de chatbot. Por favor, consulte con su administrador.",
            chatbotEntitiesRead: "No tiene permiso para ver entidades de chatbot. Por favor, consulte con su administrador.",
            chatbotEntitiesCreate: "No tiene permiso para crear entidades de chatbot. Por favor, consulte con su administrador.",
            chatbotEntitiesUpdate: "No tiene permiso para actualizar entidades de chatbot. Por favor, consulte con su administrador.",
            chatbotEntitiesDelete: "No tiene permiso para eliminar entidades de chatbot. Por favor, consulte con su administrador.",
            chatbotReportRead: "No tienes permiso para ver los informes del chatbot. Por favor, contacta a tu administrador.",
            chatbotTrainRead: "No tienes permiso para ver el entrenamiento del chatbot. Por favor, contacta a tu administrador.",
            chatbotSegmentCreate: "No tienes permiso para crear segmentos de usuarios del chatbot. Por favor, contacta a tu administrador.",
            chatbotSegmentRead: "No tienes permiso para ver los segmentos de usuarios del chatbot. Por favor, contacta a tu administrador.",
            chatbotSegmentUpdate: "No tienes permiso para actualizar los segmentos de usuarios del chatbot. Por favor, contacta a tu administrador.",
            chatbotSegmentDelete: "No tienes permiso para eliminar los segmentos de usuarios del chatbot. Por favor, contacta a tu administrador.",
            integrationsRead: "No tienes permiso para ver la página de integraciones. Por favor, contacta a tu administrador.",
            whatsappIntegrationRead: "No tienes permiso para ver la página de integración de WhatsApp. Por favor, contacta a tu administrador.",
            instagramIntegrationRead: "No tienes permiso para ver la página de integración de Instagram. Por favor, contacta a tu administrador.",
            telegramIntegrationRead: "No tienes permiso para ver la página de integración de Telegram. Por favor, contacta a tu administrador.",
            integrationCreate: "No tienes permiso para activar integraciones. Por favor, contacta a tu administrador.",
            triggerCreate: "No tienes permiso para crear desencadenadores. Por favor, contacta a tu administrador.",
            triggerRead: "No tienes permiso para ver los desencadenadores. Por favor, contacta a tu administrador.",
            triggerUpdate: "No tienes permiso para actualizar los desencadenadores. Por favor, contacta a tu administrador.",
            triggerDelete: "No tienes permiso para eliminar los desencadenadores. Por favor, contacta a tu administrador.",
            billingRead: "No tienes permiso para ver las facturas. Por favor, contacta a tu administrador.",
            taskCreate: "No tienes permiso para crear tareas. Por favor, contacta a tu administrador.",
            taskRead: "No tienes permiso para ver tareas. Por favor, contacta a tu administrador.",
            taskUpdate: "No tienes permiso para actualizar tareas. Por favor, contacta a tu administrador.",
            taskDelete: "No tienes permiso para eliminar tareas. Por favor, contacta a tu administrador.",
            calendarCreate: "No tienes permiso para crear calendarios/reservas. Por favor, contacta a tu administrador.",
            calendarRead: "No tienes permiso para ver calendarios/reservas. Por favor, contacta a tu administrador.",
            calendarUpdate: "No tienes permiso para actualizar calendarios/reservas. Por favor, contacta a tu administrador.",
            calendarDelete: "No tienes permiso para eliminar calendarios/reservas. Por favor, contacta a tu administrador.",
            mailCreate: "No tienes permiso para crear correos electrónicos. Por favor, contacta a tu administrador.",
            mailRead: "No tienes permiso para ver correos electrónicos. Por favor, contacta a tu administrador.",
            mailUpdate: "No tienes permiso para actualizar correos electrónicos. Por favor, contacta a tu administrador.",
            mailDelete: "No tienes permiso para eliminar correos electrónicos. Por favor, contacta a tu administrador."
        },
        message: {
            artificialIntelligence: "Inteligencia artificial",
            appBreadcrumb: {
                tasks: "Tareas",
                broadcastLabel: "Mensaje masivo",
                walletBalanceTooltip: "Saldo de tu billetera: {amount}₺",
                broadcastStatusCreated: "Creado",
                broadcastStatusScheduled: "Programado",
                broadcastStatusQueued: "En cola",
                broadcastStatusRunning: "Enviando",
                broadcastStatus: "Estado",
                broadcastProgress: "Progreso"
            },
            confirmDeleteRedStationIntegration: "¿Estás seguro de que quieres eliminar este canal de Kırmızı Santral?",
            enterRedStationIntegration: "Ingresa tus credenciales de API de Kırmızı Santral",
            redStationIntegration: "Integración de Kırmızı Santral",
            copyChannelID: "Copiar ID del Canal",
            redStationChannels: "Canales de Kırmızı Santral",
            bannedUserError: "Se produjo un error al agregar la prohibición.",
            bannedUserSuccess: "Prohibición agregada con éxito.",
            selectAtLeastOneOption: "Por favor selecciona al menos una opción.",
            enterValidValue: "Por favor ingresa un valor válido.",
            enterValidIpAddress: "Por favor ingresa una dirección IP válida.",
            enterValidVisitorId: "Por favor ingresa un ID de visitante válido.",
            enterValidWhatsappNumber: "Por favor ingresa un número de WhatsApp válido.",
            invalidEmailAddress: "Por favor ingresa una dirección de correo electrónico válida.",
            bannedUser: "Prohibido",
            unbannedUser: "No Prohibido",
            banModalDescription: "Ingresa la plataforma y el valor para prohibir al usuario.",
            exampleNumber: "Número de ejemplo: 905551111111",
            clearSelectedFiltersTooltip: "Limpia los valores de filtros seleccionados en la página",
            minutesText: "{count} minutos",
            secondsText: "{count} segundos",
            downloadCooldownWarning: "Por favor espera {time} para crear una nueva solicitud de descarga.",
            excelExportReceiveQuestion: "¿Cómo te gustaría recibir el archivo de Excel?",
            sendToMe: "Envíamelo",
            sendToSomeoneElse: "Enviar a Otra Persona",
            enterEmailAddress: "Ingresa dirección de correo electrónico",
            exportRequestSuccess: "Tu solicitud ha sido creada, te la enviaremos por correo electrónico lo antes posible",
            maxDateRangeWarning: "El rango de fechas seleccionado puede ser de máximo 45 días",
            ticketOnlyMail: "Esta solicitud solo puede responderse por correo electrónico. Los mensajes enviados a través de WhatsApp no se pueden reenviar.",
            cardInfoUpdateError: "Se produjo un error al actualizar la información de la tarjeta",
            billingInfoSavedSuccessfully: "Su información de facturación se ha guardado correctamente",
            billingInfoSaveError: "Error al guardar la información de facturación:",
            paymentInfoSavedSuccessfully: "Su información de pago se ha guardado correctamente",
            annualDiscount: "Obtenga un 20% de descuento en compras anuales",
            annualDiscountDescription: "Puede ahorrar significativamente eligiendo una suscripción anual.",
            payOnlyForUsedFeatures: "Pague solo por lo que usa",
            payOnlyForUsedFeaturesDescription: "Pague solo por las funciones que utiliza, no pague por más.",
            cancelAnytime: "Cancele en cualquier momento",
            cancelAnytimeDescription: "No necesita contratos a largo plazo, puede cancelar cuando lo desee.",
            noPermissionDescription: "No tienes permiso para realizar esta acción.",
            creditCardRequired: "Se requiere información de tarjeta de crédito",
            creditCardRequiredDescription: "Tiene suscripciones de pago. Puede continuar ingresando su información de tarjeta de crédito o cancelando sus suscripciones.",
            creditCardRequiredDescription2: "Debe ingresar información de tarjeta de crédito porque tiene suscripciones de pago en su cuenta.",
            subscriptionManagement: "Gestión de Suscripciones",
            addCreditCard: "Agregar Información de Tarjeta",
            transferOwnership: "Transferir Propiedad y Redirigir",
            errorLoadingAgents: "Se produjo un error al cargar los agentes",
            pleaseFillRequiredFields: "Por favor, complete los campos requeridos",
            callStartedSuccessfully: "Llamada iniciada exitosamente",
            errorStartingCall: "Se produjo un error al iniciar la llamada",
            errorLoadingData: "Se produjo un error al cargar los datos",
            errorLoadingDataPhoneNumbers: "Se produjo un error al cargar los números de teléfono",
            noVariablesFound: "No se encontraron variables en el prompt. Las variables deben estar en formato <code v-pre>{{ nombre_variable }}</code>.",
            aiVoiceAgentSpecialVariables: "Valores de Variables Especiales",
            addAiVoiceAgentChannel: "Agregar Canal",
            multiLanguageSupport: "Soporte multiidioma",
            customerService247: "Servicio al cliente 24/7",
            autoCallAnswer: "Respuesta automática de llamadas",
            aiVoiceAgentChannelRequired: "Canal de Agente de Voz IA Requerido",
            aiVoiceAgentChannelRequiredDescription: "Necesita agregar un canal de Agente de Voz IA para usar esta función.",
            aiVoiceAgentChannelRequiredDescription2: "El Agente de Voz IA es un asistente impulsado por inteligencia artificial que puede realizar llamadas telefónicas con sus clientes.",
            startCall: "Iniciar Llamada",
            selectContactFieldPlaceholder: "Seleccionar información de contacto",
            aiVoiceAgentVariableValuePlaceholder: "Introducir valor",
            aiVoiceAgentVariables: "Información de Variables del Agente",
            aiVoiceAgentVariableManual: "Manual",
            aiVoiceAgentVariableContact: "Información de Contacto",
            toNumberHelpText: "Debe estar en formato E.164. Ejemplo: +905321234567",
            toNumber: "Número a Llamar",
            selectAiVoiceAgentHelpText: "Si no se selecciona, se utilizará el agente saliente predeterminado del número",
            selectAiVoiceAgent: "Seleccionar agente (opcional)",
            aiVoiceAgent: "Agente",
            selectFromNumber: "Seleccionar número llamante",
            fromNumber: "Número Llamante",
            startAiCall: "Iniciar Llamada con Agente de Voz IA",
            aiCall: "Realizar Llamada con Agente de Voz IA",
            groupByNone: "Sin agrupación aplicada",
            groupByAgent: "Agrupar contactos por los agentes de su última sesión",
            groupByDepartment: "Agrupar contactos por el departamento seleccionado en su última sesión",
            groupByChannel: "Agrupar contactos por el canal del que vinieron",
            groupByPlatform: "Agrupar contactos por la plataforma de la que vinieron",
            groupByWebsite: "Agrupar contactos por el sitio web del que vinieron",
            groupByTag: "Agrupar contactos por sus etiquetas",
            groupByAnswerStatus: "Agrupar contactos por su estado de respuesta de su última sesión",
            groupByOwner: "Agrupar contactos por sus propietarios",
            changeGroupBy: "Cambiar Modo de Agrupación",
            changeSortMode: "Cambiar Modo de Ordenación",
            selectIcon: "Seleccionar Icono",
            iconPickerTitle: "Selector de Iconos",
            searchIconPlaceholder: "Buscar icono...",
            profileFieldsDescriptionChat: "Haga clic para personalizar sus campos de perfil",
            createCommentSuccess: "Comentario creado con éxito",
            createCommentError: "Se produjo un error al crear el comentario",
            updateCommentSuccess: "Comentario actualizado con éxito",
            updateCommentError: "Se produjo un error al actualizar el comentario",
            deleteCommentSuccess: "Comentario eliminado con éxito",
            deleteCommentError: "Se produjo un error al eliminar el comentario",
            formSubmission: "Envío de formulario",
            selectForm: "Seleccionar formulario",
            updateOwnerUsers: "Actualizar propietarios",
            updateOwnerUsersDesc: "¿Quieres actualizar los propietarios de este usuario? Puedes transferirlos a otro usuario o dejarlos sin propietario.",
            deposit: "Depósito",
            creditUsage: "Uso de crédito",
            businessMarketing: "Marketing",
            businessUtility: "Utilidad",
            businessAuthentication: "Autenticación",
            businessService: "Servicio",
            incomingSessionMessage: "Mensaje entrante",
            outgoingSessionMessage: "Mensaje saliente",
            freeTierConversation: "Conversación gratuita (FTC)",
            chatStart: "Iniciar chat",
            wpMessage: "Mensaje Masivo de Whatsapp QR",
            pin: "Fijar",
            rename: "Renombrar",
            browserSpeechRecognitionNotSupported: "Tu navegador no soporta el reconocimiento de voz. Recomendamos usar el navegador Chrome.",
            spaceKeyReleaseToSave: "Se guardará cuando sueltes la tecla de espacio",
            spaceKeyHint: "Puedes hablar manteniendo presionada la tecla de espacio",
            listeningInProgress: "Escuchando...",
            speakNow: "Habla ahora...",
            toggleAllPermissions: "Activar/Desactivar todos los permisos del rol",
            rolePermissions: "Permisos del rol",
            roleSaved: "Rol guardado.",
            creatingRole: "Creando rol...",
            savingRole: "Guardando rol...",
            editRole: "Editar rol",
            newRoleCreate: "Crear nuevo rol",
            descriptionEmail: "Agrega automáticamente la dirección de correo electrónico del visitante en el chat al cuadro de mensaje y permite enviarlo",
            exampleEmail: "Ejemplo: @email hola",
            nameDescription: "Agrega automáticamente el nombre del visitante en el chat al cuadro de mensaje y permite enviarlo",
            exampleName: "Ejemplo: @name hola",
            pmDescription: "Permite enviar un mensaje privado. Solo otros representantes de atención al cliente pueden ver estos mensajes, los visitantes no.",
            examplePm: "Ejemplo: pm: Este mensaje es privado",
            chatShortcuts: "Atajos de Chat",
            showSystemStatus: "Mostrar Estado del Sistema",
            endChatWizard: "Asistente para Terminar Sesión",
            terminationError: "Se ha producido un error",
            profileFieldsUpdateError: "Ocurrió un error al actualizar los campos de perfil",
            profileFieldsUpdated: "Campos de perfil actualizados",
            aiSuggestionError: "No se pudieron obtener sugerencias de IA",
            profileFieldsDescription: "Puedes llenar los campos de perfil personalizados para esta persona para proporcionar más información a tu equipo.",
            categoryTags: "Puedes agregar etiquetas a esta persona para clasificarla rápidamente.",
            manageTags: "Gestionar Etiquetas",
            enterNote: "Ingrese Nota",
            noteDescription: "Puedes agregar notas sobre esta persona. Estas notas también se verán después de la conversación.",
            suggestedProfileFields: "Campos de perfil sugeridos:",
            suggestedTags: "Etiquetas sugeridas",
            suggestedNote: "Nota sugerida:",
            applyAll: "Aplicar todo",
            aiSuggestionTitle: "Sugerencias de IA",
            aiSuggestion: "Supsis Asistan Sugerencias",
            searchItem: "Buscar elemento",
            makeSelection: "Hacer Selección",
            channel: "Canal",
            taskClosingDate: "Fecha de Cierre de Tarea",
            deleteOperation: "Operación de Eliminación",
            confirmDeleteTask: "¿Está seguro de que desea eliminar esta tarea?",
            taskDeletedSuccess: "Tarea eliminada exitosamente",
            taskDeleteError: "Error al eliminar la tarea",
            selectColumns: "Seleccione las Columnas que Desea Ver en la Tabla",
            linkedinChannels: "Canales de LinkedIn",
            updateLinkedinChannelDesc: "Actualiza tu canal de LinkedIn",
            deleteLinkedinChannel: "Eliminar Canal de LinkedIn",
            confirmDeleteLinkedinChannel: "¿Estás seguro de que quieres eliminar este canal de LinkedIn?",
            contactIdPlaceholder: "ID de contacto",
            contactId: "ID de contacto",
            enterOwnerId: "Ingresar ID del propietario",
            selectOwner: "Seleccionar propietario",
            dynamic: "Dinámico",
            owner: "Propietario",
            addCollaborator: "Agregar colaborador",
            dynamicValue: "Valor dinámico",
            selectCollaborator: "Seleccionar colaborador",
            collaborator: "Colaborador",
            collaborators: "Colaboradores",
            addFollower: "Agregar seguidor",
            selectFollower: "Seleccionar seguidor",
            followers: "Seguidores",
            follower: "Seguidor",
            addAssignee: "Agregar asignado",
            selectUser: "Seleccionar usuario",
            assignees: "Asignados",
            assignee: "Asignado",
            pipelineStage: "Etapa del pipeline",
            selectPipelineStage: "Seleccionar etapa del pipeline",
            title: "Título",
            taskTitle: "Título de la tarea",
            description: "Descripción",
            taskDescription: "Descripción de la tarea",
            priority: "Prioridad",
            selectPriority: "Seleccionar prioridad",
            workflow: "Flujo de trabajo",
            selectWorkflow: "Seleccionar flujo de trabajo",
            packagePurchase: "Compra de paquete",
            upcomingInvoice: "Factura próxima",
            invoiceUpdated: "Factura actualizada",
            invoiceMarkedInvalid: "Factura marcada como inválida.",
            invoiceUpdateError: "Error de actualización de factura",
            invoiceMarkInvalidError: "Ocurrió un error al marcar la factura como inválida.",
            refunded: "Reembolsado",
            paid: "Pagado",
            pending: "Pendiente",
            unpaid: "No pagado",
            paymentFailed: "Pago fallido",
            paymentProcessError: "Ocurrió un error durante el proceso de pago.",
            paymentSuccessful: "Pago exitoso",
            paymentProcessSuccessful: "El proceso de pago se completó exitosamente.",
            invoiceRefund: "Reembolso de factura",
            invoiceRefundedSuccessfully: "La factura ha sido reembolsada exitosamente.",
            invoicePaymentError: "Error en el pago de la factura",
            invoicePaymentProcessError: "Ocurrió un error durante el proceso de pago de la factura.",
            invoicePaid: "Factura pagada",
            invoiceMarkedAsPaid: "La factura ha sido marcada como pagada exitosamente.",
            invoicePriceUpdateError: "Ocurrió un error al actualizar el precio de la factura.",
            invoicePriceUpdatedSuccessfully: "El precio de la factura ha sido actualizado exitosamente.",
            invoicePdf: "Factura PDF",
            viewInvoice: "Ver factura",
            makePayment: "Realizar pago",
            autoForwardToOwnerForceDescription: "En todos los casos, los contactos con propietario se reenvían automáticamente a su propietario. No se mantienen en cola ni se transfieren al chatbot. Incluso si esta configuración está desactivada, si el chatbot no está activo en el sistema, se reenviarán a su propietario.",
            autoForwardToOwnerForce: "Reenvío automático al propietario (incluso con chatbot activo)",
            socialMedia: "Redes Sociales",
            email: "Correo electrónico",
            sms: "SMS",
            crm: "CRM",
            ecommerce: "Comercio electrónico",
            utilities: "Utilidades",
            advertising: "Publicidad",
            cancelPlanTitle: "Cancelar plan",
            cancelPlanDescription: "Después de cancelar el plan, el paquete podrá ser utilizado hasta el final del período de validez.",
            voteSuccess: "Voto guardado correctamente",
            voteSuccessDescription: "Hemos recibido su solicitud para añadir la integración {integrationName} a Supsis",
            companyName: "Nombre de la empresa",
            company: "Empresa",
            languageTitle1: "Idioma predeterminado del panel",
            languageTitle2: "Idioma predeterminado de mensajería",
            languageTitle3: "Región y zona horaria",
            languageTitle4: "Configuración automática del idioma del cliente",
            languageTitle5: "Selección del idioma de mensajería del cliente en WebChat",
            languageDesc1: "Establece el idioma del panel de Supsis AI",
            languageDesc2: "Puedes cambiar el idioma de mensajería predeterminado desde aquí.",
            languageDesc3: "Establece la región y la zona horaria",
            languageDesc4: "Permite la detección automática del idioma de mensajería del cliente con soporte de IA.",
            languageDesc5: "Activa la función que permite al cliente seleccionar su idioma hablado en el canal de WebChat.",
            featuresTitle1: "Selección de departamento",
            featuresTitle2: "Mostrar número de clientes en espera",
            featuresTitle3: "Restricción de palabras prohibidas",
            featuresTitle4: "Permitir a los clientes crear tickets",
            featuresTitle5: "Llamada de voz",
            featuresTitle6: "Videollamada",
            featuresTitle7: "Envío de mensajes de voz (agente)",
            featuresTitle8: "Envío de mensajes de voz (cliente)",
            featuresTitle9: "Transferencia automática de llamadas",
            featuresTitle10: "Mostrar chat entre representantes",
            featuresTitle11: "Envío de archivos (agente)",
            featuresTitle12: "Envío de archivos en WebChat (cliente)",
            featuresTitle13: "Permitir el envío de mensajes antes de que se conecte el representante",
            featuresTitle14: "Ocultar mensajes del sistema de los representantes",
            featuresTitle15: "Permitir al cliente eliminar información personal",
            featuresTitle16: "Notificación de cliente en línea",
            featuresTitle17: "Traducción automática",
            featuresTitle18: "Inicio de sesión automático del visitante",
            featuresTitle19: "Compartir ubicación en WebChat (cliente)",
            featuresTitle20: "Compartir ubicación (representante)",
            featuresTitle21: "Copiloto AI de chat",
            featuresTitle22: "Colocar en cola conversaciones sin propietario",
            featuresTitle23: "Ocultar información de contacto",
            featuresDesc1: "Enrutamiento obligatorio a departamentos según los temas seleccionados por el cliente.",
            featuresDesc2: "Muestra a los clientes su posición en la cola cuando los representantes están ocupados.",
            featuresDesc3: "Evita que los representantes envíen palabras prohibidas definidas en el sistema a los clientes cuando la restricción de palabras prohibidas está activa.",
            featuresDesc4: "Activa la opción de crear un ticket en la burbuja de WebChat.",
            featuresDesc5: "Activa la función de llamada de voz en la burbuja de WebChat.",
            featuresDesc6: "Activa la función de videollamada en la burbuja de WebChat.",
            featuresDesc7: "Permite a los representantes enviar mensajes de voz.",
            featuresDesc8: "Permite a los clientes enviar mensajes de voz en el canal de WebChat.",
            featuresDesc9: "Asigna automáticamente las llamadas en espera a los representantes disponibles.",
            featuresDesc10: "Muestra el panel de conversación entre representantes.",
            featuresDesc11: "Permite a los representantes enviar archivos.",
            featuresDesc12: "Permite a los clientes enviar archivos en el canal de WebChat.",
            featuresDesc13: "Permite a los clientes enviar mensajes antes de que se conecte un representante.",
            featuresDesc14: "Oculta los mensajes del sistema de los representantes, evitando que los clientes los vean.",
            featuresDesc15: "Activa la posibilidad de que los clientes eliminen su información personal con un solo clic en la burbuja de WebChat.",
            featuresDesc16: "Notifica a los representantes con un mensaje del sistema cuando un cliente sale o regresa al canal de WebChat.",
            featuresDesc17: "Traduce automáticamente los mensajes de los clientes al idioma del representante.",
            featuresDesc18: "Inicia la conversación tan pronto como el visitante hace clic en la burbuja.",
            featuresDesc19: "Activa la posibilidad de que los clientes compartan su ubicación en el canal de WebChat.",
            featuresDesc20: "Activa la posibilidad de que los representantes compartan su ubicación.",
            featuresDesc21: "Activa el uso de asistencia AI para los representantes para corregir errores tipográficos, cambiar el tono de los mensajes y generar respuestas asistidas por AI.",
            featuresDesc22: "Activa esta función para mantener a las personas sin propietario en la cola.",
            featuresDesc23: "Evita que los representantes vean los números de teléfono y las direcciones de correo electrónico de los clientes.",
            featuresTitle24: "Asistente de fin de sesión",
            featuresDesc24: "Muestra el asistente de cierre de sesión a los representantes antes de cerrar la conversación",
            groupBy: "Agrupar",
            privacyPolicyAndTerms: "Política de privacidad / Términos de servicio",
            privacyPolicyTitle: "Política de privacidad para sistemas de soporte y chatbot de Supsis",
            privacyPolicyDescription: "Esta Política de privacidad describe cómo Softcand Yazılım Hizmetleri A.S. (“Softcand”, “nosotros”, “nuestro” o “nuestra”) recopila, utiliza y divulga información sobre los usuarios (“usted” o “su”) de la aplicación web Supsis (“Supsis”). Esta Política de privacidad se aplica a la información que recopilamos cuando utiliza Supsis; esta información es válida cuando se accede a través de nuestro sitio web, aplicaciones móviles u otras plataformas donde se publica la Política de privacidad.",
            informationWeCollect: "Información que recopilamos",
            weCollectFollowingInformation: "Recopilamos la siguiente información",
            customerAccountInformation: "Información de la cuenta del cliente",
            customerAccountData: "Al crear una cuenta de Supsis, recopilamos los siguientes datos: nombre, apellido, número de teléfono y dirección de correo electrónico.",
            userInformation: "Información del usuario",
            userProvidedInformation: "Información proporcionada por los usuarios de la aplicación, incluyendo nombre, apellido y dirección de correo electrónico.",
            dataDeletionProcess: "Proceso de eliminación de datos",
            dataDeletionProcedures: "Seguimos estos procedimientos para la eliminación de datos",
            automaticDeletion: "Eliminación automática",
            automaticDeletionInfo: "Las cuentas de clientes se eliminan automáticamente cuando se cierran o después de seis meses de inactividad.",
            directRequest: "Solicitud directa",
            directRequestInfo: "Los clientes pueden solicitar la eliminación de todos sus datos contactándonos directamente.",
            websiteVisitorDataDeletion: "Eliminación de datos de visitantes del sitio web",
            websiteVisitorDataDeletionInfo: "Los visitantes del sitio web pueden eliminar sus datos, incluyendo el historial de chat, mensajes y archivos, directamente a través de la interfaz de chat web.",
            howToContactUs: "Cómo contactarnos",
            contactChannels: "Puede contactarnos a través de los siguientes canales",
            dataProcessingAndSharing: "Procesamiento y compartición de datos",
            handleCustomerData: "Procesamos los datos de los clientes de la siguiente manera",
            noThirdPartySharing: "No compartimos con terceros",
            noThirdPartySharingInfo: "Supsis no comparte los datos de los clientes con ninguna organización, empresa o individuo de terceros.",
            promotionalEmails: "Correos electrónicos promocionales",
            promotionalEmailsInfo: "Podemos enviar correos electrónicos promocionales a los clientes; pueden optar por darse de baja de estos correos.",
            visitorAndConversationData: "Datos de visitantes y conversaciones",
            noSharingVisitorData: "No compartimos ni utilizamos la información de los visitantes y chats de los clientes.",
            thirdPartyServices: "Servicios de terceros",
            googleOAuth: "Google OAuth",
            googleCalendar: "Google Calendar",
            googleCalendarInfo: "Supsis utiliza Google Calendar para habilitar funciones relacionadas con el calendario dentro de la aplicación. Los datos sincronizados desde los calendarios no se comparten con nadie y son visibles solo para el usuario. Cuando Google OAuth expira, todos los eventos sincronizados de Supsis y Google Calendar se eliminan automáticamente.",
            googleAccountPublicProfile: "Perfil público de la cuenta de Google",
            googleAccountPublicProfileInfo: "Supsis recopila información sobre el nombre y la dirección de correo electrónico para verificar y autenticar a los usuarios durante el inicio de sesión. Esta información no se almacena después de la verificación.",
            changesToPrivacyPolicy: "Cambios en esta política de privacidad",
            privacyPolicyUpdateInfo: "Podemos actualizar esta política de privacidad de vez en cuando. Si hacemos cambios materiales, le informaremos a través de nuestro sitio web u otros canales de comunicación.",
            privacyPolicyContactInfo: "Si tiene alguna pregunta sobre esta política de privacidad, contáctenos en m@softcand.com.",
            termsOfServiceTitle: "Términos de servicio para sistemas de soporte y chatbot de Supsis",
            lastUpdated: "Última actualización",
            inEffect: "En vigor",
            importantTerms: "Importante: Estos Términos de servicio, que incluyen nuestra Política de privacidad, constituyen un contrato vinculante entre la persona nombrada durante el proceso de 'Registro' como usuario del Servicio (“usted”) y Softcand Yazılım Hizmetleri Anonim Şirketi (que opera bajo el nombre de Supsis o Supsis Live Support o Supsis Live Support y sistemas de chatbot) (“nosotros”) y rigen su uso de nuestros sitios web ubicados en supsis.com (página de destino del producto), softcand.com (sitio web de la empresa) o supsis.live (aplicación del producto) o beta.supsis.live (versión beta de la aplicación del producto). Por esta razón, estos Términos son importantes y debe asegurarse de leerlos detenidamente y contactarnos con cualquier pregunta antes de usar el Servicio.",
            termsDescription: "Estos Términos de servicio rigen su uso de nuestros sitios web ubicados en supsis.com (página de destino del producto), softcand.com (sitio web de la empresa) o supsis.live (aplicación del producto) o beta.supsis.live (versión beta de la aplicación del producto).",
            applicationOfTerms: "Aplicación de los términos",
            termsApplyToAllUsers: "Estos Términos se aplican a todos los usuarios del Servicio, ya sea que utilice el Servicio en su propio nombre o en nombre de otra persona u organización.",
            termsUpdateNotice: "Podemos actualizar o modificar los Términos en cualquier momento a nuestra discreción. Si cambiamos los Términos, le informaremos notificándole a través de nuestra plataforma web y por correo electrónico.",
            termsDisagreementNotice: "Debe aceptar estar sujeto a los Términos actualizados haciendo clic en su aceptación en el aviso que se le presente antes de continuar utilizando el Servicio.",
            consumerRightsNotice: "Si se le clasifica como 'consumidor' de acuerdo con la legislación aplicable, puede tener derechos legales bajo esta legislación local que prohíben la aplicación de todas o parte de algunas de las limitaciones y exclusiones establecidas en estos Términos a usted, y en ese caso, esas partes no se aplicarán a usted.",
            theService: "El Servicio",
            serviceGrant: "Le otorgamos un derecho no exclusivo, mundial, no transferible y revocable para utilizar el Servicio de acuerdo con estos Términos.",
            serviceAccess: "Puede acceder y utilizar el Servicio (incluyendo cualquier copia accidental que ocurra en el marco de este uso) de acuerdo con estos Términos.",
            serviceAgentAppointment: "Cuando inicia sesión en el Servicio y conecta una cuenta de redes sociales al Servicio, nos nombra como su agente en relación con esa Cuenta para realizar acciones en su nombre, a su dirección (por ejemplo, responder a un mensaje directo en Instagram o en otra Plataforma) al proporcionar el Servicio.",
            additionalAccountsAppointment: "Cuando conecta cuentas adicionales al Servicio, también nos nombra como su agente en relación con esas cuentas para llevar a cabo actividades en el marco de la Agencia.",
            accountControl: "Usted garantiza que controla cada Cuenta y que está autorizado a nombrarnos como su agente con la autoridad para llevar a cabo actividades en el marco de la Agencia en su nombre para cada Cuenta.",
            serviceAffiliation: "Usted reconoce y acepta que el Servicio no está afiliado ni autorizado por Instagram, Facebook, Twitter o cualquier otro servicio de redes sociales para el cual proporcionamos el Servicio, y que cualquier acceso a cada Plataforma (incluyendo a través del Servicio) está regulado por los Términos de uso de la Plataforma correspondiente.",
            serviceLinks: "El Servicio contiene enlaces a otros sitios web, así como contenido agregado por personas que no somos nosotros. No respaldamos, patrocinamos ni aprobamos ningún contenido generado por el usuario o cualquier contenido disponible en un sitio web vinculado.",
            contentMonitoring: "No tenemos ninguna obligación de monitorear, editar o eliminar contenido cargado o publicado por nuestros usuarios en el Servicio y luego publicado en una Cuenta en cualquiera de las Plataformas.",
            serviceControl: "Usted reconoce y acepta que: (1) mantenemos el control sobre el Servicio y podemos modificar, complementar o cesar el funcionamiento del Servicio en cualquier momento a nuestra sola discreción (le informaremos razonablemente sobre cualquier modificación que afecte significativamente la funcionalidad del Servicio); (2) el Servicio puede no estar disponible de vez en cuando (incluyendo por mantenimiento), y en la medida de lo posible, le informaremos sobre cualquier tiempo de inactividad planificado; y (3) podemos negarnos a publicar el contenido que usted agrega al Servicio que consideremos, actuando razonablemente, que no cumple con la sección 3 de estos Términos.",
            yourRightsAndObligations: "Sus derechos y obligaciones",
            contentAdditionRestriction: "No debe agregar ningún contenido al Servicio: (1) a menos que posea todos los derechos, licencias y consentimientos necesarios para hacerlo; (2) que podría hacer que usted o nosotros violen cualquier ley o regulación o cualquier otra regla, código u obligación legalmente exigible; (3) que sea o que nosotros, actuando razonablemente, consideremos spam, obsceno, inapropiado, difamatorio, despectivo, indecente, provocador, ofensivo, pornográfico, amenazante, abusivo, que incite al odio racial, ilegal, discriminatorio, blasfemo, que viole la privacidad o que infrinja cualquier ley de privacidad; (4) que podría desacreditar a nosotros o al Servicio; o (5) que infrinja los derechos de propiedad intelectual u otros derechos de cualquier persona.",
            restrictionsOnServiceUse: "No debe: (1) intentar duplicar o reproducir, o modificar, cambiar o preparar obras derivadas del Servicio, del contenido que publicamos en relación con el Servicio o de cualquier otro material que no posea o para el cual no tenga una licencia pertinente; (2) distribuir virus o código malicioso; (3) utilizar el Servicio para publicar información que sea engañosa o fraudulenta; (4) acceder a la cuenta de otra persona en nuestro Servicio sin su permiso; (5) modificar, desactivar, interferir o eludir cualquier aspecto del Servicio o probar o descompilar el Servicio para encontrar limitaciones, vulnerabilidades o eludir las capacidades de filtrado; o (6) hacer algo que pueda afectar el acceso o la integridad del Servicio.",
            payments: "Pagos",
            paymentAcknowledgment: "Usted reconoce y acepta que:",
            paymentMethodDebit: "Cobraremos su método de pago designado en la fecha de facturación especificada (el día en que finaliza su período de prueba) cada mes, año u otro período de facturación (según corresponda) por el siguiente período de facturación por adelantado, a menos que cancele el Servicio antes de esta fecha; y",
            cancellationPolicy: "Si cancela el Servicio, continuará teniendo acceso al Servicio hasta su próxima fecha de facturación, y cualquier reembolso de cualquier cantidad pagada por el período de facturación actual queda a nuestra discreción (es decir, los pagos no son reembolsables, excepto a nuestra discreción).",
            intellectualProperty: "Propiedad intelectual",
            contentDefinition: "En estos Términos, 'Contenido' incluye materiales en forma de texto, audio, gráfico, pictórico y de video, o cualquier combinación de materiales, en cualquier forma.",
            intellectualPropertyRightsTransfer: "Nada en estos Términos constituye una transferencia de derechos de propiedad intelectual. Usted reconoce y acepta que, entre usted y nosotros, poseemos todos los derechos de propiedad intelectual en el Servicio (es decir, poseemos los derechos sobre las aplicaciones que ponemos a su disposición; no poseemos derechos de propiedad intelectual sobre su Contenido; vea a continuación en 5(3)).",
            userContentRights: "Reconocemos que, entre usted y nosotros, usted posee o tiene una licencia sobre todos los derechos de propiedad intelectual en el Contenido que proporciona al Servicio o que nos proporciona de otra manera con el fin de proporcionar el Servicio.",
            grantLicense: "Nos concede un derecho y una licencia perpetuos, no exclusivos, libres de regalías, irrevocables, mundiales y transferibles para usar, de cualquier manera (incluyendo publicando en una Cuenta en cualquier Plataforma como usted lo indique): (a) el Contenido que agrega al Servicio; y (b) el contenido del perfil en plataformas de redes sociales asociadas con su Cuenta (incluyendo, sin limitación, reproduciendo, cambiando o adaptando, y comunicando ese Contenido al público) con el fin de proporcionarle el Servicio.",
            subLicense: "Podemos sublicenciar la licencia en el párrafo 5(4) a proveedores de servicios de terceros que nos ayuden a proporcionar el Servicio.",
            moralRights: "En algunos países donde opera el Servicio, la legislación local reconoce que los autores de Contenido pueden tener 'derechos morales' en relación con el Contenido. Ejemplos de derechos morales pueden incluir el derecho a ser atribuido como autor del Contenido, el derecho a oponerse a la atribución falsa de la autoría del contenido y el derecho a oponerse al trato degradante del Contenido en ciertas circunstancias.",
            licenseSurvival: "La licencia en el párrafo 5(4) sobrevivirá a cualquier terminación de estos Términos.",
            rightsRepresentation: "Usted declara y garantiza que tiene todos los derechos necesarios para otorgar las licencias y otros compromisos establecidos en este artículo 5.",
            warranties: "Garantías",
            warrantiesAcknowledgment: "Usted declara y garantiza que:",
            accountOwnership: "Todas las Cuentas, en cualquier Plataforma, agregadas al Servicio son propiedad o están controladas por usted;",
            serviceUsageAgreement: "Utilizará el Servicio de acuerdo con estos Términos; y",
            legalCapacity: "Tiene la capacidad legal y la autoridad para celebrar estos Términos.",
            liability: "Responsabilidad",
            liabilityForLoss: "Usted es responsable de cualquier pérdida o daño causado si incumple sus obligaciones bajo estos Términos o si no ejerce un cuidado razonable en su uso del Servicio. Su responsabilidad se reducirá en la medida en que nosotros causamos o contribuimos a esa pérdida o daño por nuestra propia violación de estos Términos o nuestra propia falta de cuidado razonable en la prestación del Servicio.",
            indemnification: "Usted nos indemniza por cualquier pérdida o daño que suframos como resultado de su incumplimiento de estos Términos (incluidas las garantías que nos otorga bajo estos Términos), o cualquier conducta intencional, acto ilegal o negligencia en su uso o abuso del Servicio.",
            exclusionOfLiability: "En la máxima medida permitida por la ley, y sujeto a las disposiciones 7(5) y 7(6) de estos Términos, excluimos toda responsabilidad por todas las reclamaciones, gastos, pérdidas, daños y costos presentados en su contra o incurridos por usted directa o indirectamente que surjan de o en relación con su uso del Servicio o su incapacidad para usar el Servicio, incluyendo en relación con pérdidas económicas, pérdida de datos, interrupción de negocios o cualquier daño consecuente o incidental.",
            totalLiabilityLimit: "En la máxima medida permitida por la ley, y sujeto a las disposiciones 7(5) y 7(6) de estos Términos, nuestra responsabilidad total hacia usted por incumplimiento de contrato bajo estos Términos, por delito (incluida la negligencia) o por cualquier otra causa se limita a un monto igual al total de la tarifa pagada o a pagar por usted por el Servicio durante el mes anterior al día en que surgió nuestra responsabilidad.",
            exclusionOfTerms: "En la máxima medida permitida por la ley, y sujeto a las disposiciones 7(6) y 7(7) de estos Términos, excluimos todos los términos, declaraciones, garantías, condiciones, garantías u obligaciones (ya sean expresas o implícitas) que no estén expresamente establecidas en estos Términos.",
            statutoryObligations: "En algunas jurisdicciones, la legislación puede requerir que ciertas garantías, condiciones, garantías u obligaciones relacionadas con el Servicio se incluyan en estos Términos o se impongan a nuestra prestación del Servicio ('obligaciones estatutarias'). Además, la legislación puede prohibir o anular otros términos que tengan el efecto de excluir, limitar o modificar los términos impuestos, o el ejercicio de derechos y recursos, o la recuperación de compensaciones, que de otro modo están disponibles para usted cuando violamos un término impuesto ('prohibición estatutaria').",
            statuteProhibition: "Si la legislación mencionada en el párrafo 7(6) se aplica a estos Términos tal como los acepta, o al Servicio tal como se le proporciona, nada en estos Términos está destinado a ser o a funcionar como una prohibición estatutaria. En particular, ninguna parte de estos Términos está destinada a limitar nuestra responsabilidad donde esa parte sería una prohibición estatutaria.",
            termination: "Terminación",
            terminationAutomatic: "Estos Términos se terminan automáticamente si, por cualquier motivo, dejamos de operar el Servicio.",
            terminationNotice: "También podemos terminar o suspender su acceso al Servicio de inmediato, notificándole, si razonablemente creemos que ha violado estos Términos de alguna manera.",
            cancelService: "Puede cancelar el Servicio en cualquier momento notificándonos, y puede continuar accediendo al Servicio hasta el final de su período de facturación actual.",
            terminationRights: "Todos los derechos que se le otorgan en estos Términos cesan con la terminación.",
            assignmentRestriction: "No debe ceder, sublicenciar ni de ninguna otra manera disponer de sus derechos bajo estos Términos.",
            invalidProvision: "Si alguna disposición de estos Términos es inválida o inaplicable, debe leerse o separarse en la medida necesaria sin afectar la validez o aplicabilidad de las disposiciones restantes.",
            expenseResponsibility: "Cada parte debe, a su propio costo, hacer todo lo que sea razonablemente necesario para dar pleno efecto a este Acuerdo y a los eventos contemplados por él.",
            governingLaw: "Estos Términos se rigen por las leyes de Turquía y cada parte se somete a la jurisdicción de los tribunales de Turquía.",
            privacyPolicyTab: "Política de privacidad",
            termsAndConditionsTab: "Términos y condiciones",
            placeholders: "Marcadores de posición",
            deleteConfirmationMessage: "¿Está seguro de que desea eliminar este filtro?",
            deleteSuccess: "Filtro eliminado con éxito",
            filterSavedSuccessfully: "El filtro se ha guardado correctamente",
            filterCreatedMessage: "El filtro que acaba de crear, {filterName}, ahora está disponible aquí y se puede usar en cualquier momento.",
            copyImage: "Copiar imagen",
            copyText: "Copiar texto",
            translateVisitorMessage: "Traducir mensaje",
            replyMessage: "Responder",
            downloading: "Descargando archivo...",
            downloadSuccess: "Archivo descargado correctamente",
            downloadFailed: "Error al descargar el archivo",
            filterName: "Nombre del filtro",
            enterFilterName: "Ingrese el nombre del filtro",
            selectVisibility: "Seleccione la visibilidad",
            public: "Público",
            private: "Privado",
            includeExistingFilters: "Incluir filtros existentes",
            includeSearchTerm: "Incluir término de búsqueda",
            includeSortOrder: "Incluir orden de clasificación",
            includeGroupingSelection: "Incluir selección de agrupación",
            saveFilter: "Guardar el filtro",
            ban: "Prohibir",
            chatbotTickets: "Tickets de Chatbot",
            ticketSettings: "Configuraciones de Tickets",
            offlineTickets: "Tickets Fuera de Línea",
            forwardToDepartmentAndAssign: "Reenviar al departamento y asignar",
            storageSpace: "Espacio de almacenamiento",
            completed: "Completado",
            failed: "Fallido",
            cancelled: "Cancelado",
            running: "En ejecución",
            paused: "Pausado",
            queued: "En cola",
            scheduled: "Programado",
            metaLead: "Meta Lead",
            agent: "Agente",
            invoice: "Factura",
            whatsapp: "WhatsApp",
            reservation: "Reserva",
            chatbot: "Chatbot",
            webhook: "Webhook",
            table: "Mesa",
            ticket: "Boleto",
            calendar: "Calendario",
            tag: "Etiqueta",
            low: "Bajo",
            lowest: "El más bajo",
            medium: "Medio",
            high: "Alto",
            highest: "El más alto",
            createDepartment: "Crear departamento",
            goToLink: "Ir al Enlace",
            emailAddressYouProvide: "Ya existe una cuenta con la dirección de correo electrónico proporcionada.",
            channelPrivacyPolicyNotMet: "La política de privacidad del canal no se cumple",
            userIsNotInDepartment: "El usuario no está en el departamento",
            currentDepartment: "Departamento actual",
            validDepartment: "Departamento válido",
            youCanForwardToThisDepartment: "Puede redirigir la conversación a este departamento",
            goToSettings: "Ir a las configuraciones",
            changeDepartmentAndForward: "Cambiar departamento y redirigir",
            selectDepartmentToForwardAgent: "Seleccione a través de qué departamento desea enrutar la conversación para el agente llamado {selectAgentName}.",
            selectDepartmentToForward: "Por favor, seleccione el departamento al que desea redirigir",
            packageConfirmationMessage: "¿Está seguro de que desea comprar el paquete? El paquete que compra está sujeto a cargos en tiempo real. Puede seguir utilizándolo durante un año después de la cancelación. El precio de este producto es exclusivo de IVA del 20%.",
            packagePurchaseConfirmation: "¿Estás seguro de que deseas comprar el paquete? Los paquetes mensuales se cobrarán al principio de cada mes. El uso del paquete finalizará después de la fecha de cancelación. El precio de este producto es exclusivo de IVA al 20%.",
            annualPurchaseDiscount: "¡Aprovecha la oferta de descuento del 30% en compras anuales!",
            customerTables: "Tablas de clientes",
            formIntegration: "Integración de formulario",
            automationIntegration: "Integración de automatización",
            remainingAutomationTask: "Tareas de automatización restantes",
            createUserError: "Se ha producido un error al crear el usuario",
            sendTemplateMessage: "Enviar mensaje de plantilla",
            startChatWithDifferentChannel: "Iniciar chat con otro canal",
            whatsappChatStarter: "Iniciador de chat de WhatsApp",
            pressEnterToJoin: "Presione Enter para unirse al chat",
            pressEnterToStartChat: "Presione Enter para iniciar el chat",
            cannotSendMessage: "No puede enviar mensajes a esta persona",
            cannotSendSessionMessage: "No puede enviar mensajes de sesión a esta persona",
            conversationNotInYourDepartments: "Esta conversación no pertenece a ninguno de sus departamentos",
            customizeImage: "Si desea personalizar la imagen",
            clickToUpload: "Haga clic aquí para subir una imagen",
            uploadNote: "Los siguientes son los formatos de archivo y sus tamaños respectivos que se aceptan para la carga",
            imageSize: "La imagen no se pudo cargar porque es más grande que 2 MB",
            videoSize: "El video no se pudo cargar porque es más grande que 20 MB",
            documentSize: "El documento no se pudo cargar porque es más grande que 2 MB",
            uploading: "Subiendo imagen, por favor espere...",
            uploadSuccess: "Imagen subida con éxito",
            note: "Nota",
            gridView: "Vista de tabla",
            completedTasks: "Tareas completadas",
            system: "Sistema",
            destroyedBy: "Destruido por",
            brand: "Marca",
            channelCreatedSuccess: "Canal creado exitosamente",
            channelCreatedError: "Error al crear el canal",
            plans: {
                types: {
                    supsis: "Paquetes de Representante",
                    chatbot: "Chatbot",
                    automation: "Automatización",
                    customer_tables: "Tabla de Clientes",
                    mail: "Correo Electrónico",
                    tasks: "Tareas",
                    form: "Formulario",
                    whatsapp: "WhatsApp Web (QR)",
                    whatsapp_business: "WhatsApp Business API",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Meta Lead",
                    trendyol: "Trendyol",
                    artificial_intelligence: "Inteligencia Artificial",
                    webhook: "Webhook",
                    telegram: "Telegram",
                    webphone: "Web Phone"
                }
            },
            vipCustomerDescription: "Marcar a esta persona como cliente VIP la coloca en la parte superior de la cola y garantiza que reciba servicio prioritario.",
            switchOn: "Encendido",
            switchOff: "Apagado",
            ownerDescription: "Esta función indica el propietario de un chat. Independientemente del estado del propietario (en línea o fuera de línea), los chats siempre se asignan al propietario. Los chats propiedad de un propietario solo pueden ser vistos por el respectivo propietario y no pueden ser respondidos por el chatbot.",
            permissionError: "¡No tienes permiso para realizar esta acción!",
            copySuccess: "¡Contenido copiado con éxito!",
            unowned: "Sin propietario",
            add: "Agregar",
            copy: "Copiar",
            cancel: "Cancelar",
            edit: "Editar",
            update: "Actualizar",
            search: "Empezar a buscar",
            save: "Ahorrar",
            jsonPreview: "VISTA PREVIA JSON",
            enterNewValue: "Ingrese un nuevo valor",
            updatePreferredLanguage: "Actualizar idioma preferido",
            updateTags: "Actualizar etiquetas",
            updateEmail: "Actualizar correo electrónico",
            enterNewEmail: "Ingrese un nuevo correo electrónico",
            deleteConfirmation: "Confirmación de eliminación",
            confirmDelete: "¿Está seguro de que desea eliminar esta función?",
            yesDelete: "Sí, eliminar",
            vipCustomer: "★ Cliente VIP",
            takeControlFromChatbot: "Tomar control desde el chatbot",
            enterJoin: "Puede unirse a la conversación presionando la tecla Enter",
            watchChat: "Ver conversación",
            untitledAutomation: "👉 Automatización de clic en perfil sin título",
            event: "Evento",
            chatbotSettings: "Configuración de enrutamiento del chatbot",
            chatbotScenarioNotFound: "Escenario de chatbot no encontrado",
            noChatbotScenario: "No se encontró ningún escenario de chatbot en el sistema.",
            scenarioNotFound: "Escenario no encontrado",
            descNotAvailable: "Descripción no disponible",
            lastRegulation: "Última regulación",
            taskCreator: "Creador de tareas",
            noPermission: "No tienes permiso para crear tareas.",
            notAppointed: "No asignado",
            changeStage: "Cambiar etapa",
            selectedCandidates: "1 candidato seleccionado",
            coverPhotoRemove: "Eliminar foto de portada",
            coverPhotoSet: "Establecer como foto de portada",
            autoTransfer: "Transferir automáticamente sus contactos a Zoho",
            autoTransferDescription: "Los contactos que llegan a este canal se transfieren automáticamente al módulo de contactos de Zoho CRM. Los que se transfieren a Zoho activan los widgets de Zoho.",
            zohoChannelRequiredTitle: "Canal de Zoho CRM requerido",
            zohoChannelRequiredContent: "No tiene un canal de Zoho CRM. Haga clic aquí para agregar uno de inmediato.",
            okText: "Agregar canal de Zoho CRM",
            cancelText: "Cancelar",
            forceQueueForNoOwnerContacts: "Forzar a los contactos sin propietario a esperar en la cola",
            forceQueueDescription: "Solo los contactos con propietario se asignan automáticamente, obligando a los contactos sin propietario a esperar en la cola.",
            showNoOwnerContactsToAdmins: "Mostrar contactos sin propietario solo a los administradores",
            showNoOwnerContactsDescription: "Los contactos sin propietario son visibles solo para los administradores.",
            autoAssignOwner: "Asignación automática de propietario de contacto",
            autoAssignOwnerDescription: "Cuando el chat se asigna automáticamente a un representante, también se asigna como propietario.",
            creator: "Creador",
            hideShow: "Ocultar / Mostrar",
            url: "URL",
            cannedMessages: "Mensajes predefinidos",
            templateMessages: "Mensajes de plantilla",
            chatbots: "Chatbots",
            noCannedMessages: "No se encontraron mensajes predefinidos",
            filterToFindMore: "Puedes encontrar más mensajes predefinidos cambiando tus filtros.",
            runPrompt: "Ejecutar Prompt",
            noLeadsFound: "No se encontraron leads para esta persona",
            deals: "Ofertas",
            noDealsFound: "No se encontraron ofertas para esta persona",
            loadingDeals: "Cargando ofertas",
            zohoCRM: "Zoho CRM",
            viewContact: "Ver contacto",
            noNotesAdded: "No se han agregado notas aún",
            attachments: "Adjuntos",
            addNewNote: "Agregar nueva nota",
            savingg: "Guardando...",
            warningFillFields: "Por favor, complete los campos de título y contenido.",
            successNoteAdded: "Nota agregada con éxito.",
            errorAddingNote: "Ocurrió un error al agregar la nota.",
            noteTitle: "Título de la nota",
            noteContent: "Contenido de la nota",
            selectPreferredAgent: "Seleccione el agente preferido que desea asignar al visitante.",
            postOperations: "Operaciones de publicación",
            loadingPostOperations: "Cargando operaciones de publicación",
            noPostOperations: "No se encontraron operaciones de publicación para esta persona",
            postOperationDetails: "Detalles de la operación de publicación",
            noMediaDocuments: "No hay medios ni documentos disponibles para esta persona.",
            selectionLimitError: "Puedes seleccionar un máximo de 30 elementos.",
            showNote: "Mostrar nota a todos",
            hideNote: "Ocultar nota",
            updateNote: "Actualizar nota",
            addUserNote: "Agregar una nota sobre el usuario",
            privateNote: "Nota privada",
            metaReferrals: "Referencias Meta",
            noMetaReferrals: "No se encontraron interacciones publicitarias de Meta.",
            searchPrompt: "Busca algo.",
            noRecentResults: "No se encontraron resultados recientes.",
            contactInfo: "Información de contacto",
            noPropertiesAdded: "Aún no se ha añadido ninguna propiedad.",
            propertyAddedUpdated: "Propiedad añadida/actualizada correctamente.",
            propertyError: "Se produjo un error al añadir o actualizar la propiedad.",
            propertyDeleted: "Propiedad eliminada correctamente.",
            propertyDeleteError: "Se produjo un error al eliminar la propiedad.",
            zohoSynchronization: "Sincronización de Zoho",
            zohoSyncConfirmation: "¿Quieres hacer cambios en la persona en Zoho también?",
            hideOtherInfo: "Ocultar otra información",
            showOtherInfo: "Mostrar otra información",
            whatsappChatStart: "Iniciar chat de WhatsApp",
            ownership: "Propiedad del cliente",
            countryAndLanguage: "País, Idioma",
            calendarEvent: "Evento del calendario",
            contact: "Contacto",
            user: "Usuario",
            customerOwnership: "Propiedad del cliente",
            ownerless: "Sin propietario",
            preferredDepartment: "Departamento preferido",
            flowluTransfer: "Transferir a Flowlu",
            mergeSuccess: "La operación de fusión se completó con éxito.",
            visitorOwnershipWarning: "Este visitante es propiedad de otro usuario.",
            newAutomation: "Nueva automatización",
            automations: "Automatizaciones",
            createProfileAutomation: "Crear automatización de perfil",
            profileButtonClicked: "Botón de perfil clicado",
            profileButtonDescription: "Esta automatización se activará cuando se haga clic en un botón de perfil.",
            automationName: "Nombre de la automatización",
            create: "Crear",
            dayRange: "Rango de días",
            hourRange: "Rango de horas",
            last24Hours: "Últimas 24 horas",
            today: "Hoy",
            yesterday: "Ayer",
            thisWeek: "Esta semana",
            lastWeek: "La semana pasada",
            last7Days: "Últimos 7 días",
            last30Days: "Últimos 30 días",
            thisMonth: "Este mes",
            lastMonth: "El mes pasado",
            startDateTime: "Fecha y hora de inicio",
            endDateTime: "Fecha y hora de finalización",
            complaint: "Queja",
            opens: "Aperturas",
            clicks: "Clics",
            mockData: "(Datos de prueba)",
            preferredRepresentative: "Seleccionar agente preferido",
            forwardToDepartment: "Reenviar a departamento",
            toMobileAgents: "A los agentes móviles",
            noMediaAndDocuments: "Este usuario no tiene medios o documentos",
            reportBug: "Reportar un error",
            waitingForReply: "En espera de respuesta",
            memorySize: "Tamaño de memoria",
            usedMemory: "Memoria utilizada",
            availableMemory: "Memoria disponible",
            memoryLimit: "Límite de memoria",
            memoryLimitPrice: "Precio para memoria adicional",
            telegramBotIsReachable: "El servicio de bots de Telegram tiene un error",
            telegramBotIsHealthy: "El servicio de bots de Telegram está sano",
            telegramBotIsUnhealthy: "El servicio de bots de Telegram tiene un error",
            pieView: "Vista circular",
            chartView: "Vista gráfica",
            tableView: "Vista de tabla",
            lastUpdate: "última actualización",
            task: "tarea",
            filterBy: "Por filtro",
            watchAllLive: "Ver todo en directo",
            sessionsUnique: "Sesiones (usuarios únicos)",
            sessionsAll: "Sesiones (Todos los usuarios)",
            moreFeaturesDesc: "¡Más funciones, más integraciones, más agentes! Actúa ahora para gestionar mejor tu equipo y hacer crecer tu negocio hasta su máximo potencial!",
            metaLeadForms: "Meta Lead Forms",
            metaLeadsConnectedSucs: "Meta Leads conectados con éxito",
            failedToConnectMetaLeads: "Error al conectar con Meta Leads",
            forbiddenChannel: "Canal prohibido",
            forbiddenChannelDesc: "No tiene permiso para ver este canal",
            firstContact: "Primer contacto",
            needsAnalysis: "Análisis de necesidades",
            offerSent: "Oferta enviada",
            offerReview: "Revisión de la oferta",
            decisionPhase: "Fase de decisión",
            personDeleted: "Persona eliminada",
            metaLeadsIntegration: "Integración de Meta Leads",
            phoneNumberIsInvalid: "Número de teléfono no válido",
            addAnItem: "Añadir un elemento",
            saveItem: "Guardar elemento",
            customItem: "Elemento personalizado",
            backgroundPhoto: "Imagen de fondo",
            whenYouActivateFeature: "Cuando actives esta función, no aparecerá en la página de reservas",
            logo: "Logotipo",
            noLogo: "No Logo",
            addTeamMember: "Añadir miembro del equipo",
            timezone: "Zona horaria",
            selectDayys: "Seleccionar día(s)",
            selectStartHour: "Seleccionar hora de inicio",
            selectEndHour: "Seleccionar hora de finalización",
            moveLeft: "Mover a la derecha",
            moveRight: "Mover a la izquierda",
            reply: "Respuesta",
            replyToAll: "Responder a todos",
            deleteThreadMessage: "Borrar mensaje del hilo",
            totalEmailsBounced: "Total de correos rebotados",
            totalEmailsComplained: "Total de correos sobre los que se han presentado quejas",
            untilNowTotalEmailOpens: "Total de correos electrónicos abiertos hasta el momento",
            untilNowTotalEmailLinkClicks: "Total de clics en enlaces de correo electrónico hasta el momento",
            uniqueClicks: "Clics únicos",
            untilNowTotalUniqueEmail: "Total de clics únicos en el enlace de correo electrónico hasta el momento (por destinatario)",
            emailCampaignTimeline: "Cronología de la campaña de correo electrónico",
            receivedBroadcasts: "Emisiones recibidas",
            groupDeletedSuccessfully: "Grupo eliminado con éxito",
            verify: "Verificar",
            done: "Hecho",
            pleaseSelectAnEmailAddress: "Seleccione una dirección de correo electrónico",
            goBack: "Volver atrás",
            show: "Mostrar",
            vueEmailEditor: "Vue Email Editor (Demo)",
            saveDesign: "Guardar diseño",
            exportHTML: "Exportar HTML",
            saveAsEmailCustomerGroup: "Guardar como grupo de clientes de correo electrónico",
            saveAsWhatsappCustomerGroup: "Guardar como grupo de clientes de Whatsapp",
            deleteModalFormDesc: "Si eliminas este formulario, todos los datos del formulario se borrarán permanentemente. ¿Estás seguro de que quieres continuar?",
            todo: "Cosas por hacer",
            inProgress: "En progreso",
            aprobado: "Aprobado",
            completado: "Completado",
            transactionType: "Tipo de transacción",
            previousBalance: "Saldo anterior",
            nextBalance: "Saldo siguiente",
            amount: "Importe",
            wpIntegrationChannelRequired: "Canal de integración web de Whatsapp requerido",
            wpIntegrationChannelRequiredDesc: "La integración Chatbot + Whatsapp Web requiere Whatsapp Web Channel. Por favor, crea un nuevo canal",
            wabaIntegrationChannelRequired: "Se requiere el canal de integración de Whatsapp Business",
            wabaIntegrationChannelRequiredDesc: "La integración de Chatbot + Whatsapp Business API requiere el canal web de Whatsapp. Por favor, crea un nuevo canal",
            instaIntegrationChannelRequired: "Canal de integración de Instagram requerido",
            instaIntegrationChannelRequiredDesc: "La integración de Chatbot + Instagram requiere el canal Instagram. Por favor, crea un nuevo canal",
            createWpChannel: "Crear canal web de Whatsapp",
            createWabaChannel: "Crear canal Whatsapp Business API",
            createInstaChannel: "Crear canal de Instagram",
            failedToDeleteGroup: "Error al eliminar grupo",
            failedToDeleteGroups: "Error al eliminar grupos",
            failedToFetchGroupContacts: "Fallo al recuperar contactos de grupo",
            mailAddressDeletedSuccessfully: "Dirección de correo eliminada con éxito",
            defaultMailAddressChangedSuccessfully: "Dirección de correo predeterminada cambiada con éxito",
            mailAddressAlreadyRegistered: "La dirección de correo no puede estar ya registrada o vacía",
            pleaseVerifyByClicking: "Por favor, verifique haciendo clic en el enlace enviado a su dirección de correo electrónico",
            signSucsRegistered: "Firma registrada correctamente",
            myContacts: "Mis contactos",
            unanswered: "Perdido",
            emailBroadcasts: "Emisiones de correo electrónico",
            monthlyLimit: "Límite mensual",
            totalShipments: "Total de envíos",
            shippingStatus: "Estado del envío",
            lastAction: "Última acción",
            receiver: "Receptor",
            delivered: "Entregado",
            opened: "Abierto",
            clicked: "Clicado",
            bounced: "Ha vuelto",
            clickedLinks: "Enlaces clicados",
            reason: "Razón",
            timer: "Temporizador",
            implemented: "¿Implementado?",
            module: "Módulo",
            excelDownload: "Descarga de Excel",
            serviceFeatures: "Características del servicio",
            mailAddressDeletedSucs: "Dirección de correo eliminada con éxito",
            inputSearchText: "Introducir texto de búsqueda",
            createRecord: "Crear registro",
            separatorCharacter: "Carácter separador",
            exampleResultPreview: "Vista previa del resultado de ejemplo",
            importRecords: "Importar registros",
            equals: "Igual",
            notEquals: "No igual",
            startsWith: "Empieza por",
            endsWith: "Termina con",
            greaterThan: "Mayor que",
            lessThan: "Menos que",
            before: "Antes de",
            after: "Después de",
            is: "O",
            isNot: "No",
            empty: "Vacío",
            notEmpty: "No vacío",
            isOneOff: "Una vez",
            field: "Campo",
            records: "Registro",
            addIntegration: "Añadir integración",
            chatbotScenarioReleased: "Escenario Chatbot liberado",
            chatbotScenarioHasBeenCancelled: "Chatbot Escenario ha sido cancelado",
            titleAndDesc: "Título y descripción",
            templateAndMailSelection: "Plantilla y selección de correo",
            peopleToSend: "Personas a las que enviar",
            submissionPlans: "Plan de envío",
            summary: "Resumen",
            broadcastTitle: "Título de la emisión",
            sentByEmail: "Correo electrónico enviado",
            emailTemplate: "Plantilla de correo electrónico",
            onlyPeopleWithEmail: "Sólo las personas con una dirección de correo electrónico son válidas para el envío",
            sendNow: "Enviar ahora",
            plan: "Plan",
            senderEmail: "Correo electrónico del remitente",
            totalBuyer: "Comprador total",
            estimatedDuration: "Duración estimada",
            person: "Persona",
            shippingIsNowComplete: "¡El envío se ha completado!",
            back: "Atrás",
            customerName: "Nombre del cliente",
            customerEmail: "Correo electrónico del cliente",
            customValue: "Valor personalizado",
            selectMailTemplate: "Debe seleccionar una plantilla de correo",
            youMustSelectSendingMailAddress: "Debe seleccionar la dirección de correo de envío",
            youMustSelectCustomerGroupSend: "Debes seleccionar el grupo de clientes al que enviar",
            createBroadcast: "Crear emisión",
            broadcastDetails: "Detalles de la emisión",
            youCanCheckYourEmailStatus: "Puedes comprobar el estado de tu correo electrónico actualizando tu plan. Puedes comprobar el estado de tu correo electrónico actualizando tu plan.",
            sentDetails: "Detalles del envío",
            total: "Total",
            totalEmailsProcessed: "Total de correos electrónicos procesados",
            totalEmailsDelivered: "Total de correos enviados",
            toAvailableAgents: "Para Agentes Disponibles",
            toAvailableDepartments: "Para Departamentos Disponibles",
            toWithAgentAndDepartment: "Con Agente y Departamento",
            toMobilAgents: "Para agentes móviles",
            toPreferredAgents: "Para agentes preferentes",
            searchAgent: "Buscar Agente",
            searchDepartment: "Departamento de búsqueda",
            searchMobileAgent: "Agente Móvil de Búsqueda",
            searchAgentOrDepartment: "Buscar agente o departamento",
            searchPreferredAgent: "Buscar el Agente preferido",
            noAgentsAvailableToForward: "No hay agentes disponibles para reenviar",
            noDepartmentsAvailableToForward: "No hay departamentos disponibles para reenviar",
            checkChannelVisibilityTitle: "Verifique la configuración de visibilidad del canal",
            checkChannelVisibilityDescription: "Si no puede ver algunos departamentos, verifique la configuración de visibilidad del canal",
            goToChannelSettings: "Ir a configuración del canal",
            noMobileAgentsAvailableToForward: "No hay agentes móviles disponibles para reenviar",
            noPreferredAgentsAvailableToForward: "No hay agentes preferentes disponibles para reenviar",
            ifYouSendThisConversationToTheQueue: "Si envías esta conversación a la cola, te eliminará del chat y colocará la conversación en la cola. Si la asignación automática de chat está activada, la conversación se asignará a un agente apropiado y podrá transferirse de nuevo a ti",
            ifAutomaticChatAssignmentIsDisabled: "Si la asignación automática de chat está desactivada, la llamada permanecerá en la cola. El personal autorizado puede coger la llamada de la cola",
            sendQueue: "Enviar a cola",
            agentName: "Nombre del agente",
            departmentName: "Nombre del departamento",
            toQueue: "Cola",
            web: "Web",
            mobile: "Móvil",
            noGrouping: "No Agrupar",
            groupByThis: "Agrupar por esto",
            selectGroupingCriteria: "Seleccionar criterios de agrupación",
            activeUsers: "Usuarios activos",
            passiveUsers: "Usuarios pasivos",
            noPlatform: "Sin plataforma especificada",
            noRole: "Rol no especificado",
            noDepartment: "Departamento no especificado",
            noLanguage: "Idioma no especificado",
            group2: "Grupo",
            groupedByStatus: "Agrupado por estado",
            grouping: "Agrupación",
            activeSubjects: "Sujetos activos",
            passiveSubjects: "Sujetos pasivos",
            groupSubjects: "Sujetos de grupo",
            showAll: "Mostrar todos",
            onlyActive: "Sólo Activos",
            onlyPassive: "Sólo los pasivos",
            selectTimezone: "Seleccionar zona horaria",
            userFilter: "Filtro de usuario",
            confidenceScore: "Puntuación de confianza",
            chatbotLanguage: "Idioma del chatbot",
            botScenerio: "Escenario del bot",
            selectTemplate: "Seleccionar plantilla",
            importFromReadyTemplates: "Importar desde plantillas listas",
            classification: "Clasificación",
            addClassification: "Añadir clasificación",
            expressionClassified: "Expresión a clasificar",
            zohoModuleName: "Nombre del módulo Zoho",
            selectModule: "Seleccionar módulo",
            standardFields: "Campos estándar",
            selectStandardField: "Seleccionar campo estándar",
            customFields: "Campos personalizados",
            selectCustomFields: "Seleccionar campo personalizado",
            aiFunction: "Función de inteligencia artificial",
            aiFunctionDesc: "Función de inteligencia artificial para realizar acciones basadas en las entradas del usuario",
            functionName: "Nombre de la función",
            functionDesc: "Descripción de la función",
            addParameter: "Añadir parámetro",
            chooseAiStory: "Elige una historia de IA",
            chatbotAiPromptDesc: "La inteligencia artificial aprende y determina cómo debe comportarse si se le dan instrucciones sobre una tarea o problema específico mediante la función 'prompt'",
            enterPrompt: "Introducir instrucción",
            aiParameterTunings: "Ajustes de parámetros de IA",
            aiParameterTuningsDesc: "Puedes ajustar los parámetros de la IA para hacerla más sensible y precisa. Estos parámetros se utilizan para controlar el comportamiento de la IA y cómo responde a las entradas del usuario.",
            temperature: "Temperatura",
            temperatureDesc: "Qué temperatura de muestreo utilizar, entre 0 y 2. Los valores más altos, como 0,8, harán que la salida sea más aleatoria, mientras que los valores más bajos, como 0,2, la harán más centrada y determinista.",
            topDesc: "Como alternativa al muestreo por temperatura, el llamado kernel sampling, el modelo considera los resultados de los tokens con la masa de probabilidad top_p. Así, 0,1 significa que sólo se tienen en cuenta los tokens con el 10% de masa de probabilidad superior. Normalmente recomendamos cambiar esto o la temperatura, pero no ambos.",
            toolChoices: "Opciones de la herramienta",
            noneDesc: "None significa que el modelo no invocará ninguna herramienta y en su lugar generará un mensaje.",
            autoDesc: "El modo automático es el valor por defecto y significa que el modelo puede elegir entre generar un mensaje o invocar uno o más agentes.",
            requiredDesc: "El modo requerido significa que el modelo debe llamar a uno o más agentes antes de responder al usuario.",
            createArticles: "Crear artículo",
            createArticlesDesc: "Crea artículos para ayudar a tus usuarios a encontrar respuestas a sus preguntas",
            articlesTitle: "Título del artículo",
            articlesContent: "Contenido del artículo",
            createFaq: "Crea una pregunta frecuente (FAQ)",
            createFaqDesc: "Crea una nueva FAQ para tu chatbot. Esto ayudará a tu chatbot a responder las preguntas del usuario",
            question: "Pregunta",
            saveAndClose: "Guardar y cerrar",
            contentPreview: "Vista previa del contenido",
            upgradePackageTitle: "Actualice su paquete y evite los límites",
            upgradePackageDescription: "Más funciones, más integraciones, más agentes. Actúe ahora para gestionar mejor su equipo y maximizar el potencial de su negocio.",
            upgradePackage: "Actualizar",
            newFolder: "Nueva carpeta",
            newFile: "Nuevo archivo",
            noFilesFound: "No se encontraron archivos en esta carpeta",
            uploadFile: "Subir archivo",
            enterFolderName: "Por favor, introduzca el nombre de la carpeta",
            folderName: "Nombre de la carpeta",
            dropFileHere: "Soltar archivos aquí",
            createFolder: "Crear carpeta",
            fileUploadingError: "Se ha producido un error al subir un archivo",
            fileUploadingSucs: "Carpeta creada con éxito",
            folderNameNotEmpty: "El nombre de la carpeta no puede estar vacío",
            deleteFolder: "Eliminar carpeta",
            sureDeleteFolder: "¿Está seguro de que desea eliminar esta carpeta y todos los archivos que contiene?",
            deletionSucs: "Eliminación correcta",
            deleteFile: "Eliminar archivo",
            sureDeleteFile: "¿Está seguro de que desea eliminar este archivo?",
            deletionError: "Se ha producido un error durante el proceso de borrado",
            selectFile: "Seleccionar archivo",
            moreThanOneSelect: "Puede seleccionar más de un archivo",
            selectAnFile: "Seleccione un archivo",
            deleteZohoLinkbulkSms: "SMS masivos",
            sendBulkSmsCustomers: "Envíe SMS masivos a sus clientes",
            writeYourMessage: "Escriba aquí su mensaje",
            sendSms: "Enviar SMS",
            sendSmsYourCustomers: "Envía sms a tus clientes",
            manageChannelDetail: "Gestionar la información del canal",
            details: "Detalles",
            teamGramChannels: "Canales de TeamGram",
            newTeamGramIntegration: "Nueva integración de TeamGram",
            teamGramIntegration: "Integración TeamGram",
            notMoreThanOneTeamGramChannels: "No se puede crear más de un canal TeamGram",
            teamGramDetail: "Detalle de TeamGram",
            manageYourTeamGramIntegration: "Gestione su integración TeamGram",
            trendyolChannels: "Canales Trendyol",
            trendyolStoreIntegration: "Integración de la tienda Trendyol",
            trenyolStoreConnection: "Conecta tu tienda Trendyol",
            deleteTrendyolIntegration: "Eliminar integración de Trendyol",
            sureDeleteTrendyolIntegration: "¿Seguro que quieres eliminar la integración de Trendyol? Esta acción es irreversible",
            trendyolStoreChannel: "Canal de la tienda Trendyol",
            deleteTrendyolChannel: "Eliminar canal de Trendyol",
            channelUpdatedSucs: "Canal actualizado con éxito",
            failedUpdateChannel: "Error al actualizar el canal",
            trendyolStoreIntegrationDetail: "Detalle de la integración de la tienda Trendyol",
            configureTrendyolStoreIntegrationDetail: "Configure su integración con Trendyol Store",
            trenyolStoreProductQuestManage: "Trendyol Store - Gestión de búsqueda de productos",
            trendyolStoreDesc: "Puede utilizar la siguiente configuración para gestionar las consultas a los productos de la tienda Trendyol",
            zohoCrmChannels: "Canales de Zoho CRM",
            zohoPersonalChannel: "Zoho Personal Channels",
            connectZoho: "Conectar con Zoho CRM",
            updateChannelDesc5: "Actualizar canal de Zoho CRM",
            zohoCrmIntegration: "Integración con Zoho CRM",
            sureDeleteZohoChannel: "¿Seguro que quieres borrar el canal de Zoho CRM?",
            createNotMoreThanOneZohoChannels: "No puedes crear más de un canal Zoho",
            removeZohoLink: "Eliminar Zoho Link",
            connectToZoho: "Conectar con Zoho",
            chatClosed: "Chat cerrado",
            scoreChat: "Chat puntuado",
            createdTicket: "Ticket creado",
            updatedTicket: "Ticket actualizado",
            newUserCreated: "Nuevo usuario creado",
            updateUser: "Usuario actualizado",
            deleteUsers: "Usuario eliminado",
            changeStatusRepresent: "El estado del representante ha cambiado",
            incomingMessage: "Mensaje entrante",
            outgoingMessage: "Mensaje saliente",
            createdNewTicket: "Nuevo ticket creado",
            bitrix24Channels: "Canales Bitrix24",
            sureDeleteBitrixChannel: "¿Está seguro de que desea eliminar el canal Bitrix24?",
            bitrix24Integrations: "Integración Bitrix24",
            notCreateMoreThenOneChannel: "No se puede crear más de un canal Ideasoft",
            connectToBitrix24: "Conectar con Bitrix24",
            connectToBitrix24Api: "Conectar a Bitrix24 Api",
            updateChannel: "Actualizar canal",
            updateChannelDesc: "Actualizar canal Bitrix24 Api",
            yourBitrix24Domain: "Su nombre de dominio Bitrix24",
            bitrix24ConnectedSucs: "Bitrix24 conectado con éxito",
            failedToConnectBitrix24: "Error al conectarse a Bitrix24",
            channelCreatedSuccessfully: "Canal creado con éxito",
            failedToCreateChannel: "Error al crear canal",
            holidayPlusChannels: "Canales Holiday+",
            newHolidayPlusIntegration: "Nueva integración Holiday+",
            holidayPlusIntegrations: "Integración Holiday+",
            notCreateMoreThanOneHolidayChannel: "No se puede crear más de un canal Holiday+",
            holidayPlusDetail: "Detalle de Holiday+",
            manageHolidayPlusIntegration: "Gestione su integración Holiday+",
            ideasoftChannels: "Canales de Ideasoft",
            connectToIdeasoft: "Conectar con Ideasoft",
            connectToIdeasoftApi: "Conectar con la api de Ideasoft",
            updateChannelDesc2: "Actualizar canal api de Whatsapp business",
            ideasoftIntegration: "Integración de Ideasoft",
            sureDeleteIdeasoftChannel: "¿Seguro que quiere borrar el canal de Ideasoft?",
            moreThanOneChannelError: "No se puede crear más de un canal de Ideasoft",
            websiteAddress: "Dirección del sitio web",
            ideasoftConnectedSucs: "Ideasoft conectado con éxito",
            failedToConnectIdeasoft: "Error al conectar con Ideasoft",
            redirectURLcopiedToClipboard: "URL de redirección copiada al portapapeles",
            openAIChannels: "Canales OpenAI",
            newOpenAiChannel: "Nuevo canal OpenAI",
            createNewChannelOpenAi: "Crear un nuevo canal para OpenAI",
            updateChannelDesc3: "Actualizar canal api de Whatsapp business",
            openAiIntegration: "Integración de OpenAI",
            sureDeleteOpenAiChannel: "¿Seguro que quieres borrar el canal OpenAI?",
            createMoreThenOneOpenAiChannel: "No puedes crear más de un canal OpenAI",
            postaCellChannels: "Canales PostaCell",
            newPostaCellChannel: "Nuevos canales PostaCell",
            createNewPostaCellChannel: "Crear un nuevo canal para el proveedor de sms PostaCell",
            updateChannelDesc4: "Actualizar canal Whatsapp business api",
            accessControl: "Control de acceso",
            leads: "Plomos",
            ensureFacebookAccount: "Asegúrese de que tiene una cuenta y una página de Facebook",
            ensureAdAccount: "Asegúrese de que tiene una cuenta de publicidad",
            page: "Página",
            leadCount: "Recuento de clientes potenciales",
            showLeads: "Mostrar clientes potenciales",
            syncLeeds: "Sincronizar Leeds",
            wpStartChat: "Lanzador de chat de Whatsapp",
            archivedIn: "¿Archivado?",
            makeSelect: "Hacer selección",
            newLead: "Nuevo Leed",
            initalContact: "Primer contacto",
            needsAssessnment: "Análisis de necesidades",
            proposalSent: "Oferta enviada",
            proposalReview: "Revisión de la propuesta",
            negotiation: "Negociación",
            decisionStage: "Etapa de decisión",
            closure: "Kanapnış",
            followUp: "Seguimiento",
            campagin: "Campaña",
            adSet: "Conjunto de anuncios",
            ad: "Anuncio",
            inArchived: "Archivado",
            deletedSelectedPerson: "Eliminar personas seleccionadas",
            sureDelSelectedPerson: "¿Seguro que quieres borrar las Personas Seleccionadas?",
            deletePerson: "Borrar Persona",
            sureDeletePerson: "¿Está seguro de que desea eliminar a la persona?",
            phoneNumberNotAvailable: "Número de teléfono no disponible",
            statusSucsUpdated: "Estado actualizado correctamente",
            statusUpdatedFailed: "Se ha producido un error al actualizar el estado",
            archivedContact: "Contacto archivado",
            sureWantArchivePerson: "¿Está seguro de que desea archivar a esta persona?",
            personArchived: "Persona archivada",
            personArchivedHead: "Operación de archivo fallida",
            metaLeadChannels: "Meta Canales de clientes potenciales",
            wpStartSpeech: "Iniciador de discurso de Whatsapp",
            pleaseSelectStartChat: "Por favor, seleccione el canal en el que desea iniciar el chat:",
            phoneNumber: "Número de teléfono",
            phoneNumberDesc: "Código de país con sólo números sin espacios",
            channelDesc: "En qué canal desea iniciar el chat",
            pleaseSelectStartChatOn: "Por favor, seleccione el canal en el que desea iniciar el chat",
            notAuthorisedChannel: "No estás autorizado a acceder a este canal",
            phoneNumberError: "Número de teléfono incorrecto",
            chatStartError: "Se ha producido un error al iniciar el chat. Por favor, inténtalo de nuevo",
            noRecordFailed: "No se ha encontrado ningún registro",
            metaLeadsChannel: "Canal Meta Leads",
            mlChannelDetails: "Detalles del Canal Meta Leads",
            manageMlChannel: "Gestionar sus Meta Leads",
            deleteMetaLeadsChannelInfo: "¿Está seguro de que desea eliminar el canal Meta Leads?",
            contactPage: "Página de Contacto",
            addRouted: "Añadir enrutado",
            otherEmailProviders: "Otros proveedores de correo electrónico",
            visitorScreenNaming: "Nombre de la pantalla del visitante",
            enterCatalogTitle: "Introduzca el título del catálogo...",
            passwordUpdate: "Actualizar contraseña",
            showCenterScreen: "Visualización en el centro de la pantalla",
            skipNow: "Saltar ahora",
            confirm: "Confirme",
            newTable: "Nueva tabla",
            actions: "Transacciones",
            integrationsTrendyol: "Conecte su tienda de Trendyol y responda automáticamente a las preguntas de sus clientes.",
            integrationsHoliday: "¡Integre Holiday+ para ofrecer hoteles y habitaciones a través del chatbot!",
            integrationsTeamgram: "¡Transfiera a sus clientes de Supsis a Teamgram para agilizar la gestión de clientes!",
            integrationsTicimax: "Envíe un mensaje automatizado a los miembros segmentados de Ticimax.",
            integrationsBitrix24: "Active la API de Bitrix24 para mejorar la experiencia del chatbot para sus clientes.",
            integrationsIdeasoft: "Active la API de Ideasoft para mejorar la experiencia del chatbot para sus clientes.",
            integrationsOpenAI: "Activar los servicios de OpenAI, Respuesta de IA del Chatbot, Asistente de IA CoPilot, Base de conocimientos de IA del Chatbot.",
            integrationsSMSPostacell: "Activa el envío de SMS a través del proveedor de SMS PostaCELL.",
            integrationsMetaLeads: "Administra tus clientes potenciales de Meta a través de Supsis. Conecta los leads a tickets, chatbot o soporte en vivo.",
            integrationsZoho: "Integre sus procesos de negocio en Zoho CRM con Supsis.",
            forward: "adelante",
            packUpRequired: "Se requiere actualización del paquete",
            upgradePack: "Paquete de actualización",
            supsisMobilApp: "SUPSIS MOBİL APP",
            supsisMobilAppDesc: "¡Aplicación IOS y Android en el mercado!",
            sendEmail: "Enviar correo electrónico",
            jumpToMessage: "Haga clic para saltar al mensaje",
            doesntMatter: "No importa.",
            events: "Calendario de eventos",
            reservations: "Reservas",
            designer: "Diseñador",
            targetContacts: "Contactos de destino",
            scheduler: "Planificador",
            planAndTask: "Plan y Tareas",
            insights: "Perspectivas",
            createRole: "Crear función",
            createSubject: "Crear tema",
            createUser: "Crear usuario",
            blockManuel: "Bloque Manuel",
            showHide: "mostrar/ocultar",
            contactSearch: "Búsqueda de contactos",
            favorites: "favoritos",
            downloadAllData: "descargar todos los datos",
            downloadThePage: "Descargar la página",
            choosePoints: "elige puntos",
            createdAt: "Creado En",
            action: "Acción",
            searchChannel: "Canales de Búsqueda",
            activeChannels: "Canales Activos",
            deleteChannels: "Canales Eliminados",
            selectChannel: "Seleccionar Canal",
            channelFilter: "Filtro de Canal",
            noConversationDesc: "Aquí puedes ver los chats activos y los chats asignados a ti.",
            forMe: "Para mí",
            unAssigned: "No asignado",
            agentDetails: "Detalles del agente",
            contactProperties: "Propiedades de contacto",
            goToProfile: "Ir al perfil",
            addNote: "Agregar nota",
            noPreferredAgent: "Aún no hay agente preferido",
            toPrefer: "Preferir",
            inChat: "En el chat",
            watching: "Viendo",
            chatsTitle: "Chats",
            dealyTimeMaxValueError: "El tiempo de retraso puede ser de un máximo de 15",
            dealyTimeTypeError: "El valor del tiempo de retraso debe ser un número",
            passedTimeHm: "{hour} Horas {min} Minutos",
            passedTimeMs: "{min} Minutos {sec} segundos",
            passedTimeSc: "{sec} Segundos",
            translateMessage: "Tu mensaje ha sido traducido por inteligencia artificial.",
            toneChanged: "El tono del mensaje cambió a {tone}",
            aiResponseAdded: "Respuesta de IA añadida al mensaje",
            messageLonger: "Mensaje hecho más largo",
            grammarFixed: "Gramática corregida",
            aiTranslate: "Traducción",
            other: "Otro",
            yourLanguage: "Tu idioma",
            contactLanguage: "idioma del cliente",
            myLanguage: "Mi idioma",
            forwardToChatbot: "Reenviar al Chatbot",
            friendly: "Amistoso",
            confident: "Confiado",
            straightForward: "Directo",
            casual: "Casual",
            professional: "Profesional",
            longSentence: "Frase Larga",
            changeTone: "Cambiar Tono",
            fixGrammar: "Corregir Gramática",
            aiResponse: "Respuesta de IA",
            templateButtonNote: "Para prohibir el contacto, tenga cuidado de usar los siguientes textos en el botón de prohibición. Independientemente de las letras mayúsculas o minúsculas",
            templateButtonTags: "#Enviar mensaje# | #Darse de baja# | #Prohibir# | #Bloquear#",
            dashboard: "Tablero de control",
            calendarModule: "Módulo de calendario",
            taskModule: "Módulo de gestión de tareas",
            maxUrlButtonMessage: "Puede añadir un máximo de 2 botones de URL.",
            noPreferredDepartment: "No hay departamento preferido",
            searchForDepartment: "Buscar departamento",
            departmentAssignedToTheVisitor: "Seleccione el departamento que desea asignar al visitante.",
            assignPreferredDepartment: "Asignar departamento preferido",
            smsChannel: "Canal SMS: ",
            whatsappv2Channel: "Canal Whatsapp V2: ",
            whatsappv1Channel: "Canal Whatsapp V1: ",
            wBChannel: "Canal Whatsapp Business: ",
            messengerChannel: "Canal Messenger: ",
            instagramChannel: "Canal Instagram: ",
            allPlatforms: "Todas las plataformas",
            cbStartMessage: "Mensaje de inicio del chatbot",
            cbStartMessageDesc: "El primer mensaje ingresado por el usuario es procesado automáticamente por el chatbot y dirigido a la dirección relevante.",
            messengerUserProfile: "Perfil de usuario de Messenger",
            instagramUserProfile: "Perfil de usuario de Instagram",
            noEventFound: "No se encontraron eventos",
            visitorMails: "Correos de visitantes",
            visitorActions: "Acciones de visitantes",
            notVerified: "No verificado",
            visitorEvents: "Eventos de visitantes",
            assignedTasks: "Tareas asignadas",
            mails: "Correos",
            prefferedAgents: "Agentes preferidos",
            createEvent: "Crear evento",
            blockManagement: "Gestión de bloqueo",
            deleteUser: "Eliminar usuario",
            blocked: "Bloqueado",
            profiles: "Perfiles",
            similiarProfiles: "Perfiles similares encontrados",
            ReplyAsAPm: "Responder como mensaje privado y cerrar",
            replyAsAComment: "Responder como comentario y cerrar",
            messengerAddDesc: "Haz clic en el botón Conectar a continuación e inicia sesión en tu cuenta de Facebook.",
            instaAddPrivacyCheckDesc: "He leído y acepto la {Privacy} y las {Terms and Conditions}",
            instaAddDesc5: "Haz clic en el botón Conectar a continuación e inicia sesión en tu cuenta de Facebook.",
            instaAddDesc4: "Regístrese como desarrollador de Facebook",
            instaAddDesc3: "Asegúrese de que el interruptor <b>'Permitir acceso a los mensajes'</b> esté activado",
            instaAddDesc2: "Asegúrese de que su cuenta profesional de Instagram esté conectada a su página de Facebook",
            instaAddDesc1: "Asegúrese de que su cuenta de Instagram sea una cuenta profesional de Instagram (cuenta comercial).",
            selectedDepartment: "Departamento seleccionado",
            departmentForwardEnable: "Regla de reenvío de departamento habilitada",
            departmentForwardRule: "Regla de reenvío de departamento",
            departmentForwardDesc: "Seleccione a qué departamento se redirigirán los chats entrantes en el canal.",
            channelName: "Nombre del canal",
            forwardToLiveAgents: "👉 Reenviar a agentes en vivo",
            manageIgChannel: "Administra tu canal de Instagram",
            igDetail: "Detalle de Instagram",
            manageVisibilityDesc: "Administrar quién puede ver este canal",
            selectAnIgAccount: "Seleccione una cuenta de Instagram",
            connectToInsta: "Conectar a Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "¿Estás seguro de que quieres eliminar el canal de Instagram?",
            instagramChannels: "Canales de Instagram",
            suspendedDescription: "Su cuenta ha sido suspendida debido a facturas impagas.",
            onlyChatbot: "Solo chatbot",
            onlyAgents: "Solo agentes",
            checkboxWarning: "Este campo debe estar marcado obligatoriamente",
            sendingAllow: "Envío",
            receiving: "Recepción",
            platform: "Plataforma",
            banModalTitle: "Modal de prohibición de visitantes",
            selectDepartmentDesc: "Seleccione los departamentos cuya visibilidad desea cambiar",
            selectAgentDesc: "Seleccione los agentes cuya visibilidad desea cambiar",
            selectDepartment: "Seleccionar departamento",
            selectAgent: "Seleccionar agente",
            visibleDepartments: "Departamentos visibles",
            visibleAgents: "Agentes visibles",
            visibilityInfoCont: "Todos los agentes y departamentos pueden ver este canal",
            editDepartmentVisibility: "Editar permisos del departamento",
            editAgentVisibility: "Editar permisos del agente",
            typeSTToSearch: "Escriba algo para buscar usuarios",
            exportToCSV: "Exportar a CSV",
            clear: "Limpiar",
            usedSessionCount: "Cantidad de sesiones utilizadas",
            maxSessionCount: "Cantidad máxima de sesiones",
            leftSessionCount: "Cantidad de sesiones restantes",
            planManagement: "Gestión de planes",
            maxAutomationTask: "Numero massimo di automazioni",
            teamChat: "Chat de equipo",
            templateNameIsNotValid: "El nombre de la plantilla no es válido",
            relatedAdvertisement: "Anuncio relacionado",
            whatsappNumber: "número de whatsapp",
            integrationsWhatsappV1: "Se requiere un plan de WhatsApp para una comunicación sin problemas entre Supsis y WhatsApp.",
            integrationsWhatsappV2: "Puedes compartir fácilmente información de chat entre Supsis y WhatsApp.",
            integrationsWhatsappBusiness: "Puedes transmitir información de chat de manera rápida y conveniente entre Supsis y WhatsApp.",
            selectDays: "Seleccionar días",
            addTime: "Agregar tiempo",
            instagramContactList: "Lista de contactos de Instagram",
            archiveAllRated: "Recuperar todas las conversaciones con cualquier calificación.",
            allChannels: "Todos los canales",
            comment: "comentario",
            news: "Novedades",
            conversation: "charla en equipo",
            speechTermination: "finalizar conversación",
            noSystemMessage: "Aún no hay mensajes en el sistema!",
            supsisCustomerService: "Atención al cliente proporcionada por Supsis,",
            supsisClickExperience: "puedes probar la experiencia haciendo click.",
            customerPage: "Ir a la página del cliente",
            buttonTitle: "Título del botón",
            buttonType: "Tipo de botón",
            buttonSendMessage: "enviar mensaje",
            buttonGoToBlock: "ir al blog",
            buttonOpenUrl: "Abrir URL",
            buttonPhoneCall: "llamada telefonica",
            buttonOpenMoment: "Momento abierto",
            buttonCloseChat: "Cerrar charla",
            buttonTransferChat: "Transferir chat",
            buttonCreateTicket: "Crear Ticket",
            deleteVisitor: "¿Está seguro de que desea eliminar el usuario? Esta acción no se puede deshacer.",
            userProfile: "Perfil",
            addCalendarEvent: "Evento +",
            you: "Tú",
            and: "y",
            apiIntegration: "Desarrollador",
            generateToken: "Generar Token",
            copyToken: "Copiar Token",
            dndBlocked: "Configuración de envío de archivo apagado.",
            labels: "Etiquetas",
            noData: "Sin datos",
            CHAT: "Charlar",
            color: "Color",
            titleColor: "Color del título",
            secondTitleColor: "Color del segundo título",
            tag_name_indicator: "Nombre de etiqueta",
            sendMessage: "Enviar mensaje",
            removeFromG: "Sacar del grupo",
            delChannel: "¿Estás seguro de que deseas eliminar este canal?",
            new_name: "Nuevo nombre",
            set_group_info: "Editar información del grupo",
            shortcut_desc_num: "Cambie entre conversaciones activas con dígitos numéricos",
            copilot_desc_num: "Le permite abrir Copilot en la pantalla de chat.",
            typing_w_chat: "er schreibt...",
            edit_group_info: "Editar la información del grupo",
            notif_sound: "Activar los sonidos de notificación",
            notif_mute: "Silenciar notificaciones",
            leave: "Salir",
            group: "Grupo",
            updateTag: "Actualizar etiqueta",
            ordered_desc: "Asigna chats a los representantes en orden.",
            random_desc: "Asigna chats a los representantes al azar.",
            Rrobin_desc: "Asigna chats a los representantes de manera circular. (Prioriza a los representantes menos ocupados)",
            RrobinRev_desc: "Asigna chats a los representantes de manera circular inversa. (Prioriza a los representantes más ocupados)",
            algo_desc: "Seleccione el algoritmo para la asignación automática de chats",
            algorithm: "Algoritmo",
            os_browser: "Sistema operativo y navegador",
            addTag: "Añadir etiqueta",
            tags: "Etiquetas",
            searchRepresentative: "Buscar representante",
            voting: "Votación",
            chatWidget: "Widget de chat de supsis",
            webhooks: "Webhooks",
            selectHooks: "Seleccionar ganchos web",
            planRequired: "{integratable} Plan requerido",
            allIntegrations: "Todas las integraciones",
            disableAgentSystemMessages: "Ocultar mensajes del sistema de agente",
            disableAgentSystemMessagesDesc: "Ocultar mensajes del sistema del agente.",
            disableAutoTranslate: "Traducción automática",
            disableAutoTranslateDesc: "Traduce automáticamente mensajes de diferentes idiomas. Así puedes comunicarte con tus clientes más fácilmente.",
            shouldAddMethod: "¡Debe completar el método de pago y el campo de la dirección de facturación!",
            approveSelection: "Aprobar la selección",
            trialDaysEndSelectPlan: "Confirmar la selección del plan",
            trialDaysEndSelectPlanDesc: "Tu versión de prueba ha terminado. Debe confirmar seleccionando el plan a continuación.",
            infoAboutAnnouncement: "Breve información sobre el anuncio",
            announcement: "Anuncio",
            newAnnouncementForm: "Nuevo formulario de anuncio",
            newAnnouncement: "Nuevo anuncio",
            announcements: "Anuncios",
            newTicketSound: "Nuevo boleto",
            vtippyDepartmentNotification: "Configuración de notificaciones para mensajes de la conversación del departamento",
            vtippyGroupNotification: "Configuración de notificaciones para mensajes de grupos creados",
            vtippyTicketNotification: "Configuración de notificaciones para cada nuevo ticket que reciba",
            vtippyAnnouncemenNotification: "Configuración de notificaciones para los nuevos anuncios",
            languageSelection: "Selección de idioma",
            announcementTitle: "Título de anuncio",
            infinitePlay: "Jugar continuamente",
            hideBubbleOnMobile: "Esconderse en el móvil",
            vtippyHideBubbleOnMobile: "La burbuja de chat está oculta de los usuarios móviles.",
            deleteSystemLanguage: "Eliminar {code} lenguaje del sistema",
            assignedChat: "Chat asignado",
            check: "Casilla de verificación",
            systemStatus: "Estado del sistema",
            chatAssignedToUser: "Nuevo chat asignado",
            inactiveThresholdTime: "Tiempo de chat inactivo (minuto)",
            tippyInactiveThresholdTime: "Si no se envía ningún mensaje dentro del tiempo dado, la conversación se considera inactiva. Ingrese el valor (actas). Debe ser un rango en 1min - 120 minutos.",
            inactiveTerminateTime: "El chat inactivo termina la duración (minuto)",
            tippyInactiveTerminateTime: "El chat inactivo se terminará si no cambia al modo activo dentro de un tiempo determinado. Ingrese el valor (actas). Debe ser un rango en 1min - 120 minutos.",
            removePendingMessage: "Cancelar envío de mensajes",
            disconnected: "Desconectado",
            visitorWriteEmptyChatTippy: "El cliente puede escribir en conversación antes de que el agente se conecta.",
            visitorWriteEmptyChat: "El cliente puede escribir sin el agente conectado.",
            visitorConnectionEventSystemMessageEnabled: "Mensajes del sistema de estado de conexión del visitante Habilitar mensajes",
            visitorConnectionEventSystemMessageEnabledTippy: "Visitante a la izquierda y mensajes del sistema de regreso de visitantes Habilitar los mensajes",
            openBubble: "Burbuja",
            showHeaderImage: "Mostrar imagen de encabezado",
            askQuestion: "Hacer una pregunta",
            locationPermsNeeded: "Se necesitan permisos de ubicación para usar esta función",
            useMyLocation: "Usa mi ubicación",
            acceptingChat: "Aceptar chats",
            notAcceptingChat: "No aceptar chats",
            blockBy: "Prohibido por",
            languageRemovalQuestion: "¡Estás a punto de eliminar el lenguaje {code} del sistema!",
            loggedOut: "Desconectado",
            vtippyNewVisitorNotification: "Notificación audible para cada nuevo visitante en su sitio web",
            vtippySelectnotification: "Puede elegir el sonido de notificación.",
            vtippyVoiceLevel: "puedes ajustar el volumen",
            vtippyStartVoice: "Escuchar",
            vtippyInfiniteNotification: "Si no está activo en el nuevo panel de chats, continuará jugando. Puede editar Active-Passive haciendo clic.",
            vtippyTranslateButton: "Traduce el idioma seleccionado a otros idiomas",
            vtippyTranslateClearButton: "Limpia el contenido en otros idiomas.",
            vtippyNewChatNotification: "Puede seleccionar notificación de sonido para nuevas conversaciones que lleguen al sistema y ajustar el volumen.",
            vtippyNewConversationNotification: "Puede elegir una notificación de sonido y ajustar el volumen para cuando se le asignen nuevas conversaciones entrantes.",
            vtippyNewMessageNotification: "Puede seleccionar notificaciones para mensajes entrantes en sus conversaciones y ajustar el volumen.",
            vtippyPrivateMessageNotification: "Puede seleccionar una notificación para el mensaje entrante para la charla del equipo.",
            hideInactiveAgents: "Ocultar agentes inactivos",
            hideMinorValues: "Ocultar valores menores",
            hashHintMessage: "Puede ingresar rápidamente atajos de hashtag con #hash",
            pmHintMessage: "¿Sabía que puede enviar un mensaje privado de palabra clave? por ejemplo, PM: Hola",
            shortcutHintMessage: "¿Sabía que puede enviar mensajes más rápido con mensajes de acceso directo?",
            switchBetweenConversations: "¿Sabía que puede cambiar rápidamente entre conversaciones con atajos de ABC?",
            atNameHintMessage: "¿Sabía que puede ingresar rápidamente el nombre del visitante con @name?",
            dndHintMessage: "Puede cargar archivos con arrastrar y soltar.",
            pasteFile: "Puede enviar archivos.",
            atEmailHintMessage: "¿Sabía que puede ingresar rápidamente el correo visitante con @mail?",
            pastePlainText: "Pegar del portapapeles como texto sin formato",
            pressAndTalk: "Press and talk",
            agentActivities: "Actividades de agente",
            listStatuses: "Estado",
            newHASHContent: "#Add hash",
            hash: "Hashtag",
            hashText: "Texto hash",
            exampleHash: "rastreo de orden",
            notValidHash: "No debe contener espacios.",
            websiteChatWidgetIntegration: "Integración de widgets de chat del sitio web",
            videoCallEnabledDesc: "Active para habilitar la función de videollamada.",
            videoCallEnabled: "Función de videollamada",
            audioCallDesc: "Active para habilitar la función de búsqueda de voz.",
            audioCallEnabled: "Función de búsqueda de voz",
            assignPreferredAgent: "Asignar agente preferido",
            representativeAssignedToTheVisitor: "Seleccione el agente preferido que desea asignar al visitante.",
            agentFileSendEnabledDesc: "Habilita la capacidad de enviar archivos a los delegados",
            agentFileSendEnabled: "Los representantes pueden enviar archivos",
            visitorFileSendEnabledDesc: "Le permite activar o desactivar la función de envío del archivo de visitantes",
            visitorFileSendEnabled: "Los visitantes pueden enviar archivos",
            visitorAutoLogin: "Inicio de sesión automático de visitantes",
            visitorAutoLoginDesc: "Inicie automáticamente la conversación Cuando el visitante haga clic en la burbuja de chat",
            agentVoiceRecordEnabledDesc: "Permite a los agentes grabar audio",
            agentVoiceRecordEnabled: "Los agentes pueden grabar audio",
            visitorVoiceRecordEnabledDesc: "Permite a los visitantes grabar audio",
            visitorVoiceRecordEnabled: "Los visitantes pueden grabar audio",
            startVideoCall: "Videollamada",
            startAudioCall: "Llamada de voz",
            visitorGDPRDeleteEnabledDesc: "Le permite alternar la capacidad de eliminar la información de todos los visitantes",
            visitorGDPRDeleteEnabled: "Los visitantes pueden eliminar toda su información",
            visitorLocationEnabled: "Los visitantes pueden compartir la ubicación",
            visitorLocationEnabledDesc: "Permite a los visitantes activar o desactivar la ubicación",
            customerLocationEnabled: "Los representantes pueden compartir la ubicación",
            customerAutoMergeEnabled: "Fusiona automáticamente a las mismas personas",
            customerAutoMergeEnabledDesc: "Esta función realiza una fusión automática para reunir de manera efectiva los datos relacionados con las mismas personas. Esto garantiza que los usuarios con perfiles similares estén representados de manera más consistente y ordenada en los conjuntos de datos.",
            chatAiCopilot: "Copiloto de Chat IA",
            chatAiCopilotDesc: "Responde automáticamente a las preguntas de tus clientes utilizando el Copiloto de Chat IA",
            customerLocationEnabledDesc: "Permite a los representantes activar o desactivar la ubicación",
            thoesNotOwners: "Mantener en cola a los no propietarios",
            thoesNotOwnersDesc: "Activa esta función para mantener en la cola a las personas que no son propietarias de la conversación",
            hideContactInfo: "Ocultar información de contacto",
            hideContactInfoDesc: "Al habilitar esta función, los números y correos electrónicos de tus clientes quedarán ocultos para los agentes",
            triggerAlreadyExists: "El desencadenante ya existe",
            ticketStatusForm: "Formulario de estado del boleto",
            statusFormTitle: "Título del estado del boleto",
            allStatus: "Todos los estados",
            triggers: "Desencadenantes",
            trigger: "Desencadenar",
            noTrigger: "Todavía no has agregado ningún desencadenante",
            triggerSkipLoginForm: "Formulario de inicio de sesión",
            triggerSkipLoginFormTrue: "Mostrar formulario de inicio de sesión",
            triggerSkipLoginFormFalse: "Saltar formulario de inicio de sesión e ir directamente al mensaje",
            noContent: "sin contenido",
            toCreate: "Crear",
            clickTheButton: "clic en el botón",
            triggerContent: "Escriba la descripción que desea aparecer en el modal que se abre. Solo necesita escribir en un idioma y la traducción a otros idiomas se realiza automáticamente.",
            triggerDrag: "Puede ajustar la duración del mensaje arrastrando o haciendo clic en la barra.",
            triggerNewCondition: "Puede agregar una nueva condición con el botón.",
            triggerNoConditionDescription1: "Puede crear las condiciones que desea de las opciones. Si no crea ninguna condición para ningún disparador, el primer desencadenante estará activo.",
            triggerNoConditionDescription2: "Solo uno de los desencadenantes con las mismas condiciones aparece en la página del visitante.",
            triggerShowAndHide: "Puede mostrar u ocultar disparadores cuando lo desee.",
            countryLanguage: "País/idioma",
            addTrigger: "Agregar disparador",
            yesPlease: "¡Sí, por favor!",
            noThanks: "No, gracias.",
            firstAnswer: "Diálogo de preguntas Confirmar respuesta",
            secondAnswer: "PREGUNTA diálogo descartar respuesta",
            noTitle: "Sin titaje",
            sumChat_MediaFile: "Medios y documentos",
            importantWarning: "¡ADVERTENCIA IMPORTANTE!",
            images: "Imágenes",
            URLS: "Enlaces",
            files: "Ficheros",
            noCondition: "¡Sin condicion! Puede agregar condiciones haciendo clic en el icono más.",
            showTriggers: "Haga clic para mostrar disparadores",
            showThisTrigger: "Haga clic para mostrar este disparador",
            hideTriggers: "Haga clic para ocultar disparadores",
            hideThisTrigger: "Haga clic para ocultar este disparador",
            updateTrigger: "Actualizar disparador",
            conditions: "Condiciones",
            messageDurationPerRow: "Duración del mensaje por fila",
            updateCompleted: "Actualización completada",
            CatalogUpdatedSuccessfully: "Catálogo actualizado con éxito",
            integrateSupsiswithIntegratable: "Pase la información de chat entre supsis y {integratable} con facilidad.",
            installationOK: "Instalado",
            dayTime: "Hora",
            weekDay: "Día de la semana",
            spendTimePage: "Pasé tiempo en la página",
            spendTimeSite: "Pasé tiempo en el sitio",
            pageUrl: "URL de la página",
            pageTitle: "Título de la página",
            equal: "Igual",
            not_equal: "No es igual",
            less_than: "Menos que",
            greater_than: "Mas grande que",
            less_than_or_equal: "Menor o igual",
            greater_than_or_equal: "Mayor que o igual",
            visitorName: "Nombre del visitante",
            seconds10: "10 segundos",
            seconds30: "30 segundos",
            minute1: "1 minuto",
            minutes5: "5 minutos",
            minutes10: "10 minutos",
            minutes30: "30 minutos",
            hour1: "1 hora",
            hours2: "2 horas",
            hours4: "4 horas",
            hours8: "8 horas",
            hours12: "12 horas",
            hours24: "24 horas",
            maxCondition: "Condición máxima",
            doYouWishToDeleteTrigger: "¿Desea eliminar el gatillo?",
            contains: "Contiene",
            not_contains: "No contiene",
            chatLanguage: "Lenguaje de chat",
            translating: "Traductorio",
            buyWhatsapp: "Comprar integración de WhatsApp",
            liveSupportStartingWait: "Comenzando el soporte en vivo, espere",
            noConnection: "¡Sin conexión!",
            integrations: "Integraciones",
            refundInvoiceSure: "¿Estás seguro de que quieres devolver la factura?",
            invoiceMarkedAsPaidSuccess: "La factura ha marcada como pagada con éxito",
            invoiceMarkedAsPaidError: "Error, la factura no ha marcado el pago",
            deleteConfirm: "¿Quieres eliminar este {object}?",
            markPaidConfirm: "¿Estás seguro de Mark como pagó esta factura?",
            addLink: "Enlace",
            startChatDesc: "Iniciar conversación",
            selectStep: "Seleccione un paso:",
            addGOTO: "Ir a",
            sendFastLink: "Enviar enlace rápido",
            or: "O",
            allTags: "Todas las etiquetas",
            showDetail: "Mostrar detalle",
            hideDetail: "Ocultar detalle",
            weLlSendPhone: "Enviaremos a tu teléfono",
            weLlSendEmail: "Enviaremos a su correo electrónico",
            linkSentToPhone: "Enlace enviado como SMS",
            offerlinkSendToPhone: "Le enviaremos el enlace de descarga de nuestra aplicación a través de SMS.",
            offerlinkSendToMail: "Le enviaremos el enlace de descarga de nuestra aplicación por correo electrónico.",
            theEmail: "Mi correo electrónico registrado",
            differentEmail: "Otro correo electrónico diferente",
            linkSentToMailBox: "El enlace se envió a su dirección de correo",
            errorOccurred: "Ocurrió un error !",
            clickStoreIcon: "Puede acceder a la aplicación móvil haciendo clic en el icono adecuado para su teléfono.",
            meetWithSupsis: "¿Le gustaría cumplir con nuestra aplicación móvil de supsis?",
            downloadMobileApps: "Descargar la aplicación móvil",
            getApps: "Obtener aplicaciones",
            info: "Información",
            conversationHistory: "Historial de conversación",
            planInfoHeader: "Información sobre la información",
            planInformation: "Su plan es {selectedPlan} ({detailMaxAgentCount} agente) ({freeAgent} )",
            creditAvailable: "Su crédito de agente disponible en su plan:",
            upDownGradePlan: "Si desea actualizar/degradar su plan, por favor",
            click: "Hacer clic",
            autoStartChat: "Inicio de chat automático",
            bubbleColor: "Color de burbujas de chat",
            openFolder: "Carpeta abierta",
            preDefined: "Temas",
            customIcon: "Instalar desde su computadora",
            theme: "Tema",
            themeSettings: "Ajustes de tema",
            chatThemeSettings: "Edición de tema de chat",
            bubbleSettings: "Configuración de burbujas de chat",
            inputHeightOfBubble: "Tamaño de burbuja",
            inputPixelsOfChatBubble: "Haga clic para editar distancias de burbuja de chat a los bordes",
            modalTitleIsMarginAsPixelInfo: "Distancias de burbuja de chat a los bordes:",
            inputPxOfXaxis: "Posicion horizontal",
            inputPxOfYaxis: "Posición vertical",
            inputPxOfMobileXaxis: "(Mobil) posición horizontal",
            inputPxOfMobileYaxis: "(Mobil) posición vertical",
            animations: "Animaciones",
            preferredAnimation: "Animación preferida",
            selectAnAnimation: "Seleccione una animación",
            inputOfBubbleMessage: "Agregue contenido a enormes burbujas de chat.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip: "Es la configuración para ocultar la burbuja de chat en función del estado de inicio de sesión. Muestado a todos los visitantes en caso de que se desactiven.",
            showChatBubbleOnlyLoggedUser: "Mostrar burbuja solo para iniciar sesión en el usuario. (Ideasoft)",
            helloDoUNeedHelp: "Hola, ¿necesitas ayuda?",
            bubbleIcon: "Imagen de burbujas de chat",
            overrideMargins: "Personalizar márgenes",
            autoHideBubble: "Ocultar burbuja de chat",
            vtippyAutoHideBubble: "Oculta la burbuja de chat cuando los agentes están fuera de línea",
            hideBubble: "Desactivar burbuja de chat",
            vtippyHideBubble: "Desactiva la burbuja de chat.",
            overrideMobileMargin: "Personalizar márgenes para dispositivos móviles",
            vtippyMobileMargin: "Personalizar márgenes para dispositivos móviles",
            isFabsActive: "Mostrar botón de acción flotante",
            isAlwaysActive: "El menú está siempre abierto",
            isAlwaysActiveDesc: "¿Le gustaría que el menú de burbuja de chat permanezca siempre abierto en la vista web?",
            bubbleOpenableMenu: "Desendo de chat de burbujas",
            vtippyIsFabsActive: "Configuración del botón Show / Ocult Floating Action",
            vtippyIsFabsAsIcon: "Es la configuración de si los iconos aparecerán en el menú desplegable.",
            isFabsAsIcon: "Mostrar íconos de menú.",
            setMarginAsPixel: "Establecido como píxel",
            returnDefaultMargins: "Configuración de margen predeterminada",
            deleteSite: "¿Quieres eliminar el sitio \"{siteName}\"?",
            deleteThisSite: "Eliminar el sitio",
            assetOversizeWithExt: "El tamaño del archivo debe ser inferior a 10 MB y en formato PNG, JPG.",
            closeChat: "Mensajes finales",
            formStep: "Paso de formulario",
            menuStep: "Paso de menú",
            contentStep: "Paso de contenido",
            menuTitle: "Título de menú",
            messageContent: "Contenido del mensaje",
            goToLive: "Transferir a representante",
            prevStep: "Volver al paso anterior",
            button: "Botón",
            addImage: "Imagen",
            addText: "Texto",
            stepTitle: "Título de paso",
            addTicket: "Boleto",
            formDescription: "Pregunta",
            addInput: "Pregunta",
            addRandomText: "Texto aleatorio",
            calendarPassedTimeMinSec: "{min} minuto {sec} segundo {nombre}",
            calendarPassedTimeSec: "{hora} hora {min} minuto {sec} segundo {nombre}",
            updateUserName: "Actualizar el nombre de usuario",
            forgotPassword: "Has olvidado tu contraseña",
            osrFromMessageSaved: "Mensaje fuera de línea guardado.",
            requiredField: "Este campo es obligatorio.",
            nightModeOn: "Modo nocturno en",
            catalogMenu: "Menú",
            catalogContent: "Contenido",
            all: "Todo",
            allDepartments: "Todos los departamentos",
            preferredLanguage: "Idioma preferido",
            kmkAutoDepartmentBind: "KMK Auto DeParment Find",
            kmkAutoDepartmentBindDesc: "Búsqueda del vendedor en los sitios de clientes de KMK y se establece en la página de inicio de sesión como departamento",
            visitorEmailUpdated: "Correo electrónico del visitante actualizado",
            visitorEmailIsNotValid: "El correo electrónico del visitante no es válido",
            visitorNameUpdated: "Nombre del visitante actualizado",
            clickToEdit: "Haz click para editar",
            addEmail: "+ Agregar correo electrónico",
            addFullname: "+ Agregar Name Full",
            partner: "¿Árbitro?",
            isIntegrated: "¿Integración?",
            agentCount: "Conteo de agentes",
            closePreviewColors: "Vista previa del tema cercano",
            previewColors: "Vista previa del tema abierto",
            videoCalls: "Videollamadas",
            filterLost: "Chats perdidos",
            vtipyCustomLogin: "Puede personalizar la información que se solicitará en el formulario de inicio de sesión cuando sus visitantes se conecten al sistema.",
            vtipyLoginlessChat: "El formulario de inicio de sesión del visitante estará oculto. El visitante puede conectarse para chatear directamente.",
            loginlessChat: "Formulario de inicio de sesión del visitante",
            imageUrl: "URL de la imagen",
            replied: "Respondió",
            solved: "Resuelto",
            openImage: "Abrir imagen",
            writeFeedback: "Puede escribir sus comentarios sobre la supsis aquí.",
            feedbackFailed: "Se produjo un error al enviar comentarios.",
            feedbackSuccessful: "Presentación de comentarios exitoso.",
            sendFeedback: "Enviar comentarios",
            errorReport: "Puede darnos comentarios sobre los problemas que tiene sobre la supsis.",
            sendErrorFeedBack: "Danos comentarios sobre el problema que está experimentando.",
            successImgUpload: "Su imagen ha sido cargada con éxito.",
            successImgDelete: "La imagen se ha eliminado correctamente.",
            errorImgUpload: "Se produjo un error al cargar su imagen.",
            errorImgDelete: "Se ha producido un error al borrar la imagen",
            chatBotEndStatics: "Tasa de éxito de conversación de chatbot",
            videoCallDist: "Distribución de videollamadas",
            departmentInfo: "Información del departamento",
            infoAboutDepartment: "Dar información breve sobre el departamento",
            deleteDepartmentQuestion: "¿Realmente quieres eliminar este departamento?",
            departmentDeleted: "Departamento eliminado",
            departmentTitle: "Título de departamento",
            updateDepartmentForm: "Formulario de actualización del departamento",
            newDepartmentForm: "Nuevo formulario de departamento",
            department: "Departamento",
            newDepartment: "Nuevo departamento",
            departmentSaved: "Departamento guardado",
            selectAll: "Seleccionar todo",
            collapseAll: "Contraer todo",
            expandAll: "Expandir todo",
            addUsersToDepartment: "Añadir usuarios al departamento",
            removeFromDepartment: "Eliminar del departamento",
            moveToDepartment: "Mover a otro departamento",
            noUsersInDepartment: "No hay usuarios en este departamento",
            selectAtLeastOneUser: "Seleccione al menos un usuario",
            departmentUsersUpdated: "Usuarios actualizados",
            copyToDepartment: "Añadir también al departamento",
            userAlreadyInDepartment: "El usuario ya está en este departamento",
            removeUserFromDepartmentConfirm: "¿Está seguro de que desea eliminar este usuario del departamento?",
            bulkUpdateProgress: "Actualización masiva",
            usersUpdated: "actualizado",
            moveToAllDepartments: "Mover a todos los departamentos",
            copyToAllDepartments: "Añadir también a todos los departamentos",
            deselectAll: "Deseleccionar todo",
            sameDepartment: "Hay un departamento con el mismo nombre",
            sameValue: "¡Hay un valor con el mismo nombre!",
            sameTag: "¡Hay una etiqueta con este nombre!",
            departments: "Departamentos",
            chatTimingSettings: "Configuración de tiempo de chat",
            assetOversize: "El tamaño del archivo que desea enviar no debe exceder 2 MB.",
            assetOversizeMB: "El tamaño del archivo que desea enviar no debe superar los {mb} MB.",
            messageDeleted: "Este mensaje se elimina",
            filterLostChat: "Filtro de chats perdidos",
            filterClosedByAgent: "Filtro cerrado por agente",
            filterVideoCall: "Filtro de videollamadas",
            notificationText: "La supsis necesita permiso para",
            notificationTitle: "Notificaciones desactivadas",
            deniedText: "Sus notificaciones están cerradas, debe activar sus notificaciones para que no se pierda a sus clientes.",
            deniedTitle: "Haz clic para abrir tus notificaciones!",
            deniedHeader: "Para no perderte a tus clientes, debes activar tus notificaciones!",
            showNotificationGuide: "Haga clic para obtener más detalles",
            howToEnableNotification: "¿Cómo puedo habilitar las notificaciones?",
            notificationOK: "De acuerdo",
            notificationUnderstood: "¡Entendido!",
            notificationCancel: "Cancelar",
            howToEnableNotificationInstruction1: "Haga clic en el icono de bloqueo en la barra de direcciones del navegador",
            howToEnableNotificationInstruction2: "Si las 'notificaciones' se deshabilitan en la sección de permisos, habilitarlo",
            howToEnableNotificationInstruction3: "Si no aparecen \"notificaciones\" en la sección de permisos, haga clic en \"Configuración del sitio",
            howToEnableNotificationInstruction4: "Encienda el permiso de \"notificaciones\" de la sección \"Permisos\" de la página de configuración del sitio",
            checkPaymentMethod: "Verifique su método de pago",
            pushNotificationEnabled: "Gran notificación de push habilitada",
            pushNotificationDenied: "Has negado el permiso de notificación",
            suspendedMessage: "Tu cuenta ha sido suspendida",
            enableNotification: "Habilitar notificaciones de escritorio.",
            languageSettings: "Idioma seleccionado",
            problemsSound: "Si tiene problemas con las notificaciones, puede hacer clic en Bloquear la imagen del cuadro de búsqueda de su navegador (que se muestra en la imagen) Haga clic en 'Configuración del sitio' y cambie 'Sound' para permitir",
            betweenRepresentative: "Hay un nuevo mensaje de un representante",
            desktopNotifications: "Notificaciones de escritorio",
            notificationEnabled: "Las notificaciones de escritorio de supsis están habilitadas.",
            newMessageAlert: "Tienes un nuevo mensaje.",
            notificationDisable: "Puede deshabilitar la notificación de la configuración representativa",
            newConversationAlert: "Tienes un nuevo visitante.",
            chatBot: "Chatbot",
            ticketResponse: "Temsilcinin yanıtı:",
            archived: "archivo",
            chatbotChatCount: "Chatbot",
            changeTitle: "Cambiar título",
            changeVisitorTitle: "Cambiar título de visitante",
            catalog: "Título de catálogo",
            openTheCatalog: "Catálogo abierto",
            catalogNotOpen: "La función de catálogo está deshabilitada. Puede activar la función de catálogo para admitir a sus clientes con contenido prepreparado.",
            showCatalogCategories: "Establezca si el menú de catálogo aparecerá en la burbuja de chat",
            showChatBot: "Establezca si chatbot aparecerá en la burbuja de chat",
            openCatalog: "Visibilidad del catálogo",
            unreadMessages: "Mensajes no leídos",
            personalFirstMsg: "Promedio del tiempo de respuesta del agente (Sec)",
            personalRating: "Puntaje del personal AVG",
            soundSettings: "Configuración de las notificaciones",
            newPrivateMessage: "Mensaje privado",
            addNewGroup: "Crear un nuevo grupo",
            newMessage: "Nuevo mensaje",
            newConversation: "Nueva conversación",
            newVisitor: "Nuevo visitante",
            chatPosition: "Posición de chat",
            bottomLeftCorner: "esquina inferior izquierda",
            leftDocked: "izquierda Atracado",
            bottomRightCorner: "esquina inferior derecha",
            rightDocked: "derecho acoplado",
            chatPositionSelect: "Elija la posición",
            teamChatGroup: "Mensajes de grupo",
            teamChatDepartment: "Mensajes del departamento",
            teamChatTeam: "Mensajes de equipo",
            teamChatDm: "Mensajes DM",
            bottomLeft: "Abajo a la izquierda",
            left: "Izquierda",
            bottomRight: "Abajo a la derecha",
            right: "Bien",
            mailorname: "Correo electrónico o nombre",
            fieldName: "Nombre clave",
            value: "Valor",
            addSetting: "Agregar una configuración",
            globalSettings: "Ajustes globales",
            breaksByTime: "Romper el recuento de tiempo",
            clPlaceholder: "Nombre que aparecerá en el formulario del cliente",
            target: "Dirección de prueba de carga",
            duration: "Duración de la prueba de carga (Sec)",
            arrivalCount: "Recuento de chat",
            bootMaxLife: "Chat Max Life Time (Sec)",
            startLoadTest: "Prueba de carga de inicio",
            noClusterInstanceFound: "No hay servidor",
            stopLoadTest: "Prueba de carga de parada",
            integrationDesc: "Simplemente agregue el código de una línea a continuación a su sitio.",
            integrationDemoCode: "Código de demostración de integración simple",
            integrationWindow: "¿Cómo me integro en mi sitio?",
            notIntegrated: "Integración",
            help: "Ayuda",
            notIntegratedDesc: "Notamos que no agregó el sistema de chat a su sitio. Cuando lo integre en su sitio y comience el primer chat, completará la integración. Haga clic en el script de integración",
            backToLogin: "Vuelve a la pantalla de inicio de sesión",
            passwordlessLoginUnsuccessful: "El inicio de sesión no es exitoso. URL podría expirarse o usarse antes",
            passwordlessLogin: "Iniciar sesión sin contraseña",
            loginWithEmail: "Iniciar sesión con el correo electrónico",
            loginWithPassword: "Iniciar sesión con contraseña",
            enteringPasswordless: "Iniciar sesión sin contraseña ...",
            toMainPath: "Redirigir a la página principal",
            userRoleChanged: "Sus permisos cambiaron. Serás redirigido a la página principal.",
            passwordChangeSuccess: "Su contraseña cambió con éxito",
            feedback: "Mostrar comentarios",
            showFeedbackHistory: "Mostrar mensajes que se han enviado comentarios",
            newSelfServiceSite: "Nuevo sitio de autoservicio",
            subdomain: "Subdominio",
            rootUserEmail: "Correo electrónico",
            rootUserName: "Nombre",
            newVersion: "Nueva versión disponible",
            closeLiveSupport: "Cerrar apoyo en vivo",
            newVersionShort: "Nueva versión",
            bannedWordRestrict: "Bloqueo de palabras prohibidas",
            ticketShow: "Permitir a los clientes crear tickets",
            ticketShowDesc: "Activar la opción de creación de tickets en el menú de chat",
            autoLoadIframe: "Tráfico vivo",
            autoLoadIframeDesc: "Carga automática para iframe, pase todo el tráfico de visitantes",
            bannedWordRestrictDesc: "Cuando se enciende el bloqueo de palabras prohibido, se impide que los representantes escriban las palabras prohibidas definidas en el sistema a los visitantes.",
            agentDown: "Agente",
            delayChat: "Chat retrasado",
            tableSettingTippy: "Puede cambiar la información que aparecerá en la tabla.",
            tableSettings: "Configuración de tabla",
            tableSettingsInfo: "Puede cambiar la información que aparecerá en la tabla. Puede seleccionar 7 columna como máximo",
            privateParametry: "Parámetros de usuario personalizados",
            systemOperetor: "Información del sistema",
            cityAndDistrict: "Distrito de la ciudad",
            general: "General",
            availability: "Disponibilidad",
            home: "Hogar",
            successful: "Exitoso",
            forgetPasswordSent: "Se envió el correo electrónico del enlace de contraseña de restablecimiento, consulte su bandeja de entrada",
            saturday: "Sábado",
            friday: "Viernes",
            thursday: "Jueves",
            wednesday: "Miércoles",
            tuesday: "Martes",
            monday: "Lunes",
            sunday: "Domingo",
            download: "Descargar archivo",
            calendarPassedTimeHour: "{name} por {hour} hora",
            calendarPassedTime: "{name} para {hour} hora {min} min",
            calendarPassedTimeMin: "{name} para {sec} min",
            workScheduleOneDay: "{name} El horario de trabajo en {value}",
            workSchedule: "{name} El horario de trabajo entre {sDate} - {eDate}",
            noRating: "No hay calificación para mostrar",
            rateDist: "Distribución de tarifas",
            distConversation: "Distribución de discursos por representantes",
            distributionConversa: "Distribución de puntuación",
            distChatbotAgent: "Canales de comunicación",
            distAgent: "Chatbot & Agente",
            distFugitive: "Discurso perdido y discurso recibido",
            distLive: "Chat en vivo",
            distChatbot: "Chatbot",
            distComplex: "Chatbot & Chat en vivo",
            distHandled: "chat respondido",
            distMissed: "sin respuesta",
            distWeb: "Sitio web",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Recuento de chat de whatsapp",
            statsByTime: "Número de chat por tiempo",
            selectRep: "Seleccione un representante",
            allRepresentatives: "Todos los representantes",
            avgRating: "Puntuación de calificación ({point}) ({count} Calificación)",
            avgFirstMessageTime: "Tiempo promedio de respuesta",
            totalBreakTime: "Tiempo de descanso del sistema",
            totalBreakNum: "Recuento de descanso",
            averageConTime: "Tiempo de conversación promedio",
            multiWpReportTitle: "Número de conversación múltiple de Whatsapp",
            multiWpReport: "Número de múltiples chats de WhatsApp",
            multiWpReportExplanation: "Puede ver la cantidad de chat de sus múltiples canales de Whatsapp.",
            longestConTime: "El tiempo de conversación más largo",
            shortestConTime: "El tiempo de conversación más corto",
            refresh: "Actualizar",
            waitingReply: "Mensajes pendientes",
            organizationName: "Nombre de la Organización",
            companySlogan: "Nombre largo de la organización",
            messageSentErr: "Mensaje no enviar, inténtelo de nuevo.",
            messageSent: "Mensaje enviado.",
            openPrivateChat: "Chat representativo abierto",
            escKey: "Esconde una conversación activa",
            archiveChatKey: "Le permite unirse al chat en la parte inferior de la página de archivo.",
            chatCopilot: "Activa Chat CoPilot",
            privateChat: "Panel de conversación entre agentes",
            multiModeAlertDesc: "La supsis está abierta en otra ventana. Haga clic en \"Use aquí\" para usar supsis en esta ventana.",
            useHereText: "Usar aquí",
            brandVisibility: "La etiqueta de la marca de supsis aparece en la burbuja de chat",
            focusInput: "Focus cursor Cursor Active Chat Campo de entrada del chat",
            send: "Enviar",
            notYet: "Aún no",
            sending: "Enviando",
            onlyRepresentative: "Su mensaje solo puede ver por representantes",
            yourMessage: "Tu mensaje",
            liveFabListDescription: "Soporte vital",
            messengerIntegrationDesc: "Chatea con tus clientes a través de la página de Facebook, envía mensajes automáticos con el chatbot.",
            checkDepartmentToAgent: "Verificar el departamento para el agente en línea",
            ifAllOfflineStory: "Historia para dirigir si todos están fuera de línea",
            AssignMessagesToAgents: "Asignar Todos los Mensajes a los Agentes",
            firstChatbotAndAssign: "Primero responde el Chatbot y luego se asigna a un agente",
            hybridAssign: "El sistema verifica el departamento para ver si hay un agente en línea, y si no hay un agente en línea, lo asigna al chatbot.",
            ticketFabListDescription: "Boleto",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Teléfono",
            emailFabListDescription: "Correo electrónico",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Gorjeo",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Escriba su enlace de canal {channelLink} en este campo.",
            typeYourAccountLink: "Escriba su enlace de cuenta {accountLink} en este campo.",
            typeYourMessage: "Escribe tu mensaje aquí",
            typeYourMessageMail: "El Cliente enviará el mensaje ingresado en este campo a la dirección de correo anterior como el primer mensaje.",
            typeYourMessageDesc: "El Cliente enviará el mensaje ingresado en este campo al número de teléfono anterior como el primer mensaje.",
            sendNumber: "Número de teléfono para enviar el mensaje a: {path}",
            callNumber: "Número de teléfono para que su cliente llame: {phoneNumber}",
            numberIsNotCorrect: "Número faltante ingresado !!",
            emailIsNotCorrect: "¡El correo electrónico no es correcto!",
            selectFab: "Seleccione un fabuloso",
            notValid: "Solo puedes ingresar letras. (Carácter único) .e, d, f, z, a, x, c, v, w, t, n letras no son válidas",
            forMacUsers: "Los usuarios de Mac pueden usar el atajo de control (⌃)",
            basePriceValue: "Precio base",
            basePriceDiscount: "Descuento",
            basePriceCurrency: "Divisa",
            customerDBEnabled: "Selección de la base de datos: use el servidor de bases de datos de clientes",
            customerDBDisabled: "Selección de la base de datos: use el servidor de base de datos Supsis",
            mongoConnectionString: "Conexión Mongo",
            whatsappBasePriceValue: "Precio base de whatsapp",
            whatsappPlusBasePriceValue: "Whatsapp más precio base",
            instagramBasePriceValue: "Precio base de Instagram",
            instagramPlusBasePriceValue: "Instagram más precio base",
            clientAddress: "Dirección del cliente",
            customerClientAddress: "Dirección de cliente",
            apiAddress: "Dirección API",
            socketAddress: "Dirección de enchufe",
            backendAddress: "dirección de fondo",
            panelLogoUrl: "URL del logotipo del panel",
            panelCustomCssUrl: "URL CSS personalizada de panel",
            customerLogoUrl: "URL del logotipo de los clientes",
            customerCssUrl: "URL CSS del cliente",
            siteAlias: "Alias ​​de sitio",
            language: "Idioma",
            features: "Características",
            interactionPopularity: "Popularidad de las interacciones",
            interactionCount: "Número de interacción",
            uniqueUserCount: "Número de usuario único",
            allUserPercentage: "(%) Porcentaje de todos los usuarios",
            represantativeSettings: "Configuración representativa",
            documentTitle: "Formulario Documento Supuesto",
            supsisDocument: "Documento Supuesto",
            ApiDoc: "Documentación de la API",
            chatBalloonTehemeSettings: "Configuración de globo de chat y temas",
            customLoginFormSettingsTitle: "Personalizar el formulario de inicio de sesión del visitante",
            addNewField: "Agregar nuevo campo",
            editField: "Campo de edición",
            typeHere: "¡Escriba el contenido aquí!",
            pco: "CANALLA",
            perPage: "/página",
            perPageInFilter: "Pedazo",
            noUserInfoFound: "No se ha encontrado información del usuario",
            startFilter: "Filtro de inicio",
            showMyChats: "Muestra mis chats",
            showOnlineAgents: "Mostrar solo agentes en línea",
            showWaitingChats: "Mostrar chats de espera",
            addNewStatus: "Agregar estado",
            newTitleContent: "Nuevo título",
            newCTRLContent: "Nuevo contenido CTRL",
            newALTContent: "Nuevo contenido ALT",
            newTABContent: "Nuevo contenido de pestaña",
            roleName: "Nombre de rol",
            error: "Error",
            contentTitle: "Título de contenido",
            contentType: "Tipo de contenido",
            cannotMoveFullParent: "No puedo mover este elemento",
            newSiteForm: "Nuevo formulario de registro del sitio",
            updateSiteForm: "Formulario de actualización del sitio",
            newBannedWordForm: "Nuevo formulario de registro de palabras prohibido",
            updateBannedWordForm: "Formulario de actualización de palabras prohibidas",
            newWelcomeMessageForm: "Nuevo formulario de registro de mensajes de bienvenida",
            updateWelcomeMessageForm: "Formulario de actualización del mensaje del sistema",
            newDefaultContentForm: "Nuevo formulario de registro de contenido predeterminado",
            updateDefaultContentForm: "Formulario de actualización de contenido predeterminado",
            newSubjectForm: "Nuevo formulario de registro de asignaturas",
            updateSubjectForm: "Formulario de actualización de la asignatura",
            showChatColorMeaning: "Colores de chat",
            showIntro: "Introducción",
            options: "Opción",
            resetPassword: "Restablecer la contraseña",
            audioLevel: "Volumen de alerta de audio",
            privateChatNotificationSound: "Sonido de notificación",
            continue: "Continuar",
            newRoleForm: "Nuevo formulario de registro de roles",
            updateRoleForm: "Formulario de actualización de roles",
            newRolePlaceHolder: "Haga clic en el nuevo rol",
            newUserForm: "Nuevo formulario de registro de usuario",
            updateUserForm: "Formulario de actualización del usuario",
            changeOSRForm: "Mensaje de cambio fuera de línea",
            tooltipOSRForm: "Puede cambiar el mensaje fuera de línea.",
            newOSRForm: "Formulario de soporte fuera de línea",
            newOSRMessages: "Agregar mensaje fuera de línea",
            updateOSRForm: "Formulario de actualización fuera de línea",
            osrTitle: "Título",
            osrTitleDescription: "Puede agregar Título del formulario de soporte fuera de línea",
            osrContent: "Contenido",
            osrContentDescription: "Puede agregar contenido de formulario de soporte fuera de línea",
            hello: "Hola Mundo",
            date: "Fecha",
            startDate: "Fecha de inicio",
            finish: "Finalizar",
            start: "Comenzar",
            endDate: "Fecha final",
            representative: "Representantes",
            representative_: "Representante",
            star: "Estrella",
            filter: "FILTRAR",
            reset: "REINICIAR",
            dailyChatList: "Lista de chat diaria",
            dailyChatDuration: "Duración diaria de chat",
            chatDuration: "Duración del chat",
            dailyChatGraph: "Gráfico de chat diario",
            ok: "DE ACUERDO",
            chatCount: "Recuento de chat",
            shortest: "El mejor",
            longest: "El más largo",
            average: "Promedio",
            count: "Contar",
            averagePoint: "Punto promedio",
            pointDist: "Distribución de puntos",
            point: "Punto",
            filters: "Filtros",
            totalCustomer: "Cliente total",
            avResponseTime: "Tiempo de respuesta promedio",
            breakDuration: "Ruptura de la duración",
            breakCount: "Recuento de descanso",
            lastLoginPlatform: "Plataforma",
            active: "Activo",
            passive: "Pasivo",
            userForm: "Formulario de usuario",
            sender: "Remitente",
            profile: "Perfil",
            name: "Nombre",
            number: "Número",
            username: "Nombre de usuario",
            password: "Contraseña",
            oldPassword: "Contraseña anterior",
            newPassword: "Nueva contraseña",
            passwordAtLeast: "Contraseña (al menos {num} carácter)",
            passwordRepeat: "Repita la contraseña",
            changePassword: "Cambiar la contraseña",
            status: "Estado",
            enableState: "¿Activo?",
            douYouWishToDeleteUser: "Dou, ¿desea eliminar a este usuario?",
            userDeleted: "Usuario eliminado",
            userSaved: "Guardado del usuario.",
            oldPasswordError: "La contraseña anterior es incorrecta, verifique.",
            chooseAnOption: "Seleccione un sonido de notificación.",
            userVolumeUpdated: "Configuración de volumen actualizada.",
            addNewMenu: "Agregar nuevo menú",
            addNewContent: "Agregar contenido nuevo",
            pleaseTitleEnter: "Por favor titular ingresar",
            like: "Como",
            disLike: "Disgusto",
            users: "Usuarios",
            visitor: "Visitantes",
            allContacts: "Todos los contactos",
            allUsers: "Todos los representantes",
            allSites: "Todos los dominios",
            newUser: "Nuevo Usuario",
            noNewUser: "Todavía no hay usuario.",
            noNewAdminUser: "Todavía no hay usuario administrativo.",
            noRoleFound: "Todavía no hay ningún papel.",
            noBannedWordFound: "Todavía no hay una palabra prohibida.",
            noWelcomeMessageFound: "Todavía no hay mensaje del sistema.",
            noSubjectFound: "Todavía no hay tema.",
            noVisitorFound: "No hay visitante.",
            noContactFound: "No hay contacto.",
            sendResponse: "Escribe una respuesta",
            delete: "Borrar",
            noLiveSupportFound: "No hay visitante conectar al soporte en vivo",
            noLiveSupportFoundWithDepartment: "No hay discurso que pertenezca al departamento",
            duplicate: "Duplicar",
            makeDefault: "Hacer por defecto",
            checkMore: "Verifique más",
            useReadyTemplates: "Usar plantillas listas",
            noRePresentativeFound: "No hay representante",
            noBannedVisitorFound: "Todavía no hay un visitante prohibido.",
            removeBanDescription: "Eliminar la prohibición",
            editThisItem: "Actualizar este elemento",
            removeThisItem: "Eliminar este elemento",
            role: "Role",
            autoChatAssignLimit: "Límite de asignación de chat automático",
            chatAssignInfo: "-1 = predeterminado del sistema, 0 = no asignar,> 0 = asignar como valor dado.",
            relatedDepartments: "Departamentos relacionados",
            subjectInfo: "Si no hay sujeto seleccionado, todos los sujetos están permitidos.",
            archive: "Archivo",
            offlineSupportRequests: "Soportes fuera de línea",
            first: "Primero",
            last: "Último",
            query: "Empezar a buscar",
            clean: "Limpio",
            loading: "Cargando",
            loadMore: "Carga más",
            noMessage: "No es ningún mensaje",
            selectChat: "Elige una charla",
            noMessageInChat: "No hay ningún mensaje en este chat",
            noMediaToShow: "No Media to show",
            firstSeen: "Primera vez visto",
            userInfo: "Información de usuario",
            chatId: "ID de chat",
            visitorId: "ID de visitante",
            visitingPage: "Página de visita",
            osAndBrowser: "Sistema operativo y navegador",
            customerClientVersion: "Versión del cliente del cliente",
            visitorFeedback: "Comentarios de los visitantes",
            notes: "Notas",
            nameSurname: "Nombre Apellido",
            chats: "Chatas",
            bannedVisitors: "Visitantes prohibidos",
            country: "País",
            city: "Ciudad",
            cityDistrict: "Distrito de la ciudad",
            browser: "Navegador",
            os: "Sistema operativo",
            ipAddress: "Dirección IP",
            connectionDate: "Fecha de conexión",
            transaction: "Transacción",
            banRemoved: "Prohibición eliminada.",
            bannedWords: "Palabras prohibidas",
            newBannedWord: "Nueva palabra prohibida",
            noBannedWord: "No hay una palabra prohibida todavía.",
            bannedWordForm: "Formulario de trabajo prohibido",
            word: "Palabra",
            bannedWordAndWordGroup: "Palabra / grupo de trabajo prohibido",
            doYouWishToDeleteBannedWord: "Dou, ¿realmente desea eliminar esta palabra prohibida?",
            doYouWishToOfflineSupportRequest: "Dou, ¿realmente desea eliminar este mensaje?",
            bannedWordSaved: "Palabra prohibida guardada",
            deletedSuccessfully: "Borrado exitosamente",
            deleteErrorMsg: "Error: no se elimina, intente de nuevo",
            socketError: "Error de conexión de socket. Actualice la página y vuelva a intentarlo.",
            socketConnecting: "Conectando al servidor",
            offlineModeDescription: "Sistema Down, los clientes no podrán acceder al soporte en vivo.",
            offlineModeSettingsDescription: "Verifique la función del modo fuera de línea en el menú Configuración.",
            offlineModeUser: "Debe haber al menos un representante en línea en el sistema.",
            offlineModeMessage: "Mensaje fuera de línea",
            offlineMode: "Modo offline",
            adminCannotConnectSocket: "El administrador no puede conectarse a Socket.",
            liveSupport: "Soporte vital",
            siteVisitors: "Visitantes del sitio",
            visitors: "Visitantes",
            thoseConnectedToLiveSupport: "Los que se conectaron con el soporte en vivo",
            visitorHistory: "Historial de visitantes",
            visitorHistoryDescription: "Puede ver y descargar el historial de chat de los visitantes.",
            privateMessage: "Mensaje privado",
            addRepresentative: "Agregar representante",
            forwardRepresentative: "Representante delantero",
            keyboardShortcuts: "Atajos de teclado",
            chatColorMeanings: "Significados de color del chat",
            connLostCheckInternet: "Conexión perdida, consulte su conexión a Internet.",
            wishToEndThisChat: "Dou, ¿desea terminar este chat?",
            defaultContents: "Contenido predeterminado",
            contents: "Contenido",
            newDefaultContent: "Nuevo contenido predeterminado",
            shortcutChar: "Personaje de atajo",
            pickOne: "Elegir uno",
            writeSomething: "Escribe un personaje (A-Z | 0-9)",
            letterSequence: "Secuencia de letras",
            exampleText: "Ejemplo: SOC -> Fútbol",
            anyChar: "Cualquier personaje",
            shorcutKey: "Tecla de acceso directo",
            content: "Contenido",
            shortcutName: "Nombre de atajo",
            type: "Tipo",
            shortcut: "Atajo",
            defaultContentForm: "Formulario de contenido predeterminado",
            titleContentForm: "Contenido listo Cabecera",
            deleteContentQuestion: "¿Realmente deseas eliminar este contenido predeterminado?",
            defaultContentDeleted: "Contenido predeterminado eliminado",
            defaultContentSaved: "Contenido predeterminado guardado.",
            contentMoved: "Contenido movido.",
            yourEmail: "Dirección de correo electrónico",
            yourName: "Su nombre y apellido",
            login: "Acceso",
            lostPassword: "Has olvidado tu contraseña",
            multipleSession: "Estás firmado en otro lugar.",
            notAuthorizedToDisplayPage: "¡No estás autorizado a ver esta página!",
            permissions: "Permisos",
            newPermission: "Nuevo permiso",
            permissionForm: "Formulario de permiso",
            displayTitle: "Título de exhibición",
            key: "Llave",
            keyToUseInSystem: "Valor clave para usar en el sistema",
            deletePermissionQuestion: "¿Realmente desea eliminar este permiso?",
            permissionDeleted: "Permiso eliminado.",
            permissionSaved: "Permiso guardado.",
            newRole: "Nuevo rol",
            selectARole: "Seleccione un rol",
            yes: "Sí",
            no: "No",
            fullAuth: "Autorización completa",
            roleDeleted: "Rol eliminado.",
            roleForm: "Forma de rol",
            roles: "Roles",
            settings: "Ajustes",
            selectTopic: "Departamento seleccionado",
            autoCallTransfer: "Transferencia de llamadas automáticas",
            customerTyping: "Typing de clientes",
            typing: "Mecanografía",
            agentTyping: "Tipificación representativa",
            disconnectTime: "Tiempo de reconexión máxima (Sec)",
            tippyDissconnectTime: "Cuando un chat inactivo después de cuántos segundos terminará la conversación.",
            queueNumberVisibleFeature: "Mostrar número de cola al visitante",
            privateChatEnabled: "Mostrar el chat entre representantes",
            delayedTalkTime: "Tiempo de retraso (Sec)",
            employeeAverageChatCount: "Número de chat promedio para la tasa de chat de los empleados",
            customerDownTimeWhenRepExit: "Tiempo de inactividad del cliente cuando el representante se va (sn.)",
            autoAssignLimit: "Límite de asignación automática",
            wasted: "Conversación Tiempo perdido (Sec)",
            settingFormWrong: "Los datos del formulario son incorrectos, intente nuevamente después de verificarlo",
            settingsSaved: "Ajustes guardados.",
            settingsCannotSaved: "No se pueden guardar los ajustes",
            noAuthorization: "No autorización",
            warningBadInput: "Se recomienda ingresar un número entre 0 y 70.",
            warning: "¡ADVERTENCIA!",
            warningBadInputMarginY: "Advertencia sobre entrada del margen vertical ⚠️",
            warningBadInputMarginX: "Advertencia sobre entrada del margen horizontal ⚠️",
            warningBadInputBubbleSize: "Advertencia sobre la entrada de burbujas de chat ⚠️",
            delayTime: "Tiempo de retraso (Sec)",
            sites: "Sitios",
            newSite: "Nuevo sitio",
            noSiteYet: "Todavía no hay sitio.",
            siteAddress: "Dirección del sitio",
            turnBack: "Devolver",
            customerRepLimit: "Límite de representante del cliente",
            siteSaved: "Sitio guardado.",
            siteSaveError: "Se produjo un error durante la creación del sitio",
            subjects: "Asignaturas",
            newSubject: "Nuevo sujeto",
            noSubject: "No hay sujeto todavía.",
            subject: "Sujeto",
            subjectTitle: "Título del tema",
            infoAboutSubject: "Información sobre sujeto",
            deleteSubjectQuestion: "¿Realmente deseas eliminar este tema?",
            subjectDeleted: "Sujeto eliminado.",
            subjectSaved: "Sujeto guardado.",
            welcomeMessages: "Mensajes del sistema",
            newWelcomeMessages: "Nuevo mensaje de bienvenida",
            noWelcomeMessage: "Sin mensaje del sistema.",
            welcomeMessageContent: "Contenido de mensaje del sistema",
            makeChoice: "Tomar una decisión...",
            welcomeMessage: "Mensaje de bienvenida",
            repLoggedIn: "Representante iniciado sesión",
            loginMessage: "Mensaje de inicio de sesión",
            message: "Mensaje",
            deleteWelcomeMessageQuestion: "¿Realmente desea eliminar este mensaje del sistema?",
            welcomeMessageDeleted: "Mensaje del sistema eliminado",
            welcomeMessageSaved: "Mensaje del sistema guardado.",
            welcomeMessageForm: "Formulario de mensaje del sistema",
            noRep: "Todavía no hay representante.",
            addChat: "Agregar chat",
            forwardChat: "Chat avanzado",
            ago: "atrás",
            repName: "nombre representativo",
            lastOnline: "Última conexión/hora en línea",
            lastStatusChange: "Último cambio de estado",
            activeChat: "Chat activo",
            userMaxCapacity: "Capacidad de chat máxima",
            noActiveChat: "Sin chat activo",
            watch: "MIRAR",
            join: "UNIRSE",
            open: "Conversación abierta",
            directMessage: "MENSAJE PRIVADO",
            block: "BLOQUEAR",
            transactions: "Actas",
            informations: "Información",
            visitStart: "Inicio de visita",
            fullName: "Nombre completo",
            waitChatTime: "Tiempo de espera/chat",
            blockUserConfirm: "¿Quieres bloquear a este usuario?",
            messaging: "Mensajería",
            hideChat: "Esconder chat",
            block_: "Bloquear",
            privateMessage_: "Mensaje privado",
            assignRep: "Asignar representante",
            forwardRep: "Adelante",
            leaveChat: "Deja el chat",
            endChat: "Chat finalizado",
            translatedTextDescription: "Amazon tradujo este mensaje {from} -> {to}.",
            autoTranslate: "Traducir automático",
            translateThisMessage: "Traducir este mensaje",
            autoTranslateDetectedDesc: "El lenguaje de visitantes es {visitorLanguage}. Haga clic aquí para activar la traducción automática",
            on: "en",
            off: "apagado",
            prevChats: "Chats anteriores",
            noShortCut: "Sin atajo",
            leaveChartConfirm: "Dou, ¿realmente deseas salir del chat?",
            endChatConfirm: "Dou, ¿desea terminar el chat?",
            endConversation: "Finalizar la conversación",
            onlyOneRep: "¡Eres el único representante en esta conversación!",
            chatList: "Lista de chat",
            chatBar: "Barra de chat",
            unreadTitle: "No leído",
            visitorLeftTitle: "Visitante se fue",
            activeChatTitle: "Chat activo",
            autoAssignedTitle: "Chat asignado automáticamente",
            watchModeTitle: "Modo de reloj",
            lostChat: "Conexión representativa perdida",
            chatWidthDelay: "Charlar con demora",
            repChatWidthDelay: "Cuando no hay representante activo en el sistema o en todos nuestros representantes llenos debido al alto tráfico, los antecedentes de chat serán verdes",
            repLostConn: "Si el representante del cliente ha perdido la conexión, los antecedentes de chat serán rosados.",
            unreadMsg: "Si hay mensajes no leídos, el fondo será azul claro.",
            visitorLeftChat: "Si el visitante dejó la conversación, el fondo se vuelve gris oscuro.",
            activeChatMsg: "El fondo es verde si el chat está activo",
            autoAssignMsg: "El fondo se vuelve mostaza si se asigna la asignación automática y la conversación no se ve más allá",
            watchModeMsg: "Si se enciende en modo de reproducción, el fondo se vuelve rojo",
            online: "En línea",
            beRightBack: "Lejos",
            away: "Lejos",
            busy: "Ocupado",
            offline: "Desconectado",
            logout: "Cerrar sesión",
            forWindows: "Para ventanas",
            forMac: "Para Mac",
            nextChatFromActive: "Cambiar de activo a la siguiente conversación",
            previousChatFromActive: "Cambiar de activo a anterior",
            hideActiveChat: "Ocultar conversación activa",
            closeActiveChat: "Cerrar conversación activa",
            firsthiddenChat: "Únete al chat de cliente más esperado",
            firstChatWaiting: "Cambiar a la conversación de espera",
            previousOpenedChat: "Independientemente del pedido, salte a la conversación previamente abierta",
            historyDetails: "Detalles del historial",
            chat: "Charlar",
            chatNotFound: "No se encontró ningún discurso.",
            dataNotFound: "Datos no encontrados.",
            visitorInfo: "Información del visitante",
            timeSpent: "Tiempo usado",
            noActiveVisitors: "No hay visitantes activos",
            totalConnected: "Conteo de conversación",
            missedChat: "Recuento de chat perdido",
            workTime: "Tiempo de trabajo",
            closedChatCount: "Chat cerrado",
            activeConvo: "Conversación activa",
            notAnswered: "Todavía no respondió",
            delayedConvo: "Demorado",
            leavingRep: "Dejando representante",
            staffRate: "Tasa de trabajo del personal",
            select: "Menú desplegable",
            fullname: "Nombre completo",
            text: "Texto",
            numeric: "Número",
            phone: "Teléfono",
            optionsPlaceholder: "Valor de la opción",
            selectField: "Haga clic si desea agregar un menú desplegable",
            fullnameField: "Haga clic si desea agregar un campo de nombre completo.",
            textField: "Haga clic si desea agregar un campo de texto.",
            labelField: "Haga clic si desea agregar un campo de descripción.",
            numericField: "Haga clic si desea agregar un campo numérico.",
            phoneField: "Haga clic si desea agregar un campo de teléfono.",
            departmentField: "Haga clic si desea agregar un campo de departamento.",
            emailField: "Haga clic si desea agregar un campo de correo electrónico.",
            visible: "Visible",
            required: "Requerido",
            label: "Comentario",
            customLoginAlert: "Su formulario de inicio de sesión debe contener al menos un campo visible.",
            atLeastOneLanguage: "Debes sentir al menos un idioma",
            requiredFieldField: "Este campo es obligatorio",
            notRequiredField: "Este campo no es requerido",
            visibleField: "Este campo es visible",
            notVisibleField: "Este campo no aparece en el formulario.",
            connectServer: "Estás conectado al servidor",
            disconnectServer: "No está conectado al servidor",
            liveChatOff: "El chat en vivo está apagado",
            visitorScreen: "Pantalla de visitante",
            viewOnTheSite: "Ver en la página",
            viewOnTheSiteTippy: "Haga clic aquí para ver cómo se mantienen sus cambios.",
            showHint: "Mostrar pista",
            dontShowHint: "No muestres pistas",
            liveChatOn: "El chat en vivo está encendido",
            nightModeOff: "Modo nocturno apagado",
            doubleClickEdit: "Haga doble clic o presione el botón Editar para editar.",
            deleteField: "Borrar",
            arrow_upward: "Flecha hacia arriba",
            arrow_downward: "Flecha hacia abajo",
            newCatalogCategory: "Nueva categoría de catálogo",
            childCreate: "Haga doble clic para crear un nuevo niño",
            updateCatalogCategoryFrom: "Formulario de categoría de catálogo de actualización",
            newCatalogCategoryFrom: "Nuevo formulario de categoría de catálogo",
            catalogCategoryMenu: "Agregar menú Catálogo de categoría",
            catalogCategoryLeaf: "Agregar submenú de categoría de catálogo",
            catalogCategoryName: "Nombre de categoría de catálogo",
            newCatalogContentFrom: "Nuevo formulario de contenido de catálogo",
            catalogContentName: "Nombre del contenido del catálogo",
            catalogCategorySaved: "Categoría de catálogo guardada",
            catalogCategoryDeleted: "Categoría de catálogo eliminada",
            catalogCategoryRate: "Tasa de contenido",
            catalogContentFeature: "Función de contenido de catálogo",
            vtipyAudioLevel: "Se usa para silenciar o inmutarse sonidos de notificación.",
            vtipyOrganizationName: "Puede cambiar el nombre de la organización y actualizarlo.",
            vtipyBrandVisibility: "La supsis es la configuración de si la etiqueta se puede mostrar en la burbuja de chat.",
            vtipyBrandVisibilityForced: "¡Solo los usuarios de Proplan pueden cambiar!",
            vtipyClientDefault: "Puede cambiar el idioma de la página del agente aquí.",
            vtipyCustomerClientDefault: "Puede cambiar el idioma de la página del cliente (chat) aquí.",
            vtipyVisitorPreferredLang: "El cliente puede seleccionar el idioma hablado en la página (CHAT).",
            vtipyCustomerClientLanguageDetect: "Puede cambiar el idioma de la página del cliente (chat) aquí.",
            vtipySelectTopic: "Se producen tareas automáticas a representantes existentes en el departamento seleccionado.",
            vtipyAutoCallTransfer: "Asigna automáticamente las llamadas de espera a los agentes disponibles.",
            vtipyCustomerTyping: "Le permite ver lo que el cliente escribió en la pantalla de chat en la pantalla de chat representativa.",
            vtipyAgentTyping: "Da información cuando el representante escribe al cliente en el chat Buble",
            vtipyQueueNumberVisibleFeature: "Cuando los representantes están ocupados, muestra a los clientes que desean conectarse, en qué orden son.",
            vtipyPrivateChatEnabled: "Muestra el panel de conversación entre agentes.",
            vtipyDelayedTalkTime: "Si no se conectan los delegados a la conversación durante este tiempo, se etiquetará \\ \"Chat retrasado \\",
            vtipyOfflineMode: "Le permite poner el sistema en modo fuera de línea.",
            vtipyAutoAssignLimit: "Determina cuántos clientes (CHAT) se asignarán al representante automáticamente.",
            vtipyCustomerDownTimeWhenRepExit: "Tiempo de inactividad del cliente cuando el representante sale (Sec.)",
            tippyDisconnectTime: "El chat se interviene después de desconectar al cliente (SEC).",
            changeSettings: "Cambiar la configuración global",
            totalBg: "Chats Totales",
            activeBg: "Chats Activos",
            watchBg: "MIRAR",
            waitingBg: "Chats Pendientes",
            lateBg: "conversaciones pasajeras",
            freeBg: "GRATIS",
            maxCapacityBg: "MÁXIMA CAPACIDAD",
            addNewSettings: "Agregar una nueva configuración global",
            darkMode: "Modo oscuro",
            clientDefault: "Lenguaje predeterminado del panel",
            customerClientDefault: "Cliente Idioma predeterminado del cliente",
            customerClientLanguageDetect: "Language del cliente Detección automática",
            visitorPreferredLang: "Deje que el cliente elija el idioma hablado",
            preferredThemeColor: "Color del tema preferido para la pantalla de chat del cliente",
            detail: "Detalle",
            supportUs: "Contáctenos (soporte en vivo)",
            langSetting: "Configuración de idioma",
            changeLang: "Cambiar idioma",
            fontSizeSetting: "Configuración de zoom de pantalla",
            changeLangDesc: "Cambia el lenguaje de aplicación a {code}",
            trLang: "turco",
            enLang: "Inglés",
            fieldRequired: "{field} se requiere campo",
            selectALanguage: "Selecciona un idioma",
            selectATheme: "Selecciona un tema",
            responseForm: "Formulario de respuesta",
            clientRequestInfo: "Información de solicitud de cliente",
            createdDate: "Fecha de creación",
            descMessage: "Mensajes",
            new: "Nuevo",
            selectAllPermission: "Seleccionar todo",
            catalogCategories: "Catalogar",
            copiedClipboard: "Copiado al portapapeles",
            changeLogo: "Cambiar logotipo",
            changePhoto: "Cambiar foto",
            addPhoto: "Añadir una foto",
            seePhoto: "Ver la foto",
            deletePhoto: "Borrar la foto",
            organizationLogo: "Logotipo de la organización",
            changePlan: "Cambio de plan",
            close: "Cerca",
            vtipyUploadLogo: "Al cargar el logotipo de su empresa desde esta área, puede usar su propio logotipo en correos electrónicos de clientes y páginas de clientes.",
            tagName: "Nombre de etiqueta",
            tagDescription: "Etiqueta Descripción",
            tagColor: "Color de la etiqueta",
            userInformations: "informacion del usuario",
            incomingChat: "Chat entrante",
            support: "Apoyo",
            team: "Colocar",
            groups: "Grupos",
            newConversationStarted: "Nueva conversación iniciada",
            allHistoryLoaded: "Todo el historial subido",
            chatCreator: "Creador de chat",
            enterGroupTitle: "Ingrese el título del grupo",
            requiredTitle: "No puede dejar el campo de título en blanco",
            requiredChannel: "El nombre del canal no puede estar vacío",
            next: "Confirmar",
            selectPeople: "Seleccionar personas",
            textLimitAlertMessage: "El límite de caracteres en WhatsApp es de 19 caracteres y más allá de este límite no se mostrará. Sin embargo, en la web, los textos que superan el límite de 19 caracteres se mueven automáticamente a la siguiente línea y se muestran.",
            artificialIntelligence: "Inteligencia artificial",
            channelSettings: "Configuración del canal",
            apiKeyMode: "API Key Mode",
            byokTitle: "Use My Own API Key (BYOK)",
            byokDesc: "Use the API key from your OpenRouter account",
            supsisKeyTitle: "Let Supsis AI Provide API Key",
            supsisKeyDesc: "Use API key provided by Supsis",
            openrouterApiKey: "OpenRouter API Key",
            openrouterApiKeyHint: "You can get your API key from the OpenRouter Dashboard.",
            noChannels: "No channels yet",
            createFirstChannel: "Click 'Add Channel' to create your first channel.",
            createChannel: "Create Channel",
            providerInfo: "Provider Info",
            channels: "Channels",
            channelUpdatedSuccessfully: "Channel updated successfully",
            channelDeletedSuccessfully: "Channel deleted successfully",
            failedToSaveChannel: "Failed to save channel",
            failedToDeleteChannel: "Failed to delete channel",
            apiKeyRequired: "API key is required",
            deleteChannelConfirm: "Are you sure you want to delete this channel?",
            copiedToClipboard: "Copied to clipboard",
            showMore: "Show More",
            showLess: "Mostrar menos",
            dropdown: "Seleccionable",
            selectRepresentativeChatbot: "Seleccionar representante/Chatbot",
            selectDomain: "Seleccionar dominio",
            salesOrders: "Pedidos de venta",
            noSalesOrdersFound: "No se encontraron pedidos de venta para esta persona",
            loadingSalesOrders: "Loading sales orders",
            contacts: "Contactos",
            noContactsFound: "No se encontraron contactos para este número de teléfono",
            loadingContacts: "Cargando contactos",
            approval: "Aprobación",
            isOneOf: "Uno de",
            between: "Entre",
            chatbotScenarioHasBeenCanceled: "El escenario del chatbot ha sido cancelado",
            aiClassificationTextMode: "Clasificación de texto",
            aiClassificationImageMode: "Clasificación de imagen",
            aiClassificationImageUrlLabel: "Imagen a clasificar (URL)",
            aiClassificationImageUrlPlaceholder: "Introduzca una URL de imagen en formato https://...",
            updateChannelDesc6: "Actualizar canal de API de Whatsapp Business",
            newWabaChannel: "Nuevo canal de Whatsapp Business",
            newWabaChannelDesc: "Crear un nuevo canal para la API de Whatsapp Business",
            deleteFiles: "Eliminar archivos",
            sureDeleteMultipleFiles: "¿Está seguro de que desea eliminar los archivos seleccionados?",
            cancelSelection: "Cancelar selección",
            deleteSelected: "Eliminar archivos seleccionados",
            bulkSms: "SMS masivo",
            questions: "Preguntas",
            notAuthorizedChannel: "No está autorizado a acceder a este canal.",
            integrationsYouTubeComments: "Gestione los comentarios de YouTube desde un único panel e interactúe con sus clientes.",
            integrationsGoogleBusinessReviews: "Gestione las reseñas de Google Business desde un único panel e interactúe con sus clientes.",
            integrationsGooglePlayReviews: "Gestione las reseñas de aplicaciones de Google Play desde un único panel e interactúe con sus usuarios.",
            integrationsAppStoreReviews: "Gestione las reseñas de aplicaciones de App Store desde un único panel e interactúe con sus usuarios.",
            integrationsGoogleDrive: "Gestione sus archivos de Google Drive en Supsis y compártalos en las conversaciones.",
            integrationsPage: {
                compare: "Comparar",
                dead: "Inactivo",
                whatsappV2Web: "WhatsApp V2 (Web)",
                whatsappV3QR: "WhatsApp V3 (QR Code)",
                whatsappBusinessAPI: "WhatsApp Business API",
                whatsappBusinessAPIv2: "WhatsApp Business API v2",
                instagram: "Instagram",
                instagramV2: "Instagram V2",
                instagramV2Desc: "Conexión directa con Instagram Login. No se requiere cuenta de Facebook.",
                messenger: "Messenger",
                linkedin: "LinkedIn",
                telegramQR: "Telegram (QR Code)",
                telegramBotFather: "Telegram (Bot Father)",
                youtubeComments: "Comentarios de YouTube",
                googleBusinessReviews: "Reseñas de Google Business",
                googlePlayReviews: "Reseñas de Google Play",
                appStoreReviews: "Reseñas de App Store",
                googleDrive: "Google Drive",
                webTabs: "Pestañas web",
                webTabsDesc: "Abrir aplicaciones externas en Supsis añadiendo pestañas personalizadas al menú lateral",
                webApps: "Web Apps",
                webAppsDesc: "Cargar y gestionar sus propias aplicaciones web",
                mail: "Mail",
                smsPostacell: "SMS - Postacell",
                zohoCRM: "Zoho CRM",
                teamgram: "Teamgram",
                ideasoft: "Ideasoft",
                ticimax: "Ticimax",
                ticimaxV2: "Ticimax-V2",
                ticimaxV2Desc: "Gestione su tienda Ticimax y responda a los clientes en tiempo real a través de Supsis.",
                tsoft: "T-SOFT",
                tsoftDesc: "Gestione pedidos y envíos de T-SOFT fácilmente con SUPSIS AI.",
                ikas: "IKAS",
                ikasDesc: "Gestione pedidos y envíos de Ikas fácilmente con SUPSIS AI.",
                cacheManager: "Cache Manager",
                cacheManagerDesc: "Gestión de caché para compartir datos entre automatización y chatbots",
                openai: "OpenAI",
                slack: "Slack",
                pushover: "Pushover",
                metaLeads: "Meta Leads",
                voice: "Voz",
                webphoneRedsantral: "Webphone (Red Central)",
                webphoneRedsantralDesc: "Integración de sistema telefónico basado en web",
                webphoneTelnyx: "Webphone (Telnyx)",
                webphoneTelnyxDesc: "Integración Telnyx para llamadas globales",
                webphoneNetgsm: "Webphone (NetGSM)",
                webphoneNetgsmDesc: "Integración telefónica web con centralita NetGSM",
                aiVoiceAgent: "AI Voice Agent",
                aiVoiceAgentDesc: "Gestione sus teléfonos con asistente de voz IA. También puede integrar asistente de voz en su sitio web.",
                artificialIntelligenceFallback: "Inteligencia Artificial",
                openRouter: "OpenRouter",
                openRouterDesc: "Acceso a todos los modelos LLM mediante una única API",
                openAIDesc: "Modelos GPT-4, GPT-4o y ChatGPT",
                googleAIStudio: "Google AI Studio",
                googleAIStudioDesc: "Modelos Gemini",
                anthropic: "Anthropic",
                anthropicDesc: "Modelos Claude 3.5 Sonnet y Claude",
                mistral: "Mistral",
                mistralDesc: "Mistral Large y otros modelos",
                microsoftAzure: "Microsoft Azure",
                microsoftAzureDesc: "Servicios Azure OpenAI",
                amazonBedrock: "Amazon Bedrock",
                amazonBedrockDesc: "Plataforma AWS LLM",
                cohere: "Cohere",
                cohereDesc: "Modelos Command R+ y NLP",
                xai: "xAI",
                xaiDesc: "Modelos Grok",
                deepInfra: "DeepInfra",
                deepInfraDesc: "Infraestructura de inferencia LLM",
                together: "Together",
                togetherDesc: "Servicios LLM de código abierto",
                fireworks: "Fireworks",
                fireworksDesc: "Inferencia LLM rápida",
                siliconFlow: "SiliconFlow",
                siliconFlowDesc: "Plataforma de modelos IA",
                parasail: "Parasail",
                parasailDesc: "Servicio API LLM",
                nebius: "Nebius",
                nebiusDesc: "Infraestructura de IA en la nube",
                alibabaCloud: "Alibaba Cloud",
                alibabaCloudDesc: "Modelos Qwen",
                xiaomi: "Xiaomi",
                xiaomiDesc: "Modelos MiLM",
                sambaNova: "SambaNova",
                sambaNovaDesc: "Hardware y software de IA",
                moonshotAI: "Moonshot AI",
                moonshotAIDesc: "Modelos Kimi",
                minimax: "Minimax",
                minimaxDesc: "Modelos Abab",
                nvidia: "NVIDIA",
                nvidiaDesc: "Modelos NVIDIA NIM",
                whatsappComparisonTitle: "Comparación de soluciones WhatsApp",
            },
            trendyol: "Trendyol",
            addUserToRole: "Add user to role",
            moveToRole: "Move to role",
            noUsersInRole: "No users in this role",
            removeUserFromRole: "Remove user from role",
            removeUserFromRoleConfirm: " Are you sure you want to remove this user from the role?",
            selectNewRole: "Select new role",
            selectRole: "Select role",
            roleUsersUpdated: "Users updated",
            userNotFound: "User not found",
            unnamed: "Unnamed",
            adminReports: "Admin Reports",
            whatsappv3Channel: "Canal de Whatsapp V3: ",
            linkedinChannel: "Canal de LinkedIn: ",
            telegramChannel: "Canal de Telegram: ",
            linkedinUserProfile: "Linkedin User Profile",
            telegramUserProfile: "Telegram User Profile",
            createTask: "Create Task",
            integrationsInstagram: "Instagram mesajlarınızı tek panelden yönetin, sosyal medyada kesintisiz müşteri iletişimi sağlayın.",
            integrationsLinkedin: "LinkedIn mesaj ve yorumlarını yönetin, otomatik yanıtlarla hızlı müşteri etkileşimi kurun.",
            integrationsTelegram: "Telegram kanalınızı tek platformdan yönetin, tüm mesajları kolayca kontrol edin.",
            integrationsWebchat: "Web sitenizde 7/24 aktif chatbot, SSS yanıtları ve müşteri adayı takibiyle dönüşüm artırın.",
            deleteThread: "Are you sure you want to delete all mails? This operation cannot be undone.",
            deleteMail: "Are you sure you want to delete mail? This operation cannot be undone.",
            tokenCopied: "Erişim token'ı kopyalandı.",
            cardInfos: "Card Infos",
            saveSystemCardInfo: "Kartınız sistemimize kaydedilip ödenecek tarih geldiğinde otomatik ödenir.",
            cardNumber: "Card Number",
            cardType: "Card Type",
            skt: "ED",
            cvv: "CVV",
            saveCard: "Save Card",
            cardNameSurname: "Card Holder's Name and Surname",
            confidentialityAgreementCheck: "I Accept the Confidentiality Agreement",
            confidentialityAgreement: "Confidentiality Agreement",
            announcementInfo: "Duyuru Bilgisi",
            deleteAnnouncementQuestion: "Bu duyuruyu gerçekten silmek istiyor musunuz?",
            announcementDeleted: "Duyuru silindi",
            updateAnnouncementForm: "Formulario de actualización de anuncio",
            announcementSaved: "Duyuru kaydedildi.",
            newOsrMessageTitle: "Çevrim Dışı Mesaj Başlığı",
            startChat: "Chat Başlat",
            douYouWishToDeleteAnnouncement: "Bu duyuruyu gerçekten silmek istiyor musunuz?",
            noNewAnnouncement: "Henüz bir duyuru yok.",
            useAITemplates: "Use GPT-4 AI Ready Templates",
            mail: "Mails",
            sameRole: "There is a role with the same name!",
            messageTitle: "Başlık",
            joinChat: "Join Chat",
            billingAddress: "Billing Address",
            addNewAddress: "Add New Address",
            adressTitle: "Address Title",
            address: "Address",
            contactUs: "Contact Us",
            Aufgabe: "Aufgabe",
            FromName: "Name des Absenders",
            ImportFromReadyTemplates: "الاستيراد من القوالب الجاهزة",
            KeepUsingFeatures: "For Keep Using Your Features",
            anWarteschlange: "Warteschlange",
            beginsWith: "Inizia con",
            campaign: "Campaign",
            cantProceedPayment: "Cause of we couldn't proceed payment",
            configureTrendyolStoreStoreIntegrationDetail: "تكوين تكامل متجر ترينديول الخاص بك",
            connectZohoZoho: "الاتصال بـ Zoho CRM",
            createMoreThanOneOpenAiChannel: "لا يمكنك إنشاء أكثر من قناة OpenAI واحدة",
            deleteModalModalFormDesc: "إذا قمت بحذف هذا النموذج، فسيتم حذف جميع بيانات النموذج نهائيًا. هل أنت متأكد من رغبتك في المتابعة؟",
            failToDeleteGroup: "فشل حذف المجموعة",
            failToDeleteGroups: "فشل في حذف المجموعات",
            failToFetchGroupContacts: "فشل في جلب جهات اتصال المجموعة",
            favorite: "preferiti",
            featureIsNotAvailable: "функция недоступна.",
            ifYouSendThisConversationToTheQue: "Если вы отправите этот разговор в очередь, это удалит вас из чата и поместит разговор в очередь. Если включено автоматическое назначение чата, разговор будет назначен соответствующему агенту и может быть передан вам обратно.",
            initialContact: "First Contact",
            manageYourYourTeamGramIntegration: "إدارة تكامل TeamGram الخاص بك",
            needsAssessment: "Needs Assessment",
            notCreateMoreThanOneChannel: "لا يمكنك إنشاء أكثر من قناة واحدة من قنوات Ideasoft",
            payNow: "PAY NOW",
            removeZohoLinkbulkSms: "إرسال رسائل نصية قصيرة مجمعة",
            saveAsAsEmailCustomerGroup: "الحفظ كمجموعة عملاء البريد الإلكتروني",
            saveAsAsWhatsAppCustomerGroup: "حفظ كمجموعة عملاء واتساب",
            saving: "Сохранение...",
            sendBulkBulkSmsCustomers: "إرسال رسائل نصية قصيرة مجمعة إلى عملائك",
            supprimerZohoLinkbulkSms: "Bulk SMS",
            sureDeleteDeleteZohoChannel: "هل أنت متأكد من رغبتك في حذف قناة Zoho CRM؟",
            suspendedPlan: " features are suspended",
            temperatura: "Temperatura",
            trendyolStoreConnection: "Подключите свой магазин Trendyol",
            usageLimitExceeded: "Превышен лимит использования",
            utoForwardToOwnerForce: "Automatische Weiterleitung an Eigentümer (auch bei aktivem Chatbot)",
            visitorScreenLabel: "تسمية شاشة الزائر"
        },
        "No money will be withdrawn from your account": {
            "": "#VALUE!"
        },
        "At the end of the month, an invoice will be created according to your usage amount": {
            "": "#VALUE!"
        },
        "{contentOfChatBubble}": "#VALUE!",
        telegram: {
            typeInTelegramToken: "Escriba la token de telegrama",
            token: "Simbólico",
            telegramTokenTitle: "Telegram Susis Integración",
            telegramAlertForm: "Puede obtener el token de bot de Telegram de",
            telegramAlertTitle: "Realmente desea eliminar el token?",
            telegramAlertText: "El token desaparecerá permanentemente!",
            telegram: "Telegram"
        },
        wp: {
            sendingStatus: "Envío en proceso",
            sent: "Enviado",
            allErrors: "Todos los errores",
            inProcess: "En proceso",
            sendingStatuses: "Estados de envío",
            downloadCSV: "Descargar CSV",
            errorMessage: "Mensaje de error",
            noNumbersAdded: "No se han añadido números",
            downloadDetails: "Descargar detalles",
            broadcastFound: "Se encontraron {count} emisión(es)",
            resendForFailedNumbersTooltip: "Iniciar reenvío para restantes",
            date: "Fecha",
            walletBalanceInsufficient: "Saldo de monedero insuficiente.",
            broadcastCreatedSuccess: "Emisión creada correctamente.",
            broadcastCreateFailed: "No se pudo crear la emisión.",
            resendTitlePrefix: "Reenviar ({count} destinatarios): ",
            duplicateTitlePrefix: "Duplicado: ",
            broadcastClonedSuccess: "Emisión clonada correctamente.",
            broadcastCloneFailed: "No se pudo clonar la emisión.",
            broadcastCancelRequestSent: "Solicitud de cancelación enviada. Espere...",
            broadcastCancelledSuccess: "Emisión cancelada correctamente.",
            downloadError: "¡Error al descargar!",
            progressTooltipFormat: "{percent}% ({sent} enviados/{total} contactos)",
            successRatioTooltipFormat: "Total enviados = {total} \n Mensajes exitosos = {success} \n Mensajes fallidos = {failed}",
            notAvailable: "N/D",
            fieldRequired: "El campo {field} es obligatorio.",
            defaultBroadcastMessageText: "Hola {{name}}, gracias por elegirnos.",
            sendAgain: "Enviar de nuevo",
            shippingDetails: "Detalles de envío",
            importContactsFromFile: "Importar Contactos Desde Archivo",
            chatStarted: "El chat comenzó",
            chatNotStarted: "El chat no empezado",
            contactSelected: "Contacto seleccionado",
            startChatWithAnyNo: "Empiece a chatear con cualquier número",
            toLittleChar: "Numero faltante !",
            typeInANumberDesc: "Escriba el número para comenzar el chat con:",
            wpPlusAndLicenceRequired: "Se requieren plan y licencia de WhatsApp Plus.",
            wpPlusAndLicenceRequiredDesc: "Antes de que pueda comenzar los chats con números que no están registrados en sus contactos, debe actualizar su plan de WhatsApp y obtener una licencia.",
            chatStartingWait: "Conversación comenzando, por favor espera",
            whatsapp: "Whatsapp",
            agreement: "Acuerdo",
            purchase: "Compra",
            activating: "Activación del servicio de whatsapp",
            authenticating: "Autenticación del código QR",
            ready: "Listo",
            enableFeature: "Habilitar la función WhatsApp",
            readAndAgree: "He leído y estoy de acuerdo",
            subscribe: "Suscribir",
            subscribed: "Suscrito",
            toEnableWpDescription: "Para habilitar las funciones de WhatsApp, haga clic en el botón de abajo.",
            waitForWpActivationDescription: "Su servicio de cuenta de WhatsApp se está activando. Por favor espera un momento. Se necesitan alrededor de 10-30 segundos.",
            greatWpActivatedDescription: "¡Genial, su servicio de cuenta de WhatsApp está activado!",
            unsubscribe: "Cancelar la suscripción",
            planDetails: "Características",
            sendReceiveMessage: "Enviar y recibir mensajes de texto",
            sendReceiveImage: "Enviar y recibir archivos de imagen",
            sendReceiveAudio: "Enviar y recibir archivos de audio",
            sendReceiveGif: "Enviar y recibir archivos GIF",
            startChat: "Empiece a chatear en supsis",
            supsisFunctionality: "Funcionalidad de chat de supsis útil",
            onePhoneMultiAgent: "Un teléfono y múltiples agentes",
            basicIntegration: "Integración básica y configuración cero",
            activationTitle: "Para activar la integración de WhatsApp en supsis:",
            wpIntegrationInstruction1: "Abra WhatsApp en su teléfono",
            wpIntegrationInstruction2: "Toque el menú o la configuración. Haga clic en dispositivos vinculados",
            wpIntegrationInstruction3: "Apunte su teléfono a esta pantalla para capturar el código",
            qrGeneratingWait: "Generación del código QR Por favor espere ...",
            pleaseContinueToWaitUntilCompleted: "Después de verificar el código QR, cambiará automáticamente al campo completado. Espere por favor...",
            authenticatingWait: "Autenticando, por favor espera ...",
            unsubscribeWpInetgration: "Cancelar la suscripción de la integración de whatsapp",
            unsubscribeIGIntegration: "Cancelar la suscripción de la integración de Instagram",
            wpBack: "Atrás",
            terminatelWpInetgration: "Cuando se hace clic en el botón 'cancelar suscripción', su integración de WhatsApp terminará",
            cancelWpInetgration: "¿Quieres cancelar la integración de WhatsApp?",
            terminatelIGIntegration: "Cuando se hace clic en el botón 'cancelar suscripción', su integración de Instagram terminará",
            cancelIGIntegration: "¿Quieres cancelar la integración de Instagram?",
            startChatWp: "Comenzar chat",
            purchaseHeader: "Compra de integración de supsis-whatsapp",
            wpServices: "Servicio de whatsapp",
            wpServicesIntegrationCompleted: "Su integración de WhatsApp está completa. Ahora puede usar el servicio.",
            purchasePaymentDescription: "Característica de WhatsApp facturada mes a mes. Su servicio de WhatsApp se activará después de aceptar la suscripción.",
            wpIntegrationFeatures: "Características de integración de WhatsApp",
            saveChanges: "Guardar cambios",
            contactList: "Lista de contactos",
            broadcast: {
                broadcast: "Transmisión",
                detail: "Detalle de transmisión",
                customer: "Cliente",
                phoneNumbers: "Números de contacto",
                showMore: "Mostrar más",
                groupName: "Nombre del grupo",
                messages: "Mensajes",
                status: "Estado",
                usageCost: "Costo de uso",
                sendingTime: "Envío de tiempo",
                progress: "Progreso",
                groupDetail: "Detalle grupal",
                messagesPerContact: "Mensajes por contacto",
                successRatio: "Relación de éxito",
                showLess: "Mostrar menos",
                message: "Mensaje"
            },
            messages: "Mensajes",
            broadcastRequests: "Solicitudes de transmisión",
            customerGroups: "Grupos de clientes",
            messageTemplates: "Plantillas de mensajes",
            plans: "Planes",
            wpIntegrationRequired: "Se requiere integración de WhatsApp",
            wpRequiredIntegrationDescription: "Lo siento, la página que visitó se activará cuando integre su WhatsApp.",
            integrateWp: "Vamos, integrar whatsapp",
            active: "Activo",
            archived: "Archivado",
            createBroadcastMessage: "Crear mensaje de transmisión",
            title: "Título",
            description: "Descripción",
            createdAt: "Creado en",
            numbers: "Números",
            actions: "Comportamiento",
            action: "Acción",
            createCustomerGroup: "Crear un grupo de clientes personalizado",
            search: "Buscar",
            name: "NOMBRE",
            contacts: "Contactos",
            noContactFound: "No se encontró contacto",
            broadcastTitle: "Dale un título a tu transmisión.",
            recipients: "Receptores",
            selectRecipients: "Seleccionar destinatarios",
            writeYourMessage: "Escribe tu mensaje.",
            schedule: "Cronograma",
            scheduleNowOrLater: "Programe ahora o más tarde",
            summary: "Resumen",
            cancel: "Cancelar",
            send: "Enviar",
            sending: "Enviando",
            deleteCustomerGroup: "¿Estás seguro de eliminar este grupo de clientes? {nombre}",
            customerGroupDeleting: "Grupo de clientes Eliminando ...",
            customerGroupDeletingSuccess: "Grupo de clientes eliminado con éxito",
            customerGroupDeletingError: "Error al eliminar el grupo de clientes",
            wpPlusRequired: "Se requiere plan de WhatsApp Plus.",
            broadcastMessageArchived: "Mensaje de transmisión como archivado",
            broadcastMessageNotArchived: "El mensaje de transmisión no está archivado",
            groupNameSearch: "Escriba el nombre del grupo de clientes",
            groupNameDesc: "Nombre del grupo de clientes Identifique sus grupos de clientes",
            save: "Ahorrar",
            number: "NÚMERO",
            addColumn: "Añadir columna",
            addColumnDesc: "Agregue una columna a la tabla",
            addNewContact: "Añadir nuevo contacto",
            addNewContactDesc: "Agregue un contacto a la mesa",
            importFile: "Importar desde el archivo",
            importFileDesc: "Importar contactos desde el archivo Excel o CSV",
            contactAdded: "Contacto agregado",
            updateCustomerGroup: "Actualización del grupo de clientes ...",
            updateCustomerGroupSuccess: "Grupo de clientes actualizado con éxito",
            sendBroadcastMessage: "Enviar mensaje de transmisión",
            columnName: "Nombre de columna",
            columnType: "Tipo de columna",
            defaultValue: "Valor por defecto",
            setDefaultValue: "Establezca el valor predeterminado en los contactos existe",
            age: "Edad",
            location: "Ubicación",
            gender: "Género",
            selectContactFile: "Seleccione el archivo de contacto",
            selectContactCsvOrExcel: "Seleccione un archivo CSV o Excel.",
            importConfiguration: "Configuración de importación",
            customizeFile: "Personalice su configuración de importación.",
            sendMessageTo: "¿A quién quieres enviar el mensaje?",
            allContact: "Todo contacto",
            messageTypes: "Tipos de mensajes",
            whenSendMessage: "¿Cuándo quieres enviar el mensaje?",
            instantlyRightNow: "Al instante ahora mismo",
            completed: "Terminado",
            scheduleFuture: "Programe para una fecha futura",
            messageDesc: "Su mensaje se enviará instantáneamente a todos los destinatarios.",
            messageSendAt: "Su mensaje se enviará a todos los destinatarios en",
            estimatedPrice: "Precio estimado",
            estimatedTime: "Hora prevista",
            now: "Ahora",
            tenMinute: "10 minutos",
            cancelled: "Cancelado",
            failed: "Fallido",
            running: "Correr",
            queued: "Puesto en cola",
            scheduled: "Programado",
            noNumberAdded: "No hay números agregados",
            csvOrExcelFile: "Archivo CSV o Excel",
            broadcastMessagesToContactFile: "Mensajes de transmisión a la lista de contactos",
            broadcastMessageTemplates: "Plantillas de mensajes de transmisión",
            messageFlow: "Flujo de mensajes",
            textMessageSupport: "Soporte de mensajes de texto",
            imageMessageSupport: "Soporte de mensaje de imagen",
            spamPreventions: "Preventivos de spam",
            includesAllBasicPlans: "Incluye todo en el plan básico",
            chatbotIntegration: "Integración de chatbot",
            messageToNewNumbers: "Mensaje a nuevos números",
            broadcastMessageToEveryone: "Transmitir mensajes a todos",
            personalizedBroadcastMessage: "Mensajes de transmisión personalizados",
            customerGroupSegmentation: "Segmentación del grupo de clientes",
            scheduleBroadcastMessage: "Programe un mensaje de transmisión",
            locationMessageSupport: "Soporte de mensaje de ubicación",
            advancedSpamPreventions: "Preventiones de spam avanzadas",
            whatsappPlans: "Planes de whatsapp",
            selectBestPlan: "Elija el plan que le convenga",
            comingSoon: "Muy pronto...",
            selectFile: "Seleccione un archivo",
            created: "Creado",
            message: "Mensaje",
            cancelIGIntgeration: "¿Desea cancelar la integración de Instagram?",
            uploadFromComputer: "Subir desde el equipo"
        },
        ig: {
            instagram: "Instagram"
        },
        ticket: {
            trendyolQandA: "Preguntas y Respuestas de Trendyol",
            facebookComments: "Comentarios de Facebook",
            chatbotTickets: "Tickets del Chatbot",
            ticketSettings: "Configuraciones de Tickets",
            instagramComments: "Comentarios de Instagram",
            messengerComments: "Comentarios de Messenger",
            trendyolComments: "Comentarios de Trendyol",
            ticketSelection: "Ticket Seleccionado",
            bulkClose: "Cierre Masivo",
            igComment: "Comentario de Instagram",
            igMentioned: "Menciones de Instagram",
            incomingReqChatbot: "Solicitudes entrantes con Chatbot",
            incomingReqWebForm: "Solicitudes desde formulario web",
            incomingReqAutomation: "Solicitudes de automatización",
            thisPersonEmailAnswered: "Esta persona desea que se le responda por correo electrónico",
            thisPersonWpAnswered: "Esta persona está esperando una respuesta vía WhatsApp",
            clickStartWpChat: "Haz clic para iniciar el chat de WhatsApp",
            requestProgress: "Solicitar progreso",
            requestMessage: "Solicitar mensaje",
            clickAddMailAddress: "Haz clic para añadir una dirección de correo",
            sendReplyCloseTicket: "Enviar respuesta y cerrar ticket",
            closeTicket: "Cerrar Ticket",
            selectEmailSender: "Seleccionar remitente de correo electrónico",
            withEmailWillNotRecievice: "¡No podrá recibir respuestas al correo cuando envíe con esta dirección de correo!",
            deleteCommentAndClose: "Eliminar y cerrar comentario",
            sendReplyAndClose: "Enviar respuesta y cerrar",
            startChatWp: "Iniciar chat de WhatsApp",
            sureWantToDeleteTicket: "¿Estás seguro de que quieres borrar un ticket?",
            bulkDeleteConfirmation: "Confirmación de eliminación masiva",
            selectedTicketSucsDelete: "Los tickets seleccionados se eliminaron correctamente",
            thereErrorDeletingTicket: "Se ha producido un error al borrar tickets",
            deleteConfirm: "Confirme el borrado",
            sureDeleteTicket: "¿Está seguro de que desea borrar este ticket?",
            ticketSucsDelete: "Ticket borrado con éxito",
            represantiveSucsAppoint: "El agente ha sido nombrado con éxito",
            ticketClosedSucs: "Ticket cerrado con éxito",
            ticketCloureFailed: "Cierre de ticket fallido.",
            unprocessed: "No procesado",
            pleaseSelectValidStatus: "Por favor, seleccione un estado válido",
            ticketStatusBeenUpdatd: "Se ha actualizado el estado del ticket",
            doYouWantCloseTicket: "¿Desea cerrar el ticket?",
            ticketWillMarkedClosed: "El ticket se marcará como cerrado y se archivará",
            errorUpdatingTicketFailed: "Se ha producido un error al actualizar el estado del ticket",
            igCommentDeleteIgPost: "Se ha eliminado el comentario de Instagram de tu publicación de IG",
            igCommentHideChange: "Se ha cambiado el estado de ocultación del comentario de Instagram",
            pleaseChooseRepresent: "Por favor, seleccione un representante",
            selectedTicketSucsDelegated: "Los tickets seleccionados se han delegado correctamente",
            errorOccuredDuringDelegation: "Se ha producido un error durante el proceso de delegación",
            bulkTicketClosing: "Cierre masivo de tickets",
            sureWantCloseTicket: "¿Está seguro de que desea cerrar el ticket?",
            selectedTicketSucsClosed: "Los tickets seleccionados se cerraron con éxito",
            thereErrorClosingTicket: "Se ha producido un error al cerrar los tickets",
            changeFilterTicketPage: "Cambiar los filtros de la página Tickets",
            nameOfFilter: "Nombre del filtro",
            filterValue: "Valor del filtro",
            deletesSelectedTickets: "Elimina los tickets seleccionados",
            idTicketBeDelete: "Los ids de los tickets a borrar (ids de los tickets seleccionados o todos los ids de los tickets listados)",
            assignsAgentSelectedTickets: "Asigna un representante a los boletos seleccionados",
            idTicketBeAssigned: "IDs de los boletos a asignar. (IDs de boletos seleccionados o todos los IDs de boletos listados)",
            idAgentAssigned: "ID del representante a asignar",
            changesStatusSelectedTicket: "Cambia el estado de los boletos seleccionados",
            idTicketWhoseStatus: "IDs de los boletos cuyo estado será cambiado. (IDs de boletos seleccionados o todos los IDs de boletos listados)",
            newStatus: "Nuevo Estado",
            selectedTicketsSucsUpdated: "El estado de los boletos seleccionados se actualizó con éxito.",
            errorWhileChangingStatus: "Se produjo un error al cambiar el estado de los boletos.",
            thisPageVoiceAssistant: "Esta página tiene un asistente de voz",
            hello: "¡Hola!",
            voiceAssistantContent: "¿Sabías que hay un <strong>Asistente de Inteligencia Artificial</strong> que puede ayudarte en esta página?\n                Puedes probar los siguientes métodos para usar el asistente:",
            commandHoldingDownTheKey: "Puedes mantener presionada una combinación de teclas y hablar para dar comandos.",
            topRightContent: "En la esquina superior derecha,",
            clickOnTheIcon: "puedes hacer clic en el icono para iniciar el asistente.",
            sampleVoiceCommands: "Comandos de voz de ejemplo:",
            showMyTickets: "Mostrar mis boletos",
            showMeZeynepsOpenTicket: "Mostrar los boletos abiertos de Zeynep hoy",
            deleteTicketsScreen: "Eliminar boletos en la pantalla",
            assigntLastTicketAli: "Asignar el último boleto a Ali",
            changeStatusAllTicket: "Cambiar el estado de todos los boletos a completado",
            setStatusTicketsScreen: "Establecer el estado de los boletos en la pantalla a .......",
            assigntUserTicketScreen: "Asignar los boletos en la pantalla al usuario .....",
            assigntFirstTicket: "Asignarme el primer boleto",
            showIgTickets: "Mostrar los boletos de Instagram del mes pasado",
            makeChoice: "Hacer una selección",
            makeAssignment: "Hacer una asignación",
            tickets: "Entradas",
            instagramTickets: "Entradas de Instagram",
            facebookTickets: "Entradas Facebook",
            trendyolTickets: "Entradas de Trendyol",
            automationTickets: "Entradas de automatización",
            supsisFormTickets: "Entradas de formulario Supsis",
            columnSettings: "Ajustes de columna",
            ticketField: "Área de entradas",
            contactPropertyFields: "Áreas de propiedad de Reach",
            ticketFilterList: {
                archivedRequests: "Solicitudes archivadas",
                comingFromFacebook: "Desde Facebook",
                comingFromInstagram: "Desde Instagram",
                unassignedOpenRequests: "Solicitudes pendientes no asignadas",
                openRequests: "Solicitudes abiertas",
                requestsOpenedThisWeek: "Solicitudes abiertas esta semana",
                specialList: "Lista especial",
                creationDate: "Fecha de creación",
                supsisFromTheForm: "Supsis Desde El Formulario",
                fromTrendyol: "Desde Trendyol",
                comesWithAutomation: "Viene de Automatización",
                label: "Etiqueta",
                status: "Estado",
                subject: "Asunto",
                email: "Correo electrónico",
                name: "Nombre",
                phone: "Teléfono",
                type: "Tipo",
                assignedUser: "Usuario asignado"
            },
            appointingRepresentative: "Nombrar un representante",
            ticketTagFilter: "Etiqueta de filtro de boleto",
            ticketEmails: "Lista de correo electrónico de reenvío de boletos",
            save: "Ahorrar",
            delete: "Borrar",
            transactions: "Opción",
            noEmailTicketNotifications: "No hay datos",
            emailIsNotValid: "El correo no es válido",
            emailNotificationDeleted: "Artículo eliminado con éxito",
            emailNotificationDeleteError: "Ocurrió un error",
            tagFilterRequired: "Etiqueta de filtro de ticket requerida, use *(comodín) etiqueta para todos los boletos",
            emailsRequired: "Reenviar correos electrónicos no debe ser nulo",
            emailNotificationCreated: "Regla de bosque de boletos creados",
            emailNotificationCreateError: "Ocurrió un error",
            ticketForwarding: "Reenvío de correo electrónico de boleto",
            ticketTagFilterDesc: "Utiliza los temas de boletos que usó en el diseño de chatbot para filtrar los boletos. Puede escribir una etiqueta diferente y presionar Entrar para agregarla. Si selecciona la etiqueta '*', seleccionará todos los boletos",
            ticketEmailsDesc: "Lista de correo electrónico a la que se reenviarán los boletos. Puede agregar las direcciones de los representantes en el sistema seleccionándolos. También puede agregar correos electrónicos sin sistema.",
            ticketList: "Reglas de reenvío de boletos",
            ticketTagFilterPlaceHolder: "Filtro de boletos, seleccione '*' para todos",
            ticketEmailsPlaceHolder: "Reenvío de la lista de correo electrónico",
            offlineTickets: "Tickets sin conexión",
            assignFirstTicket: "Asignarme el primer ticket.",
            assignLastTicketAli: "Asignar el último ticket a Ali.",
            assignUserTicketScreen: "Asignar los tickets de la pantalla al usuario .....",
            placeholders: "Marcadores de posición",
            ticketStatusBeenUpdated: "El estado del ticket ha sido actualizado."
        },
        theme: {
            opacity: "Opacidad",
            headerColor1: "Color de la sección Hader 1",
            headerColor1A: "Opacidad de la sección Hader 1",
            headerColor2: "Color de la sección del encabezado 2",
            headerColor2A: "Opacidad de la sección del encabezado 2",
            backgroundColor: "Color de fondo 1",
            backgroundColorA: "Opacidad de fondo 1",
            backgroundColor2: "Color de fondo 2",
            backgroundColor2A: "Opacidad de fondo 2",
            textColor: "Color de texto",
            errorTheme: "Color de error",
            bubbleBackground: "Color de burbujas representativo",
            bubbleVisitorBackground: "Color de burbujas de clientes",
            bubbleBackgroundA: "Opacidad de burbuja representativa",
            bubbleVisitorBackgroundA: "Opacidad de la burbuja del cliente",
            bubbleText: "Color de texto representativo",
            bubbleVisitorText: "Color de texto del cliente",
            textFormColor: "Color de forma",
            selectCustom: "Seleccionar tema personalizado",
            headerColorSecond: "Color superior del encabezado",
            headerColorFirst: "Color inferior del título",
            backgroundColorFirst: "Color superior de fondo",
            formColor: "Color del texto del formulario",
            buttonColor: "Color del boton",
            backgroundColorSecond: "Color inferior de fondo",
            chatBotButtonText: "Color de fuente del chatbot",
            chatBotButtonColor: "Color del botón del chatbot",
            font: "Font"
        },
        billing: {
            paymentId: "ID de pago",
            billType: "Tipo de factura",
            invoiceAmount: "Cantidad de factura",
            invoiceDate: "Fecha de factura",
            invoiceStatus: "Estado de factura",
            invalidBill: "Factura no válida",
            invalidBillNotPossible: "Esta factura no ha sido creada, por lo que no puede ser marcada como no válida.",
            myInvoices: "Mis facturas",
            allInvoices: "Todas las facturas",
            manualInvoices: "Facturas manuales",
            endOfPeriodInvoices: "Facturas de periodo",
            purchaseInvoices: "Facturas de compra",
            paidInvoices: "Facturas pagadas",
            unpaidInvoices: "Facturas no pagadas",
            walletDeposit: "Depósito de portafolio",
            updateBillingInfo: "Actualizar información de facturación",
            notFoundSavedBillingAddress: "No se ha agregado ninguna dirección de facturación",
            notFoundSavedCard: "No se ha agregado ninguna tarjeta de crédito",
            cardInfoIsStoredSecurelyByIyzico: "Las informaciones de la tarjeta se almacenan de forma segura por Iyzico",
            paymentMethodAndInvoiceAddress: "Método de pago y dirección de facturación",
            unpaidInvoiceBannerMessage: "Tienes una factura sin pagar. Por favor, paga tu factura para evitar la interrupción del servicio.",
            unpaidInvoiceBannerMessageWithDate: "Tienes una factura sin pagar. Si no pagas antes del {date}, tu cuenta será suspendida.",
            clickToPay: "Ir a la página de pago",
            packageDescriptions: {
                whatsapp: "Integra tu cuenta de WhatsApp normal para responder a los clientes en todos los canales.",
                whatsappBusiness: "Integra tu cuenta de WhatsApp Business para responder a los clientes en todos los canales.",
                supsis: "Con más representantes, puedes responder a tus clientes de manera más rápida y eficiente.",
                chatbot: "La integración de un chatbot te permite atender a tus clientes las 24 horas del día, los 7 días de la semana.",
                instagram: "Integra tu cuenta de Instagram para responder a los clientes en todos los canales.",
                telegram: "Integra tu cuenta de Telegram para responder a los clientes en todos los canales.",
                custom: "Elige uno de nuestros planes personalizados para obtener soluciones adaptadas a tu negocio.",
                messenger: "Integra tu cuenta de Messenger para responder a los clientes en todos los canales.",
                trendyol: "Integra tu cuenta de Trendyol para responder rápidamente a las preguntas de tus clientes.",
                metaLead: "Integra tu cuenta de Meta Lead para gestionar los leads directamente desde el panel de control.",
                customerTables: "Crea tablas dinámicas para gestionar la información de los clientes, pedidos y mucho más.",
                form: "Crea formularios para recopilar información de tus clientes y analizar los datos.",
                automation: "Configura automatizaciones para agilizar procesos y mejorar el servicio.",
                mail: "La integración con correo electrónico te permite enviar y recibir emails de tus clientes.",
                tasks: "Crea tareas para planificar y gestionar tus procesos de trabajo.",
                artificialIntelligence: "La integración de inteligencia artificial te ayuda a responder a los clientes de manera más rápida y eficiente.",
                webhook: "Integra tus aplicaciones con Supsis mediante webhooks.",
                default: "Explora nuestros paquetes para obtener más información."
            },
            autoRenew: "Renovación automática",
            purchased: "Comprado",
            currentPlans: "Mis planes",
            individual: "Individuo",
            expirationDate: "F. Cad",
            yourNameSurname: "Su nombre y apellido",
            editCardInformation: "Editar información de la tarjeta",
            billingContactInfo: "Información de contacto de facturación actualizada correctamente",
            defaultRootEmail: "Por defecto: Correo electrónico básico",
            invoiceEmailAddress: "Dirección de correo electrónico de facturación",
            invoiceSettings: "Configuración de la factura",
            updateChannelDesc6: "Actualizar canal api de Whatsapp business",
            newWabaChannel: "Nuevo canal de Whatsapp business",
            newWabaChannelDesc: "Crear un nuevo canal para Whatsapp business api",
            popular: "Popular",
            selectedPlan: "Plan seleccionado",
            editPlan: "Editar Plan",
            removePlan: "Quitar Plan",
            showPlan: "Mostrar plan",
            hiddenPlan: "Ocultar Plan",
            contactSales: "Contactar con Ventas",
            showLess: "Mostrar menos",
            more: "Más",
            selectTransactionType: "Tipo de transacción",
            walletLogs: "Registros de billetera",
            addBalance: "Añadir saldo",
            availableBalance: "Saldo disponible",
            walletTransactions: "Transacciones de billetera",
            autoReload: "Recarga automática",
            transactionTypes: "Tipos de transacción:",
            transactionTypesHint: "(Clic para selección única, Ctrl+clic para selección múltiple)",
            importantInfo: "Información importante",
            walletImportantPoint1: "Si no se puede cobrar el pago de su tarjeta, el sistema se desactivará automáticamente; debe activarlo usted mismo.",
            walletImportantPoint2: "Solo 1 recarga cada 10 minutos. Mantenga el saldo objetivo alto para uso intensivo.",
            walletImportantPoint3: "Puede habilitar más notificaciones en Configuración de notificaciones.",
            walletImportantPoint3Before: "Puede habilitar más notificaciones en ",
            walletImportantPoint3After: ".",
            walletImportantPoint4: "Puede ver las recargas automáticas en la pestaña \"Transacciones de billetera\".",
            walletImportantPoint5: "No hay límite en el número o monto de recargas; asegúrese de ingresar la configuración correcta.",
            autoBalanceReload: "Recarga automática de saldo",
            autoBalanceReloadDesc: "Carga saldo automáticamente cuando el saldo de su billetera cae por debajo del umbral que establezca.",
            autoReloadToggle: "Recarga automática",
            autoReloadToggleDesc: "Puede habilitar/deshabilitar esta función",
            disabledDueToFailure: "Deshabilitado debido a fallo",
            thresholdValue: "Valor umbral (TL)",
            thresholdValueDesc: "La recarga automática se realiza cuando el saldo cae por debajo de este valor",
            reloadMode: "Modo de recarga",
            reloadModeDesc: "¿Qué debe suceder cuando el saldo cae por debajo del umbral?",
            addFixedAmount: "Añadir monto fijo",
            fixBalance: "Fijar saldo",
            modeAddDesc: "Cuando el saldo cae por debajo del umbral, se añade el monto especificado. Ej.: Umbral 50 TL, Saldo 30 TL → 200 TL añadidos → Saldo 230 TL.",
            modeFixedDesc: "Cuando el saldo cae por debajo del umbral, se completa al monto especificado. Ej.: Umbral 50 TL, Saldo 30 TL → 170 TL añadidos → Saldo 200 TL.",
            amountToAdd: "Monto a añadir (TL)",
            targetBalance: "Saldo objetivo (TL)",
            amountToAddDesc: "Este monto se añadirá cuando el saldo caiga por debajo del umbral",
            targetBalanceDesc: "El saldo se completará a este monto cuando caiga por debajo del umbral (debe ser mayor que el umbral)",
            panelNotifications: "Notificaciones del panel",
            panelNotificationsDesc: "¿En qué casos desea recibir notificaciones?",
            notifyOnRecharge: "Notificación de recarga exitosa",
            notifyOnFailure: "Notificación de fallo",
            notifyOnDisabled: "Notificación de deshabilitación",
            emailNotifications: "Notificaciones por correo",
            emailNotificationsDesc: "¿Quién debe recibir notificaciones por correo? (opcional)",
            emailPlaceholder: "Ingrese direcciones de correo (separar con coma)",
            emailHint: "Si se deja vacío, el correo solo se enviará al propietario del sitio",
            lastTrigger: "Último disparo:",
            neverTriggered: "Aún no se ha disparado",
            failedAttempt: "Intento fallido:",
            saveSettings: "Guardar configuración",
            tabAll: "Todos",
            tabAiUsage: "Uso de IA",
            tabVoiceAgent: "Agente de voz",
            tabAutomation: "Automatización",
            balanceAddedSuccess: "Se ha añadido {price}TL a su cuenta de WhatsApp",
            balanceAddFailed: "No se pudo añadir saldo a su cuenta.",
            autoRebalanceLoadError: "No se pudieron cargar la configuración de recarga automática",
            thresholdMinError: "El valor umbral debe ser 0 o mayor",
            targetBalanceMinError: "El saldo objetivo debe ser mayor que 0",
            targetBalanceThresholdError: "El saldo objetivo debe ser mayor que el umbral",
            autoRebalanceSaveSuccess: "Configuración de recarga automática guardada correctamente",
            settingsSaveFailed: "No se pudieron guardar la configuración",
            testFailed: "Prueba fallida",
            creditCardRequiredForAutoReload: "Debe añadir la información de su tarjeta de crédito primero para recarga automática",
            notificationSettings: "Configuración de notificaciones",
            appsumoPack: "Pack Appsumo",
            updatePlan: "Actualizar plan",
            createPlan: "Crear plan",
            freePack: "Pack gratuito",
            instantFee: "Se facturarán gastos instantáneos",
            planSequence: "Secuencia del plan",
            requiredCodes: "Número de códigos requeridos",
            subHeading: "Subtítulo",
            featureKey: "Clave de la función",
            customerKey: "Clave del cliente",
            monthlyPrice: "Precio mensual",
            monthlyNonDiscounted: "Precio mensual no actualizado (visualización no funcional)",
            twoYearDiscount: "Descuento por 2 años",
            yearDisccount: "Descuento anual",
            sixMonthDiscount: "Descuento por 6 meses",
            threeMonthDiscount: "Descuento por 3 meses",
            features: "Características",
            sessionCount: "Recuento de sesiones",
            subType: "Tipo de suscripción",
            skipTrialVersion: "Saltar versión de prueba",
            skipTrialVersionDesc: "Puede omitir la versión de prueba y continuar seleccionando el paquete adecuado para su negocio. Si omite la versión de prueba, esta acción no se puede deshacer.",
            skipStep: "Omitir este paso",
            switchToPay: "Pasar a pagar",
            forward: "Adelante",
            pleaseFillInCard: "¡Rellene los datos de la tarjeta!",
            fillInTheBillingAddress: "¡Rellene los datos de la dirección de facturación!",
            cardNumberWrong: "¡El número de tarjeta es incorrecto!",
            pleaseConfirmTheUser: "Por favor, confirme el acuerdo de usuario.",
            pleaseCheckYourCard: "Por favor, compruebe su tarjeta y sus datos.",
            site: "Sitio",
            period: "Período",
            billStatus: "Estado de la factura",
            totalPrice: "Precio total + IVA",
            depotMoneyWallet: "Depósito en monedero",
            threeMonthly: "Cada 3 meses",
            sixMonthly: "Cada 6 meses",
            twoYearly: "2 años",
            forever: "Para siempre",
            extraPackage: "Paquete extra",
            teamPackage: "Paquetes de equipo",
            adventPackage: "Paquetes ventajosos",
            cupponError: "El código del cupón es incorrecto o ha caducado.",
            enterYourCard: "Por favor, introduzca su tarjeta de crédito.",
            invalidCard: "Tarjeta de crédito no válida, pago no recibido.",
            calculateThis: "Calcular para:",
            adventageousPackage: "¡Descuentos ventajosos en paquetes!",
            cupponApplied: "Cupón aplicado con éxito",
            subStart: "Suscripción iniciada",
            subSuccessStart: "Su suscripción se ha iniciado correctamente",
            success: "Éxito",
            succesDesc: "Suscripción creada con éxito",
            successDesc: "Su función se ha activado correctamente.",
            maxNumber: "Número máximo de representantes que pueden intervenir",
            currentAmountDetails: "Detalles del importe actual",
            endOfMonthForecastDetails: "Detalles de la previsión a final de mes",
            totalAmount: "Importe total",
            vatAmount: "Importe del IVA (20%)",
            totalAmountIncludingVAT: "Importe total IVA incluido",
            hideDetails: "Ocultar detalles",
            createInvoice: "Crear factura",
            reimbursementMade: "Reembolso realizado",
            invalidInvoice: "Factura no válida",
            balanceTopUp: "Recarga de saldo WhatsApp",
            paidSuccesfully: "La factura se pagó correctamente",
            paymentFailed: "El proceso de pago de la factura ha fallado",
            areYouSurePaid: "¿Está seguro de que desea marcar esta factura como pagada?",
            invoiceMarkedPaid: "La factura ha sido marcada como pagada",
            invoiceMarkedFailed: "Se ha producido un error y no se ha podido marcar la factura como pagada",
            areYouSoreRefundInvoice: "¿Está seguro de que desea procesar un reembolso para esta factura?",
            copied: "Copiado",
            copiedToClipboard: "Contenido copiado al portapapeles.",
            copyFailed: "Error en la operación de copia.",
            invoiceGenerated: "Factura generada",
            invoiceNotGenerated: "Factura no generada",
            notAvailable: "N/D",
            estimated: "Estimado",
            dueDate: "Fecha de vencimiento",
            markAsPaid: "Marcar como pagado",
            refundPayment: "Procesar reembolso",
            editInvoice: "Editar factura",
            deleteInvoice: "Eliminar factura",
            adminGroup: "Admin",
            billTypeNone: "Ninguno",
            billTypeManual: "Manual",
            billTypeMonthly3: "3 meses",
            billTypeMonthly6: "6 meses",
            billTypeAnnual: "Anual",
            billTypeAnnual2: "2 años",
            billTypeEducation: "Educación",
            billTypeConsultancy: "Consultoría",
            billTypeInstallation: "Instalación",
            billTypeOther: "Otro",
            paymentNotPossible: "Pago no posible",
            saveCardFirst: "Por favor, guarde su tarjeta de crédito primero para realizar un pago.",
            youMustFillInEmpty: "Debe rellenar todos los espacios en blanco",
            createdNewInvoice: "La nueva factura se ha creado correctamente",
            createdNewInvoiceFailed: "Se ha producido un error al crear la factura",
            invoiceUpdated: "El importe de la factura se ha actualizado correctamente...",
            invoiceUpdatedFailed: "Se ha producido un problema al actualizar la factura",
            planes: "Planes",
            companyName: "Nombre de la empresa",
            compony: "Empresa",
            person: "Persona",
            invoiceAddressInfo: "Información sobre la dirección de la factura",
            idNo: "ID turco",
            taxOffice: "Agencia Tributaria",
            taxNumber: "Número de identificación fiscal",
            packageCanNotDownSupsis: "Su paquete no se puede degradar. Por favor, elimine o deshabilite varios de sus Agentes para degradar su paquete.",
            packageCanNotDownWp: "Su paquete no puede ser degradado. Por favor, elimina varios de tus canales de Whatsapp para bajar de categoría tu paquete.",
            packageCanNotDownWPBussiness: "Tu paquete no se puede bajar de categoría. Por favor, borra varios de tus canales de Whatsapp Business para bajar el estado de tu paquete.",
            chooseYourPlan: "Elige tu plan.",
            numberOfRepresentatives: "Número de representantes",
            numberOfChannels: "Número de canales",
            wpNumberOfChannels: "Número de canales de Whatsapp",
            igNumberOfChannels: "Número de canales de Instagram",
            msNumberOfChannels: "Número de canales de Messenger",
            cancelIt: "Cancelar",
            activePlan: "Plan activo",
            activate: "Activar",
            noTransition: "Sin transición",
            daysLater: "días después",
            payBack: "Reembolso",
            paid: "Pagado",
            unPaid: "Sin pagar",
            editPrice: "Editar precio",
            payNow: "pagar ahora",
            youAreCurrentlyOnTrial: "Estás en periodo de prueba. Puedes saltarte la prueba ahora para ver paquetes exclusivos.",
            youAreCurrentlyLimited: "Actualmente estás limitado por el sistema porque tus paquetes no cumplen las condiciones.",
            youHaveOneRepresentative: "Tienes un representante.",
            deactivateOrDeleteYourPiece: "Desactiva o borra tu representante de Piece o compra un representante.",
            youHaveOneWhatsappQRChannel: "Tienes un canal QR de Whatsapp.",
            deleteYourWhatsAppQR: "Desactiva o borra tu canal de Whatsapp QR o compra un canal.",
            youHaveAWhatsappBusiness: "Tienes un canal de Whatsapp Business.",
            deleteYourWhatsapp: "Elimina tu canal de Whatsapp Business o compra un canal.",
            youHaveAnInstagram: "Tienes un canal de Instagram.",
            deleteYourInstagram: "Borra tu canal de Instagram o compra un canal.",
            youHaveAMessenger: "Tienes un canal de Messenger.",
            deleteYourMessenger: "Borra tu canal de Messenger o compra un canal.",
            additionalPackages: "Paquetes adicionales",
            availablePackages: "Paquetes disponibles",
            buyNow: "Comprar ahora",
            invoiceInformation: "Información de la factura",
            invoiceAddress: "Dirección de la factura",
            invoiceType: "Tipo de factura",
            review: "Revisión",
            viewDetails: "Ver detalles",
            addNewAddress: "Agregar nueva dirección",
            enterYourBillingAddress: "Ingresa tu dirección de facturación",
            selectPlan: "Seleccionar plan",
            paymentStatus: "Estado del pago",
            amount: "Cantidad",
            invoiceID: "ID de la factura",
            expected: "Esperado...",
            currentAmount: "Monto actual",
            monthlyEstimatedAmount: "Monto estimado mensual",
            creationDate: "Fecha de creación",
            invoicePeriod: "Periodo de facturación",
            newPaymentMethod: "Nuevo método de pago",
            channelCount: "Cantidad de canales",
            remainingTime: "Tiempo restante",
            chatbotLimit: "Límite de chatbot",
            free: "Gratis",
            maxChatbotSession: "Máximo de Sesiones de Chatbot",
            buyIt: "Comprar",
            renewalDate: "Fecha de renovación",
            monthly: "Mensual",
            yearly: "Anual",
            packagePeriod: "Período del paquete",
            packageType: "Tipo de paquete",
            packageManagement: "Gestión de paquetes",
            invoiceManagement: "Gestión de facturas",
            futureInvoice: "Factura futura",
            pastInvoices: "Facturas pasadas",
            creditCard: "Tarjeta de crédito",
            invoice: "Factura",
            mustBeUpgradePlanForChatBot: "Para activar la función de chatbot, ¡debe cambiar al plan profesional!",
            cardInfo: "Información de la tarjeta",
            billingDetails: "Detalles de facturación",
            addCardIyzico: "No tienes una tarjeta registrada. Para pagar sus tarifas de uso mensuales, debe agregar una tarjeta. El sistema de pago es proporcionado por Iyzico.",
            billingPlanSettings: "Factura",
            startWith: "La tarjeta {CardFamily} comienza con {binnumber}",
            paymentMethod: "Método de pago",
            billingDate: "Fecha de facturación",
            isPaid: "¿Está pagado?",
            markPaid: "Mark como pagado",
            paymentDate: "Fecha de pago",
            pay: "Pagar",
            newInvoice: "Crear factura",
            updateBilling: "Detalles de facturación de actualización",
            updateCard: "Cambiar tarjeta de crédito",
            paymentBilling: "Método de pago y detalles de facturación",
            price: "Precio",
            billingAddress: "Dirección de Envio",
            billingCity: "Ciudad",
            billingCountry: "País",
            contactName: "Nombre de contacto de facturación",
            expireMonth: "Mes expirar",
            expireYear: "Expirar año",
            expireDate: "Fecha de expiración",
            cardNumber: "Número de tarjeta",
            cardHolderName: "Nombre del titular de la tarjeta",
            cardAlias: "Alias ​​de tarjeta",
            identityNumber: "Número de identidad",
            name: "Nombre",
            surname: "Apellido",
            email: "Correo electrónico",
            addCard: "Agregar tarjeta",
            update: "Actualizar",
            cancel: "Cancelar",
            save: "Ahorrar",
            saving: "Ahorro",
            noInvoiceFound: "No hay factura",
            year: "Año",
            updating: "Actualización ...",
            newInvoiceForm: "Nuevo formulario de creación de factura",
            error: "Error",
            transactions: "Opción",
            paymentMethodAdded: "El método de pago ha agregado con éxito",
            paymentMethodAddError: "El método de pago no ha agregado, se produjo un error",
            creditCardChanged: "La tarjeta de crédito ha cambiado con éxito",
            errorOccurred: "Se produjo un error, intente nuevamente",
            billingDetailUpdated: "Los detalles de facturación se han actualizado con éxito",
            invoiceCreated: "La factura ha creado con éxito",
            paymentSuccess: "Pago con éxito, gracias",
            paymentFail: "Fallidad de pago, intente nuevamente",
            billingAddressChanged: "La dirección de facturación ha cambiado con éxito",
            hidePlan: "Ocultar",
            informationShopping: "Shopify controla su información de pago, información de facturación, información de la tarjeta de crédito.",
            trialTimeInformation: "La prueba termina {DayCount} días después. Si no ingresa un método de pago hasta el vencimiento de este período, el sistema cambiará automáticamente al plan gratuito.",
            trialTimeInformationShort: "Prueba: último día {DayCount}",
            currentPlanLabel: "Plan actual: {PlanName} ({AgentCount} agente)",
            changeCancelPlan: "Plan de cambio/cancelación",
            oneAgent: "Agente",
            agent: "Agente",
            yourCurrentPlan: "Plan actual",
            month: "Mes",
            billedMonthToMonth: "(facturado mes a mes)",
            selectAgentCount: "Seleccionar recuento de agentes",
            selectFreePlan: "Seleccione un plan gratis",
            planDetails: "Detalles del plan",
            multiAgent: "(Agente múltiple)",
            selectProPlan: "Seleccionar plan profesional",
            foreverFree: "Siempre libre",
            websiteIntegration: "Integración del sitio web",
            websiteIntegrationUnlimited: "Integración del sitio web",
            ChatBotUnlimited: "Chatbot",
            videoCallUnlimited: "Videollamada",
            multiAgentUpTo: "Agente multi (hasta {agentCount} agente)",
            audioCallUnlimited: "Llamado de audio",
            screenSharingUnlimited: "Compartir pantalla",
            fileTransferUnlimited: "Transferencia de archivos",
            autoChatAssignerUnlimited: "Asignador de chat automático",
            multiLanguageTranslationUnlimited: "Traducir automático",
            detailedReporting: "Informes",
            days30TrialsAvailable: "Pruebas de 30 días disponibles",
            limitedArchiveLookupLastMo: "Búsqueda de archivo limitado (último {monthCount} -mo)",
            fullCustomizationUnlimited: "Personalización",
            planUpdated: "Genial, su plan se actualiza.",
            planUpdating: "Tu plan está actualizando ...",
            planUpdatingDescription: "Espere durante la actualización de su plan",
            done: "Hecho",
            freePlanUpdated: "Su plan se actualizó como un plan gratuito. (Crédito del agente máximo: 1)",
            proPlanUpdated: "Su plan actualizado como un plan profesional. (Crédito del agente máximo: {agenteCount})",
            canNotDwnGrade: "No se puede degradar su plan de Pro {agentCountFirst} agente (s) a {valNewPlnToUppr} {agentCountSecond}. Su agente acredita en uso.",
            deleteWarning: "Debe eliminar o deshabilitar {valDif} agente (s)",
            warnMessage: "El plan seleccionado debe ser diferente al plan actual",
            add: "Agregar",
            cancelYourPlan: "Cancele su plan",
            upgradeYourPlan: "Actualiza tu plan",
            downgradeYourPlan: "Degradar su plan",
            agree: "ACEPTAR",
            disagree: "DISCREPAR",
            invoices: "Facturas",
            priceIntervals: "Intervalo de precio",
            selectSiteAlias: "Seleccione o ingrese el nombre del sitio",
            selectPriceInterval: "Seleccione o ingrese el intervalo de precio",
            isRefunded: "¿Se reembolsa?",
            invoiceId: "Factura no",
            siteId: "Sitio no",
            createdDate: "Fecha de creación",
            failCount: "Número de intentos de búsqueda de pago fallidos",
            failDate: "Fecha de pago fallida",
            Dashboard: "Panel",
            Agents: "Agentes",
            Integration: "Integración",
            Settings: "Ajustes",
            Contacts: "Contactos",
            Domain: "Dominio",
            lastActivity: "Última actividad",
            basePrice: "Precio base",
            packagePrice: "Precio del paquete",
            whatsappPrice: "Precio de whatsapp",
            realtimeVisitorCount: "Visitante en tiempo real",
            suspend: "Suspender",
            partner: "Pareja",
            plan: "Plan",
            trialDay: "Días de prueba",
            mobile: "Móvil",
            webSite: "Sitio web",
            websiteOrigins: "Origen del sitio web",
            ownerName: "Nombre del dueño",
            ownerEmailAddress: "Correo electrónico del propietario",
            discount: "Descuento",
            daysLeft: "Días restantes",
            newTrialPopUp: "¿Cuántos días debería ser el nuevo período de prueba?",
            newWpPricePopUp: "¿Cuánto cuesta la nueva tarifa de WhatsApp?",
            newIGPricePopUp: "¿Cuánto cuesta la nueva tarifa de Instagram?",
            newBasePricePopUp: "¿Cuánto cuesta el nuevo precio base?",
            siteInfoUpdated: "Información del sitio actualizada",
            siteInfoNotUpdated: "Información del sitio no actualizada",
            siteInfoNotUpdatedErr: "¡Ocurrió un error! Información del sitio no actualizada.",
            depositMoneyWallet: "Ingresar dinero en la billetera",
            couponError: "El código del cupón es incorrecto o ha caducado.",
            paidSuccessfully: "Factura pagada correctamente.",
            areYouSureRefundInvoice: "¿Está seguro de que desea procesar un reembolso para esta factura?",
            plans: "Planes",
            company: "Empresa",
            incorrect: "Incorrecto",
            firstPreferredCard: "Establecer como tarjeta principal",
            primary: "Principal",
            billingHistory: "Historial de facturas",
            cuponApplied: "Cupón aplicado correctamente",
            deleteYourWhatsApp: "Elimine su canal de WhatsApp Business o compre un canal.",
            packageCanotDownSupsis: "Su paquete no se puede degradar. Elimine o desactive varios de sus agentes para bajar de categoría su paquete.",
            packageCanotDownWPBussiness: "Su paquete no se puede degradar. Elimine varios de sus canales de WhatsApp Business para bajar el estado de su paquete.",
            packageCanotDownWp: "Su paquete no se puede degradar. Elimine varios de sus canales de WhatsApp para bajar de categoría su paquete.",
            sito: "Sitio",
            yearDiscount: "Descuento anual",
            youHaveAWhatsAppBusiness: "Tiene un canal de WhatsApp Business.",
            youHaveOneWhatsAppQRChannel: "Tiene un canal de WhatsApp QR."
        },
        tour: {
            closeChat: "Chat cerrado",
            ticket: "Boleto",
            formStep: "Paso de formulario",
            menuStep: "Paso de menú",
            contentStep: "Paso de contenido",
            menuTitle: "Título de menú",
            messageContent: "Contenido del mensaje",
            goToLive: "Conectar representante",
            stats: "Panel de estadísticas",
            settings: "AJUSTES",
            status: "ESTADO",
            prevStep: "Paso anterior",
            nextStep: "Próximo paso",
            finish: "Finalizar",
            skip: "Saltar",
            skip2: "Omitir, conozco el sistema",
            startTour: "Empezar recorrido",
            firstTimeIntro: "Está ingresando al sistema por primera vez, quiero presentar la aplicación si lo permite",
            hi: "Hola",
            welcomeTo: "Bienvenido al soporte en vivo de Supsis",
            statsPanel: "Es la barra de estado que muestra los números de chat totales y activos que esperan instantáneamente con el sistema.",
            sidebarMenu: "MENÚ",
            sidebarMenuContent: "Puede cambiar entre páginas aquí.",
            representativePrivateMessage: "Panel de conversación entre representantes",
            representativePrivateMessageContent: "Puede ver conversaciones privadas entre agentes aquí.",
            helpMenu: "MENÚ DE AYUDA",
            helpMenuContent: "Puede encontrar información de ayuda sobre el sistema aquí.",
            settingsMenu: "Menú Configuración",
            settingsMenuContent: "Puede hacer el idioma, el modo nocturno y los pasos de aumento de pantalla aquí.",
            startChat: "Comenzar chat",
            profileMenu: "Menú de perfil",
            profileMenuContent: "Puede cambiar su disponibilidad y establecer la configuración de su agente aquí.",
            visitorsTab: "Visitantes",
            visitorsTabContent: "Puedes ver visitantes aquí.",
            visitorTabHistory: "Historial de visitantes",
            visitorTabHistoryContent: "Puedes ver el historial de visitantes aquí.",
            representativeTab: "Representantes",
            representativeTabContent: "Puedes ver a los representantes aquí.",
            liveSupport: "Soporte vital",
            liveSupportContent: "Puede ver el número de clientes que reciben soporte en vivo aquí.",
            siteVisitors: "Visitantes del sitio",
            siteVisitorsContent: "Puede ver el número de visitantes del sitio aquí.",
            tableSettings: "Configuración de tabla",
            tableSettingsContent: "Puede mostrar u ocultar columnas en la tabla aquí.",
            watchModeButton: "Botón Visador",
            watchModeContent: "Puede unirse aquí como modo de visor y solo puede ver lo que se publica.",
            popoverInfo: "Detalles del visitante",
            popoverInfoContent: "Proporciona información sobre el visitante.",
            popoverButton: "Configuración de chat avanzada",
            popoverButtonContent: "Puede abrir la conversación, enviar un mensaje directamente al representante o bloquear el visitante.",
            openChat: "Unir el botón de conversación",
            openChatContent: "Puedes abrir la conversación aquí",
            pagination: "Menú de paginación.",
            paginationContent: "Puede aumentar el número de páginas aquí.",
            changeLang: "Puede cambiar el lenguaje del sistema",
            changeTheme: "Puede cambiar el tema oscuro y ligero",
            changeStatus: "Puede cambiar su estado de disponibilidad",
            logout: "¿Puede el sistema de inicio de sesión desde aquí?",
            chatwindow: {
                chatWindowActionButtons: "Botones de acción de la ventana de chat",
                chatPanelActions: "Acciones del panel de chat",
                otherPanels: "Otros paneles",
                chatColorButton: "Mostrar el significado de los colores del bar de chat",
                keyboardShortcutButton: "Mostrar funciones de accesos directos de Keybpard",
                hideButton: "Minimizar el chat actual sin salir",
                closeButton: "Fuerza cerrar y salir del chat actual",
                ellipsisButton: "Más acciones de chat. Minimizar, cerrar, prohibir el visitante, enviar mensajes privados, asignar representante",
                userInfoWidget: "Mostrar detalle del visitante del propietario del usuario de chat actual",
                preparedContentWidget: "Widget de plantillas de mensajes preparados, puede seleccionar insertar rápidamente una plantilla de mensaje en el chat actual",
                chatHistoryWidget: "Si hay algún historial de chat del visitante actual, puede verlos",
                chatWindowSettingsButtons: "Botón de configuración de la ventana de conversación",
                settingsButton: "Puede bloquear la conversación, avanzar, mensaje confidencial y asignar delegados.",
                chatBarButton: "Aquí puede bloquear la conversación activa, enviar un mensaje privado al agente y dejar la conversación."
            },
            chats: "Panel de chat",
            representativ_eTab: "Representantes",
            selectColumnsToDisplay: "Seleccionar columnas a mostrar",
            selectAll: "Seleccionar todo",
            deselectAll: "Deseleccionar todo",
            resetToDefault: "Restablecer valores por defecto",
            settingsSaved: "Configuración guardada"
        },
        adminUser: {
            newAdminUserForm: "Nuevo formulario de registro de usuario de administrador",
            updateAdminUserForm: "Formulario de actualización del usuario de administrador",
            adminUsers: "Usuarios administrativos",
            newAdminUser: "Nuevo usuario administrativo",
            noAdminUser: "Todavía no hay usuarios administrativos",
            adminUserName: "Nombre de usuario administrativo"
        },
        report: {
            channel: "Canal",
            channelType: "Tipo de canal",
            contactCount: "Número de contactos",
            tag: "Etiqueta",
            owner: "Propietario",
            email: "Correo electrónico",
            language: "Idioma",
            approvalCount: "Número de aprobaciones",
            adTitle: "Título del anuncio",
            sourceType: "Tipo de fuente",
            contactDistributions: "Distribuciones de contactos",
            mostUsedTag: "Etiqueta más utilizada",
            leastUsedTag: "Etiqueta menos utilizada",
            timeDistribution: "Distribución de contactos por tiempo",
            channelDistribution: "Distribución de contactos por canal",
            tagDistribution: "Distribución de contactos por etiquetas",
            platformDistribution: "Distribución de contactos por plataforma",
            ownerDistribution: "Distribución de contactos por propietario",
            languageDistribution: "Distribución de contactos por idioma",
            adsDistribution: "Distribución de contactos por anuncios",
            contactPropertyDistribution: "Distribución de contactos por propiedades de contacto",
            totalPersonCount: "Número total de contactos",
            averagePersonCount: "Promedio de contactos",
            personCount: "Número de contactos",
            person: "Contacto",
            mostEffectiveAd: "Anuncio más efectivo",
            leastEffectiveAd: "Anuncio menos efectivo",
            mostUsedChannel: "Canal más utilizado",
            leastUsedChannel: "Canal menos utilizado",
            columnChart: "Gráfico de columnas",
            pieChart: "Gráfico circular",
            mostUsed: "Más utilizado",
            leastUsed: "Menos utilizado",
            mostUsedLanguage: "Idioma más utilizado",
            leastUsedLanguage: "Idioma menos utilizado",
            mostAssigned: "Más asignado",
            leastAssigned: "Menos asignado",
            mostUsedPlatform: "Plataforma más utilizada",
            leastUsedPlatform: "Plataforma menos utilizada",
            commentAnalysis: "Análisis de comentarios",
            whatsappChannelDistribution: "Distribución de chats por canales de WhatsApp",
            instagramChannelDistribution: "Distribución de chats por canales de Instagram",
            messengerChannelDistribution: "Distribución de chats por canales de Messenger",
            trendyolChannelDistribution: "Distribución de chats por canales de Trendyol",
            metaLeadsChannelDistribution: "Distribución de chats por canales de Meta Leads",
            chatDistributionByTelegramChannels: "Distribución de chats por canales de Telegram",
            chatDistributionByLinkedinChannels: "Distribución de chats por canales de Linkedin",
            channelTimeseries: "Línea de tiempo de canales",
            channelPies2: "Distribución de canales",
            date: "Fecha",
            incomingMessages: "Mensajes entrantes",
            outgoingMessages: "Mensajes salientes",
            customerCount: "Recuento de clientes",
            mailCount: "Recuento de correo",
            answered: "Respuesta",
            unanswered: "Sin respuesta",
            selectaChannel: "seleccionar un canal",
            sentMails: "Correos enviados",
            sentMailCount: "Número de correos enviados",
            eventCount: "Número de actos",
            ticketDistribution: "Distribución de entradas",
            selectWorkflow: "Seleccione su flujo de trabajo",
            distributionOfTasks: "Distribución de tareas",
            mostMissioned: "Mayor número de misiones",
            leastTask: "Menos tareas",
            totalNumberTasks: "Número total de tareas",
            errorFetchingTask: "Error al recibir datos de la tarea:",
            pipelinePhase: "Fase del pipeline",
            status: "Estado",
            numberOfTasks: "Número de tareas",
            insufficientData: "Datos insuficientes",
            hourly: "(Por hora)",
            hourlyAverage: "Promedio por hora",
            hourlyMax: "Máximo por hora",
            hourlyMin: "Mínimo por hora",
            totalAmount: "Monto Total",
            averageAmount: "Monto Promedio",
            minAmount: "Monto Mínimo",
            maxAmount: "Monto Máximo",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Series temporales de canales",
            channelPies: "Tartas de canal",
            pieView: "Gráfico circular",
            topVisitorCountry: "País con más visitantes",
            websiteTrafficByCountry: "Tráfico del sitio web por país",
            visitorCount: "Número de visitantes",
            websiteVisitorTraffic: "Tráfico de visitantes del sitio web",
            websiteTraffic: "Tráfico del sitio web",
            author: "Autor",
            topWorstComments: "Peores comentarios",
            topBestComments: "Mejores comentarios",
            topComments: "Comentarios principales",
            noComment: "Aún no hay comentarios",
            minWaitingTime: "Tiempo de espera mínimo",
            maxWaitingTime: "Tiempo de espera máximo",
            averageWaitTime: "Tiempo de espera promedio",
            waitTime: "Tiempo de espera (segundos)",
            agentWaitDurationTitle: "Gráfico de duración de espera del agente",
            incomingMessage: "Mensaje(s) entrante(s)",
            outgoingMessage: "Mensaje(s) saliente(s)",
            totalSpent: "Gasto total",
            avgSpent: "Gasto promedio",
            totalPayment: "Pago total",
            walletStatus: "Estado del monedero",
            walletBalanceStatus: "Estado del saldo del monedero",
            messageTraffic: "Tráfico de mensajes",
            breakCount: "Recuento de descansos",
            agentBreakTime: "Recuentos de descanso del agente ☕",
            agentStatusHour: "Hora del estado del agente",
            agentWorkTimeCalendar: "Calendario de tiempo de trabajo del agente",
            agentActivity: "Actividad del agente",
            noEnoughtData: "Datos insuficientes",
            averageFirstResponse: "Tiempo promedio de primera respuesta",
            slowestResponser: "Más lento en responder",
            fastestResponder: "Más rápido en responder",
            firstAnswerTimeSec: "Tiempo del primer mensaje (en segundos)",
            firstAnswerByAgent: "Tiempo del primer mensaje por el agente",
            averageSolutionTime: "Tiempo promedio de solución",
            slowestSolver: "Resolutor más lento",
            fastestSolver: "Resolutor más rápido",
            averageChat: "Chat promedio",
            leastChatReceiver: "Receptor de chat menos activo",
            mostChatRecipients: "La mayoría de los destinatarios de chat",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Tiempo de resolución (min)",
            resolveTimeByUser: "Tiempo de resolución de chat por usuario (en minutos)",
            chatResolveTimeByAgent: "Tiempo de resolución de chat por agentes",
            chatDistByHandleType: "Distribución de chats por manejador",
            chatDistByHandDesc: "¿Cuántos chats fueron manejados por agentes, chatbots y híbridos?",
            chatCountsByHandleType: "Cantidad de chats por tipo de manejo",
            missed: "Perdido",
            chatDistByAnsDesc: "¿Cuántos chats fueron respondidos o perdidos?",
            chatCountsByAns: "Recuento de chats por respuesta",
            chatCountByPlatform: "Recuento de chats por plataforma",
            chatDistByPDesc: "¿Cuántos chats llegaron a cada plataforma?",
            chatDistByPlatform: "Distribución de chats por plataforma",
            ticketCountByUser: "Recuento de entradas por agentes",
            ticketCountByStatus: "Recuento de entradas por estado de respuesta",
            user: "Usuario",
            saveAsImage: "Guardar como imagen",
            fullScreen: "Pantalla completa",
            download: "Descargar",
            tableView: "Vista de tabla",
            chartView: "Vista de gráfico",
            chatDistByUsers: "Distribución de chats por usuarios",
            chatCountsByUsers: "Recuento de chats por usuarios",
            minDuration: "Duración mínima",
            maxDuration: "Duración máxima",
            totalDurationByAgent: "Duración total de la sesión por agente",
            averageDurationByAgent: "Duración promedio de la sesión por agente",
            totalDurationByCB: "Duración total de la sesión por chatbot",
            averageDurationByCB: "Duración promedio de la sesión por chatbot",
            viewUnitAs: "Ver unidad como",
            hybrid: "Híbrido",
            handledBy: "Manejado por",
            sessionDurationOverall: "Duración total de la sesión",
            allChannels: "Todos los Canales",
            sessionsDurationOverall: "Duración total de las sesiones",
            sessionsOverall: "Sesiones totales",
            calendarEvents: "Eventos de calendario",
            reservationEvents: "Eventos de reserva",
            incomingMails: "Correos entrantes",
            incomingMailCount: "Conteo de correos entrantes",
            reservation: "Reserva",
            event: "Evento",
            reservationEventCount: "Conteo de eventos de reserva",
            channelBreakdown: "Desglose de canales",
            websiteAnalysis: "Análisis del sitio web",
            customerSatisfaction: "Satisfacción del cliente",
            teamBreakAnalysis: "Análisis de pausas del equipo",
            dailyAgentActivity: "Actividad diaria del agente",
            agentPerformance: "Rendimiento del agente",
            chatDistributions: "Distribución de chats",
            users: "Usuarios",
            segmentTimeseries: "Serie temporal del segmento",
            segmentsOverall: "Segmentos en General",
            unmatchRatio: "Proporción de no coincidencia",
            totalMatchCount: "Número total de coincidencias",
            totalUnmatchCount: "Número total de no coincidencias",
            matchRatio: "Proporción de coincidencia",
            matched: "Coincidente",
            trainingOverall: "Entrenamiento General",
            trainingStatusTimeseries: "Serie temporal del estado de entrenamiento",
            duration: "Duración",
            totalSessionDuration: "Duración total de la sesión",
            averageSessionDuration: "Duración promedio de la sesión",
            second: "segundo",
            minute: "minuto",
            hour: "hora",
            aggregateAs: "Agregar como",
            chatbotSessionDurationOverall: "Duración total de la sesión del chatbot",
            ratingTimeSeries: "Serie temporal de calificaciones",
            chatCountTimeseries: "Serie temporal del número de chats",
            notRated: "No calificado",
            totalRatingCount: "Cantidad total de calificaciones",
            averageRating: "Calificación promedio",
            weightedAverageRating: "Calificación promedio ponderada",
            rate: "Calificar",
            ratingOverall: "Valoraciones generales de los clientes",
            session: "Sesión",
            total: "Total",
            average: "Promedio",
            max: "Máximo",
            min: "Mínimo",
            sessionCount: "Conteo de sesiones",
            uniqueUsers: "Usuarios Únicos",
            viewAs: "Ver como:",
            overall: "En General",
            detailReport: "Reporte detallado",
            dailyReports: "Reportes diarios",
            pointBasedReports: "Informes basados ​​en puntos",
            personDateBasedPointReport: "Informe de punto basado en la persona y la fecha",
            personDateBasedReport: "Informe basado en la persona y la fecha",
            personBasedReport: "Informes basados ​​en la persona",
            personAndDateBasedGraph: "Gráfico basado en la persona y la fecha",
            noReport: "Sin informe",
            reports: "Informes",
            totalBar: "Total",
            ticketCount: "Ticket Count",
            adNameDistribution: "Contact Distribution by Ad Name",
            adsetDistribution: "Contact Distribution by Ad Set Name",
            campaignDistribution: "Contact Distribution by Campaign Name",
            selectChannel: "Bir Kanal Seçin",
            leastTasked: "Least Tasked",
            dailyAverage: "Günlük Ortalama",
            dailyMax: "Günlük Maksimum",
            dalyMin: "Günlük Minimum",
            topBestWorstComments: "En İyi/Kötü Yorumlar",
            erorFetchingTask: "خطأ في تلقي بيانات المهمة:"
        },
        stats: {
            total: "Número de todos los chats abiertos",
            active: "Número de chats activos asignados para usted",
            waiting: "Número de visitantes que esperan que ingrese un representante",
            late: "Número de visitantes que esperan más de un cierto período",
            free: "Número de visitantes gratuitos que esperan que el nuevo representante ingrese",
            pco: "[Tasa de utilización de capacidad] Tasa de trabajo Carga de capacidad de chat representativa activa",
            maxCapacity: "Número máximo de chat que el sistema puede asignar representantes sin esperar",
            chatbot: "Número de chat activo con chatbot"
        },
        time: {
            lastYear: "El Año Pasado",
            thisYear: "Este Año",
            last3Months: "Últimos 3 Meses",
            last7: "Últimos 7 Días",
            today: "Hoy",
            yesterday: "Ayer",
            lastWeek: "La semana pasada",
            currentWeek: "Esta semana",
            currentMonth: "Este mes",
            lastMonth: "El mes pasado",
            last30Day: "Últimos 30 días",
            allTime: "Todo el tiempo",
            custom: "Fecha personalizada"
        },
        fastWizard: {
            generalColors: "Colores generales",
            tellUsMore: "Cuéntanos más, para que podamos personalizar tu experiencia",
            moreInfo: "Más información",
            display: "Mostrar",
            availability: "Disponibilidad",
            preview: "Avance",
            installCode: "Código de instalación",
            previous: "Anterior",
            setupSupsisLiveChat: "Configurar chat en vivo de supsis",
            continue: "Próximo paso",
            completeInitialize: "Configuración completa",
            completedMessage: "Configuración de chat en vivo de Supsis completada con éxito.",
            websiteIntegration: "La dirección de su sitio web para integrar el chat en vivo de supsis",
            customizeLiveChat: "Personaliza tu chat en vivo",
            createBrandedExperience: "Cree una experiencia de chat de marca para sus visitantes.",
            chatColor: "Color de chat",
            chooseChatColor: "Elija un color de acento.",
            chatBubble: "Burbuja de chat",
            selectBubble: "Seleccione una burbuja de chat",
            chatBubbleColor: "Color de burbujas de chat",
            selectChatBubbleColor: "Seleccione un color de burbuja de chat",
            customSelection: "La selección personalizada:",
            chatAvailability: "Disponibilidad de chat",
            onlineSupportVisitorTime: "¿Cuándo está en línea para apoyar a sus visitantes?",
            channelAvailability: "Disponibilidad de canales",
            availability724: "El chat está disponible 7/24",
            basedOnTeam: "Basado en el estado del miembro del equipo",
            basedOnTeamExplanation: "El chat aparecerá en línea cuando al menos 1 miembro esté disponible en",
            customHours: "Horario comercial personalizado",
            customHoursExplanation: "Configure su horario hábil",
            customHoursTimezone: "Zona horaria:",
            customHoursFrom: "De:",
            customHoursTo: "A:",
            customHoursAddHours: "+Agregar horas",
            previewDesktop: "Escritorio",
            previewIpad: "Ipad",
            installationAndInstructions: "Instrucciones de instalación",
            installationTrackingCode: "Instale el código de seguimiento en su sitio web",
            installationTrackingCodePlease: "Pegue el código de acuerdo con las instrucciones a continuación, justo antes del final de la etiqueta {bodyTag} en cualquier página donde desee habilitar el chat en vivo de Supsis.",
            installationInstructionsJavascript: "Pegue el código de integración dado anteriormente en la etiqueta {bodyTag} justo antes del cierre.",
            installationInstructionsCopy: "Copiar",
            installationInstructionsCoppyMessage: "Script de integración copiado en portapapeles",
            installationInstructionsShopify1: "1. Inicie sesión en su panel de Shopify",
            installationInstructionsShopify2: "2. Vaya a la tienda en línea> Temas> Menú desplegable Acciones en el tema actual> Editar código> teme.liquid",
            installationInstructionsShopify3: "3. Coloque Peque el código de integración dado anteriormente justo antes de la etiqueta {bodyTag} al final del script teme.liquid.",
            installationInstructionsIdeaSoft1: "1. Inicie sesión en el panel de su distribuidor.",
            installationInstructionsIdeaSoft2: "2. Vaya a Configuración -> SEO -> Servicios de motor de búsqueda.",
            installationInstructionsIdeaSoft3: "3. Seleccione \"Verificación del sitio con metaetiqueta\" de la sección Código de seguimiento.",
            installationInstructionsIdeaSoft4: "4. Copie y pegue el código de integración anterior en el cuadro abierto y guarde.",
            installationInstructionsIdeaSoft5: "5. Configuración interna -> Optimizaciones Haga clic en el botón \"Borrar caché\". Así se completa la integración.",
            installationInstructionsWordPress1: "1. Inicie sesión en su panel de administración de WordPress",
            installationInstructionsWordPress2: "2. Vaya a la aparición> Editor de temas",
            installationInstructionsWordPress3: "3. En archivos de temas (extrema derecha), busque el pie de página del tema (footer.php) y seleccione",
            installationInstructionsWordPress4: "4. Paste el código de integración anterior antes de la etiqueta {bodyTag} en la parte inferior.",
            installationInstructionsWordPress5: "5. Haga clic en Actualizar el archivo para guardar cambios",
            installationInstructionsOpenCart1: "1. Inicie sesión en su panel de administración de OpenCart",
            installationInstructionsOpenCart2: "2. Ir al diseño> Editor de temas",
            installationInstructionsOpenCart3: "3. Seleccione la carpeta 'común' y abra 'Header.twig' archivo.",
            installationInstructionsOpenCart4: "4. Paste el código de integración anterior antes de la etiqueta {headTag} en la parte inferior.",
            installationInstructionsOpenCart5: "5. Haga clic en el botón Guardar.",
            installationInstructionsTicimax1: "1. Inicie sesión en su panel de administración de Ticimax",
            installationInstructionsTicimax2: "2. Abierto de diseño> Diseño> Configuración de diseño de pie de página de encabezado",
            installationInstructionsTicimax3: "3. Haga clic en el botón 'Fuente' en la sección de diseño del logotipo.",
            installationInstructionsTicimax4: "4. Pegue el código de integración arriba debajo del código HTML.",
            installationInstructionsEticaretteyim1: "1. Accede al panel de administración de tu ecommerce",
            installationInstructionsEticaretteyim2: "2. Simplemente nombre SUPSIS desde Complementos> Generar HTML> y copie el código.",
            installationInstructions: "Instrucciones",
            installationVerify: "Verifique la instalación de su sitio web de supsis",
            installationVerifyChecking: "Comprobación",
            installationVerifyCheck: "Controlar",
            installationVerifyCheckingStatus: "Verificación del estado de integración de supsis en {website}",
            installationCheckingStatusMessageYes: "¡Genial, el supsis está integrado en el sitio web {website}!",
            installationCheckingStatusMessageNo: "SUPSIS no está actualmente integrado con el sitio web {website}. Puede completar su proceso de integración ahora o más tarde.",
            vtippyPreferredLanguage: "Idioma preferido"
        },
        akinon: {
            typeOrSelectSKU: "Escriba o seleccione SKU",
            akinonUserId: "ID de usuario de Akinon",
            userEmail: "Correo electrónico de usuario",
            userEmailDesc: "Escriba o seleccione el correo electrónico del usuario ...",
            send: "Enviar",
            selectCity: "Ciudad selecta",
            city: "Ciudad",
            selectState: "Seleccione estado",
            state: "Estado",
            useMap: "Usar mapa",
            chooseAddress: "Elegir dirección",
            selectCountry: "Seleccionar país",
            country: "País",
            productIdDesc: "Escriba o seleccione producto ...",
            productId: "ID del Producto",
            userIdDesc: "Escriba la identificación de usuario de Akinon ...",
            productSKU: "Sku de productos",
            latitudeDesc: "Escriba o seleccione Latitud de ubicación objetivo ...",
            longitudeDesc: "Escriba o seleccione la longitud de ubicación de destino ...",
            orderNumber: "Su número de orden",
            orderDesc: "Escriba el número de pedido ...",
            longitude: "Longitud",
            latitude: "Latitud"
        },
        headBar: {
            source: "Fuente",
            label: "Etiqueta",
            completed: "¿Terminado?",
            email: "Correo electrónico",
            phone: "Teléfono",
            name: "Nombre",
            date: "Historia",
            subject: "Sujeto",
            situation: "Situación",
            representative: "Representante",
            transactions: "Actas",
            channel: "Canal de contacto",
            Email: "E-mail"
        },
        login: {
            loginTitle1: "Bienvenido a",
            loginTitle2: "Supsis AI",
            email: "Tu dirección de correo electrónico",
            emailPlaceholder: "Por favor, introduzca su dirección de correo electrónico.",
            emailError: "Por favor introduzca un correo electrónico válido",
            password: "Tu contraseña",
            passwordLogin: "Iniciar sesión sin contraseña",
            passwordAndLogin: "Iniciar sesión con contraseña",
            passwordNew: "Restablecer mi contraseña",
            loginAnd: "O",
            passwordPlaceholder: "Por favor, introduzca su contraseña.",
            loginMemory: "Recuerde este dispositivo",
            passwordForget: "Olvidé mi contraseña",
            passwordNewAgain: "Nueva contraseña",
            passwordNewAgainTwo: "Repetir nueva contraseña",
            passwordNewAgainPlaceholder: "Por favor ingrese su nueva contraseña.",
            passwordNewAgainPlaceholderTwo: "Vuelva a introducir su nueva contraseña.",
            login: "Acceso",
            loginFooter: "O inicie sesión con correo electrónico",
            emailLogin: "Iniciar sesión con correo electrónico",
            welcomeTitle: "Bienvenido",
            welcomeMorning: "Buenos días",
            welcomeAfternoon: "Buenas tardes",
            welcomeEvening: "Buenas tardes",
            welcomeNight: "Buenas noches"
        },
        settings: {
            ipWhitelist: "Lista de acceso IP",
            loadMore: "Cargar más...",
            detectIpAddress: "Detectar Mi Dirección IP",
            addWighteListAddress: "Agregar dirección IP a la lista blanca",
            accessControlSubTitles: "El Control de Acceso proporciona una capa de seguridad adicional que permite que solo las IP autorizadas accedan al sistema.",
            companyInformation: "Información de la empresa",
            ipAddress: "Mi dirección IP",
            whiteList: "Lista IP segura",
            whiteListAdd: "Añadir IP segura",
            whiteListDeletedSuccessfully: "Lista blanca eliminada correctamente",
            whiteListDeletedFailed: "Lista blanca no eliminada",
            whiteListAddedSuccessfully: "Lista blanca agregada correctamente",
            whiteListAddedFailed: "Lista blanca no agregada",
            deleteWhiteListTitle: "¿Estás seguro de que quieres eliminar esta lista blanca?",
            talkSettings: "Ajustes de voz",
            talkSubtitles: "Gestiona tu configuración de voz",
            changeSettings: "Cambiar la configuración de la asignación automática de chat",
            dateAndTime: "Fecha y hora",
            actor: "Actor",
            event: "Evento",
            accessControl: "Control de acceso",
            rulesGroup: "Reglas",
            organizationLongName: "Nombre largo de la organización",
            visitorNewDesc: "Puede utilizar la nueva versión del tema del visitante",
            transactionType: "Tipo de transacción",
            priorBalance: "Saldo anterior",
            nextBalance: "Saldo siguiente",
            amount: "Importe",
            phoneNumber: "Número de teléfono",
            profileInfoRemoved: "Información de perfil eliminada",
            newValueUpdated: "Nuevo valor actualizado",
            ballanceToTransferred: "Saldo a transferir",
            availableBalance: "Saldo disponible",
            balanceReceived: "Saldo recibido",
            totalBalance: "Saldo total",
            paymentCard: "Tarjeta de pago",
            wpPhoneNumber: "Número de teléfono de Whatsapp",
            wpSendingMessage: "Whatsapp Enviando Primer Mensaje",
            auditlogs: "Registros de auditoría",
            myaccount: "Mi cuenta",
            notifications: "Notificaciones",
            company: "Empresa",
            features: "Caracteristicas",
            general: "General",
            chat: "Charla",
            timings: "Horarios",
            wallet: "cartera",
            language: "Idioma",
            "bubble-settings": "Configuración de la burbuja",
            "bubble-actions": "Acciones de burbujas",
            "theme-settings": "Configuración del tema",
            visitorLoginForm: "Formulario de inicio de sesión de visitantes",
            visitorAttribute: "Información del perfil del visitante",
            timing_settings: "Configuración de tiempo",
            auto_assign: "Auto Assign",
            availability: "Disponibilidad",
            "website-integration": "Integración del sitio web",
            General: "General",
            Chat: "Charla",
            Timings: "Horarios",
            Integration: "Integración",
            developer: "Desarrollador",
            visitorNew: "Visitante nuevo",
            companySubtitles: "Gestionar la información de su empresa.",
            featuresSubtitles: "Gestionar las características de su empresa.",
            languageSubtitles: "Establezca el idioma y la zona horaria preferidos para su empresa.",
            bubbleSettings: "Configuración de la burbuja",
            bubbleSettingsSubtitles: "Gestionar la configuración de la burbuja de su empresa.",
            bubbleActionsSubtitles: "Gestionar las acciones de la burbuja de su empresa.",
            chatThemeSettingsSubtitles: "Gestionar la configuración del tema de chat de su empresa.",
            visitorLoginFormSubtitles: "Gestionar la configuración del formulario de inicio de sesión de visitantes de su empresa.",
            chatTimingSettingsSubtitles: "Gestionar la configuración de tiempo de chat de su empresa.",
            webSiteIntegrationSubtitles: "Gestionar la integración de su sitio web de empresa.",
            apiAccessTitle: "Acceso API",
            apiAccessSubtitles: "Gestionar el acceso a la API de su empresa.",
            youTubeActionForm: "Agregue su canal de YouTube",
            linkedinActionForm: "Agrega tu cuenta de LinkedIn",
            telegramActionForm: "Agregar cuenta de Telegram",
            facebookActionForm: "Agregue su página de Facebook",
            tiwitterActionForm: "Agregue su página de Twitter",
            instagramActionForm: "Agregue su página de Instagram",
            liveSupportDescription: "Müşterilerinizle canlı bir sohbet açın",
            ticketDescription: "Crea un ticket de soporte con tus clientes",
            whatsappDescription: "Deje que sus clientes se comuniquen con usted a través de Whatsapp",
            phoneDescription: "Deje que sus clientes se comuniquen con usted por teléfono",
            emailDescription: "Deje que sus clientes se comuniquen con usted por correo electrónico",
            facebookDescription: "Deje que sus clientes se comuniquen con usted a través de Facebook",
            twitterDescription: "Deje que sus clientes se comuniquen con usted a través de Twitter",
            instagramDescription: "Deje que sus clientes se comuniquen con usted a través de Instagram",
            youtubeDescription: "Deje que sus clientes se comuniquen con usted a través de Youtube",
            linkedinDescription: "Deja que tus clientes te contacten con LinkedIn",
            telegramDescription: "Deje que sus clientes alcancen el tamaño con Telegram",
            whatsappModalTitle: "Formulario de acción de Whatsapp",
            whatsappModalDescription: "Para agregar su cuenta de Whatsapp, complete el siguiente formulario.",
            phoneModalTitle: "Formulario de acción telefónica",
            phoneModalDescription: "Para agregar su cuenta telefónica, complete el siguiente formulario.",
            emailModalTitle: "Formulario de acción de correo electrónico",
            emailModalDescription: "Para agregar su cuenta de correo electrónico, complete el siguiente formulario.",
            facebookModalTitle: "Formulario de acción de Facebook",
            facebookModalDescription: "Para agregar su cuenta de Facebook, complete el siguiente formulario.",
            twitterModalTitle: "Formulario de acción de Twitter",
            twitterModalDescription: "Para agregar su cuenta de Twitter, complete el siguiente formulario.",
            instagramModalTitle: "Formulario de acción de Instagram",
            instagramModalDescription: "Para agregar su cuenta de Instagram, complete el siguiente formulario.",
            youtubeModalTitle: "Formulario de acción de Youtube",
            youtubeModalDescription: "Para agregar su cuenta de Youtube, complete el siguiente formulario.",
            linkedinModalTitle: "Formulario de transacción de LinkeIn",
            linkedinModalDescription: "Complete el siguiente formulario para vincular su cuenta de LinkedIn.",
            telegramModalTitle: "Formulario de transacción de Telegram",
            telegramModalDescription: "Ingrese el enlace de su perfil de Telegram en el siguiente formulario para vincular su cuenta de Telegram",
            instagramAlertTitle: "Se requiere integración de Instagram",
            instagramAlertDesc: "Lo siento, la página que visitaste se activará cuando integres tu Instagram.",
            instagramActivateText: "Vamos, integra Instagram",
            remove: "Eliminar",
            edit: "Editar",
            connected: "Conectado",
            add: "Añadir",
            themeDescription: "Gestionar la configuración del tema de chat de su empresa.",
            fontDescription: "Gestionar la configuración de fuente de chat de su empresa.",
            isFabsAsIcon: "Mostrar textos de iconos de menú.",
            chatBubbleTextSetting: "Configuración de texto de burbujas de chat",
            textOnChatBubble: "Puede ajustar la configuración de texto que aparecerá en la burbuja de chat.",
            textToAppearOnChatBubble: "Texto para aparecer en la burbuja de chat",
            newVisitorProfileInformation: "Información del perfil del nuevo visitante",
            newVisitorProfileInformationDescription: "Agregar nuevo valor a la información del perfil del visitante",
            create: "Crear",
            newAdd: "Agregar nuevo",
            toInform: "Para informar",
            toInformDescription: "Puede hacer coincidir los valores que agrega en esta página con el formulario de inicio de sesión del visitante.",
            showVisitor: "Mostrar visitante",
            label: "Boleto",
            text: "Escribiendo",
            email: "Correo electrónico",
            phone: "Teléfono",
            number: "Número",
            url: "URL",
            date: "Tiempo",
            dropdown: "seleccionable",
            languageTimeZone: "Langue et région",
            timeZoneTitle: "Région et fuseau horaire",
            timeZoneDescription: "Configuración de región y zona horaria",
            integration: "Entegrasyon",
            emailTitle: "E-Posta Adresinizi Giriniz",
            emailMessage: "E-posta İlk Gönderim Mesajı",
            advertising: "Pubblicità",
            balanceToTransferred: "Balance to be transferred",
            ballanceToTransfer: "Solde à transférer",
            crm: "CRM",
            ecommerce: "E-commerce",
            sms: "SMS",
            socialMedia: "Social Media",
            utilities: "Utilità",
            web: "Web"
        },
        sessions: {
            mySessions: "Mis sesiones",
            mySessionsDesc: "Ver y gestionar sus sesiones activas conectadas a su cuenta.",
            allSessions: "Todas las sesiones",
            sessionManagement: "Gestión de sesiones",
            allSessionsDesc: "Ver y gestionar todas las sesiones activas en el sistema.",
            noActiveSessions: "No se encontraron sesiones activas",
            currentSession: "Sesión actual",
            lastAccess: "Último acceso",
            createdAt: "Creado",
            revoke: "Revocar",
            revokeConfirm: "¿Está seguro de que desea revocar esta sesión?",
            revokeAllConfirm: "¿Está seguro de que desea revocar todas las demás sesiones?",
            revokeSuccess: "Sesión revocada correctamente",
            revokeAllSuccess: "Todas las sesiones revocadas correctamente",
            revokeFailed: "Error al revocar la sesión",
            revokeAllOther: "Revocar todas las demás sesiones",
            unknownLocation: "Ubicación desconocida",
            unknownDevice: "Dispositivo desconocido",
            filterByUser: "Filtrar por usuario",
            mobile: "Móvil",
            supsisMobileApp: "Aplicación móvil Supsis",
            httpClient: "Cliente HTTP",
            unknown: "Desconocido",
            ios: "iOS",
            android: "Android"
        },
        contactModuleRules: {
            title: "Reglas del Módulo de Contactos",
            description: "Definir acciones automáticas al crear una ficha de cliente o abrir un chat",
            active: "Activo",
            passive: "Pasivo",
            when: "Cuándo:",
            conditions: "Condiciones:",
            actions: "Acciones:",
            elseTitle: "Else (cuando no coincide ninguna regla)",
            noActionsDefined: "No se han definido acciones",
            addNewRule: "Añadir Nueva Regla",
            rulesDisabled: "Reglas del Módulo de Contactos Desactivadas",
            enableHint: "Active el interruptor anterior para habilitar acciones automáticas",
            rulesEnabledSuccess: "Reglas del módulo de contactos activadas",
            rulesDisabledSuccess: "Reglas del módulo de contactos desactivadas",
            ruleEnabledSuccess: "Regla activada",
            ruleDisabledSuccess: "Regla desactivada",
            ruleUpdateError: "Error al actualizar la regla",
            orderUpdatedSuccess: "Orden de reglas actualizado",
            orderUpdateError: "Error al actualizar el orden",
            ruleNameTemplate: "Regla {n}",
            ruleSavedSuccess: "Regla guardada",
            ruleSaveError: "Error al guardar la regla",
            deleteRuleTitle: "Eliminar Regla",
            deleteRuleConfirm: "¿Está seguro de que desea eliminar la regla \"{name}\"?",
            delete: "Eliminar",
            ruleDeletedSuccess: "Regla eliminada",
            ruleDeleteError: "Error al eliminar la regla",
            elseActionsSavedSuccess: "Acciones Else guardadas",
            actionsSaveError: "Error al guardar las acciones",
            whenContactCreated: "Cuando se crea la ficha del cliente",
            whenChatOpened: "Cuando se abre el chat",
            noCondition: "Sin condición",
            and: "y",
            or: "o",
            AND: "Y",
            OR: "O",
            fieldNotSelected: "Campo no seleccionado",
            noAction: "Sin acción",
            doNothing: "No hacer nada",
            assignToOwnerless: "sin asignar",
            assignOwnerlessAction: "Asignar como <strong>{ownerless}</strong>",
            assignTo: "asignar a",
            assignToUser: "Asignar a <strong>{name}</strong>",
            unknown: "Desconocido",
            leastContact: "Menos conversaciones",
            roundRobin: "Round robin",
            today: "hoy",
            last7Days: "últimos 7 días",
            last30Days: "últimos 30 días",
            channelAccessUsers: "usuarios con acceso al canal",
            usersCount: "{n} usuarios",
            allUsers: "todos los usuarios",
            random: "Aleatorio",
            algorithmic: "Algorítmico",
            addTagNotSelected: "Añadir etiqueta (no seleccionada)",
            tagsLabel: "etiquetas",
            tagLabel: "etiqueta",
            addDepartmentNotSelected: "Añadir departamento (no seleccionado)",
            addDepartmentTo: "departamento",
            applyToConversation: "(también aplicar a la conversación)",
            updatePropertyNotSelected: "Actualizar propiedad (no seleccionada)",
            changeOwner: "Cambiar Propietario",
            addTag: "Añadir Etiqueta",
            addDepartment: "Añadir Departamento",
            updateProperty: "Actualizar Propiedad",
            yes: "Sí",
            no: "No",
            fields: {
                fullname: "Nombre",
                email: "Email",
                phone: "Teléfono",
                whatsappNumber: "WhatsApp",
                whatsappCountry: "País WhatsApp",
                platform: "Plataforma",
                ownerExists: "Propietario",
                ownerIsOnline: "Propietario en línea",
                ownerStatus: "Estado del propietario",
                uptime: "Edad (min)",
                tags: "Etiquetas",
                channel: "Canal",
                preferredDepartment: "Departamento",
                hour: "Hora",
                day: "Día",
                conversationStatus: "Estado del chat",
                conversationSubject: "Departamento del chat"
            },
            operators: {
                equals: "igual",
                not_equals: "no igual",
                contains: "contiene",
                not_contains: "no contiene",
                gt: "mayor que",
                gte: "≥",
                lt: "menor que",
                lte: "≤",
                in: "contiene",
                not_in: "no contiene",
                exists: "existe",
                not_exists: "no existe"
            },
            ruleEditor: {
                editTitle: "Editar Regla",
                createTitle: "Crear Nueva Regla",
                stepWhen: "¿Cuándo?",
                stepConditions: "Condiciones",
                stepActions: "Acciones",
                whenQuestion: "¿Cuándo debe ejecutarse la regla?",
                ruleName: "Nombre de la Regla",
                ruleNamePlaceholder: "Introduzca un nombre para la regla",
                contactCreatedTitle: "Cuando se crea la ficha del cliente",
                contactCreatedDesc: "Se ejecuta cuando se crea un nuevo registro de cliente",
                chatOpenedTitle: "Cuando se abre el chat",
                chatOpenedDesc: "Se ejecuta cuando el cliente inicia una nueva conversación",
                conditionsQuestion: "¿Qué condiciones deben cumplirse?",
                actionsQuestion: "¿Qué acciones deben ejecutarse?",
                back: "Atrás",
                cancel: "Cancelar",
                next: "Siguiente",
                save: "Guardar",
                newRule: "Nueva Regla"
            },
            elseEditor: {
                title: "Editar Acciones Else",
                description: "Definir acciones predeterminadas cuando no coincida ninguna regla"
            },
            ruleTester: {
                title: "Probar Regla",
                description: "Puede probar cuántos contactos coincidirán con su regla",
                selectRule: "Seleccionar Regla",
                selectRulePlaceholder: "Seleccione la regla a probar",
                test: "Probar",
                ruleInfo: "Información de la Regla",
                conditionCount: "Número de condiciones:",
                actionCount: "Número de acciones:",
                ruleNotFound: "Regla no encontrada",
                testComingSoon: "Función de prueba próximamente.",
                testError: "Error durante la prueba"
            },
            filterBuilder: {
                noConditions: "Aún no se han añadido condiciones",
                addFirstCondition: "Añadir Primera Condición",
                groupTitle: "Grupo {n}",
                deleteGroup: "Eliminar Grupo",
                if: "Si",
                selectField: "seleccionar campo",
                operator: "operador",
                select: "seleccionar",
                selectValue: "seleccionar valor",
                enterValue: "introducir valor",
                addCondition: "Añadir condición",
                addFilterGroup: "Añadir Grupo de Filtros",
                andOption: "y",
                orOption: "o",
                fieldLabels: {
                    fullname: "Nombre del contacto",
                    email: "Email del contacto",
                    phone: "Teléfono del contacto",
                    whatsappNumber: "Número WhatsApp",
                    whatsappCountry: "País WhatsApp",
                    platform: "Plataforma del contacto",
                    ownerExists: "El contacto tiene propietario",
                    ownerIsOnline: "Propietario en línea",
                    ownerStatus: "Estado del propietario",
                    uptime: "Edad del contacto (min)",
                    tags: "Etiquetas del contacto",
                    channel: "Canal del contacto",
                    preferredDepartment: "Departamento preferido",
                    hour: "Hora actual",
                    day: "Día actual",
                    conversationStatus: "Estado de la conversación",
                    conversationSubject: "Departamento de la conversación"
                },
                operators: {
                    equals: "igual",
                    not_equals: "no igual",
                    contains: "contiene",
                    not_contains: "no contiene",
                    gt: "mayor que",
                    gte: "mayor o igual",
                    lt: "menor que",
                    lte: "menor o igual",
                    between: "entre",
                    exists: "existe",
                    not_exists: "no existe",
                    in: "contiene",
                    not_in: "no contiene"
                }
            },
            actionsEditor: {
                noActions: "Aún no se han añadido acciones",
                addFirstAction: "Añadir Primera Acción",
                actionNumber: "Acción {n}",
                actionType: "Tipo de Acción",
                addAction: "Añadir Acción"
            },
            changeOwnerConfig: {
                method: "Método de Asignación",
                static: "Estático",
                algorithmic: "Algorítmico",
                random: "Aleatorio",
                userSelect: "Selección de Usuario",
                assignOwnerless: "Asignar como sin asignar",
                selectUser: "Seleccionar usuario",
                userList: "Lista de Usuarios",
                channelAccessUsers: "Todos los usuarios con acceso al canal",
                selectUsers: "Seleccionar usuarios",
                algorithm: "Algoritmo",
                leastContact: "Menos Conversaciones",
                roundRobin: "Round Robin",
                dateRange: "Rango de Fechas",
                today: "Hoy",
                last7Days: "Últimos 7 Días",
                last30Days: "Últimos 30 Días",
                onlyOnline: "Incluir solo usuarios en línea"
            },
            addTagConfig: {
                tagsToAdd: "Etiquetas a Añadir",
                selectTag: "Seleccionar etiqueta",
                selectedTagsHint: "Las etiquetas seleccionadas se añadirán al contacto"
            },
            addDepartmentConfig: {
                departmentSelect: "Selección de Departamento",
                selectDepartment: "Seleccionar departamento",
                departmentHint: "El departamento seleccionado se añadirá a la lista de departamentos del contacto",
                applyToConversation: "También aplicar a la conversación",
                applyToConversationHint: "Si está activado, el departamento de la conversación abierta también se establecerá"
            },
            upsertContactPropertyConfig: {
                propertySelect: "Selección de Propiedad",
                selectProperty: "Seleccionar propiedad",
                propertyHint: "Propiedad a actualizar o crear",
                value: "Valor",
                valuePlaceholder: "Introducir valor de la propiedad",
                valueHint: "Este valor se asignará a la propiedad"
            }
        },
        taskModuleRules: {
            title: "Reglas del Módulo de Tareas",
            description: "Definir acciones automáticas al crear, actualizar una tarea o añadir un comentario",
            settingsTitle: "Reglas del Módulo de Tareas",
            settingsDescription: "Definir reglas de tareas automáticas para cada flujo de trabajo",
            selectWorkflow: "Seleccionar flujo de trabajo",
            selectWorkflowPlaceholder: "Seleccionar flujo de trabajo",
            selectWorkflowHint: "Seleccione un flujo de trabajo para editar las reglas del módulo de tareas",
            active: "Activo",
            passive: "Pasivo",
            when: "Cuándo:",
            conditions: "Condiciones:",
            actions: "Acciones:",
            elseTitle: "Else (cuando no coincide ninguna regla)",
            noActionsDefined: "No se han definido acciones",
            addNewRule: "Añadir Nueva Regla",
            rulesDisabled: "Reglas del Módulo de Tareas Desactivadas",
            enableHint: "Active el interruptor anterior para habilitar acciones automáticas",
            rulesEnabledSuccess: "Reglas del módulo de tareas activadas",
            rulesDisabledSuccess: "Reglas del módulo de tareas desactivadas",
            ruleEnabledSuccess: "Regla activada",
            ruleDisabledSuccess: "Regla desactivada",
            ruleUpdateError: "Error durante la operación",
            orderUpdatedSuccess: "Orden de reglas actualizado",
            orderUpdateError: "Error al actualizar el orden",
            ruleNameTemplate: "Regla {n}",
            ruleSavedSuccess: "Regla guardada",
            ruleSaveError: "Error al guardar la regla",
            deleteRuleTitle: "Eliminar Regla",
            deleteRuleConfirm: "¿Está seguro de que desea eliminar la regla \"{name}\"?",
            delete: "Eliminar",
            ruleDeletedSuccess: "Regla eliminada",
            ruleDeleteError: "Error al eliminar la regla",
            elseActionsSavedSuccess: "Acciones Else guardadas",
            actionsSaveError: "Error al guardar las acciones",
            noCondition: "Sin condición",
            and: "y",
            or: "o",
            AND: "Y",
            OR: "O",
            fieldNotSelected: "Campo no seleccionado",
            noAction: "Sin acción",
            chainBadge: "Encadenamiento",
            chainBadgeTooltip: "Esta regla puede activar otras reglas",
            automationOffBadge: "Automatización desactivada",
            automationOffTooltip: "No se notifica a Supsis Automations",
            yes: "Sí",
            no: "No",
            unknown: "Desconocido",
            cancel: "Cancelar"
        },
        userInfoWidget: {
            zohoInfo: "Información de Zoho",
            messageSearch: "Buscar mensaje",
            userInformation: "Informacion del usuario",
            fullName: "Nombre y apellido",
            newValue: "Nuevo valor",
            newProfileInfo: "Nueva información de perfil",
            affiliatedRepresentatives: "Representantes",
            preferredAgents: "Agente (s) Preferido (s)",
            labels: "Etiquetas",
            agentNotes: "Notas del agente",
            newNote: "Nueva nota",
            note: "Nota",
            available: "Hay notas disponibles.",
            systemInformation: "Información del sistema",
            speechID: "identificación de voz",
            customerVersion: "Versión del cliente",
            IPAddress: "Dirección IP",
            pageVisited: "Página visitada",
            systemAndBrowser: "Sistema operativo y navegador",
            countryAndLanguage: "País e idioma",
            clickToEdit: "Editar Haga clic dentro de la publicación",
            adsYouAreInterestedIn: "Anuncios en los que estás interesado/a",
            detail: "Detalle",
            adsTitle: "Título",
            adUrl: "URL del anuncio",
            sourceID: "ID de origen",
            resourceType: "Tipo de recurso",
            adsBody: "Contenido",
            adsCreateDate: "Fecha de creación",
            adsUpdateDate: "Fecha de actualización"
        },
        newWizartV2: {
            generalSettings: "Configuración general",
            themeSettings: "Ajustes de tema",
            representativeWorkingHours: "Horas de trabajo representativas",
            preview: "avance",
            setup: "Configuración",
            formStepTitle: "Danos más información para que podamos personalizar tu experiencia.",
            supsisEntergation: "¿Dónde usará Supsis en su sitio web?:",
            goToNextStep: "Dar el siguiente paso",
            readytemplate: "Usar plantilla de color listo",
            customSettings: "Ajustes personalizados",
            customerMessageView: "Mensaje del cliente Ver",
            backcgroundColor: "Color de fondo",
            textColor: "Color de fuente",
            agentMessageView: "Vista de mensajes del agente",
            workingHours: "¿En qué intervalos de tiempo proporciona servicios a sus visitantes?",
            continuousService: "Servicio Continuo",
            continuousServiceDescription: "La burbuja de chat siempre está activa. Incluso si no estás en el sistema.",
            vote: "Haz tu elección",
            representativeWorking: "Horas de trabajo representativas",
            representativeWorkingDescription: "El chat aparece en línea cuando al menos 1 agente está en línea. Si no hay un representante en línea, aparecerá como fuera de línea.",
            computer: "Computadora",
            tablet: "Tablet",
            uploadTrackingCodeToYourWebsite: "Cargue el código de seguimiento en su sitio web",
            password: "Establecer nueva contraseña"
        },
        whatsappChannel: {
            whatsappTitleV1: "Canales de Whatsapp V1 (QR)",
            whatsappTitleV2: "Canales de Whatsapp V2 (QR)",
            channelName: "Nombre del Canal",
            phoneNumber: "Número de Teléfono",
            forwardToChatbot: "Reenviar al Chatbot",
            forwardingChatbotOrLiveAgent: "Reenvío (Chatbot o Agente en Vivo)",
            addChannel: "Agregar Canal",
            newWhatsappChannel: "Nuevo Canal de WhatsApp",
            newWhatsappChannelDescription: "Cree un nuevo canal de WhatsApp escaneando el código QR",
            editWhatsappChannel: "Editar Canal de WhatsApp",
            editWhatsappChannelDescription: "Editar canal de WhatsApp",
            whatsappChannel: "Canal de WhatsApp",
            deleteWhatsappChannelDescription: "¿Estás seguro de que deseas eliminar este canal?",
            whatsappIntegration: "Integración de WhatsApp",
            deleteChannel: "Eliminar Canal",
            restartChannel: "Reiniciar Canal",
            wantRestartChannel: "¿Quieres reiniciar el canal?",
            deleteSMSChannelDescription: "Estás seguro de que quieres eliminar el canal de SMS?",
            smsChannel: "canal SMS",
            maxChannelCount: "No puedes crear más de un canal de SMS!",
            smsModalText: "Nuestra integración con soluciones de comunicación modernas le brinda la oportunidad de enviar SMS de manera fácil y efectiva. ¡Elimine los límites en la comunicación, conéctese directamente con sus clientes!",
            smsModalBtn: "Haga clic para abrir el canal SMS...",
            postaCellDetail: "Detalle del canal PostaCell",
            phoneNummer: "Telefon Numarası"
        },
        noPermission: "No tienes permiso para realizar esta operación.",
        mail_integration_detail: {
            title: "Detalle del correo",
            integration: "Integración",
            sender: "Correo del remitente",
            signature: "Firma",
            inbox: "Bandeja de entrada",
            medias: "Medios",
            visibility: "Visibilidad",
            settings_group: "Configuración",
            contacts: "Contactos"
        },
        whatsapp_business_api: {
            userVisibility: "Visibilidad del usuario",
            userVisibilityDesc: "Los canales a los que pueden acceder los usuarios dependen de su rol y de la configuración de visibilidad del canal. Los usuarios con el rol Full Admin o root pueden ver todos los canales. Si la configuración de visibilidad de un canal está vacía, el canal es público. Sin embargo, si el canal está definido para usuarios o departamentos específicos, sólo esos usuarios o miembros del departamento pueden ver el canal.",
            searchTemplate: "Plantilla de búsqueda...",
            forwardToChatbot: "Reenviar a Chatbot",
            forwarding: "Reenviar (Chatbot o Agente en vivo)",
            forwardLiveAgents: "👉 Reenviar a Live Support",
            forwardingToDepartment: "Reenviar a Departamento",
            selectDepartment: "Seleccionar Departamento",
            createWbChannel: "Para crear un canal de Whatsapp Business, debes adquirir un paquete de Whatsapp Business. Puedes acceder a paquetes asequibles inmediatamente.",
            wbCreateChannelMax: "Has alcanzado el límite de creación de canales de Whatsapp Business. Máximo",
            wbContinue: "Puedes crear un canal de Whatsapp Business. Para continuar, actualiza tu paquete o elimina alguno de tus canales de Whatsapp Business.",
            chatInitiatorTemplate: "Plantilla de iniciador de chat",
            selectChatInitiatorTemplate: "Selecciona tu plantilla de iniciador de chat.",
            dailyUsageReport: "Informe de uso diario",
            metaInsightsTitle: "Meta Insights",
            metaInsightsSubtitle: "Ver estadísticas de WhatsApp Business API",
            metaInsightsDateRange: "Rango de fechas",
            metaInsightsDateStart: "Inicio",
            metaInsightsDateEnd: "Fin",
            metaInsightsGranularity: "Granularidad",
            metaInsightsGranularityDay: "Diario",
            metaInsightsGranularityMonth: "Mensual",
            metaInsightsGranularityHalfHour: "Media hora",
            metaInsightsRefresh: "Actualizar",
            metaInsightsTabMessaging: "Analítica de mensajería",
            metaInsightsTabConversation: "Analítica de conversaciones",
            metaInsightsTabPricing: "Analítica de precios",
            metaInsightsTabTemplate: "Analítica de plantillas",
            metaInsightsTabTemplateGroup: "Analítica de grupos de plantillas",
            metaInsightsErrorMessaging: "Error al cargar datos de analítica de mensajería",
            metaInsightsErrorConversation: "Error al cargar datos de analítica de conversaciones",
            metaInsightsErrorPricing: "Error al cargar datos de analítica de precios",
            metaInsightsErrorTemplate: "Error al cargar datos de analítica de plantillas",
            metaInsightsErrorTemplateGroup: "Error al cargar datos de analítica de grupos de plantillas",
            metaInsightsViewChart: "Vista de gráfico",
            metaInsightsViewTable: "Vista de tabla",
            metaInsightsDownloadExcel: "Descargar Excel",
            metaInsightsTotalSent: "Total enviados",
            metaInsightsTotalDelivered: "Total entregados",
            metaInsightsDeliveryRate: "Tasa de entrega",
            metaInsightsUnitMessage: "mensajes",
            metaInsightsMessageStats: "Estadísticas de mensajes",
            metaInsightsSent: "Enviados",
            metaInsightsDelivered: "Entregados",
            metaInsightsDateColumn: "Fecha",
            metaInsightsCountryBreakdown: "Desglose por país",
            metaInsightsNoData: "No se encontraron datos. Compruebe el rango de fechas.",
            metaInsightsPieChart: "Gráfico circular",
            metaInsightsTotalConversations: "Total conversaciones",
            metaInsightsTotalCost: "Coste total",
            metaInsightsAvgCost: "Coste medio",
            metaInsightsUnitConversation: "conversaciones",
            metaInsightsCostPerConversation: "$/conversación",
            metaInsightsCategoryBreakdown: "Desglose por categoría",
            metaInsightsConversationStats: "Estadísticas de conversaciones",
            metaInsightsCategoryDistribution: "Distribución por categoría",
            metaInsightsConversationCount: "Número de conversaciones",
            metaInsightsCost: "Coste",
            metaInsightsCategory: "Categoría",
            metaInsightsType: "Tipo",
            metaInsightsConversationCategoryAuth: "Autenticación",
            metaInsightsConversationCategoryMarketing: "Marketing",
            metaInsightsConversationCategoryService: "Servicio",
            metaInsightsConversationCategoryUtility: "Utilidad",
            metaInsightsConversationCategoryOther: "Otro",
            metaInsightsConversationDistribution: "Distribución de conversaciones",
            metaInsightsTotalVolume: "Volumen total",
            metaInsightsAvgUnitCost: "Coste unitario medio",
            metaInsightsCostPerMessage: "$/mensaje",
            metaInsightsPricingCategoryBreakdown: "Desglose por categoría de precios",
            metaInsightsPricingTypeBreakdown: "Desglose por tipo de precios",
            metaInsightsPricingStats: "Estadísticas de precios",
            metaInsightsCostDistribution: "Distribución de costes",
            metaInsightsCountry: "País",
            metaInsightsVolume: "Volumen",
            metaInsightsTier: "Nivel",
            metaInsightsPricingCategoryAuth: "Autenticación",
            metaInsightsPricingCategoryAuthInternational: "Autenticación internacional",
            metaInsightsPricingCategoryMarketing: "Marketing",
            metaInsightsPricingCategoryService: "Servicio",
            metaInsightsPricingCategoryUtility: "Utilidad",
            metaInsightsPricingCategoryReferral: "Conversión por referido",
            metaInsightsPricingTypeRegular: "Regular",
            metaInsightsPricingTypeFreeCustomerService: "Servicio al cliente gratuito",
            metaInsightsPricingTypeFreeEntryPoint: "Punto de entrada gratuito",
            metaInsightsTemplateAboutTitle: "Acerca de analíticas de plantillas",
            metaInsightsTemplateAboutDesc: "Debe seleccionar plantillas para las analíticas. Puede seleccionar hasta 10 plantillas. Los datos se devuelven con granularidad diaria y puede acceder a 90 días de historial.",
            metaInsightsTemplateSelectLabel: "Seleccionar plantillas (máx. 10)",
            metaInsightsTemplateSelectPlaceholder: "Seleccionar plantillas...",
            metaInsightsFetchData: "Obtener datos",
            metaInsightsTotalRead: "Total leídos",
            metaInsightsReadRate: "Tasa de lectura",
            metaInsightsRead: "Leídos",
            metaInsightsTemplatePerformance: "Rendimiento de plantillas",
            metaInsightsCostInfo: "Información de costes",
            metaInsightsTotalSpent: "Total gastado",
            metaInsightsCostPerDelivered: "Coste por entrega",
            metaInsightsClickInfo: "Información de clics",
            metaInsightsClickInfoDesc: "Los clics en botones URL y Quick Reply solo están disponibles para plantillas en categorías MARKETING y UTILITY.",
            metaInsightsTemplateNoData: "No se encontraron datos de analíticas de plantillas. Puede obtener datos seleccionando IDs de plantillas.",
            metaInsightsTemplateId: "ID de plantilla",
            metaInsightsTemplateGroupAboutTitle: "Acerca de analíticas de grupos de plantillas",
            metaInsightsTemplateGroupAboutDesc: "Debe introducir los IDs de grupos de plantillas creados en Meta para las analíticas. Puede introducir hasta 10 grupos. Los datos se devuelven con granularidad diaria y puede acceder a 90 días de historial.",
            metaInsightsTemplateGroupIdsLabel: "IDs de grupos de plantillas (separados por comas, máx. 10)",
            metaInsightsTemplateGroupIdsPlaceholder: "Ej.: 1044106240855852, 1044106240855853",
            metaInsightsTemplateGroupPerformance: "Rendimiento de grupos de plantillas",
            metaInsightsGroupBreakdownTitle: "Rendimiento por grupo",
            metaInsightsGroupLabel: "Grupo",
            metaInsightsTemplateGroupNoData: "No se encontraron datos de analíticas de grupos de plantillas. Puede obtener datos introduciendo los IDs de grupos de plantillas.",
            metaInsightsGroupId: "ID de grupo",
            capiStatus: "Estado CAPI",
            capiActive: "Activo",
            capiPassive: "Inactivo",
            capiConnectionMethod: "Método de conexión",
            capiConnectThroughMeta: "Conectar mediante Meta",
            capiWithDatasetAndToken: "Con dataset y token",
            capiOauthInfoDesc: "Debe volver a autorizar para conectar mediante Meta. Esto no afecta su canal existente, solo añade permisos adicionales.",
            capiConnecting: "Conectando...",
            capiConnectWithMeta: "Conectar con Meta",
            capiDatasetSelection: "Selección de dataset",
            capiSelectDataset: "Seleccione un dataset",
            capiCreating: "Creando...",
            capiCreateNewDataset: "Crear nuevo dataset",
            capiDatasetId: "ID de dataset",
            capiEnterDatasetId: "Introduzca el ID del dataset",
            capiAccessToken: "Token de acceso",
            capiEnterAccessToken: "Introduzca el token de acceso",
            capiTesting: "Probando...",
            capiTestConnection: "Probar conexión",
            capiConnectionSuccess: "Conexión exitosa",
            capiConnectionFailed: "Conexión fallida",
            capiAutoEventSend: "Envío automático de eventos",
            capiEventInitiateCheckout: "Chat iniciado",
            capiEventInitiateCheckoutDesc: "Cuando se crea una nueva conversación",
            capiEventPurchase: "Compra",
            capiEventPurchaseDesc: "Cuando se completa la compra",
            capiEventAppointmentBooked: "Cita reservada",
            capiEventAppointmentBookedDesc: "Cuando se reserva una cita",
            capiEventAddToCart: "Añadido al carrito",
            capiEventAddToCartDesc: "Cuando se añade un producto al carrito",
            capiEventViewContent: "Contenido visto",
            capiEventViewContentDesc: "Cuando se ve una página o producto",
            capiEventOrderCreated: "Pedido creado",
            capiEventOrderCreatedDesc: "Cuando el pedido se crea correctamente",
            capiEventOrderShipped: "Pedido enviado",
            capiEventOrderShippedDesc: "Cuando el pedido se envía",
            capiMetaConnectionSuccess: "Conexión con Meta exitosa",
            capiMetaConnectionFailed: "Conexión con Meta fallida",
            capiDatasetsLoadError: "No se pudieron cargar los datasets",
            capiDatasetCreated: "Nuevo dataset creado",
            capiDatasetCreateError: "No se pudo crear el dataset",
            capiConnectionTestSuccess: "¡Conexión CAPI exitosa!",
            capiConnectionTestFailed: "Conexión CAPI fallida",
            capiConnectionTestError: "No se pudo realizar la prueba de conexión",
            wabaMovementsTitle: "Actividades de Webhook",
            wabaMovementsSubtitle: "Seguir las actividades del canal de WhatsApp Business API",
            wabaMovementsTotalActivity: "actividades totales",
            wabaMovementsEmailNotifications: "Notificaciones por email",
            wabaMovementsActive: "Activo",
            wabaMovementsOff: "Desactivado",
            wabaMovementsEmailSettingTitle: "Recibir notificaciones de cuenta por email",
            wabaMovementsEmailSettingDesc: "Enviar notificaciones por email para actividades de webhook",
            wabaMovementsEmailListHeader: "Direcciones de email para enviar notificaciones",
            wabaMovementsEmailPlaceholder: "Introduzca la dirección de email",
            wabaMovementsNoEmailsYet: "Aún no se han añadido direcciones de email",
            wabaMovementsActivityLoadError: "Error al cargar los registros de actividad",
            wabaMovementsNotificationsOn: "Notificaciones por email activadas",
            wabaMovementsNotificationsOff: "Notificaciones por email desactivadas",
            wabaMovementsUpdateError: "Error durante la actualización",
            wabaMovementsEmailAlreadyAdded: "Esta dirección de email ya está añadida",
            wabaMovementsEmailAdded: "Dirección de email añadida",
            wabaMovementsEmailAddError: "Error al añadir el email",
            wabaMovementsEmailRemoved: "Dirección de email eliminada",
            wabaMovementsEmailRemoveError: "Error al eliminar el email",
            freeChat: "Chat gratuito",
            paidChat: "Chat de pago",
            templateMessage: "Plantilla de mensaje",
            outgoingSession: "Sesión saliente",
            incomingSession: "Sesión entrante",
            totalCost: "Coste total",
            allOptNumbers: "Todos los números opt-in",
            startChat: "Iniciar chat",
            lastMessageDate: "Fecha del último mensaje",
            sureDeleteTemplate: "¿Seguro que quieres borrar esta plantilla?",
            manageWhoChannelChat: "Gestionar quién puede ver estos chats de canal",
            profileImageDesc: "Esta será una captura de pantalla de WhatsApp de tu negocio.",
            bussinesDesciption: "Descripción de tu negocio.",
            descOfWork: "Descripción de tu negocio en pocas palabras (Máximo 512 caracteres).",
            accountStatus: "Estado de la cuenta.",
            dockerStatus: "Estado del docker.",
            phoneQuality: "Calidad del teléfono.",
            customersOrDay: "ClientesDía.",
            messagingLimit: "Límite de mensajería.",
            canSendMessage: "Se puede enviar mensaje.",
            officialDetails: "Detalles oficiales.",
            officialDetailsDesc: "Estas direcciones se mostrarán siempre en la sección de perfil a los usuarios que chateen contigo en WhatsApp. Después de editarla, la enviaremos a WhatsApp para su aprobación.",
            addressLine: "Línea de dirección.",
            stateIfApplic: "Estado (si procede).",
            zipCodeOrPostCode: "Código postal.",
            selectCountry: "Seleccionar país.",
            selectBussVertical: "Seleccionar área de negocio.",
            saveInfo: "Guardar información.",
            active: "Activo.",
            banned: "Prohibido.",
            low: "Bajo.",
            medium: "Medio.",
            high: "Alto.",
            connected: "Conectado.",
            disConnected: "Desconectado.",
            flagged: "Marcado.",
            pending: "Pendiente.",
            restricted: "Restringido.",
            unknown: "Desconocido.",
            available: "Disponible.",
            limited: "Limitado.",
            blocked: "Bloqueado.",
            loadingProfile: "Cargando información del perfil...",
            businessProfileTitle: "Perfil de negocio",
            lastUpdate: "Última actualización:",
            updateFromMeta: "Actualizar desde Meta",
            waitSeconds: "Espere {n}s",
            wabaInfoTitle: "Información de la cuenta de WhatsApp Business",
            phoneInfo: "Información del teléfono",
            verifiedNameLabel: "Nombre verificado:",
            phoneNumberLabel: "Número de teléfono:",
            codeVerificationLabel: "Verificación de código:",
            platformSettings: "Configuración de la plataforma",
            platformTypeLabel: "Tipo de plataforma:",
            throughputLevelLabel: "Nivel de rendimiento:",
            twoFaPinLabel: "PIN 2FA:",
            enabled: "Activado",
            disabled: "Desactivado",
            dailyLimit: "Límite diario",
            messageSending: "Envío de mensajes",
            businessInfoTitle: "Información del negocio",
            profilePhoto: "Foto de perfil",
            change: "Cambiar",
            profilePhotoNote: "JPG o PNG (máx. 5MB, recomendado: 640x640px)",
            aboutText: "Texto sobre",
            aboutPlaceholder: "Escriba una breve descripción de su negocio...",
            aboutHint: "Breve descripción que aparecerá en su perfil de WhatsApp (máx. 139 caracteres)",
            businessDescriptionLabel: "Descripción del negocio",
            businessDescriptionPlaceholder: "Escriba la descripción detallada de su negocio...",
            descriptionHint: "Descripción detallada de su negocio",
            contactEmail: "Email de contacto",
            emailPlaceholder: "ejemplo@empresa.com",
            businessAddress: "Dirección del negocio",
            addressPlaceholder: "Dirección completa",
            website1: "Sitio web 1",
            website2: "Sitio web 2",
            website1Placeholder: "https://www.empresa.com",
            website2Placeholder: "https://www.facebook.com/empresa",
            businessCategory: "Categoría del negocio",
            selectBusinessCategory: "Seleccione la categoría del negocio",
            categoryHint: "Seleccione el ámbito de actividad de su negocio",
            revertChanges: "Deshacer cambios",
            updateButton: "Actualizar",
            accountModeLabel: "Modo de cuenta:",
            na: "N/D",
            verticalOther: "Otro",
            verticalAuto: "Automoción",
            verticalBeauty: "Belleza, spa y salón",
            verticalApparel: "Ropa y confección",
            verticalEdu: "Educación",
            verticalEntertain: "Entretenimiento",
            verticalEventPlan: "Planificación y servicio de eventos",
            verticalFinance: "Finanzas y banca",
            verticalGrocery: "Alimentación y comestibles",
            verticalGovt: "Servicio público",
            verticalHotel: "Hotel y alojamiento",
            verticalHealth: "Médico y salud",
            verticalNonprofit: "Sin ánimo de lucro",
            verticalProfServices: "Servicios profesionales",
            verticalRetail: "Compras y retail",
            verticalTravel: "Viajes y transporte",
            verticalRestaurant: "Restaurante",
            verticalAlcohol: "Alcohol",
            verticalOnlineGambling: "Juego en línea",
            verticalPhysicalGambling: "Juego físico",
            verticalOtcDrugs: "Medicamentos sin receta",
            verticalMatrimonyService: "Servicio matrimonial",
            success: "Éxito.",
            successDesc: "La información de su perfil se ha actualizado correctamente.",
            wabaOverview: "Visión general de la salud de WABA.",
            manageChannelDetail: "Gestiona la información de tu canal.",
            wpBussChannelDetail: "Detalle del canal de Whatsapp Business.",
            manageWpBussChannel: "Gestiona tu canal de Whatsapp para empresas.",
            channelName: "Nombre del canal.",
            phoneNumberE164: "Número de teléfono",
            phoneNumberE164Place: "Número de teléfono Por ejemplo, 908501234455.",
            channelUpdatedSucs: "Canal actualizado correctamente.",
            faieldUpdateChannel: "Error al actualizar el canal.",
            completeSetup: "Completar configuración",
            completeSetupDescription:
                "Para completar la configuración de WhatsApp Business API, haga clic en el botón de abajo para ir a la página de conexión.",
            connectWhatsAppBusinessAccount: "Conectar cuenta de WhatsApp Business",
            infoLabel: "Información",
            onboardingInfoDescription:
                "Su cuenta de Facebook Business y su número de WhatsApp deben estar listos para la configuración de WhatsApp Business API.",
            businessId: "ID de negocio",
            phoneNumberId: "ID de número de teléfono",
            wabaId: "ID WABA",
            verifiedNameLabel: "Nombre verificado",
            userAccessibility: "Accesibilidad de usuario",
            userAccessibilityDesc:
                "Las personas indicadas abajo pueden ver contactos y chats en este canal (no pueden acceder si hay propiedad). Esta configuración se usa en: <ul><li><strong>Asignación automática de chat:</strong> Los clientes entrantes se asignan según la visibilidad; no se asignan chats a quienes no tienen acceso</li><li><strong>Reenvío:</strong> Reenviar un chat desde otro lugar o añadir otro agente debe coincidir con esta configuración; no se permite reenviar a usuarios no autorizados</li><li><strong>Listas de contactos/clientes:</strong> Las listas que ve dependen de esta configuración</li><li><strong>Propiedad:</strong> Puede asignar un cliente a un agente dentro de esta configuración</li></ul>",
            makePublicButton: "Hacer público",
            channelOwners: "Propietarios del canal",
            channelOwnersDesc:
                "Los propietarios del canal tienen permiso para ver todas las conversaciones en este canal. Pueden leer todos los mensajes independientemente de la configuración de visibilidad.",
            editChannelOwners: "Editar propietarios del canal",
            selectChannelOwner: "Seleccionar propietario del canal",
            selectChannelOwnerDesc: "Seleccione los agentes que serán propietarios de este canal",
            makePublicConfirmTitle: "¿Está seguro de que desea hacer este canal público?",
            makePublicConfirmContent: "Después de esta acción, todos los agentes podrán ver las conversaciones de este canal.",
            makePublicConfirmOk: "Sí, hacer público",
            makePublicSuccessMessage: "El canal se ha hecho público",
            stepSetupTemplate: "Configurar plantilla",
            stepEditTemplate: "Editar plantilla",
            stepSubmitReview: "Enviar para revisión",
            templateNameAndLanguage: "Nombre e idioma de la plantilla",
            editModeNoticeText: "En modo edición no se pueden cambiar el nombre ni el idioma. Solo la categoría (si no está aprobada), los componentes y el time-to-live.",
            nameYourTemplate: "Nombre de la plantilla",
            enterTemplateNamePlaceholder: "Introduzca el nombre de la plantilla",
            selectLanguage: "Seleccionar idioma",
            content: "Contenido",
            footerOptional: "Pie • Opcional",
            enterTextPlaceholder: "Introducir texto",
            bodyLabel: "Cuerpo",
            bodyPlaceholder: "Introduzca el texto del cuerpo del mensaje",
            bold: "Negrita",
            italic: "Cursiva",
            strikethrough: "Tachado",
            headerLabelRecommended: "Recomendado",
            headerLabelOptionalTextOnly: "Opcional (solo texto)",
            headerLabelRequiredProduct: "Obligatorio (producto)",
            headerLabelOptional: "Opcional",
            headerNone: "Ninguno",
            headerTextOption: "Texto",
            headerDocument: "Documento",
            headerProduct: "Producto",
            productHeaderAutoSet: "El encabezado de producto se establece automáticamente al usar plantillas de producto.",
            headerTextPlaceholder: "Añada una línea corta de texto al encabezado de su mensaje",
            mediaHintNote: "Nota:",
            mediaHintIntro: "Formatos y tamaños de archivo aceptados:",
            mediaHintImage: "Imagen: JPEG, PNG (Máx. 5 MB)",
            mediaHintVideo: "Vídeo: MP4 (Máx. 16 MB)",
            mediaHintDocument: "Documento: PDF (Máx. 100 MB)",
            productHeaderAutoInfo: "El encabezado de producto se añade automáticamente desde su catálogo.",
            carouselContentDescription: "Cree dos mensajes: primero el texto general (cuerpo); después las tarjetas del carrusel. Cada tarjeta puede tener cuerpo opcional y botones (mín. 1). El cuerpo principal no puede tener botones; solo las tarjetas.",
            contentDescriptionProduct: "Añada el texto del cuerpo para la plantilla de producto. El encabezado se añade desde el catálogo.",
            contentDescriptionLTO: "Añada encabezado y cuerpo para la plantilla de oferta limitada. El pie no está soportado.",
            contentDescriptionCarousel: "Añada cuerpo general y tarjetas del carrusel. Cada tarjeta tiene encabezado, cuerpo opcional y botones.",
            contentDescriptionDefault: "Añada encabezado, cuerpo y pie para su plantilla.",
            readyToSubmit: "Listo para enviar",
            submitReviewDescription: "Su plantilla se enviará a revisión de Meta. Suele tardar minutos y hasta 24 horas.",
            bodyContentAdded: "Contenido del cuerpo añadido",
            buttonsAddedCount: "{count} botones añadidos",
            previous: "Anterior",
            discard: "Descartar",
            next: "Siguiente",
            submitForReview: "Enviar para revisión",
            updateTemplate: "Actualizar plantilla",
            cannotProceed: "No se puede continuar",
            noChangesReason: "No se han hecho cambios en la plantilla. Haga al menos un cambio.",
            categoryCannotChangeWarning: "No se puede cambiar la categoría en plantillas aprobadas.",
            setupYourTemplate: "Configure su plantilla",
            setupDescription: "Elija la categoría que mejor describa su plantilla. Luego el tipo de mensaje.",
            learnMoreCategories: "Más información sobre categorías.",
            marketing: "Marketing",
            utility: "Utilidad",
            authentication: "Autenticación",
            categoryCannotChangeApproved: "La categoría no se puede cambiar en plantillas aprobadas",
            categoryCannotEditApproved: "La categoría no se puede editar en plantillas aprobadas. Solo componentes y time-to-live.",
            notSupported: "No soportado",
            selectProductMessageType: "Seleccione el tipo de mensaje de producto",
            selectOtpAutofillType: "Seleccione el tipo de autocompletado OTP",
            templatePreview: "Vista previa de la plantilla",
            previewAlt: "Vista previa",
            previewAltCallPermission: "Solicitud de permiso de llamada",
            previewSampleCard: "Tarjeta de ejemplo",
            previewCardPreview: "Vista previa de tarjeta",
            previewBodyMarketingDefault: "¡Hola! Echa un vistazo a nuestros productos frescos. Usa el código HEALTH para un 10 % de descuento.",
            previewBodyCarouselStep0: "¡Descubre nuestros productos destacados! Desliza para explorar ofertas.",
            previewSpecialOffer: "Oferta especial",
            previewEndsIn2Days: "Termina en 2 días",
            previewExpiresLabel: "Caduca: ",
            previewSeeAllOptions: "Ver todas las opciones",
            previewBodyLto: "¡Empieza ya! Compra dos y llévate uno gratis en nuestra nueva colección de jabones.",
            previewWinterSaleHeader: "¡Nuestras rebajas de invierno están aquí!",
            previewBodyCoupon: "Compra hasta finales de diciembre y usa el código WINTER25 para un 25 % de descuento.",
            previewViewBizCatalog: "Ver el catálogo de {BIZ_NAME} en WhatsApp",
            previewBrowseCatalogueDetails: "Explora fotos y detalles de sus ofertas.",
            previewBodyCatalogue: "Compra tus productos favoritos en WhatsApp. Navega por nuestro catálogo.",
            previewBodyCatalogueSingle: "¡Mira este producto! Ideal para ti.",
            previewBodyCatalogueMulti: "¿Olvidaste algo? Parece que dejaste estos artículos en el carrito.",
            previewBodyCatalogueCarousel: "Descubre nuestros últimos productos. Navega por el catálogo.",
            previewBodyUtility: "¡Buenas noticias! Tu pedido 23KFEJJ2312 ha sido enviado. Consulta el enlace de seguimiento.",
            previewBodyAuth: "123456 es tu código de verificación. Por seguridad, no lo compartas.",
            previewBodyPlaceholder: "El cuerpo del mensaje aparecerá aquí",
            previewBodyCarouselPlaceholder: "El cuerpo del mensaje carrusel aparecerá aquí",
            previewButtonN: "Botón {n}",
            previewProductNDescription: "Descripción del producto {n}",
            previewTemplateGoodFor: "Esta plantilla es adecuada para",
            previewTemplateAreasCustomise: "Áreas de la plantilla que puedes personalizar",
            previewDescCatalogue: "Descubrimiento de productos/servicios, ventas, ofertas, marketing personalizado",
            previewDescCoupon: "Enviar códigos promocionales con botón de copiar. Un solo botón de copiar código.",
            previewDescCarousel: "Mostrar varios productos o servicios en vista deslizable. Cada tarjeta con imagen, descripción y botones.",
            previewDescMarketing: "Mensajes de bienvenida, promociones, ofertas, cupones, anuncios",
            previewDescUtility: "Confirmaciones de pedido, actualizaciones de cuenta, recibos, recordatorios",
            previewDescAuth: "Contraseña de un solo uso, recuperación de cuenta, verificación",
            previewCustomisableCallPermission: "Encabezado, cuerpo, pie",
            previewCustomisableCoupon: "Encabezado (texto), cuerpo, botón (excepto texto de copiar código)",
            previewCustomisableCarousel: "Mensaje general, tarjetas del carrusel",
            previewCustomisableMarketing: "Medios, encabezado, cuerpo, pie, botón",
            previewCustomisableUtility: "Encabezado, cuerpo, pie",
            previewCustomisableAuth: "Cuerpo",
            productMessage: "Mensaje de producto",
            callUs: "Llámanos",
            unsubscribe: "Darse de baja",
            trackShipment: "Seguir envío",
            choosePreference: "Elegir preferencia",
            autoVerify: "Verificación automática",
            yourTemplateNamePlaceholder: "nombre_plantilla",
            templateNameLabel: "Nombre de plantilla",
            categoryLabel: "Categoría",
            languageLabel: "Idioma",
            templateCreatedSuccess: "¡Plantilla creada y enviada a revisión correctamente!",
            templateUpdatedSuccess: "¡Plantilla actualizada correctamente!",
            mediaUploadedSuccess: "Medios subidos correctamente",
            mediaUploadFailedPrefix: "Error al subir medios: ",
            nameRequired: "El nombre de la plantilla es obligatorio",
            nameInvalidChars: "Solo se permiten letras minúsculas, números y guiones bajos",
            nameMaxLength: "El nombre de la plantilla debe tener 512 caracteres o menos",
            bodyRequired: "El contenido del cuerpo es obligatorio",
            ltoRequiresOneButton: "La oferta por tiempo limitado requiere al menos un botón",
            ltoRequiresUrlButton: "La oferta por tiempo limitado requiere un botón URL",
            carouselRequiresOneCard: "La plantilla carrusel requiere al menos una tarjeta",
            cardMustHaveButton: "La tarjeta {index} debe tener al menos un botón",
            cardMustHaveHeaderMedia: "La tarjeta {index} debe tener imagen o vídeo de cabecera",
            ltoUrlButtonCannotRemove: "La oferta por tiempo limitado requiere al menos un botón URL y no puede eliminarse",
            ltoRequiresOneButtonWarning: "La oferta por tiempo limitado requiere al menos un botón",
            copyCodeButtonRequired: "El botón Copiar código es obligatorio en plantillas de cupón y no puede eliminarse",
            carouselCardMustHaveButton: "Cada tarjeta del carrusel debe tener al menos un botón",
            imageMaxSize: "La imagen debe ser menor de 5 MB",
            videoMaxSize: "El vídeo debe ser menor de 16 MB",
            documentMaxSize: "El documento debe ser menor de 100 MB",
            fileUploadFailed: "Error al subir el archivo",
            uploadFileLoading: "Subiendo archivo...",
            templateTypeDefault: "Predeterminado",
            templateTypeDefaultDesc: "Envíe mensajes con medios y botones personalizados para conectar con sus clientes.",
            templateTypeLimitedTimeOffer: "Oferta por tiempo limitado",
            templateTypeLimitedTimeOfferDesc: "Cree urgencia con promociones y códigos de oferta.",
            templateTypeCarousel: "Carrusel",
            templateTypeCarouselDesc: "Envíe un carrusel de tarjetas con imágenes y botones para mostrar varios productos u ofertas.",
            templateTypeProductMessage: "Mensaje de producto",
            templateTypeProductMessageDesc: "Envíe mensajes que impulsen ventas conectando su catálogo de productos.",
            templateTypeCallPermission: "Solicitud de permiso de llamada",
            templateTypeCallPermissionDesc: "Pregunte a los clientes si puede llamarles por WhatsApp.",
            templateTypeCouponCode: "Código de cupón",
            templateTypeCouponCodeDesc: "Envíe códigos promocionales con botón de copiar para canjear fácilmente.",
            templateTypeUtilityDefault: "Predeterminado",
            templateTypeUtilityDefaultDesc: "Envíe mensajes sobre un pedido o cuenta existente.",
            templateTypeOtp: "Contraseña de un solo uso",
            templateTypeOtpDesc: "Envíe códigos para verificar una transacción o inicio de sesión.",
            catalogueSubtypeCatalogue: "Mensaje de catálogo",
            catalogueSubtypeCatalogueDesc: "Muestre su catálogo completo con botón de ver catálogo.",
            catalogueSubtypeMultiProduct: "Mensaje multiproducto",
            catalogueSubtypeMultiProductDesc: "Muestre hasta 30 productos de su catálogo en un solo mensaje.",
            catalogueSubtypeSingleProduct: "Mensaje de producto único",
            catalogueSubtypeSingleProductDesc: "Destaque un producto con detalles y botón de llamada a la acción.",
            catalogueSubtypeProductCardCarousel: "Carrusel de tarjetas de producto",
            catalogueSubtypeProductCardCarouselDesc: "Muestre hasta 10 tarjetas de producto en vista carrusel.",
            catalogueSubtypeDisabledReason: "Actualmente no soportado. Este tipo de plantilla requiere integración con catálogo de productos.",
            authSubtypeCopyCode: "Copiar código",
            authSubtypeCopyCodeDesc: "El usuario copia el código manualmente (OTP estándar).",
            authSubtypeOneTap: "Un toque",
            authSubtypeOneTapDesc: "Rellenar código con un toque en dispositivos Android compatibles.",
            authSubtypeZeroTap: "Cero toques",
            authSubtypeZeroTapDesc: "Rellenar código automáticamente sin interacción del usuario (requiere consentimiento).",
            viewCatalog: "Ver catálogo",
            viewProduct: "Ver producto",
            viewProducts: "Ver productos",
            view: "Ver",
            copyOfferCode: "Copiar código de oferta",
            oneTapAutofill: "Autocompletado con un toque",
            zeroTapAutofill: "Autocompletado con cero toques",
            shopNow: "Comprar ahora",
            viewItems: "Ver artículos",
            autofill: "Autocompletar",
            messageTtlOptional: "Tiempo de vida del mensaje (TTL) • Opcional",
            selectTtlPlaceholder: "Seleccione TTL o deje por defecto",
            ttlDescMarketing: "Si no podemos entregar su mensaje de marketing, reintentaremos durante la duración indicada.",
            ttlDescUtility: "Indique cuánto tiempo entregaremos mensajes de utilidad como confirmaciones.",
            ttlDescAuthentication: "Defina cuánto tiempo son válidos los códigos de autenticación.",
            ttlInfoMarketing: "Plantillas de marketing: 12 horas a 30 días. Por defecto lo define el sistema.",
            ttlInfoUtility: "Plantillas de utilidad: 30 segundos a 12 horas, o -1 para 30 días. Por defecto lo define el sistema.",
            ttlInfoAuthentication: "Plantillas de autenticación: 30 segundos a 15 minutos, o -1 para 30 días. Por defecto lo define el sistema.",
            ttlOption12Hours: "12 horas (43.200 segundos)",
            ttlOption1Day: "1 día (86.400 segundos)",
            ttlOption3Days: "3 días (259.200 segundos)",
            ttlOption7Days: "7 días (604.800 segundos)",
            ttlOption15Days: "15 días (1.296.000 segundos)",
            ttlOption30Days: "30 días (2.592.000 segundos)",
            ttlOption30Seconds: "30 segundos",
            ttlOption1Minute: "1 minuto (60 segundos)",
            ttlOption2Minutes: "2 minutos (120 segundos)",
            ttlOption3Minutes: "3 minutos (180 segundos)",
            ttlOption5Minutes: "5 minutos (300 segundos)",
            ttlOption10Minutes: "10 minutos (600 segundos)",
            ttlOption15Minutes: "15 minutos (900 segundos)",
            ttlOption30Minutes: "30 minutos (1.800 segundos)",
            ttlOption1Hour: "1 hora (3.600 segundos)",
            ttlOption2Hours: "2 horas (7.200 segundos)",
            ttlOption4Hours: "4 horas (14.400 segundos)",
            ttlOption6Hours: "6 horas (21.600 segundos)",
            ttlOption30DaysSpecial: "30 días (valor especial: -1)",
            authSettings: "Configuración de autenticación",
            addSecurityRecommendation: "Añadir recomendación de seguridad",
            securityRecommendationHint: "Añade el mensaje \"Por su seguridad, no comparta este código\".",
            authMessageTtlHint: "Límite de tiempo para la entrega del mensaje (60-600 segundos). Deje vacío para predeterminado.",
            authTtlPlaceholder: "60-600",
            authCodeExpPlaceholder: "1-90",
            authPackagePlaceholder: "com.example.app",
            authSignatureHash: "Hash de firma",
            messageTtlSecondsOptional: "TTL del mensaje (segundos) • Opcional",
            codeExpirationOptional: "Caducidad del código (minutos) • Opcional",
            codeExpirationHint: "Cuánto tiempo es válido el código OTP. Se muestra en el pie.",
            zeroTapTerms: "Acepto los términos de Zero Tap",
            zeroTapTermsHint: "Requerido para el autocompletado Zero Tap.",
            supportedAndroidAppsOptional: "Apps Android soportadas • Opcional",
            addApp: "Añadir app",
            limitedTimeOfferLabel: "Oferta por tiempo limitado",
            ltoDescription: "Añada texto que cree urgencia. La hora de caducidad se fijará al enviar.",
            ltoPlaceholder: "ej., ¡Oferta por tiempo limitado!, ¡Oferta flash!",
            showExpirationTimer: "Mostrar temporizador de caducidad",
            ltoExpirationHint: "Cuando esté activo, WhatsApp mostrará una cuenta atrás según el envío.",
            carouselCards: "Tarjetas del carrusel",
            carouselCardsDescription: "Estas tarjetas aparecerán como segundo mensaje tras el cuerpo. Cada tarjeta debe tener encabezado imagen/vídeo y al menos un botón (máx. 2). El cuerpo de la tarjeta es opcional y admite variables. Hasta 10 tarjetas.",
            carouselCardN: "Tarjeta {n}",
            carouselButtonsLabel: "Botones * (al menos 1, hasta 2)",
            cardHeaderRequired: "Encabezado de la tarjeta",
            cardBodyOptional: "Cuerpo de la tarjeta • Opcional",
            cardBodyPlaceholder: "Introduzca el texto del cuerpo de la tarjeta (opcional)",
            image: "Imagen",
            video: "Vídeo",
            moveUp: "Subir",
            moveDown: "Bajar",
            remove: "Quitar",
            dragDropUpload: "Arrastre y suelte para subir",
            orChooseFiles: "O elija archivos en su dispositivo",
            uploadingToMeta: "Subiendo a Meta...",
            uploadedSuccessfully: "Subido correctamente",
            addQuickReplyButton: "Añadir botón de respuesta rápida",
            addCtaButton: "Añadir botón CTA",
            urlButtonRequiredLto: "El botón URL es obligatorio para Oferta por tiempo limitado",
            copyCodeButtonFixed: "El texto del botón copiar código no se puede personalizar en plantillas de cupón",
            copyCode: "Copiar código",
            fixed: "Fijo",
            buttonsHeading: "Botones",
            buttonLabelAutoAdded: "Se añade automáticamente",
            buttonLabelRequiredCopyCode: "Obligatorio (1 Copiar código + opcional)",
            buttonLabelRequiredUrl: "Obligatorio (1 URL + opcional)",
            buttonLabelOptional: "Opcional",
            buttonDescCatalogue: "Se añade un botón de producto automáticamente. Puedes personalizar el texto del botón.",
            buttonDescCallPermission: "Se añade un botón de permiso de llamada automáticamente. No se pueden añadir más botones.",
            buttonDescAuth: "Se añade un botón de autenticación automáticamente. Puedes personalizar el texto del botón.",
            buttonDescCoupon: "Un botón Copiar código es obligatorio y su texto no se puede personalizar. Puedes añadir botones de respuesta rápida o CTA hasta 10 en total.",
            buttonDescLto: "Las ofertas por tiempo limitado requieren al menos un botón URL. Puedes añadir botones CTA o de respuesta rápida adicionales.",
            buttonDescDefault: "Añade botones de respuesta rápida o CTA. Máximo 10 botones en total.",
            buttonPlaceholderText: "Texto del botón",
            buttonMax10Warning: "Máximo 10 botones permitidos",
            buttonCopyCodeAutoAddedWarning: "El botón Copiar código se añade automáticamente y no se puede añadir manualmente",
            exampleValuePlaceholder: "valor_ejemplo",
            copyCodeExamplePlaceholder: "SUMMER20",
            quickReply: "Respuesta rápida",
            visitWebsite: "Visitar sitio web",
            callPhone: "Llamar",
            addCard: "Añadir tarjeta",
            addButton: "Añadir botón",
            title: "Canales de Whatsapp Business API",
            integration: "Integración",
            detail: "Detalle",
            visibility: "Visibilidad",
            templates: "Todos los Mensajes de Plantilla",
            settings_group: "Configuración",
            template_message_group: "Mensajes de Plantilla",
            chat_initiator_template: "Plantilla de iniciación de chat",
            contacts: "Contactos",
            numbers: "Números",
            all_contacts: "Todos los contactos",
            new_template: "Crear nueva Plantilla",
            broadcast_group: "Difusión",
            broadcast_requests: "Solicitudes de Difusión",
            customer_groups: "Grupos de Clientes",
            businessChannelDetail: "Detalles del canal de Whatsapp Business",
            wallet: "Wallet",
            postacellMessage: "Enviar SMS",
            postacellAllMessage: "Enviar SMS Masivo",
            message_group: "Mensaje",
            createNewTemplate: "Crear nuevo mensaje de plantilla",
            templateName: "Nombre de la plantilla",
            templateNameDesc: "Dale un nombre a tu plantilla de mensaje.",
            templateInfo: "Información sobre plantillas",
            viewTemplates: "Ver plantillas",
            templateListTitle: "Plantillas de mensajes",
            templateListShownTotal: "{shown} plantillas mostradas (total: {total})",
            templateListCreateButton: "Crear plantilla",
            templateListSearchPlaceholder: "Buscar plantillas...",
            templateListAllCategories: "Todas las categorías",
            templateListAllStatus: "Todos los estados",
            templateListStatusApproved: "Aprobado",
            templateListStatusPending: "En revisión",
            templateListStatusRejected: "Rechazado",
            templateListRefresh: "Actualizar",
            templateListTotalTemplates: "Total {count} plantillas",
            templateListCopied: "¡Copiado!",
            templateListCopy: "Copiar",
            templateListIdLabel: "ID:",
            templateListPreview: "Vista previa",
            templateListEdit: "Editar",
            templateListDelete: "Eliminar",
            templateListPreviewTitle: "Vista previa de plantilla",
            templateListNameLabel: "Nombre:",
            templateListCategoryLabel: "Categoría:",
            templateListLanguageLabel: "Idioma:",
            templateListStatusLabel: "Estado:",
            templateListReasonLabel: "Motivo:",
            templateListRecommendationLabel: "Recomendación:",
            templateListColumnName: "NOMBRE DE PLANTILLA",
            templateListColumnCategory: "CATEGORÍA",
            templateListColumnStatus: "ESTADO",
            templateListColumnLastEdited: "ÚLTIMA EDICIÓN",
            templateListStatusActive: "Activo",
            templateListStatusInReview: "En revisión",
            templateListStatusRejected: "Rechazado",
            templateListStatusFailed: "Error",
            templateListQualityHigh: "Alta calidad",
            templateListQualityMedium: "Calidad media",
            templateListQualityLow: "Baja calidad",
            templateListDeleteConfirmTitle: "Eliminar plantilla",
            templateListDeleteConfirmContent: "¿Está seguro de que desea eliminar \"{{name}}\"?",
            templateListDeleteConfirmOk: "Eliminar",
            templateListDeleteConfirmCancel: "Cancelar",
            templateListCopyIdError: "Error al copiar el ID",
            templateListDeletedSuccess: "{{name}} eliminado correctamente.",
            templateListDeleteFailed: "Error al eliminar la plantilla.",
            templateNameRules: "El nombre de la plantilla solo puede incluir letras minúsculas, números y guiones bajos.",
            category: "Categoría",
            categoryDesc: "Seleccione qué tipo de plantilla desea crear",
            categoryUtility: "Utilidad",
            categoryUtilityDesc: "Envíe información de utilidad como actualizaciones de cuenta, actualizaciones de pedidos, alertas y más.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc: "Envíe ofertas promocionales, ofertas de productos y más para aumentar la conciencia y participación.",
            categoryAuth: "Autenticación",
            categoryAuthDesc: "Envíe códigos para que sus clientes puedan acceder a sus cuentas.",
            optional: "Opcional",
            languageDesc: "Seleccione el idioma en el que se enviará su mensaje de plantilla",
            header: "Encabezado",
            headerRules: "Agregue un encabezado de 60 caracteres a su mensaje. Solo se admite una variable en el encabezado.",
            headerOptionMedia: "Medios",
            headerOptionText: "Texto",
            none: "Ninguno",
            headerType: "Tipo de encabezado",
            headerText: "Texto del encabezado",
            body: "Cuerpo",
            bodyRules: "Ingrese texto en el idioma que seleccionó para su mensaje",
            addVariable: "Agregar variable",
            variables: "Variables",
            variable: "Variable",
            defaultVariableName: "Nombre de variable predeterminado",
            defaultVariableToolTip: "Su variable aparece en la plantilla con este nombre. <br><br> Además, este valor se envía por defecto en caso de otras situaciones.",
            selectATemplate: "Seleccione una plantilla de mensaje",
            variableSettings: "Configuración de variable",
            example: "Ejemplo",
            footer: "Pie de página",
            footerDesc: "Agrega un pie de página de 60 caracteres a tu mensaje. Las variables no son compatibles en el pie de página.",
            buttons: "Botones",
            buttonType: "Tipo de botón",
            buttonTypeReply: "Responder",
            submit: "Guardar",
            submitting: "Enviando",
            addButton: "Agregar botón",
            rejectWhatsapp: "Rechazado por Whatsapp.",
            approvedWhatsapp: "Aprobado por Whatsapp.",
            pendingWhatsapp: "Pendiente de aprobación",
            daily_usages: "Usos diarios",
            succesDesc: "Profil bilgileriniz başarılı bir şekilde güncellendi.",
            reports: "Raporlar",
            dynamicUrlSampleNote: "Sample dynamic URL with variable (Note: Do not add the URL in your sample message body above)",
            businessDescription: "وصف نشاطك التجاري.",
            bussinesDescription: "Business description",
            failedUpdateChannel: "Failed to update channel",
            postacellMessagepostacellMessage: "Envoyer un SMS",
            selectBusinessVertical: "Select Business Area",
            stateIfApplicable: "State (if applicable)"
        },
        multi_whatsapp_api: {
            profile: "Perfil",
            integration: "Integración",
            detail: "Detalle",
            visibility: "Visibilidad",
            templates: "Todos los mensajes de plantilla",
            settings_group: "Configuración",
            template_message_group: "Mensajes de plantilla",
            new_template: "Crear nueva plantilla",
            broadcast_group: "Mensaje masivo",
            broadcast_requests: "Envíos de mensajes masivos",
            customer_groups: "Grupos de clientes",
            chat_initiator_template: "Plantilla de iniciador de chat",
            contacts: "Contactos",
            numbers: "Números",
            all_contacts: "Todos los contactos"
        },
        archive: {
            destroyedBy: {
                agent: "Agente",
                visitor: "Visitante",
                system: "Sistema",
                chatbot: "Chatbot"
            }
        },
        upgradeMessages: {
            ticket: "¡Incluso si estás desconectado, tus solicitudes se registran al instante con inteligencia artificial y chatbot! ¡Mantén siempre satisfechos a tus clientes!",
            tasks: "¡Gestiona fácilmente tus tareas y proyectos! Colabora con tu equipo y entrega proyectos a tiempo.",
            calendar: "¡Planifica fácilmente tus citas y reuniones! Mantente sincronizado con tu equipo y gestiona tu tiempo de manera más eficiente.",
            mail_integration: "¡Gestiona tus correos electrónicos fácilmente! Refuerza la comunicación con tus clientes y mejora la colaboración.",
            team_integration: "¡Comunícate más rápido y eficazmente con tu equipo! Mejora la colaboración y garantiza la entrega oportuna de los proyectos.",
            webhook_integration: "¡Conecta tus aplicaciones mediante integración Webhook y simplifica el intercambio de datos!",
            whatsapp_v2: "¡Mejora la comunicación con tus clientes a través de la integración de WhatsApp para una comunicación más rápida y eficiente!",
            whatsapp: "¡Mejora la comunicación con tus clientes utilizando la integración de WhatsApp para una comunicación más rápida y efectiva!",
            whatsapp_business_api: "¡Aprovecha la API de WhatsApp Business para comunicarte con tus clientes de manera más eficiente y efectiva!",
            instagram: "¡Interactúa con tus clientes de manera más efectiva utilizando la integración de Instagram!",
            messenger: "¡Comunícate fácilmente con tus clientes a través de la integración de Messenger!",
            sms_postacell: "¡Comunica rápidamente y de manera efectiva con tus clientes usando la integración de SMS!",
            ready_contents: "Los Contenidos Listos te ayudan a comunicarte con tus clientes de manera más rápida y efectiva.",
            automation: "¡Automatiza tus flujos de trabajo para ahorrar tiempo y gestionar tareas de manera más eficiente!",
            form: "¡Utiliza el Creador de Formularios para agilizar las interacciones con los clientes, recopilar información valiosa y mejorar la colaboración!",
            customer_tables: "¡Crea tablas personalizadas y gestiona la información de los clientes de manera eficiente!",
            trendyol: "¡Mejora la comunicación con tus clientes mediante la integración de Trendyol para una interacción sin problemas!",
            access_control: "¡Protege tus datos y previene el acceso no autorizado con las funciones de control de acceso!",
            upgrade: "Actualizar mi suscripción",
            upgradeFeature: "Comprar paquete adicional",
            featureNotAvailable: "La función no está disponible.",
            usageLimitExceeded: "Se ha superado el límite de uso.",
            maxAgentCount: "Actualiza tu plan para atender a más clientes añadiendo más agentes.",
            maxTriggerCount: "Actualiza tu plan para generar más interacciones añadiendo más activadores.",
            visitorStartChat: "Actualiza tu plan para iniciar chats con visitantes que no han interactuado previamente.",
            voiceCalling: "Actualiza tu plan para comunicarte de manera más efectiva con tus clientes mediante llamadas de voz.",
            videoCalling: "Actualiza tu plan para comunicarte de manera más efectiva con tus clientes mediante videollamadas.",
            fileAndVoiceMessage: "Actualiza tu plan para enviar archivos y mensajes de voz a tus clientes.",
            autoTranslation: "Actualiza tu plan para atender a más clientes mediante la traducción automática de mensajes.",
            telegramEntegration: "Actualiza tu plan para habilitar la integración con Telegram.",
            chatCopilot: "Actualiza tu plan para ofrecer un mejor servicio con el asistente de chat impulsado por IA.",
            calenderEntegration: "Actualiza tu plan para sincronizar tu calendario con otras aplicaciones.",
            mailEntegration: "Actualiza tu plan para gestionar el correo electrónico de manera más efectiva y mejorar la comunicación con los clientes.",
            smsEntegration: "Actualiza tu plan para llegar a tus clientes más rápido mediante la integración de SMS.",
            ticketSystem: "Actualiza tu plan para gestionar las solicitudes de los clientes de manera más eficiente con el sistema de tickets.",
            taskManagementEntegration: "Actualiza tu plan para mejorar el flujo de trabajo mediante la integración de gestión de tareas.",
            webhookEntegration: "Actualiza tu plan para sincronizar otras aplicaciones mediante la integración de webhooks.",
            readyContents: "Actualiza tu plan para mejorar la comunicación con los clientes mediante contenidos predefinidos.",
            automationEntegration: "Actualiza tu plan para optimizar el flujo de trabajo con la integración de automatización.",
            customerTablesEntegration: "Actualiza tu plan para gestionar la información de los clientes de manera más efectiva mediante tablas de clientes.",
            formEntegration: "Actualiza tu plan para gestionar las solicitudes de los clientes mediante formularios.",
            maxFormLimit: "Actualiza tu plan para crear más formularios y gestionar mejor las solicitudes de los clientes.",
            maxFormFieldLimit: "Actualiza tu plan para añadir más campos a los formularios y mejorar la gestión de solicitudes.",
            maxCustomerTableCount: "Actualiza tu plan para añadir más tablas de clientes.",
            maxCustomerTableFieldCount: "Actualiza tu plan para añadir más campos a las tablas de clientes.",
            maxCustomerTableViewCount: "Actualiza tu plan para guardar más vistas de tablas de clientes.",
            maxCustomerTableRecordCount: "Actualiza tu plan para añadir más registros a las tablas de clientes.",
            maxAutomationButton: "Actualiza tu plan para añadir más bloques de automatización.",
            automationTimerBase: "Actualiza tu plan para usar temporizadores de automatización.",
            automationEventBase: "Actualiza tu plan para usar eventos de automatización.",
            automationWebhookBase: "Actualiza tu plan para usar webhooks de automatización.",
            automationButtonBase: "Actualiza tu plan para usar botones de automatización.",
            liveScore: "Actualiza tu plan para habilitar la función de monitoreo en tiempo real.",
            multipleChatWindow: "Actualiza tu plan para abrir múltiples ventanas de chat simultáneamente.",
            maxTaskWorkflowLimit: "Actualiza tu plan para añadir más flujos de trabajo de tareas.",
            maxTaskColumnLimit: "Actualiza tu plan para añadir más columnas en las tareas.",
            maxTaskRowLimit: "Actualiza tu plan para añadir más filas en las tareas.",
            maxDepartmentLimit: "Actualiza tu plan para añadir más departamentos.",
            maxRoleLimit: "Actualiza tu plan para añadir más roles.",
            maxReadyContentsLimit: "Actualiza tu plan para añadir más contenidos predefinidos.",
            excelDownload: "Actualiza tu plan para habilitar la función de descarga de archivos Excel.",
            customerGroup: "Actualiza tu plan para usar la función de grupos de clientes.",
            maxMailCount: "Actualiza tu plan para enviar más correos electrónicos.",
            maxWhatsappChannel: "Actualiza tu plan para añadir más canales de WhatsApp.",
            maxBusinessWhatsappChannel: "Actualiza tu plan para añadir más canales de WhatsApp Business.",
            maxInstagramChannel: "Actualiza tu plan para añadir más canales de Instagram.",
            maxMessengerChannel: "Actualiza tu plan para añadir más canales de Messenger.",
            maxTelegramChannel: "Actualiza tu plan para añadir más canales de Telegram.",
            maxTrendyolChannel: "Actualiza tu plan para añadir más canales de Trendyol.",
            maxMetaLeadChannel: "Actualiza tu plan para añadir más canales de Meta Lead."
        },
        setupWizard: {
            finishModalVideos: "Videos Entrenamiento",
            finishModalDoc: "Documentación",
            finsihModalLiveSupport: "Soporte en Vivo",
            supsisSetupGuide: "Guía de Supsis",
            completed: "Entendido",
            completedWarning: "Haz clic en el botón para completar la configuración y finalizar la guía",
            supsisSetupGuideDescription: "Por favor, completa estos pasos para utilizar Supsis al máximo.",
            goToSetup: "Ir a Configuración",
            completionPercentageDescription: "Solo estás utilizando el % {percentage} de las funciones ofrecidas por Supsis.",
            aiChatbot: {
                title: "Chatbot de IA",
                content: "Responde a los mensajes entrantes de forma automática, instantánea e inteligente con Supsis AI Chatbot.",
                steps: {
                    step1: {
                        title: "Crear Chatbot",
                        content: "Usa este botón para crear un nuevo <b>escenario de chatbot</b>. Puedes comenzar rápidamente seleccionando una de las plantillas especialmente preparadas para ti, o diseñar un escenario completamente original desde cero para crear un chatbot que satisfaga plenamente las necesidades de tu negocio."
                    },
                    step2: {
                        title: "Escenarios Prediseñados",
                        content: "Comprende fácilmente la lógica de funcionamiento básica del chatbot con las <b>plantillas prediseñadas</b> aquí. Ahorra tiempo personalizando estas plantillas según tus necesidades y desarrolla soluciones a medida. Puedes comenzar eligiendo cualquiera de las plantillas listadas a continuación, adecuadas para diferentes casos de uso."
                    },
                    step3: {
                        title: "Integraciones de Chatbot",
                        content: "Integra tu chatbot preparado con <b>plataformas de redes sociales populares como WhatsApp, Instagram y Facebook</b>. De esta manera, puedes activar tu chatbot directamente en los canales que usan tus clientes, aumentando tu accesibilidad y tasas de participación."
                    },
                    step4: {
                        title: "Análisis de Chatbot",
                        content: "Visualiza y analiza el <b>rendimiento de tu chatbot con gráficos y estadísticas detalladas</b>. Al filtrar según períodos de tiempo específicos o las plataformas que has integrado, puedes medir la efectividad de tu chatbot, identificar áreas de mejora y optimizar tus estrategias."
                    }
                }
            },
            aiAssistant: {
                title: "Asistente de IA",
                content: "Activa el asistente digital para ayudar a tu equipo de soporte.",
                steps: {
                    step1: {
                        title: "Integración OpenAI",
                        content: "<p>Establece una <b>integración perfecta</b> entre OpenAI y Supsis AI para aumentar la eficiencia de tu negocio. De esta manera, tu potente asistente de IA se activará y comenzará a optimizar tus procesos. Para completar la integración, todo lo que necesitas hacer es introducir tu clave API de OpenAI. <br> <br> <b>Para obtener tu clave API de OpenAI, <a href='https://platform.openai.com/account/api-keys' target='_blank'>haz clic aquí</a>.</b></p>"
                    }
                }
            },
            aiLiveSupport: {
                title: "Soporte en Vivo con IA",
                content: "Activa el sistema de chat en vivo impulsado por IA.",
                steps: {
                    step1: {
                        title: "Filtrar Conversaciones",
                        content: "Gestiona fácilmente <b>todas las conversaciones con clientes</b> desde esta área. Puedes priorizar las conversaciones filtrándolas en diferentes categorías como no leídas, pendientes o aquellas en curso con el chatbot, asegurando que ninguna solicitud sea pasada por alto."
                    },
                    step2: {
                        title: "Vista Más Detallada",
                        content: "Usa estas opciones para examinar las conversaciones con los clientes con mayor profundidad. Puedes aplicar <b>filtro más detallados</b> como conversaciones sin respuesta de ayer o clientes específicos que te han contactado, o crear tus propios filtros personalizados para personalizar tu flujo de trabajo."
                    },
                    step3: {
                        title: "Pantalla de Soporte en Vivo",
                        content: "Cambia a esta vista para <b>gestionar eficientemente todas tus conversaciones de soporte en vivo desde una pantalla centralizada</b>. Visualiza todos los mensajes, respuestas del agente, estados actuales e información de fecha para cada conversación en un solo lugar, lo que te permite tomar decisiones rápidas y precisas."
                    },
                    step4: {
                        title: "Página de Prueba",
                        content: "Accede a esta sección para probar el rendimiento y el funcionamiento de tu chatbot creado en tiempo real. Al enviar mensajes como visitante, puedes <b>observar de cerca las respuestas y comportamientos de tu chatbot</b>, lo que te permite realizar todas las mejoras necesarias antes de presentarlo a los usuarios finales."
                    }
                }
            },
            aiAutomation: {
                title: "Automatización de IA",
                content: "Automatiza tus procesos de soporte y ahorra tiempo.",
                steps: {
                    step1: {
                        title: "Crear Nueva Automatización",
                        content: "Usa este botón para crear una nueva automatización y optimizar tus procesos de negocio. Puedes diseñar automatizaciones basadas en eventos (por ejemplo, cuando llega un nuevo mensaje), basadas en tiempo (por ejemplo, a una hora específica cada mañana), o <b>basadas en Webhook</b> para hacer tus flujos de trabajo más inteligentes."
                    },
                    step2: {
                        title: "Categorías de Automatización",
                        content: "Cuando tengas muchas automatizaciones, crea <b>categorías de automatización</b> desde esta sección para facilitar la gestión. La categorización te ayuda a mantener tus automatizaciones organizadas y encontrarlas rápidamente cuando las necesites. Usa este botón para crear una nueva categoría."
                    },
                    step3: {
                        title: "Tareas Ejecutadas",
                        content: "Después de crear y publicar tus automatizaciones, puedes <b>rastrear instantáneamente cuántas tareas han ejecutado tus automatizaciones</b> desde esta sección. Esto te permite observar qué tan activas están tus automatizaciones y qué procesos afectan."
                    },
                    step4: {
                        title: "Estadísticas de Automatización",
                        content: "Revisa <b>estadísticas de rendimiento completas</b> de tus automatizaciones en esta sección. Ve con qué frecuencia se ejecuta cada automatización, el número de tareas exitosas, la tasa de éxito y cualquier tasa de error para optimizar tus estrategias de automatización."
                    }
                }
            },
            aiDynamicCrm: {
                title: "CRM de IA",
                content: "Analiza y gestiona tus interacciones con los clientes con inteligencia artificial.",
                steps: {
                    step1: {
                        title: "Filtrar Visitantes",
                        content: "<b>Filtra fácilmente a los visitantes</b> en tu base de datos de clientes. Puedes buscar visitantes por nombre, dirección de correo electrónico, número de teléfono, etiqueta o campos de perfil personalizados. También puedes acceder a esta sección para una visualización y análisis más detallados."
                    },
                    step2: {
                        title: "Ver Visitantes",
                        content: "Todos tus visitantes están listados en esta tabla. <b>Haz doble clic en la fila relevante para acceder a más información y tomar acciones sobre un visitante</b>. En la ventana abierta, puedes acceder al historial de comunicación del visitante, notas y otra información detallada."
                    },
                    step3: {
                        title: "Bloqueo Manual",
                        content: "Puedes <b>bloquear manualmente a los visitantes</b> que exhiban un comportamiento no deseado o inapropiado. Los visitantes bloqueados se muestran en una lista separada, y puedes eliminar el bloqueo desde esta sección si es necesario."
                    },
                    step4: {
                        title: "Etiquetas",
                        content: "Haz tu CRM más organizado y manejable <b>categorizando a tus visitantes con etiquetas</b>. Para asignar etiquetas a los visitantes, primero debes crear tus propias etiquetas. Usa este botón para crear una nueva etiqueta."
                    },
                    step5: {
                        title: "Campos de Perfil",
                        content: "Los <b>campos de perfil</b> te permiten recopilar información adicional sobre tus visitantes y gestionar esta información de forma organizada. De esta manera, puedes profundizar tu segmentación de clientes, ofrecer un servicio personalizado y hacer tus relaciones con los clientes más efectivas."
                    }
                }
            },
            whatsappBusiness: {
                title: "WhatsApp Business",
                content: "Gestiona tus mensajes de soporte conectando tu cuenta de WhatsApp Business.",
                steps: {
                    step1: {
                        title: "Integración de WhatsApp Business",
                        content: "<p><b>Conecta tu cuenta de WhatsApp Business a Supsis</b> y gestiona todos tus mensajes de soporte al cliente desde un único panel central. Con esta integración, puedes enviar mensajes instantáneos a través de WhatsApp, hacer anuncios masivos, configurar respuestas automáticas y rastrear exhaustivamente tus interacciones con los clientes.</p>"
                    }
                }
            },
            whatsappWeb: {
                title: "WhatsApp Web",
                content: "Gestiona los mensajes recibidos a través de WhatsApp Web con Supsis AI.",
                steps: {
                    step1: {
                        title: "Integración de WhatsApp Web",
                        content: "<p><b>Gestiona sin problemas todos los mensajes recibidos a través de WhatsApp Web con Supsis AI.</b> Con esta integración, puedes enviar mensajes instantáneos a través de WhatsApp, crear mensajes masivos, configurar respuestas automáticas y rastrear fácilmente tus interacciones con los clientes. De esta manera, haces que tu comunicación con el cliente sea más eficiente.</p>"
                    }
                }
            },
            instagram: {
                title: "Instagram",
                content: "Responde a los DMs de Instagram a través de Supsis AI.",
                steps: {
                    step1: {
                        title: "Integración de Instagram",
                        content: "<p><b>Centraliza tu comunicación con el cliente respondiendo directamente a los DMs de Instagram a través de Supsis AI.</b> Con esta integración, puedes enviar mensajes instantáneos a través de Instagram, hacer anuncios masivos, configurar respuestas automáticas y rastrear exhaustivamente tus interacciones con los clientes.</p>"
                    }
                }
            },
            facebook: {
                title: "Facebook",
                content: "Gestiona los mensajes de tu página de Facebook en un único panel.",
                steps: {
                    step1: {
                        title: "Integración de Facebook",
                        content: "<p><b>Gestiona eficazmente todos los mensajes de tu página de Facebook con Supsis AI.</b> Con esta integración, puedes enviar mensajes instantáneos a través de Facebook Messenger, crear mensajes masivos, configurar respuestas automáticas y rastrear tus interacciones con los clientes.</p>"
                    }
                }
            },
            telegram: {
                title: "Telegram",
                content: "Integra mensajes de Telegram con Supsis AI.",
                steps: {
                    step1: {
                        title: "Integración de Telegram",
                        content: "<p><b>Integra mensajes de Telegram con Supsis AI</b> y gestiona tu comunicación con el cliente desde un único panel. Con esta integración, puedes enviar mensajes instantáneos a través de Telegram, crear mensajes masivos, configurar respuestas automáticas y rastrear sin esfuerzo todas tus interacciones con el cliente.</p>"
                    }
                }
            },
            mail: {
                title: "Correo Electrónico",
                content: "Integra tus correos electrónicos de soporte en el sistema Supsis AI.",
                steps: {
                    step1: {
                        title: "Crear un Nuevo Correo Electrónico",
                        content: "<p>Usa este botón para enviar un nuevo correo electrónico. <b>Al rellenar el contenido del correo electrónico, los destinatarios y otra información necesaria</b>, puedes enviar rápidamente tus correos electrónicos personales o masivos.</p>"
                    },
                    step2: {
                        title: "Plantillas de Correo Electrónico",
                        content: "<p><b>Gestiona</b> tus plantillas de correo electrónico desde esta sección. Puedes editar, eliminar o crear nuevas plantillas. Al usar plantillas pre-preparadas, puedes acelerar tus procesos de envío de correos electrónicos y asegurar una comunicación consistente.</p>"
                    },
                    step3: {
                        title: "Enviar Correos Electrónicos Masivos",
                        content: "<p>Usa esta área para <b>enviar correos electrónicos masivos</b> para llegar a grandes audiencias. Al rellenar los campos requeridos, puedes enviar fácilmente correos electrónicos masivos a tu lista de clientes o grupos específicos en Supsis.</p>"
                    },
                    step4: {
                        title: "Gestionar tus Grupos de Clientes",
                        content: "<p><b>Gestiona eficazmente</b> tus grupos de clientes desde esta sección. Puedes editar, eliminar o crear nuevos grupos. Con estos grupos, puedes organizar campañas de correo electrónico dirigidas y personalizar aún más tu comunicación.</p>"
                    }
                }
            },
            metaLead: {
                title: "Meta Lead",
                content: "Gestiona los formularios recibidos de tus anuncios de Facebook e Instagram.",
                steps: {
                    step1: {
                        title: "Integración de Meta Lead",
                        content: "<p>Con la <b>Integración de Meta Lead</b>, gestiona los formularios de clientes potenciales recibidos de tus anuncios de Facebook e Instagram directamente a través de Supsis. Gracias a esta integración, puedes rastrear los leads que obtienes de tus campañas publicitarias de manera más eficiente, acelerar tu comunicación con clientes potenciales y aumentar tus tasas de conversión.</p>"
                    }
                }
            },
            trendyol: {
                title: "Trendyol",
                content: "Gestiona tus pedidos y mensajes de clientes de Trendyol.",
                steps: {
                    step1: {
                        title: "Integración de Trendyol",
                        content: "<p>Gracias a las <b>Operaciones de Integración de Trendyol</b>, gestiona centralmente tus pedidos recibidos a través de Trendyol a través de Supsis. Después de completar esta integración, puedes hacer tus procesos de pedido más eficientes, facilitar tu comunicación con el cliente y reducir tu carga de trabajo operativa.</p>"
                    }
                }
            },
            formSurvey: {
                title: "Formularios y Encuestas",
                content: "Crea formularios para recopilar comentarios de los clientes.",
                steps: {
                    step1: {
                        title: "Crear un Nuevo Formulario",
                        content: "<p>Usa este botón para <b>crear un nuevo formulario o encuesta</b> para recopilar comentarios de tus clientes. Con los formularios que crees, puedes reunir valiosos comentarios de los clientes y hacer tu comunicación más eficiente.</p>"
                    },
                    step2: {
                        title: "Gestionar tus Formularios",
                        content: "<p><b>Gestiona todos tus formularios de manera efectiva</b> desde esta área. Puedes editar, archivar, eliminar o crear nuevos formularios. También puedes rastrear el rendimiento de tus formularios publicados, ver las tasas de respuesta y realizar ediciones instantáneas cuando sea necesario. Con la gestión de formularios, puedes recopilar y analizar los comentarios de los clientes de manera más efectiva.</p>"
                    }
                }
            },
            processManagement: {
                title: "Gestión de Procesos",
                content: "Planifica y gestiona tus procesos de soporte paso a paso.",
                steps: {
                    step1: {
                        title: "Gestionar tus Procesos de Negocio",
                        content: "<p>Esta sección te permite gestionar eficazmente todos tus procesos de negocio. <b>Puedes crear tareas, asignarlas a los miembros de tu equipo y optimizar tus flujos de trabajo.</b> De esta manera, puedes hacer tus procesos más eficientes, rastrear el estado de las tareas al instante y aumentar el rendimiento de tu equipo.</p>"
                    },
                    step2: {
                        title: "Listar Tareas",
                        content: "<p><b>Visualiza todas tus tareas en una vista de lista</b> desde esta sección. Puedes filtrar, eliminar o crear nuevas tareas. Rastrea fácilmente tu carga de trabajo con una vista de lista completa.</p>"
                    },
                    step3: {
                        title: "Etiquetas de Tarea",
                        content: "<p><b>Crea etiquetas</b> para organizar y gestionar mejor tus tareas. Al usar estas etiquetas, puedes categorizar fácilmente las tareas y acelerar tus procesos de búsqueda. Puedes usar este botón para crear etiquetas.</p>"
                    },
                    step4: {
                        title: "Archivar Tareas",
                        content: "<p><b>Archiva tareas completadas o inactivas para mantener tu espacio de trabajo organizado</b>. Las tareas archivadas se listan aquí y se pueden restaurar fácilmente cuando sea necesario.</p>"
                    },
                    step5: {
                        title: "Tareas Completadas",
                        content: "<p>Visualiza tus <b>tareas completadas</b> desde esta sección. Puedes cambiar el estado de las tareas completadas y archivarlas si lo deseas. De esta manera, puedes mantener un registro de tu trabajo completado y analizar el rendimiento pasado.</p>"
                    }
                }
            },
            calendar: {
                title: "Calendario",
                content: "Gestiona tu calendario de reuniones y tareas.",
                steps: {
                    step1: {
                        title: "Calendario",
                        content: "<p>Planifica fácilmente tus reuniones diarias con este <b>calendario</b> interactivo. Puedes crear nuevas citas, actualizar reuniones existentes a través del calendario o cancelarlas. Optimiza tu gestión de citas y controla eficazmente tu horario.</p>"
                    },
                    step2: {
                        title: "Sitio Web de Reservas",
                        content: "<p>Permite a tus clientes hacer citas fácilmente utilizando tu propio <b>sitio web de reservas</b>. Tus clientes pueden hacer reservas, ver, actualizar o cancelar sus citas existentes a través de este sitio.</p>"
                    },
                    step3: {
                        title: "Ver tu Sitio Web",
                        content: "<p>Usa este botón para ver instantáneamente el sitio web de reservas que creaste. <b>Verifica la versión final de tu sitio web</b> y experimenta cómo tus clientes verán sus reservas. Todas tus reservas activas se listarán en tu sitio web.</p>"
                    },
                    step4: {
                        title: "Crear una Nueva Reserva",
                        content: "<p>Usa este botón para <b>crear manualmente una nueva reserva</b>. Al rellenar toda la información necesaria, puedes añadir rápidamente la cita a tu calendario y planificar tus reuniones con tus clientes.</p>"
                    }
                }
            },
            websiteAnalysis: {
                title: "Análisis de Sitio Web",
                content: "Analiza el comportamiento del visitante y obtén información valiosa.",
                steps: {
                    step1: {
                        title: "Visitantes Totales",
                        content: "<p>Visualiza el <b>número total de visitantes</b> de tu sitio web desde esta área. Esta métrica muestra el número total de visitantes únicos de tu sitio dentro de un período de tiempo específico y te ayuda a comprender el alcance total de tu sitio.</p>"
                    },
                    step2: {
                        title: "Visitantes Promedio",
                        content: "<p>Rastrea el <b>número promedio diario o periódico de visitantes</b> de tu sitio web aquí. Esta métrica es un indicador crítico para evaluar el rendimiento consistente de tu sitio a lo largo del tiempo.</p>"
                    },
                    step3: {
                        title: "Visitantes Máximos",
                        content: "<p>Observa los <b>momentos en que tu sitio web alcanzó el mayor número de visitantes</b> con esta métrica. Muestra el número más alto de visitantes de tu sitio dentro de un período de tiempo específico, lo que te ayuda a identificar períodos pico para campañas o contenido.</p>"
                    },
                    step4: {
                        title: "Visitantes Mínimos",
                        content: "<p>Rastrea los <b>momentos en que tu sitio web recibió la menor cantidad de visitantes</b> con esta métrica. Muestra el número más bajo de visitantes de tu sitio dentro de un período de tiempo específico, lo que te ayuda a identificar períodos de bajo rendimiento y tomar las medidas necesarias.</p>"
                    }
                }
            },
            ticketSystem: {
                title: "Sistema de Tickets de Soporte",
                content: "Organiza las solicitudes de los clientes con un sistema de tickets.",
                steps: {
                    step1: {
                        title: "Nuevo Estado",
                        content: "<p><b>Crea nuevos estados</b> para facilitar la gestión de tus solicitudes de soporte. Por ejemplo, al definir estados personalizados como 'En Progreso', 'Resuelto', 'Pendiente', puedes hacer que el flujo de solicitudes sea más transparente.</p>"
                    },
                    step2: {
                        title: "Estados",
                        content: "<p><b>Visualiza los estados actuales</b> para cada solicitud de soporte abierta aquí. Al rastrear estados como 'Leído', 'Respondido', 'Cancelado', puedes ver fácilmente las etapas actuales de las solicitudes y permitir una gestión eficaz del proceso.</p>"
                    },
                    step3: {
                        title: "Modo de Vista",
                        content: "<p>Puedes cambiar entre la <b>vista de lista o kanban</b> para gestionar tus solicitudes de soporte de manera más efectiva. Al cambiar el modo de vista, puedes rastrear visualmente los estados de las solicitudes y elegir el diseño que mejor se adapte a tu flujo de trabajo.</p>"
                    }
                }
            },
            dynamicTables: {
                title: "Tablas Dinámicas",
                content: "Personaliza y gestiona tus datos filtrando.",
                steps: {
                    step1: {
                        title: "Crear Categoría",
                        content: "<p><b>Organiza y gestiona mejor tus datos categorizando tus tablas</b>. Al usar el botón de creación de categorías, puedes definir nuevas categorías, agrupar tus tablas y acceder a los datos que buscas más rápidamente.</p>"
                    },
                    step2: {
                        title: "Crear Nueva Tabla",
                        content: "<p>Usa este botón para <b>crear una nueva tabla dinámica adaptada a tus necesidades</b>. Al rellenar la información requerida en la pantalla de creación de tablas, puedes almacenar y gestionar tus datos en una estructura personalizada.</p>"
                    },
                    step3: {
                        title: "Crear Tabla con IA",
                        content: "<p>Usa este botón para <b>crear rápidamente nuevas tablas con soporte de IA</b>. Es suficiente con introducir la información relevante para crear una tabla con IA; el sistema te ayudará a diseñar tablas eficientes con sugerencias inteligentes.</p>"
                    }
                }
            },
            aiVoice: {
                title: "Agente de Voz de IA",
                content: "Gestiona las conversaciones de tus usuarios con agentes de voz impulsados por IA.",
                steps: {
                    step1: {
                        title: "Integración de Agente de Voz de IA",
                        content: "<p><b>Integra tu agente de voz de IA en Supsis</b> para automatizar y mejorar tus procesos de comunicación con el cliente. Después de completar la integración, puedes gestionar las interacciones de voz de manera más eficiente y aumentar la satisfacción del cliente.</p>"
                    }
                }
            }
        },
        common: {
            cancel: "Cancelar",
            save: "Guardar",
            yes: "Sí",
            no: "No",
            create: "Crear",
            delete: "Eliminar",
            edit: "Editar",
            add: "Añadir",
            back: "Volver",
            active: "Activo",
            inactive: "Inactivo"
        },
        youtubeChannel: {
            youtubeIntegration: "Integración de YouTube",
            deleteYoutubeChannelInfo: "¿Está seguro de que desea eliminar este canal de YouTube?",
            youtubeChannels: "Canales de YouTube",
            title: "Comentarios de YouTube",
            channelName: "Nombre del canal",
            channelDetail: "Detalles del canal",
            channelDetailDesc: "Administra tu canal de YouTube",
            youtubeChannel: "Canal de YouTube",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            detail: "Detalle",
            visibility: "Visibilidad",
            videos: "Videos",
            comments: "Comentarios",
            visibilitySettings: "Configuración de visibilidad",
            visibilityDescription: "Establece qué usuarios y departamentos pueden ver este canal",
            users: "Usuarios",
            departments: "Departamentos",
            owners: "Propietarios",
            selectUsers: "Seleccionar usuarios",
            selectDepartments: "Seleccionar departamentos",
            selectOwners: "Seleccionar propietarios",
            deleteChannel: "Eliminar canal",
            deleteChannelDescription: "¿Está seguro de que desea eliminar este canal de YouTube?",
            channelUpdatedSuccess: "Canal actualizado con éxito",
            failedUpdateChannel: "Error al actualizar el canal",
            connectedSuccess: "Cuenta de YouTube conectada con éxito",
            failedToCreateChannel: "Error al crear el canal",
            requiredChannel: "El nombre del canal es obligatorio",
            oauthTimeout: "Tiempo de espera de autorización agotado",
            all: "Todo",
            new: "Nuevo",
            replied: "Respondido",
            resolved: "Resuelto",
            searchComments: "Buscar comentarios",
            noCommentsFound: "No se encontraron comentarios",
            replies: "respuestas",
            like: "Me gusta",
            reply: "Responder",
            replyToComment: "Responder al comentario",
            writeYourReply: "Escriba su respuesta",
            pleaseEnterReply: "Introduzca una respuesta",
            replySuccess: "Respuesta enviada correctamente",
            errorSendingReply: "Error al enviar la respuesta",
            statusUpdated: "Estado actualizado",
            errorUpdatingStatus: "Error al actualizar el estado",
            errorFetchingComments: "Error al cargar los comentarios",
            commentLiked: "Comentario marcado como me gusta",
            errorLikingComment: "Error al marcar el comentario",
            noVideosFound: "No se encontraron vídeos",
            errorFetchingVideos: "Error al cargar los vídeos",
            refresh: "Actualizar",
            loadMore: "Cargar más",
            ensureYouTubeAccount: "Asegúrese de tener una cuenta de Google/YouTube",
            ensureYouTubeChannel: "Asegúrese de tener un canal de YouTube",
            permissionDesc: "Debe permitir que Supsis acceda a sus comentarios de YouTube.",
            connectToYouTube: "Conectar con YouTube",
            views: "visualizaciones",
            likes: "me gusta",
            sync: "Sincronizar",
            commentsSynced: "Comentarios sincronizados",
            errorSyncingComments: "Error al sincronizar comentarios",
            pending: "Pendiente",
            rejected: "Rechazado",
            moderation: "Moderación",
            publish: "Publicar",
            holdForReview: "Retener para revisión",
            reject: "Rechazar",
            rejectAndBan: "Rechazar y prohibir",
            moderationSuccess: "Moderación correcta",
            errorModeration: "Error en la moderación",
            videoDetail: "Detalle del vídeo",
            duration: "Duración",
            showMore: "Mostrar más",
            showLess: "Mostrar menos",
            loadingVideo: "Cargando vídeo...",
            videoNotFound: "Vídeo no encontrado",
            goBack: "Volver",
            errorLoadingVideo: "Error al cargar el vídeo",
            videosSynced: "Vídeos sincronizados",
            errorSyncingVideos: "Error al sincronizar vídeos",
            selectVideo: "Seleccionar vídeo",
            allVideos: "Todos los vídeos",
            selectCommentToPreview: "Seleccione un comentario para la vista previa",
            viewDetails: "Ver detalles",
            published: "Publicado",
            heldForReview: "Retenido para revisión"
        },
        googleBusiness: {
            title: "Reseñas de Google Business",
            channels: "Canales de Google Business",
            channelName: "Nombre del canal",
            channelDetails: "Detalles del canal",
            connectToGoogleBusiness: "Conectar con Google Business",
            ensureGoogleAccount: "Asegúrese de tener una cuenta de Google",
            ensureBusinessProfile: "Asegúrese de tener una cuenta de Google Business Profile",
            permissionDesc: "Debe permitir que Supsis acceda a sus reseñas de Google Business.",
            requiredChannel: "El nombre del canal es obligatorio",
            failedToCreateChannel: "Error al crear el canal",
            connectedSuccess: "Cuenta de Google Business conectada correctamente",
            oauthTimeout: "Tiempo de autorización agotado",
            deleteChannelInfo: "¿Está seguro de que desea eliminar este canal de Google Business?",
            deleteChannel: "Eliminar canal",
            deleteChannelDescription: "¿Está seguro de que desea eliminar este canal de Google Business?",
            detail: "Detalle",
            visibility: "Visibilidad",
            locations: "Ubicaciones",
            reviews: "Reseñas",
            accountInfo: "Información de la cuenta",
            accountName: "Nombre de la cuenta",
            accountId: "ID de la cuenta",
            status: "Estado",
            enabled: "Habilitado",
            disabled: "Deshabilitado",
            save: "Guardar",
            channelUpdated: "Canal actualizado correctamente",
            errorUpdatingChannel: "Error al actualizar el canal",
            visibilityDescription: "Establezca qué usuarios y departamentos pueden ver este canal",
            visibleToUsers: "Visible para usuarios",
            visibleToDepartments: "Visible para departamentos",
            selectUsers: "Seleccionar usuarios",
            selectDepartments: "Seleccionar departamentos",
            visibilityUpdated: "Configuración de visibilidad actualizada",
            errorUpdatingVisibility: "Error al actualizar la visibilidad",
            sync: "Sincronizar",
            refresh: "Actualizar",
            locationsSynced: "Ubicaciones sincronizadas",
            errorSyncingLocations: "Error al sincronizar ubicaciones",
            errorFetchingLocations: "Error al cargar ubicaciones",
            noLocationsFound: "No se encontraron ubicaciones",
            selectLocation: "Seleccionar ubicación",
            allLocations: "Todas las ubicaciones",
            allRatings: "Todas las valoraciones",
            all: "Todo",
            new: "Nuevo",
            replied: "Respondido",
            resolved: "Resuelto",
            noReviewsFound: "No se encontraron reseñas",
            noComment: "Sin texto de comentario",
            selectReviewToPreview: "Seleccione una reseña para la vista previa",
            yourReply: "Su respuesta",
            reply: "Responder",
            updateReply: "Actualizar respuesta",
            replyToReview: "Responder a la reseña",
            writeYourReply: "Escriba su respuesta",
            pleaseEnterReply: "Introduzca una respuesta",
            replySuccess: "Respuesta enviada correctamente",
            errorSendingReply: "Error al enviar la respuesta",
            statusUpdated: "Estado actualizado",
            errorUpdatingStatus: "Error al actualizar el estado",
            errorFetchingReviews: "Error al cargar las reseñas"
        },
        googlePlay: {
            title: "Reseñas de Google Play",
            channels: "Canales de Google Play",
            channelName: "Nombre del canal",
            channelDetails: "Detalles del canal",
            connectToGooglePlay: "Conectar con Google Play",
            ensureGoogleAccount: "Asegúrese de tener una cuenta de Google",
            ensurePlayConsole: "Asegúrese de tener una cuenta de Google Play Console",
            permissionDesc: "Debe permitir que Supsis acceda a sus reseñas de Google Play.",
            requiredChannel: "El nombre del canal es obligatorio",
            failedToCreateChannel: "Error al crear el canal",
            connectedSuccess: "Cuenta de Google Play conectada correctamente",
            oauthTimeout: "Tiempo de autorización agotado",
            deleteChannelInfo: "¿Está seguro de que desea eliminar este canal de Google Play?",
            deleteChannel: "Eliminar canal",
            deleteChannelDescription: "¿Está seguro de que desea eliminar este canal de Google Play?",
            detail: "Detalle",
            visibility: "Visibilidad",
            apps: "Aplicaciones",
            reviews: "Reseñas",
            status: "Estado",
            enabled: "Habilitado",
            disabled: "Deshabilitado",
            save: "Guardar",
            channelUpdated: "Canal actualizado correctamente",
            errorUpdatingChannel: "Error al actualizar el canal",
            visibilityDescription: "Establezca qué usuarios y departamentos pueden ver este canal",
            visibleToUsers: "Visible para usuarios",
            visibleToDepartments: "Visible para departamentos",
            selectUsers: "Seleccionar usuarios",
            selectDepartments: "Seleccionar departamentos",
            visibilityUpdated: "Configuración de visibilidad actualizada",
            errorUpdatingVisibility: "Error al actualizar la visibilidad",
            addApp: "Añadir aplicación",
            refresh: "Actualizar",
            noAppsFound: "No se encontraron aplicaciones",
            packageName: "Nombre del paquete",
            appName: "Nombre de la aplicación",
            appNamePlaceholder: "Ej.: Mi aplicación",
            iconUrl: "URL del icono",
            fillRequiredFields: "Rellene los campos obligatorios",
            appAdded: "Aplicación añadida correctamente",
            errorAddingApp: "Error al añadir la aplicación",
            syncReviews: "Sincronizar reseñas",
            reviewsSynced: "Reseñas sincronizadas",
            errorSyncingReviews: "Error al sincronizar reseñas",
            removeApp: "Quitar aplicación",
            removeAppConfirm: "¿Está seguro de que desea quitar {name}? También se eliminarán todas las reseñas relacionadas.",
            appRemoved: "Aplicación quitada",
            errorRemovingApp: "Error al quitar la aplicación",
            errorFetchingApps: "Error al cargar las aplicaciones",
            selectApp: "Seleccionar aplicación",
            allApps: "Todas las aplicaciones",
            allRatings: "Todas las valoraciones",
            all: "Todo",
            new: "Nuevo",
            replied: "Respondido",
            resolved: "Resuelto",
            noReviewsFound: "No se encontraron reseñas",
            noComment: "Sin texto de comentario",
            selectReviewToPreview: "Seleccione una reseña para la vista previa",
            yourReply: "Su respuesta",
            reply: "Responder",
            updateReply: "Actualizar respuesta",
            replyToReview: "Responder a la reseña",
            writeYourReply: "Escriba su respuesta (máx. 350 caracteres)",
            pleaseEnterReply: "Introduzca una respuesta",
            replyTooLong: "La respuesta no puede superar los 350 caracteres",
            replySuccess: "Respuesta enviada correctamente",
            errorSendingReply: "Error al enviar la respuesta",
            statusUpdated: "Estado actualizado",
            errorUpdatingStatus: "Error al actualizar el estado",
            errorFetchingReviews: "Error al cargar las reseñas",
            deviceInfo: "Información del dispositivo",
            device: "Dispositivo",
            appVersion: "Versión de la aplicación",
            manufacturer: "Fabricante"
        },
        googleDrive: {
            title: "Google Drive",
            googleDriveChannels: "Canales de Google Drive",
            googleDriveIntegration: "Integración con Google Drive",
            channelName: "Nombre del canal",
            channelInfo: "Información del canal",
            channelSettings: "Configuración del canal",
            connectedAccount: "Cuenta conectada",
            storageQuota: "Cuota de almacenamiento",
            connectToGoogleDrive: "Conectar con Google Drive",
            ensureGoogleAccount: "Asegúrese de tener una cuenta de Google",
            ensureGoogleDriveAccess: "Asegúrese de tener acceso a Google Drive",
            permissionDesc: "Debe permitir que Supsis acceda a sus archivos de Google Drive.",
            requiredChannel: "El nombre del canal es obligatorio",
            failedToCreateChannel: "Error al crear el canal",
            connectedSuccess: "Cuenta de Google Drive conectada correctamente",
            oauthTimeout: "Tiempo de autorización agotado",
            deleteGoogleDriveChannelInfo: "¿Está seguro de que desea eliminar este canal de Google Drive?",
            deleteChannel: "Eliminar canal",
            deleteChannelDescription: "¿Está seguro de que desea eliminar este canal de Google Drive?",
            driveExplorer: "Explorador de Drive",
            myDrive: "Mi unidad",
            sharedDrives: "Unidades compartidas",
            searchFiles: "Buscar archivos...",
            noSharedDrives: "No se encontraron unidades compartidas",
            noFiles: "No se encontraron archivos",
            loadMore: "Cargar más",
            filesSelected: "archivos seleccionados",
            downloadToSupsis: "Descargar a Supsis",
            fileDownloaded: "Archivo descargado correctamente",
            errorLoadingFiles: "Error al cargar archivos",
            errorLoadingDrives: "Error al cargar unidades",
            errorSearching: "Error al buscar",
            errorDownloading: "Error al descargar el archivo",
            fileName: "Nombre del archivo",
            fileSize: "Tamaño",
            modifiedTime: "Fecha de modificación",
            selectFile: "Seleccionar archivo",
            selectFileFromGoogleDrive: "Seleccionar archivo de Google Drive",
            selectChannel: "Seleccionar canal",
            noChannelsAvailable: "No se encontraron canales de Google Drive accesibles",
            selectedFiles: "Archivos seleccionados",
            upload: "Subir",
            selectUploadMethod: "Seleccione el método de subida:",
            uploadFromComputer: "Subir desde el equipo",
            downloadingFiles: "Descargando archivos...",
            myChannel: "Mis canales",
            manageWhoCanAccess: "Gestionar quién puede acceder a este canal",
            download: "Descargar",
            openInNewTab: "Abrir en nueva pestaña",
            openInGoogleDrive: "Abrir en Google Drive",
            fileType: "Tipo de archivo",
            owner: "Propietario",
            previewNotAvailable: "Vista previa no disponible para este tipo de archivo",
            byocTitle: "Use sus propias credenciales de Google Cloud",
            byocDescription: "Para la integración con Google Drive, debe crear credenciales de cliente OAuth desde su propia consola de Google Cloud.",
            clientId: "ID de cliente OAuth",
            clientIdPlaceholder: "xxxxxxxx.apps.googleusercontent.com",
            clientIdRequired: "El ID de cliente es obligatorio",
            clientSecret: "Secreto de cliente OAuth",
            clientSecretPlaceholder: "GOCSPX-xxxxxxxxxx",
            clientSecretRequired: "El secreto de cliente es obligatorio",
            redirectUriCopied: "URI de redirección copiada",
            setupGuideTitle: "Guía de configuración (clic para expandir)",
            setupStep1: "Vaya a Google Cloud Console y cree un proyecto nuevo o seleccione uno existente.",
            setupStep2: "Vaya a APIs y servicios > Sección Credenciales.",
            setupStep3: "Haga clic en \"+ CREAR CREDENCIALES\" > \"ID de cliente OAuth\". Seleccione \"Aplicación web\" como tipo de aplicación.",
            setupStep4: "Añada la siguiente URL a la sección URIs de redirección autorizados:",
            setupStep5: "Habilite \"Google Drive API\" en APIs y servicios > Biblioteca.",
            setupStep6: "Copie los valores de Client ID y Client Secret y péguelos en los campos anteriores."
        },
        appStore: {
            title: "Reseñas de App Store",
            channels: "Canales de App Store",
            channelName: "Nombre del canal",
            channelDetails: "Detalles del canal",
            connectToAppStore: "Conectar con App Store",
            credentials: "Credenciales API",
            credentialsHelp: "Introduzca sus credenciales API de App Store Connect. Puede crear una clave API desde",
            issuerId: "ID del emisor",
            issuerIdPlaceholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
            keyId: "ID de clave",
            keyIdPlaceholder: "XXXXXXXXXX",
            privateKey: "Clave privada (contenido del archivo .p8)",
            privateKeyPlaceholder: "-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----",
            requiredField: "Este campo es obligatorio",
            validateCredentials: "Validar credenciales",
            credentialsValid: "Las credenciales son válidas",
            credentialsInvalid: "Credenciales no válidas",
            pleaseValidateFirst: "Valide sus credenciales primero",
            failedToCreateChannel: "Error al crear el canal",
            connectedSuccess: "Cuenta de App Store conectada correctamente",
            deleteChannelInfo: "¿Está seguro de que desea eliminar este canal de App Store?",
            deleteChannel: "Eliminar canal",
            deleteChannelDescription: "¿Está seguro de que desea eliminar este canal de App Store?",
            detail: "Detalle",
            visibility: "Visibilidad",
            apps: "Aplicaciones",
            reviews: "Reseñas",
            status: "Estado",
            enabled: "Habilitado",
            disabled: "Deshabilitado",
            save: "Guardar",
            channelUpdated: "Canal actualizado correctamente",
            errorUpdatingChannel: "Error al actualizar el canal",
            visibilityDescription: "Establezca qué usuarios y departamentos pueden ver este canal",
            visibleToUsers: "Visible para usuarios",
            visibleToDepartments: "Visible para departamentos",
            selectUsers: "Seleccionar usuarios",
            selectDepartments: "Seleccionar departamentos",
            visibilityUpdated: "Configuración de visibilidad actualizada",
            errorUpdatingVisibility: "Error al actualizar la visibilidad",
            syncApps: "Sincronizar aplicaciones",
            refresh: "Actualizar",
            noAppsFound: "No se encontraron aplicaciones",
            appsAutoFetch: "Las aplicaciones se obtienen automáticamente de App Store Connect. Haga clic en 'Sincronizar aplicaciones' para actualizar la lista.",
            appsSynced: "Aplicaciones sincronizadas correctamente",
            errorSyncingApps: "Error al sincronizar aplicaciones",
            syncReviews: "Sincronizar reseñas",
            reviewsSynced: "Reseñas sincronizadas",
            errorSyncingReviews: "Error al sincronizar reseñas",
            errorFetchingApps: "Error al cargar las aplicaciones",
            selectApp: "Seleccionar aplicación",
            allApps: "Todas las aplicaciones",
            all: "Todo",
            new: "Nuevo",
            replied: "Respondido",
            resolved: "Resuelto",
            noReviewsFound: "No se encontraron reseñas",
            noComment: "Sin texto de comentario",
            anonymous: "Anónimo",
            selectReviewToPreview: "Seleccione una reseña para la vista previa",
            yourReply: "Su respuesta",
            reply: "Responder",
            edit: "Editar",
            delete: "Eliminar",
            editReply: "Editar respuesta",
            replyToReview: "Responder a la reseña",
            writeYourReply: "Escriba su respuesta",
            pleaseEnterReply: "Introduzca una respuesta",
            replySuccess: "Respuesta enviada correctamente",
            errorSendingReply: "Error al enviar la respuesta",
            deleteResponse: "Eliminar respuesta",
            deleteResponseConfirm: "¿Está seguro de que desea eliminar esta respuesta?",
            responseDeleted: "Respuesta eliminada correctamente",
            errorDeletingResponse: "Error al eliminar la respuesta",
            statusUpdated: "Estado actualizado",
            errorUpdatingStatus: "Error al actualizar el estado",
            errorFetchingReviews: "Error al cargar las reseñas",
            territory: "Territorio",
            region: "Región"
        },
        LinkedinContacts: "Contactos de LinkedIn",
        TelegramContacts: "Contactos de Telegram",
        announcements: {
            menu: "Anuncios",
            newAnnouncementForm: "Formulario de nuevo anuncio",
            updateAnnouncementForm: "Formulario de actualización de anuncio"
        },
        packages: {
            mostPopular: "MÁS POPULAR",
            currency: "₺",
            activePlan: "PLAN ACTIVO"
        },
        totalCost: {
            title: "COSTE DE SUPSIS",
            monthlyPayments: "Pagos mensuales",
            currency: "₺",
            currencyMonthly: "₺ / Mes",
            oneTimePayments: "Pagos únicos",
            oneTimeDiscount: "Descuento por paquete anual",
            currencyYearly: "₺ / Anual",
            totalOneTimeCost: "Total a pagar de una vez",
            totalTax: "Impuestos (18%)",
            referenceCode: "¿Tiene un código de referencia?",
            referencePlaceholder: "Introduzca el código",
            codeButton: "Aplicar",
            monthlyCost: "¿Importe a cargar mensualmente en su cuenta?",
            oneTimeFullCost: "¿Importe único todo incluido?",
            payment: "Realizar pago"
        },
        probel: {
            branchCode: "Código de rama",
            branchCodeDesc: "Escriba o seleccione el código de rama...",
            hospitalBranchCode: "Código de sucursal",
            hospitalBranchCodeDesc: "Escriba o seleccione el código de sucursal...",
            clinicCode: "Código de policlínico",
            clinicCodeDesc: "Escriba o seleccione el código de policlínico...",
            date: "Fecha de cita",
            dateDesc: "Introduzca o seleccione la fecha de cita...",
            patientToken: "Token del paciente",
            patientTokenDesc: "Escriba o seleccione el token del paciente...",
            appointmentId: "ID de cita",
            appointmentIdDesc: "Escriba o seleccione el ID de cita...",
            identityType: "Tipo de identificación",
            identityNumber: "Número de identificación",
            name: "Nombre del paciente",
            surname: "Apellido del paciente",
            gender: "Género del paciente",
            birthDay: "Fecha de nacimiento del paciente",
            phoneNumber: "Teléfono del paciente",
            identityTypeDesc: "Escriba o seleccione el tipo de identificación...",
            identityNumberDesc: "Escriba o seleccione el número de identificación...",
            nameDesc: "Escriba o seleccione el nombre del paciente...",
            surnameDesc: "Escriba o seleccione el apellido del paciente...",
            genderDesc: "Escriba o seleccione el género del paciente...",
            birthDayDesc: "Escriba o seleccione la fecha de nacimiento del paciente...",
            phoneNumberDesc: "Escriba o seleccione el teléfono del paciente..."
        },
        waba: {
            templateCreationFailed: "Error al crear la plantilla",
            templateError_2388040: "Límite de caracteres superado",
            templateErrorDesc_2388040: "Un campo de su plantilla ha superado el límite máximo de caracteres permitido.",
            templateError_2388047: "El formato del encabezado del mensaje es incorrecto",
            templateErrorDesc_2388047: "El encabezado del mensaje contiene un formato no válido.",
            templateError_2388072: "El formato del cuerpo del mensaje es incorrecto",
            templateErrorDesc_2388072: "El cuerpo del mensaje contiene un formato no válido.",
            templateError_2388073: "El formato del pie del mensaje es incorrecto",
            templateErrorDesc_2388073: "El pie del mensaje contiene un formato no válido.",
            templateError_2388293: "La proporción de parámetros y palabras supera el límite",
            templateErrorDesc_2388293: "Esta plantilla tiene demasiadas variables para su longitud. Reduzca el número de variables o aumente la longitud del mensaje.",
            templateError_2388299: "No se permiten parámetros al inicio o al final",
            templateErrorDesc_2388299: "Las variables no pueden estar al inicio o al final de la plantilla."
        },
        profile: {
            subtitle: "Gestione la configuración de su cuenta y las sesiones"
        },
        integrations: {
            requiredField: "Este campo es obligatorio",
            existingChannels: "Canales existentes",
            createNewChannel: "Crear nuevo canal",
            channelName: "Nombre del canal",
            createChannel: "Crear canal",
            channelCreated: "Canal creado correctamente",
            channelCreateError: "Se produjo un error al crear el canal",
            channelActivated: "Canal activado",
            channelDeactivated: "Canal desactivado",
            channelUpdateError: "Se produjo un error al actualizar el canal",
            deleteChannelConfirm: "Eliminar canal",
            deleteChannelConfirmContent: "¿Está seguro de que desea eliminar el canal {name}?",
            channelDeleted: "Canal eliminado correctamente",
            channelDeleteError: "Se produjo un error al eliminar el canal",
            slackIntegration: "Integración con Slack",
            slackDescription: "Envíe mensajes a su espacio de Slack mediante la automatización y el chatbot de Supsis.",
            slackSetupTitle: "Pasos de configuración:",
            slackStep1: "Vaya a api.slack.com/apps",
            slackStep2: "Seleccione su aplicación de Slack existente o cree una nueva",
            slackStep3: "Haga clic en 'Incoming Webhooks' en el menú izquierdo y actívelo",
            slackStep4: "Haga clic en 'Add New Webhook to Workspace' y seleccione el canal al que desea enviar mensajes",
            slackCardDescription: "Envíe mensajes a sus canales de Slack mediante automatización y chatbot",
            slackChannelNamePlaceholder: "Ej.: Notificaciones de soporte",
            slackWebhookUrl: "URL del webhook",
            slackWebhookUrlPlaceholder: "https://hooks.slack.com/services/...",
            slackWebhookUrlHelper: "Vaya a Slack App > Incoming Webhooks > Add New Webhook to Workspace",
            slackWebhookUrlInvalid: "Introduzca una URL de webhook de Slack válida",
            slackDefaultChannel: "Canal predeterminado (opcional)",
            slackDefaultChannelPlaceholder: "#general",
            slackDefaultChannelHelper: "Si no se especifica, se utilizará el canal conectado al webhook",
            pushoverIntegration: "Integración con Pushover",
            pushoverCardDescription: "Envíe notificaciones push a sus dispositivos móviles mediante automatización y chatbot",
            pushoverDescription: "Envíe notificaciones push a sus dispositivos móviles mediante la automatización y el chatbot de Supsis. Puede crear una cuenta y obtener la User Key y el Application Token en pushover.net.",
            pushoverChannelNamePlaceholder: "Ej.: Notificaciones móviles",
            pushoverUserKey: "Clave de usuario",
            pushoverUserKeyPlaceholder: "Clave de usuario de Pushover",
            pushoverUserKeyHelper: "Puede obtenerla en la página de su cuenta de pushover.net",
            pushoverAppToken: "Token de la aplicación",
            pushoverAppTokenPlaceholder: "Token de la aplicación Pushover",
            pushoverAppTokenHelper: "Puede crear una aplicación en pushover.net para obtener el token"
        },
        addWebhook: "Añadir webhook",
        allIntegrations: "Todas las integraciones",
        editWebhook: "Editar webhook",
        integrateYourCBwithChatGpt3: "El chatbot se puede integrar con GPT-4. Se requiere clave API de GPT-4.",
        integrateYourCBwithChatWidget: "Integre su chatbot con el widget de chat.",
        integrateYourCBwithIntegratable: "Transfiera fácilmente la información del chat entre el chatbot y {integratable}.",
        integrateYourCBwithWebHook: "Transfiera fácilmente la información del chat entre el chatbot y sus servicios web.",
        newWebhook: "Nuevo webhook",
        shouldAddMethod: "¡Debe rellenar el método de pago y la dirección de facturación! No se retirará dinero de su cuenta. Al final del mes se creará una factura según su uso.",
        webhookPassword: "Contraseña del webhook",
        webhookTitle: "Título del webhook",
        webhookToken: "Token del webhook",
        webhookUrl: "URL del webhook",
        webhookUsername: "Nombre de usuario del webhook",
        task_reports: {
            title: "Informes de Tareas",
            date: "Fecha",
            workflow: "Flujo de Trabajo",
            select: "Seleccionar",
            agent: "Agente",
            all: "Todo",
            select_workflow_to_view_reports: "Seleccione un flujo de trabajo para ver los informes.",
            created_task: "Tarea Creada",
            updated_task: "Tarea Actualizada",
            assigned_tasks_by_personnel: "Tareas Asignadas por Personal",
            assigned_task: "Tarea Asignada",
            no_assigned_task_found_in_date_range: "No se encontraron tareas asignadas en el rango de fechas seleccionado.",
            updated_tasks: "Tareas Actualizadas",
            task: "Tarea",
            current_stage: "Etapa Actual",
            assigned: "Asignado",
            update: "Actualización",
            no_updated_task_found_in_date_range: "No se encontraron tareas actualizadas en el rango de fechas seleccionado.",
            task_distribution_by_agent: "Distribución de Tareas por Agente",
            total: "Total",
            no_assigned_task_found: "No se encontraron tareas asignadas.",
            timeline: "Línea de Tiempo",
            unassigned_tasks: "Tareas No Asignadas",
            transition_process: "Proceso de Transición",
            no_active_task_found_for_agent: "No se encontraron tareas activas para este agente.",
            select_agent_to_view_timeline: "Seleccione un agente para ver la línea de tiempo.",
            entry: "Entrada",
            exit: "Salida",
            still_in_this_stage: "Aún en esta etapa",
            duration: "Duración",
            day: "día",
            hour: "hora",
            max_30_days_range_warning: "Puede seleccionar un rango de fechas de hasta 30 días.",
            today: "Hoy",
            this_week: "Esta Semana",
            this_month: "Este Mes",
            last_month: "Mes Pasado",
            unknown: "Desconocido",
            unassigned: "No asignado",
            gantt: "Gantt",
            table: "Tabla"
        }
    }
};

export default messagesES;
